export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  JSON: any;
};

export type AcceptInviteModel = {
  activationDate?: Maybe<Scalars['String']>;
  creationDate: Scalars['String'];
  emailAddress: Scalars['String'];
  expirationDate: Scalars['String'];
  id: Scalars['String'];
  inviteStatus: Scalars['String'];
  isUserExists: Scalars['Boolean'];
  organizationId: Scalars['String'];
  organizationName: Scalars['String'];
  roles: Array<Scalars['String']>;
  sender: WorkspaceInviteSenderModel;
  workspaceId: Scalars['String'];
  workspaceName: Scalars['String'];
};

export type AccessDetailsFilter = {
  accessDetails?: Maybe<Array<Scalars['String']>>;
};

export type AccessManagementApp = {
  dataTable: Array<AccessManagementAppAccount>;
  id: Scalars['String'];
  includeReview: Scalars['Boolean'];
  integrationTypeConfig?: Maybe<IntegrationTypeConfig>;
  lastReviewDate?: Maybe<Scalars['String']>;
  lastUpdateDate?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  type: Scalars['String'];
  vendorId?: Maybe<Scalars['String']>;
  vendorOwner?: Maybe<IdNameModel>;
  workspaceId: Scalars['String'];
};

export type AccessManagementAppAccount = {
  account: Scalars['String'];
  accountId?: Maybe<Scalars['String']>;
  accountType?: Maybe<Scalars['String']>;
  employee?: Maybe<Scalars['String']>;
  employeeId?: Maybe<Scalars['String']>;
  roles: Array<AccessManagementAppAccountRole>;
  status: Scalars['String'];
};

export type AccessManagementAppAccountEditRequestType = {
  account: Scalars['String'];
  accountId?: InputMaybe<Scalars['String']>;
  accountType?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<Scalars['String']>;
  employeeId?: InputMaybe<Scalars['String']>;
  roles: Array<AccessManagementAppAccountRoleEditRequestType>;
  status: Scalars['String'];
};

export type AccessManagementAppAccountInput = {
  account: Scalars['String'];
  accountId?: InputMaybe<Scalars['String']>;
  accountType?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<Scalars['String']>;
  employeeId?: InputMaybe<Scalars['String']>;
  roles: Array<AccessManagementAppAccountRoleInput>;
  status: Scalars['String'];
};

export type AccessManagementAppAccountRole = {
  roleName: Scalars['String'];
  rolePermissions: Array<Scalars['String']>;
};

export type AccessManagementAppAccountRoleEditRequestType = {
  roleName: Scalars['String'];
  rolePermissions: Array<Scalars['String']>;
};

export type AccessManagementAppAccountRoleInput = {
  roleName: Scalars['String'];
  rolePermissions: Array<Scalars['String']>;
};

export type AccessManagementAppEditRequestInput = {
  dataTable: Array<AccessManagementAppAccountEditRequestType>;
  id: Scalars['String'];
  includeReview: Scalars['Boolean'];
  integrationTypeConfig?: InputMaybe<IntegrationTypeConfigInput>;
  lastReviewDate?: InputMaybe<Scalars['String']>;
  lastUpdateDate?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  type: Scalars['String'];
  vendorId?: InputMaybe<Scalars['String']>;
  vendorOwner?: InputMaybe<IdNameInput>;
  workspaceId: Scalars['String'];
};

export type AccessRuleInput = {
  rule: Scalars['String'];
};

export type AccessRuleModel = {
  rule: Scalars['String'];
};

export type AccessionItem = {
  consentDate?: Maybe<Scalars['String']>;
  details: Array<Scalars['String']>;
  typeAccession: Scalars['String'];
  userInfo: UserInfo;
};

export type AccountFilterModel = AppNameFilter | EmailFilter | NameFilter;

export type AccountMappingConfig = {
  accountCollection: Scalars['String'];
  accountCollectionField: Scalars['String'];
  employeeCollection: Scalars['String'];
  employeeCollectionField: Scalars['String'];
};

export type AccountMappingConfigInput = {
  accountCollection: Scalars['String'];
  accountCollectionField: Scalars['String'];
  employeeCollection: Scalars['String'];
  employeeCollectionField: Scalars['String'];
};

export type AccountModel = {
  appInfo?: Maybe<IdNameLogoModel>;
  authenticationInfo: AuthenticationInfoModel;
  condition: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identity?: Maybe<IdentitySmallModel>;
  name?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  roles: Array<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  synthetic: Scalars['Boolean'];
};

export type AccountsExtendedCollabModel = {
  active: Scalars['Boolean'];
  blockedReason?: Maybe<Scalars['String']>;
  createDate: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastLoginDate?: Maybe<Scalars['String']>;
  lastName: Scalars['String'];
  organizationName: Scalars['String'];
  publicId: Scalars['String'];
  region: Scalars['String'];
};

export type AccountsInput = {
  filter: FilterInput;
  pageInfo: SharedPaginationInput;
};

export type AccountsResponseModel = {
  accounts: Array<AccountModel>;
  allIdentities: Array<IdentitySmallModel>;
  filters: Array<Filter>;
  pageInfo: PageInfo;
};

export type AccountsShortCollabModel = {
  active: Scalars['Boolean'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  publicId: Scalars['String'];
  region: Scalars['String'];
};

export type AccountsSmallOrganization = {
  blocked?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  name: Scalars['String'];
  role: Scalars['String'];
  subscription: Scalars['String'];
};

export type ActorCallerTypeFilter = {
  actorCallerType?: Maybe<Array<Scalars['String']>>;
};

export type ActorEmailFilter = {
  actorEmail?: Maybe<Array<Scalars['String']>>;
};

export type ActorExistsResponseModel = {
  isExists: Scalars['Boolean'];
};

export type ActorFieldBoxModel = {
  location: Array<Scalars['Float']>;
  size: Array<Scalars['Float']>;
};

export type ActorFieldModel = {
  box: ActorFieldBoxModel;
  type: Scalars['String'];
};

export type ActorInput = {
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  publicId?: InputMaybe<Scalars['String']>;
};

export type ActorLogModel = {
  callerType: Scalars['String'];
  email: Scalars['String'];
  key?: Maybe<Scalars['String']>;
  publicId: Scalars['String'];
};

export type ActorModel = {
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  publicId?: Maybe<Scalars['String']>;
};

export type AddCrownJewelRequest = {
  appCrownJewels: Array<AppCrownJewels>;
  color: Scalars['String'];
  name: Scalars['String'];
};

export type AddEvidenceInput = {
  categories: Array<Scalars['String']>;
  collectorId?: InputMaybe<Scalars['String']>;
  controlId?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  organizationId: Scalars['String'];
  origin: Scalars['Boolean'];
  visibility: Scalars['String'];
};

export type AddFrameworkInput = {
  description: Scalars['String'];
  logo: Scalars['String'];
  name: Scalars['String'];
  origin: Scalars['Boolean'];
  type: Scalars['String'];
  visibility: Scalars['String'];
};

export type AddIntegrationInput = {
  applicationId: Scalars['String'];
  detailsId: Scalars['String'];
  endpointMappingName: Scalars['String'];
  hris: Scalars['Boolean'];
  identity: Scalars['Boolean'];
  integration: Scalars['JSON'];
  name: Scalars['String'];
  status: Scalars['String'];
  workspaceId: Scalars['String'];
};

export type AddIntegrationResponse = {
  id: Scalars['String'];
};

export type AddIntegrationVendorInput = {
  owner?: InputMaybe<IdNameInput>;
  providedService: Scalars['String'];
  riskLevel: Scalars['String'];
  type: Scalars['String'];
};

export type AddPolicyInput = {
  configuration: Scalars['JSON'];
  description: Scalars['String'];
  editableTemplates: Array<EditableHtmlInput>;
  frameworks: Array<NameLogoInput>;
  name: Scalars['String'];
  organizationId: Scalars['String'];
  tag: Array<Scalars['String']>;
  templates: Array<PolicyTemplateInput>;
  visibility: Scalars['String'];
};

export type AddPolicyQsModel = {
  assets: Array<FileModel>;
  config: Scalars['JSON'];
  policyId: Scalars['String'];
  wpId: Scalars['String'];
};

export type AddPolicyQsModelResponse = {
  array: Array<AddPolicyQsModel>;
};

export type AddProfileInput = {
  category: Scalars['String'];
  description: Scalars['String'];
  name: Scalars['String'];
};

export type AddedAppModel = {
  appInfo: IdNameLogoModel;
  id: Scalars['String'];
  name: Scalars['String'];
  settingsCount: Scalars['Float'];
};

export type AddedAppResponseModel = {
  applications: Array<AddedAppModel>;
  filters: Array<Filter>;
  pageInfo: PageInfo;
};

export type AdminAccountsFilterModel = EmailFilter | PublicIdFilter | RegionFilter;

export type AdminAddEvidenceInput = {
  categories: Array<Scalars['String']>;
  collectorId?: InputMaybe<Scalars['String']>;
  controlId?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  gap?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  organizationId?: InputMaybe<Scalars['String']>;
  origin: Scalars['Boolean'];
  visibility?: InputMaybe<Scalars['String']>;
};

export type AdminAddFrameworkInput = {
  description: Scalars['String'];
  id: Scalars['String'];
  logo: Scalars['String'];
  name: Scalars['String'];
  origin: Scalars['Boolean'];
  type: Scalars['String'];
  visibility?: InputMaybe<Scalars['String']>;
};

export type AdminAddPolicyInput = {
  description: Scalars['String'];
  name: Scalars['String'];
  organizationId?: InputMaybe<Scalars['String']>;
  tag: Array<Scalars['String']>;
  templates: Array<AdminPolicyTemplateInput>;
  visibility?: InputMaybe<Scalars['String']>;
};

export type AdminBuilderControlModel = {
  category?: Maybe<Scalars['String']>;
  description: Array<Scalars['String']>;
  evidences?: Maybe<Array<AdminBuilderEvidenceModel>>;
  foundInFrameworks?: Maybe<Array<IdNameModel>>;
  foundInFrameworksCounter?: Maybe<Scalars['Float']>;
  foundInFrameworksIds?: Maybe<Array<Scalars['String']>>;
  group?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationId?: Maybe<Scalars['String']>;
  origin: Scalars['Boolean'];
  visibility?: Maybe<Scalars['String']>;
};

export type AdminBuilderEvidenceModel = {
  categories: Array<Scalars['String']>;
  collectorId?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  foundInControls: Array<IdNameModel>;
  foundInControlsCounter?: Maybe<Scalars['Float']>;
  foundInControlsIds?: Maybe<Array<Scalars['String']>>;
  gap?: Maybe<Scalars['JSON']>;
  id: Scalars['String'];
  name: Scalars['String'];
  organizationId?: Maybe<Scalars['String']>;
  origin: Scalars['Boolean'];
  visibility?: Maybe<Scalars['String']>;
};

export type AdminBuilderFilesInput = {
  controlEvidencesFile?: InputMaybe<Scalars['String']>;
  controlFrameworkFile?: InputMaybe<Scalars['String']>;
  controlsFile?: InputMaybe<Scalars['String']>;
  evidencesFile?: InputMaybe<Scalars['String']>;
};

export type AdminBuilderFrameworkModel = {
  controls: Scalars['Float'];
  description: Scalars['String'];
  evidences: Scalars['Float'];
  id: Scalars['String'];
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationId?: Maybe<Scalars['String']>;
  origin: Scalars['Boolean'];
  type: Scalars['String'];
  visibility?: Maybe<Scalars['String']>;
};

export type AdminBuilderGapFilesInput = {
  gapFile?: InputMaybe<Scalars['String']>;
};

export type AdminBuilderPolicyModel = {
  description: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  organizationId?: Maybe<Scalars['String']>;
  origin: Scalars['Boolean'];
  pipeLinesCounter: Scalars['Float'];
  tag: Array<Scalars['String']>;
  templates: Array<AdminBuilderPolicyTemplateModel>;
  visibility?: Maybe<Scalars['String']>;
};

export type AdminBuilderPolicyTemplateModel = {
  fileId: Scalars['String'];
  fileName: Scalars['String'];
};

export type AdminBuilderResponseModel = {
  allControlsCounter: Scalars['Float'];
  allEvidencesCounter: Scalars['Float'];
  allPoliciesCounter: Scalars['Float'];
  frameworks: Array<AdminBuilderFrameworkModel>;
};

export type AdminChangeFrameworkNameInput = {
  frameworkId: Scalars['String'];
  name: Scalars['String'];
};

export type AdminChangeFrameworkVisibilityInput = {
  frameworkId: Scalars['String'];
  visibility: Scalars['String'];
};

export type AdminControlInput = {
  category: Scalars['String'];
  description: Array<Scalars['String']>;
  frameworkId?: InputMaybe<Scalars['String']>;
  group: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  organizationId?: InputMaybe<Scalars['String']>;
  origin: Scalars['Boolean'];
  visibility?: InputMaybe<Scalars['String']>;
};

export type AdminControlsWithFilterModel = {
  controls: Array<AdminBuilderControlModel>;
  pageInfo: PageInfo;
};

export type AdminDataInput = {
  editor?: InputMaybe<Scalars['JSON']>;
  innerHtml?: InputMaybe<Scalars['String']>;
  variables?: InputMaybe<Array<AdminDataVariablesInput>>;
};

export type AdminDataVariablesInput = {
  description?: InputMaybe<Scalars['String']>;
  format?: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
  order: Scalars['Float'];
  title: Scalars['String'];
  type: Scalars['String'];
  value?: InputMaybe<Scalars['String']>;
};

export type AdminDeleteAllFilesInput = {
  fileIds: Array<Scalars['String']>;
};

export type AdminEditControlInput = {
  category?: InputMaybe<Scalars['String']>;
  description: Array<Scalars['String']>;
  evidences?: InputMaybe<Array<AdminEvidenceInput>>;
  foundInFrameworks?: InputMaybe<Array<IdNameInput>>;
  foundInFrameworksCounter?: InputMaybe<Scalars['Float']>;
  foundInFrameworksIds?: InputMaybe<Array<Scalars['String']>>;
  group?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  organizationId?: InputMaybe<Scalars['String']>;
  origin: Scalars['Boolean'];
  visibility?: InputMaybe<Scalars['String']>;
};

export type AdminEmailTemplate = {
  id: Scalars['String'];
  template: Scalars['String'];
};

export type AdminEmailTemplateInput = {
  id: Scalars['String'];
  template: Scalars['String'];
};

export type AdminEvidenceInput = {
  categories: Array<Scalars['String']>;
  collectorId?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  foundInControls?: InputMaybe<Array<IdNameInput>>;
  foundInControlsCounter?: InputMaybe<Scalars['Float']>;
  foundInControlsIds?: InputMaybe<Array<Scalars['String']>>;
  gap?: InputMaybe<Scalars['JSON']>;
  id: Scalars['String'];
  name: Scalars['String'];
  organizationId?: InputMaybe<Scalars['String']>;
  origin: Scalars['Boolean'];
  visibility?: InputMaybe<Scalars['String']>;
};

export type AdminEvidencesWithFilterModel = {
  evidences: Array<AdminBuilderEvidenceModel>;
  pageInfo: PageInfo;
};

export type AdminLicensesFilterModel = IdFilter;

export type AdminLinkControlResponseModel = {
  controls: Scalars['Float'];
  evidences: Scalars['Float'];
};

export type AdminOrganizationModel = {
  blocked: Scalars['Boolean'];
  blockedReason?: Maybe<Scalars['String']>;
  collaborators: Array<AdminCollabModel>;
  configuration: AdminOrganizationConfigModel;
  id: Scalars['String'];
  name: Scalars['String'];
  subscription: Scalars['String'];
  subscriptionExpiry: Scalars['String'];
  trialUsed: Scalars['Boolean'];
  workspaces: Array<AdminSmallWorkspaceModel>;
};

export type AdminOrganizationsFilterModel = IdFilter | NameFilter;

export type AdminPermissionInput = {
  name: Scalars['String'];
  tags: Array<Scalars['String']>;
};

export type AdminPermissionModel = {
  name: Scalars['String'];
  tags: Array<Scalars['String']>;
};

export type AdminPoliciesWithFilterModel = {
  pageInfo: PageInfo;
  policies: Array<AdminBuilderPolicyModel>;
};

export type AdminPolicyInput = {
  description: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  organizationId?: InputMaybe<Scalars['String']>;
  origin: Scalars['Boolean'];
  pipeLinesCounter: Scalars['Float'];
  tag: Array<Scalars['String']>;
  templates: Array<AdminPolicyTemplateInput>;
  visibility?: InputMaybe<Scalars['String']>;
};

export type AdminPolicyTemplateInput = {
  fileId: Scalars['String'];
  fileName: Scalars['String'];
};

export type AdminSmallOrganizationModel = {
  blocked: Scalars['Boolean'];
  id: Scalars['String'];
  name: Scalars['String'];
  subscription: Scalars['String'];
  subscriptionExpiry: Scalars['String'];
};

export type AdminUnlinkControlInput = {
  controlId: Scalars['String'];
  frameworkId: Scalars['String'];
};

export type AdminUnlinkEvidenceInput = {
  controlId: Scalars['String'];
  evidenceId: Scalars['String'];
  frameworkId?: InputMaybe<Scalars['String']>;
};

export type AnalyseConfigApp = {
  active: Scalars['Boolean'];
  disabled: Scalars['Boolean'];
  id: Scalars['String'];
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type AnalyseConfigAppInput = {
  active: Scalars['Boolean'];
  disabled: Scalars['Boolean'];
  id: Scalars['String'];
  logo?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type AnalyseConfigControl = {
  frameworkId: Scalars['String'];
  id: Scalars['String'];
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type AnalyseConfigControlInput = {
  frameworkId: Scalars['String'];
  id: Scalars['String'];
  logo?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type AnalyseConfigInput = {
  applications: Array<AnalyseConfigAppInput>;
  controls: Array<AnalyseConfigControlInput>;
};

export type AnalyseConfigModel = {
  applications: Array<AnalyseConfigApp>;
  controls: Array<AnalyseConfigControl>;
};

export type AnalyseConfigResponseModel = {
  config: AnalyseConfigModel;
  history: AnalyseHistoryResponseModel;
  playbook: PlaybookModel;
};

export type AnalyseHistoryFrameworkModel = {
  auditId: Scalars['String'];
  auditName: Scalars['String'];
  date: Scalars['String'];
  findings: Scalars['JSON'];
  findingsCount: Scalars['Float'];
  historyId: Scalars['String'];
  solution?: Maybe<Scalars['JSON']>;
  status: Scalars['String'];
};

export type AnalyseHistoryFrameworkResponseModel = {
  history: Array<AnalyseHistoryFrameworkModel>;
  pageInfo: PageInfo;
};

export type AnalyseHistoryModel = {
  date: Scalars['String'];
  details: HistoryAnalyseDetailsModel;
  findings: Scalars['Float'];
  id: Scalars['String'];
  status: Scalars['String'];
};

export type AnalyseHistoryResponseModel = {
  history: Array<AnalyseHistoryModel>;
  pageInfo: PageInfo;
};

export type AnalysisFilterModel = NameFilter;

export type AnswerValidationInput = {
  correctAnswer: Array<Scalars['String']>;
  points: Scalars['Float'];
};

export type AppConfigFilterModel = AppNameFilter;

export type AppCrownJewels = {
  appId: Scalars['String'];
  application: Scalars['String'];
  asset?: InputMaybe<Array<Scalars['String']>>;
  groupRole?: InputMaybe<Scalars['String']>;
  logo: Scalars['String'];
  privilege?: InputMaybe<Scalars['String']>;
};

export type AppDataSnapshotType = {
  applicationAccessId: Scalars['String'];
  applicationId?: Maybe<Scalars['String']>;
  dataTable: Array<AccessManagementAppAccount>;
  vendorId?: Maybe<Scalars['String']>;
};

export type AppDutiesPaginationModel = {
  categories: Array<Scalars['String']>;
  data: Array<AppDutyModel>;
  pageInfo: PageInfo;
};

export type AppDutyInput = {
  duties: Array<DutyInput>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type AppDutyModel = {
  duties: Array<DutyModel>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type AppHistoryModel = {
  applicationId: Scalars['String'];
  end: Scalars['String'];
  errorReason?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  prefix?: Maybe<Scalars['String']>;
  start: Scalars['String'];
  status: Scalars['String'];
  workspaceId: Scalars['String'];
};

export type AppInfo = {
  appId: Scalars['String'];
  consentDate?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  type: Scalars['String'];
};

export type AppLogModel = {
  applicationId: Scalars['String'];
  fileId: Scalars['String'];
  id: Scalars['String'];
  prefix: Scalars['String'];
  size: Scalars['Float'];
  timestamp: Scalars['String'];
  workspaceId: Scalars['String'];
};

export type AppNameFilter = {
  appName?: Maybe<Array<Scalars['String']>>;
};

export type AppSettingModel = {
  id: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
  value: Scalars['String'];
};

export type AppSettingsResponseModel = {
  pageInfo: PageInfo;
  settings: Array<AppSettingModel>;
};

export type ApplicationCrownJewels = {
  appId: Scalars['String'];
  application: Scalars['String'];
  asset?: Maybe<Array<Scalars['String']>>;
  groupRole?: Maybe<Scalars['String']>;
  logo: Scalars['String'];
  privilege?: Maybe<Scalars['String']>;
};

export type ApplicationFilter = {
  application?: Maybe<Array<Scalars['String']>>;
};

export type ApplicationModel = {
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type ApplicationsMonitoringModel = {
  appId: Scalars['String'];
  appName: Scalars['String'];
  logo?: Maybe<Scalars['String']>;
};

export type Asset = {
  accounts: Array<IdNameLogoModel>;
  appInfo: AppInfo;
  id: Scalars['String'];
  name: Scalars['String'];
  privileges: Array<IdNameLogoModel>;
  type?: Maybe<Scalars['String']>;
};

export type AssetFilter = {
  asset?: Maybe<Array<Scalars['String']>>;
};

export type AssetFilterModel = AppNameFilter | NameFilter | TypeFilter;

export type AssetRequestRequestorInput = {
  fullName: Scalars['String'];
  publicId: Scalars['String'];
};

export type AssetRequestRequestorModel = {
  fullName: Scalars['String'];
  publicId: Scalars['String'];
};

export type AssetSettingByAdminModel = {
  jobDescription?: Maybe<Array<JobTitleByAdminModel>>;
  name: Scalars['ID'];
  status?: Maybe<Array<StatusByAdminModel>>;
  title: Scalars['String'];
  values: Array<Scalars['String']>;
};

export type Assets = {
  assets: Array<Asset>;
  filters?: Maybe<Array<Filter>>;
  pageInfo: PageInfo;
};

export type AssetsFilteredInput = {
  filter: FilterInput;
  pageInfo: SharedPaginationInput;
};

export enum AssetsRequestAssetType {
  Certificate = 'CERTIFICATE',
  Physical = 'PHYSICAL',
  Saas = 'SAAS',
  Software = 'SOFTWARE',
  Virtual = 'VIRTUAL'
}

export enum AssetsRequestStatus {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Created = 'CREATED',
  Rejected = 'REJECTED'
}

export enum AssetsRequestType {
  AddAsset = 'ADD_ASSET',
  Remove = 'REMOVE',
  Request = 'REQUEST'
}

export type AssigneeModel = {
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type AssignmentControlModel = {
  added?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  id: Scalars['String'];
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type AssignmentsControlResponseModel = {
  assignments: Array<AssignmentControlModel>;
  pageInfo: PageInfo;
};

export type AuditLogModel = {
  actor: ActorLogModel;
  events: Array<EventModel>;
  id: Scalars['String'];
  organizationId: Scalars['String'];
  time: Scalars['String'];
  workspaceId: Scalars['String'];
};

export type AuditLogSingleEventModel = {
  actor: ActorLogModel;
  events: EventModel;
  id: Scalars['String'];
  organizationId: Scalars['String'];
  time: Scalars['String'];
  workspaceId: Scalars['String'];
};

export type AuditLogsByFiltersPaginationModel = {
  data: Array<AuditLogSingleEventModel>;
  filters: Array<SingleEventFiltersModel>;
  pageInfo: PageInfo;
};

export type AuditLogsFilterModel = ActorCallerTypeFilter | ActorEmailFilter | EventNameFilter;

export type AuditRow = {
  id: Scalars['String'];
  lastUpdate: Scalars['String'];
  name: Scalars['String'];
  status?: Maybe<Scalars['String']>;
};

export type AuditorVariantsAuditorModel = {
  email: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type AuditorVariantsModel = {
  auditors: Array<AuditorVariantsAuditorModel>;
  organization: IdNameModel;
};

export type AuthenticationInfoModel = {
  idp?: Maybe<Scalars['String']>;
  lastLogin?: Maybe<Scalars['String']>;
  mfa?: Maybe<Scalars['Boolean']>;
  type: Scalars['String'];
};

export type AutoDataAssetAuditSpaceModel = {
  data: Scalars['JSON'];
  pageInfo: PageInfo;
  tableFields: Array<Scalars['String']>;
};

export type AutoDataAssetModel = {
  data: Scalars['JSON'];
  keys: Array<Scalars['String']>;
  pageInfo: PageInfo;
};

export type AutocompleteHrManagersResponse = {
  pageInfo: PageInfo;
  values: Array<IdNameModel>;
};

export type AutocompleteIdNameResponse = {
  pageInfo: PageInfo;
  values: Array<IdNameModel>;
};

export type AutocompleteInput = {
  count: Scalars['Float'];
  page: Scalars['Float'];
  search?: InputMaybe<Scalars['String']>;
};

export type AutocompleteResponseModel = {
  pageInfo: PageInfo;
  values: Array<Scalars['String']>;
};

export type Automation = {
  active: Scalars['Boolean'];
  createDate: Scalars['String'];
  documents: DocumentModel;
  evidence: EvidenceNodeModel;
  history: Array<AutomationHistoryModel>;
  id: Scalars['String'];
  lastExecutorId?: Maybe<Scalars['String']>;
  lastRunningDate?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  pageInfo: PageInfo;
  stages: Array<StageModel>;
  trigger: TriggerModel;
  workspaceId: Scalars['String'];
  workspaceName: Scalars['String'];
};

export type AutomationControlModel = {
  category: Scalars['String'];
  frameworkIds: Array<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type AutomationEvidenceModel = {
  controlIds: Array<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type AutomationEvidenceStageModel = {
  data: Array<AutomationSaveEvidenceModel>;
  status?: Maybe<Scalars['String']>;
  statusChangedDate?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type AutomationFrameworkModel = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export type AutomationGetEvidencesResponseModel = {
  controls: Array<AutomationControlModel>;
  evidences: Array<AutomationEvidenceModel>;
  frameworks: Array<AutomationFrameworkModel>;
};

export type AutomationHistoryModel = {
  evidence: AutomationEvidenceStageModel;
  id: Scalars['String'];
  runDate: Scalars['String'];
  stages: Array<AutomationStageHistoryModel>;
  status?: Maybe<Scalars['String']>;
};

export type AutomationHistoryResponseModel = {
  history: Array<AutomationHistoryModel>;
  pageInfo: PageInfo;
};

export type AutomationInput = {
  active: Scalars['Boolean'];
  createDate: Scalars['String'];
  documents: DocumentInput;
  evidence: EvidenceNodeInput;
  id?: InputMaybe<Scalars['String']>;
  lastExecutorId?: InputMaybe<Scalars['String']>;
  lastRunningDate?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  stages: Array<StageInput>;
  trigger: TriggerInput;
  workspaceId: Scalars['String'];
  workspaceName: Scalars['String'];
};

export type AutomationSaveEvidenceDto = {
  controlId: Scalars['String'];
  frameworkId: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type AutomationSaveEvidenceModel = {
  controlId: Scalars['String'];
  frameworkId: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type AutomationStageActorHistoryModel = {
  email: Scalars['String'];
  fileChanged: Scalars['Boolean'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  publicId?: Maybe<Scalars['String']>;
  signatureId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  statusChangedDate?: Maybe<Scalars['String']>;
};

export type AutomationStageHistoryModel = {
  actors: Array<AutomationStageActorHistoryModel>;
  id: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type AutomationsFilterModel = NameFilter;

export type AvailableAppCollectionConfig = {
  alias: Scalars['String'];
  data: Array<Scalars['String']>;
  headers: Array<Scalars['String']>;
  mappingFieldsSchema: Array<TMappingFieldsSchema>;
  name: Scalars['String'];
};

export type AvailableAppConfig = {
  collectionConfigs: Array<AvailableAppCollectionConfig>;
  collectionPrefix: Scalars['String'];
};

export type AvailableAppModel = {
  applicationGroup: Scalars['String'];
  certifications: Array<Scalars['String']>;
  config?: Maybe<AvailableAppConfig>;
  description: Scalars['String'];
  documentationLink?: Maybe<Scalars['String']>;
  endpointMappingName: Scalars['String'];
  id: Scalars['String'];
  logo: Scalars['String'];
  name: Scalars['String'];
  releaseDate?: Maybe<Scalars['String']>;
  securityScope: Scalars['String'];
  status: Scalars['String'];
  type: Scalars['String'];
};

export type AvailableCategoryListModel = {
  name: Scalars['String'];
  pageInfo: PageInfo;
  value: Array<Scalars['String']>;
};

export type AvailableCollaboratorsRule = {
  count: Scalars['Float'];
  email?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type AvailableCollaboratorsRulesModel = {
  count: Scalars['Float'];
  email: Scalars['String'];
  type: Scalars['String'];
};

export type AvailableIdentitiesByProfile = {
  id: Scalars['String'];
  identities?: Maybe<Array<IdentitySmallModel>>;
};

export type AvailableOptions = {
  discovery: Scalars['String'];
};

export type BillingInfoModel = {
  additionalData: Scalars['JSON'];
  address: Scalars['String'];
  country: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  zip: Scalars['String'];
};

export type BillingModel = {
  billingInfo: BillingInfoModel;
  currentTear: CurrentTearModel;
  futurePayments: Array<FuturePaymentModel>;
  paymentHistory: Array<PaymentHistoryModel>;
  paymentMethod?: Maybe<PaymentMethodModel>;
  paymentPeriodStart?: Maybe<Scalars['String']>;
  transactionNumber: Scalars['String'];
};

export type BillingPrimaryInfoInput = {
  address: Scalars['String'];
  country: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  zip: Scalars['String'];
};

export type BuilderControlModel = {
  category: Scalars['String'];
  description: Array<Scalars['String']>;
  evidences?: Maybe<Array<BuilderEvidenceModel>>;
  foundInFrameworksCounter?: Maybe<Scalars['Float']>;
  group: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  organizationId?: Maybe<Scalars['String']>;
  origin: Scalars['Boolean'];
  visibility: Scalars['String'];
};

export type BuilderEvidenceModel = {
  categories: Array<Scalars['String']>;
  collectorId?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  foundInControlsCounter?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  name: Scalars['String'];
  organizationId?: Maybe<Scalars['String']>;
  origin: Scalars['Boolean'];
  visibility: Scalars['String'];
};

export type BuilderFrameworkInput = {
  controls: Scalars['Float'];
  createdBy: Scalars['String'];
  description: Scalars['String'];
  evidences: Scalars['Float'];
  id: Scalars['String'];
  logo?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  organizationId?: InputMaybe<Scalars['String']>;
  origin: Scalars['Boolean'];
  type: Scalars['String'];
  visibility: Scalars['String'];
};

export type BuilderFrameworkModel = {
  controls: Scalars['Float'];
  createdBy: Scalars['String'];
  description: Scalars['String'];
  evidences: Scalars['Float'];
  id: Scalars['String'];
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationId?: Maybe<Scalars['String']>;
  origin: Scalars['Boolean'];
  type: Scalars['String'];
  visibility: Scalars['String'];
};

export type BuilderPolicyModel = {
  configuration: Scalars['JSON'];
  description: Scalars['String'];
  editableTemplates: Array<EditableHtmlModel>;
  frameworks: Array<NameLogoModel>;
  id: Scalars['String'];
  name: Scalars['String'];
  organizationId: Scalars['String'];
  origin: Scalars['Boolean'];
  pipeLinesCounter: Scalars['Float'];
  tag: Array<Scalars['String']>;
  templates: Array<BuilderPolicyTemplateModel>;
  visibility: Scalars['String'];
};

export type BuilderPolicyTemplateModel = {
  fileId: Scalars['String'];
  fileName: Scalars['String'];
};

export type BuilderResponseModel = {
  allControlsCounter: Scalars['Float'];
  allEvidencesCounter: Scalars['Float'];
  allPoliciesCounter: Scalars['Float'];
  frameworks: Array<BuilderFrameworkModel>;
};

export type CjAvailableCategory = {
  name: Scalars['String'];
  values: Array<Scalars['String']>;
};

export type CampaignReviewExecutorSmallModel = {
  applicationAccessIds: Array<Scalars['String']>;
  description: Scalars['String'];
  etaConfig: EtaConfigModel;
  evidence: EvidenceNodeModel;
  expirationDate: Scalars['String'];
  finalApprover: FinalApprover;
  id: Scalars['String'];
  instructionId: Scalars['String'];
  name: Scalars['String'];
  runDate: Scalars['String'];
  stages: Array<SmallCampaignReviewExecutorStageType>;
  status: Scalars['String'];
  statusChangedDate: Scalars['String'];
  trigger: TriggerModel;
  workspaceId: Scalars['String'];
  workspaceName: Scalars['String'];
};

export type CampaignReviewFullExecutorModel = {
  applicationAccessIds: Array<Scalars['String']>;
  applications: Array<MappedApplicationModel>;
  dataSnapshots: Array<DataSnapshotType>;
  description: Scalars['String'];
  etaConfig: EtaConfigModel;
  evidence: EvidenceNodeModel;
  evidences: Array<EvidenceWithNameModel>;
  expirationDate: Scalars['String'];
  finalApprover: FinalApprover;
  id: Scalars['String'];
  instructionId: Scalars['String'];
  name: Scalars['String'];
  runDate: Scalars['String'];
  stages: Array<CampaignReviewExecutorStageType>;
  status: Scalars['String'];
  statusChangedDate: Scalars['String'];
  trigger: TriggerModel;
  workspaceId: Scalars['String'];
  workspaceName: Scalars['String'];
};

export type CampaignReviewInstructionInput = {
  active: Scalars['Boolean'];
  applicationAccessIds: Array<Scalars['String']>;
  applications: Array<MappedApplicationInput>;
  createDate: Scalars['String'];
  description: Scalars['String'];
  etaConfig: EtaConfigInput;
  evidence: EvidenceNodeInput;
  evidences: Array<EvidenceWithNameInput>;
  finalApprover: ActorInput;
  id: Scalars['String'];
  lastExecutorId?: InputMaybe<Scalars['String']>;
  lastRunStatus?: InputMaybe<Scalars['String']>;
  lastRunningDate?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  trigger: TriggerInput;
  workspaceId: Scalars['String'];
  workspaceName: Scalars['String'];
};

export type CampaignReviewInstructionModel = {
  active: Scalars['Boolean'];
  applicationAccessIds: Array<Scalars['String']>;
  applications: Array<MappedApplicationModel>;
  createDate: Scalars['String'];
  description: Scalars['String'];
  etaConfig: EtaConfigModel;
  evidence: EvidenceNodeModel;
  evidences: Array<EvidenceWithNameModel>;
  finalApprover: ActorModel;
  id: Scalars['String'];
  lastExecutorId?: Maybe<Scalars['String']>;
  lastRunStatus?: Maybe<Scalars['String']>;
  lastRunningDate?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  trigger: TriggerModel;
  workspaceId: Scalars['String'];
  workspaceName: Scalars['String'];
};

export type CategoryFilter = {
  category?: Maybe<Array<Scalars['String']>>;
};

export type CategoryModel = {
  icon?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type CertificateAssetInput = {
  customFields?: InputMaybe<Scalars['JSON']>;
  fileId?: InputMaybe<Scalars['String']>;
  fileName: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  owner?: InputMaybe<Scalars['String']>;
  renewal?: InputMaybe<Scalars['String']>;
};

export type CertificateAssetModel = {
  customFields?: Maybe<Scalars['JSON']>;
  fileId?: Maybe<Scalars['String']>;
  fileName: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  owner?: Maybe<Scalars['String']>;
  renewal?: Maybe<Scalars['String']>;
};

export type CertificateAssetSettingsInput = {
  customFields?: InputMaybe<Scalars['JSON']>;
  renewal?: InputMaybe<Scalars['JSON']>;
};

export type CertificateAssetSettingsModel = {
  customFields?: Maybe<Scalars['JSON']>;
  renewal?: Maybe<Scalars['JSON']>;
};

export type CertificateAssetsPaginationModel = {
  data: Array<CertificateAssetModel>;
  pageInfo: PageInfo;
};

export type ChangeFrameworkNameInput = {
  frameworkId: Scalars['String'];
  name: Scalars['String'];
};

export type ChangeFrameworkVisibilityInput = {
  frameworkId: Scalars['String'];
  visibility: Scalars['String'];
};

export type ChangeNameInput = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  publicId: Scalars['String'];
};

export type ChangePasswordInput = {
  newPass: Scalars['String'];
  oldPass: Scalars['String'];
  publicId: Scalars['String'];
};

export type ChangePasswordOutsideInput = {
  email: Scalars['String'];
  hash: Scalars['String'];
  password: Scalars['String'];
};

export type ChangeReviewControlModel = {
  controlId: Scalars['String'];
  reportId: Scalars['String'];
  reviewed: Scalars['Boolean'];
  workspaceId: Scalars['String'];
};

export type ChartIssuesDto = {
  date: Scalars['String'];
  high: Scalars['Float'];
  low: Scalars['Float'];
  medium: Scalars['Float'];
};

export type ChartRequestDto = {
  category: CategoryModel;
  issues: Array<ChartIssuesDto>;
};

export type CheckAliasModel = {
  alias: Scalars['String'];
  checkId: Scalars['String'];
};

export type CheckAliasModelInput = {
  alias: Scalars['String'];
  checkId: Scalars['String'];
};

export type CheckEmployeeCollaboratorDto = {
  collaborator?: Maybe<WorkspaceCollaboratorModel>;
  isEmployeeExist: Scalars['Boolean'];
};

export type Collaborator = {
  publicId: Scalars['String'];
  role: Scalars['String'];
};

export enum CollaboratorRole {
  RolePortalMember = 'ROLE_PORTAL_MEMBER',
  RoleSystemAdmin = 'ROLE_SYSTEM_ADMIN',
  RoleSystemAuthenticatedUser = 'ROLE_SYSTEM_AUTHENTICATED_USER',
  RoleWorkspaceAdmin = 'ROLE_WORKSPACE_ADMIN',
  RoleWorkspaceEditor = 'ROLE_WORKSPACE_EDITOR',
  RoleWorkspaceMember = 'ROLE_WORKSPACE_MEMBER',
  RoleWorkspaceOwner = 'ROLE_WORKSPACE_OWNER',
  RoleWorkspaceViewer = 'ROLE_WORKSPACE_VIEWER'
}

export type CollaboratorsForReleaseModel = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  publicId: Scalars['String'];
};

export type CollectionConfig = {
  alias: Scalars['String'];
  data: Array<Scalars['String']>;
  excludeFields: Array<Scalars['String']>;
  headers: Array<Scalars['String']>;
  mappingFieldsSchema: Array<TMappingFieldsSchema>;
  name: Scalars['String'];
  sortingField?: Maybe<Scalars['String']>;
};

export type CollectionConfigInput = {
  alias: Scalars['String'];
  data: Array<Scalars['String']>;
  excludeFields: Array<Scalars['String']>;
  headers: Array<Scalars['String']>;
  mappingFieldsSchema: Array<TMappingFieldsSchemaInput>;
  name: Scalars['String'];
  sortingField?: InputMaybe<Scalars['String']>;
};

export type CollectorEvidenceData = {
  controlId: Scalars['String'];
  controlName: Scalars['String'];
  evidenceId: Scalars['String'];
  evidenceName: Scalars['String'];
  frameworkId: Scalars['String'];
  frameworkName: Scalars['String'];
};

export type CollectorHistoryModel = {
  collectorId?: Maybe<Scalars['String']>;
  end?: Maybe<Scalars['String']>;
  errorReason?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  workspaceId?: Maybe<Scalars['String']>;
};

export type CollectorHistoryPaginationModel = {
  collector: ShortCollectorModel;
  evidences: Array<CollectorEvidenceData>;
  history: Array<CollectorHistoryModel>;
  pageInfo: PageInfo;
};

export type CollectorModel = {
  collection: Scalars['String'];
  createDate: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  evidence?: Maybe<EvidenceCollectorModel>;
  id: Scalars['String'];
  name: Scalars['String'];
  origin: Scalars['Boolean'];
  requiredApps?: Maybe<Array<Scalars['String']>>;
  stages: Array<CollectorStageModel>;
  trigger?: Maybe<CollectorTriggerModel>;
  visibility?: Maybe<Scalars['String']>;
  workspaceId?: Maybe<Scalars['String']>;
};

export type CollectorPaginationModel = {
  collectors: Array<CollectorModel>;
  pageInfo: PageInfo;
};

export type CollectorStageFilterModel = {
  filters: Scalars['JSON'];
};

export type CollectorStageMergeModel = {
  collection: Scalars['String'];
  filter?: Maybe<CollectorStageFilterModel>;
  project?: Maybe<CollectorStageProjectModel>;
  source: Scalars['String'];
};

export type CollectorStageModel = {
  filter?: Maybe<CollectorStageFilterModel>;
  merge?: Maybe<CollectorStageMergeModel>;
  project?: Maybe<CollectorStageProjectModel>;
  type: Scalars['String'];
};

export type CollectorStageProjectModel = {
  projects: Array<Scalars['String']>;
};

export type CollectorTriggerModel = {
  repeat: Scalars['Float'];
  start: Scalars['String'];
  type: Scalars['String'];
};

export type Comment = {
  author: IdNameLogoModel;
  controlId: Scalars['String'];
  date: Scalars['String'];
  frameworkId: Scalars['String'];
  id: Scalars['String'];
  text: Scalars['String'];
  workspaceId: Scalars['String'];
};

export type CommentsModel = {
  comments: Array<Comment>;
  pageInfo: PageInfo;
};

export type CommonFilterDto = {
  count?: InputMaybe<Scalars['Int']>;
  fieldName: FilterIndex;
  value: Scalars['String'];
};

export type Config = {
  accountMappingConfig: AccountMappingConfig;
  collectionConfigs: Array<CollectionConfig>;
  collectionPrefix: Scalars['String'];
};

export type ConfigInput = {
  accountsMappingSchema?: InputMaybe<Scalars['String']>;
  profilesMappingSchema: Array<ProfilesMappingSchemaInput>;
};

export type ConfigModel = {
  accountsMappingSchema?: Maybe<Scalars['String']>;
  profilesMappingSchema: Array<ProfilesMappingSchemaModel>;
};

export type ConfigResponse = {
  config: ConfigModel;
  configValues: ConfigValues;
};

export type ConfigTarget = {
  availableScanTypes: Array<Scalars['String']>;
};

export type ConfigValues = {
  accountsMappingSchema: Array<Scalars['String']>;
  profilesMappingSchema: Array<ProfilesMappingSchemaModel>;
};

export type ConflictExceptionInput = {
  account: Scalars['String'];
  active: Scalars['Boolean'];
  allowedDate: Scalars['String'];
  deniedBy?: InputMaybe<IdNameInput>;
  reason: Scalars['String'];
  resolution: Scalars['String'];
};

export type ConflictExceptionModel = {
  account: Scalars['String'];
  active: Scalars['Boolean'];
  allowedDate: Scalars['String'];
  deniedBy?: Maybe<IdNameModel>;
  reason: Scalars['String'];
  resolution: Scalars['String'];
};

export type ConflictRecipientInput = {
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  publicId?: InputMaybe<Scalars['ID']>;
};

export type ConflictRecipientModel = {
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  publicId?: Maybe<Scalars['ID']>;
};

export type ConnectionTypeFilter = {
  connectionType?: Maybe<Array<Scalars['String']>>;
};

export type ConsentGrantDetailsFilter = {
  consentGrantDetails?: Maybe<Array<Scalars['String']>>;
};

export type ContactPersonInput = {
  email: Scalars['String'];
  name: Scalars['String'];
  phone: Scalars['String'];
};

export type ContactPersonModel = {
  email: Scalars['String'];
  name: Scalars['String'];
  phone: Scalars['String'];
};

export type ControlGroupModel = {
  controls: Array<FrameworkControlModel>;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type ControlInput = {
  category: Scalars['String'];
  description: Array<Scalars['String']>;
  frameworkId?: InputMaybe<Scalars['String']>;
  group: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  organizationId: Scalars['String'];
  origin: Scalars['Boolean'];
  visibility: Scalars['String'];
};

export type ControlResponseModel = {
  frameworkInfo: FrameworkInfoModel;
  groupWithControl?: Maybe<ControlGroupModel>;
};

export type ControlsEvidencesShortModel = {
  evidences: Array<IdNameModel>;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type ControlsWithFilterModel = {
  controls: Array<BuilderControlModel>;
  pageInfo: PageInfo;
};

export type CorrectiveActionInput = {
  authorPublicId: Scalars['String'];
  description: Scalars['String'];
  proposedCompletionDate?: InputMaybe<Scalars['String']>;
};

export type CorrectiveActionModel = {
  authorPublicId: Scalars['String'];
  description: Scalars['String'];
  proposedCompletionDate?: Maybe<Scalars['String']>;
};

export type CountryFieldModel = {
  fieldKey: Scalars['String'];
  fieldLabel: Scalars['String'];
  fieldPlaceholder?: Maybe<Scalars['String']>;
};

export type CountryModel = {
  code: Scalars['String'];
  fields?: Maybe<Array<CountryFieldModel>>;
  name: Scalars['String'];
};

export type CoverImageModel = {
  id: Scalars['String'];
  image: Scalars['String'];
  thumbnail: Scalars['String'];
  type: MainCoverImageType;
};

export type CreateAccessManagementAppByVendorInput = {
  name: Scalars['String'];
  vendorId: Scalars['String'];
};

export type CreateAccountByInviteDto = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  invitationCode: Scalars['String'];
  lastName: Scalars['String'];
  license: Scalars['Boolean'];
  organizationName: Scalars['String'];
  password: Scalars['String'];
};

export type CreateJobTitleInput = {
  description: Scalars['String'];
  jobType: Scalars['String'];
  name: Scalars['String'];
  requirements: Scalars['String'];
};

export type CreateNewAccessManagementAppInput = {
  name: Scalars['String'];
  owner: IdNameInput;
  providedService: Scalars['String'];
  riskLevel: Scalars['String'];
  type: Scalars['String'];
};

export type CreateNewDocumentDto = {
  approvers: Array<DocApproverCreateInput>;
  data?: InputMaybe<NewDocDataInput>;
  editors?: InputMaybe<Array<NewDocumentActorInput>>;
  folderId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  recipients: Array<RecipientInput>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  workspaceId: Scalars['String'];
};

export type CreateOrganizationBillingInfoInput = {
  additionalBillingInfo: Scalars['JSON'];
  billingPrimaryInfo: BillingPrimaryInfoInput;
  collaboratorsCount: Scalars['Float'];
  isVat: Scalars['Boolean'];
  period: Scalars['String'];
};

export type CreateOrganizationConfigurationDto = {
  availableCollaboratorsCount: Scalars['Float'];
  availableWizards: Array<Scalars['String']>;
  availableWorkspaceCount: Scalars['Float'];
};

export type CreateOrganizationDetailsDto = {
  address: Scalars['String'];
  country: Scalars['String'];
  howBigIsCompany: Scalars['String'];
  howMuchBranches: Scalars['String'];
  isSingleBranch: Scalars['String'];
  offsetWidth: Scalars['String'];
  providingServices: Array<Scalars['String']>;
  website: Scalars['String'];
};

export type CreateOrganizationDto = {
  configuration: CreateOrganizationConfigurationDto;
  licenseCode?: InputMaybe<Scalars['String']>;
  logo: Scalars['String'];
  name: Scalars['String'];
  organizationDetails: CreateOrganizationDetailsDto;
  subscription: Scalars['String'];
};

export type CreateOrganizationResponseModel = {
  organization: NewOrganizationModel;
  workspace: NewWorkspaceModel;
};

export type CreateTargetDto = {
  fields: Array<TKycTemplateFieldFillableModelInput>;
  templateId: Scalars['String'];
};

export type CreateTargetExceptionDto = {
  checkId: Scalars['String'];
  entityCaption: Scalars['String'];
  entityId: Scalars['String'];
  limited: Scalars['Boolean'];
  reason?: InputMaybe<Scalars['String']>;
  score: Scalars['Float'];
  screeningId: Scalars['String'];
  targetId: Scalars['String'];
  till?: InputMaybe<Scalars['String']>;
};

export type CreateTargetInput = {
  configTarget: ConfigTargetInput;
  name: Scalars['String'];
  target: Scalars['String'];
};

export type CreateWcMapperInput = {
  active: Scalars['Boolean'];
  appIntegrations: Array<Scalars['String']>;
  collectorId: Scalars['String'];
  evidence: EvidenceWcMapperInput;
  id?: InputMaybe<Scalars['String']>;
  origin: Scalars['Boolean'];
  trigger: TriggerInput;
  workspaceId: Scalars['String'];
};

export type CrownJewel = {
  appCrownJewels: Array<ApplicationCrownJewels>;
  color: Scalars['String'];
  createdDate: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type CrownJewelsFilterModel = ApplicationFilter | AssetFilter | GroupFilter | NameFilter | PrivilegeFilter;

export type CrownJewelsFiltersInput = {
  application?: InputMaybe<Array<Scalars['String']>>;
  asset?: InputMaybe<Array<Scalars['String']>>;
  groupRole?: InputMaybe<Array<Scalars['String']>>;
  name?: InputMaybe<Array<Scalars['String']>>;
  privilege?: InputMaybe<Array<Scalars['String']>>;
};

export type CrownJewelsInput = {
  filter: CrownJewelsFiltersInput;
  pageInfo: SharedPaginationInput;
};

export type CrownJewelsResponse = {
  data: Array<CrownJewel>;
  pageInfo: PageInfo;
};

export type CurrentTearModel = {
  discountPercentage?: Maybe<Scalars['Float']>;
  items: Array<ItemModel>;
  variant: Scalars['String'];
  vatPercentage?: Maybe<Scalars['Float']>;
};

export type CustomerModel = {
  active: Scalars['Boolean'];
  blockedReason?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastLoggedDate?: Maybe<Scalars['String']>;
  lastName: Scalars['String'];
  organizationName?: Maybe<Scalars['String']>;
  publicId: Scalars['String'];
  status: Scalars['String'];
};

export type DataForAllowedConflictModel = {
  conflictException?: Maybe<ConflictExceptionModel>;
};

export type DataForCreateDutyModel = {
  shortApplications: Array<DutyApplicationModel>;
};

export type DataForCreateJobTitleByAdmin = {
  jobTypeVariants: Array<Scalars['String']>;
};

export type DataForCreateRuleModel = {
  duties: Array<IdNameModel>;
};

export type DataForDenyConflictModel = {
  collaborators: Array<CollaboratorsForReleaseModel>;
};

export type DataInput = {
  editor?: InputMaybe<Scalars['JSON']>;
  innerHtml?: InputMaybe<Scalars['String']>;
  variables?: InputMaybe<Array<DataVariableModelInput>>;
};

export type DataModel = {
  config?: Maybe<PageModel>;
  editor?: Maybe<Scalars['JSON']>;
  innerHtml?: Maybe<Scalars['String']>;
  variables?: Maybe<Array<DataVariableModel>>;
};

export type DataModelInput = {
  config?: InputMaybe<PageModelInput>;
  editor?: InputMaybe<Scalars['JSON']>;
  innerHtml?: InputMaybe<Scalars['String']>;
  variables?: InputMaybe<Array<DataVariableModelInput>>;
};

export type DataVariableModel = {
  description?: Maybe<Scalars['String']>;
  format?: Maybe<Scalars['String']>;
  key: Scalars['String'];
  order: Scalars['Float'];
  title: Scalars['String'];
  type: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type DataVariableModelInput = {
  description?: InputMaybe<Scalars['String']>;
  format?: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
  order: Scalars['Float'];
  title: Scalars['String'];
  type: Scalars['String'];
  value?: InputMaybe<Scalars['String']>;
};

export type DateRangeFilter = {
  dateRange?: Maybe<Array<Scalars['String']>>;
};

export type DelegatedTaskInput = {
  controlId?: InputMaybe<Scalars['String']>;
  createdDate: Scalars['String'];
  data?: InputMaybe<FrameworksDelegatedTaskDataInput>;
  description: Scalars['String'];
  evidenceId?: InputMaybe<Scalars['String']>;
  frameworkId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  performDate?: InputMaybe<Scalars['String']>;
  performer: FrameworksDelegatedTaskCollaboratorInput;
  performerComment?: InputMaybe<Scalars['String']>;
  requestor: FrameworksDelegatedTaskCollaboratorInput;
  requestorComment: Scalars['String'];
  resolveDate?: InputMaybe<Scalars['String']>;
  resolver?: InputMaybe<FrameworksDelegatedTaskCollaboratorInput>;
  resolverComment?: InputMaybe<Scalars['String']>;
  source: DelegatedTaskSources;
  status: FrameworksDelegatedTaskStatus;
  title: Scalars['String'];
  type: FrameworksDelegatedTaskType;
  vicaStepId?: InputMaybe<Scalars['String']>;
  workspaceId: Scalars['String'];
};

export type DelegatedTaskModel = {
  controlId?: Maybe<Scalars['String']>;
  createdDate: Scalars['String'];
  data?: Maybe<FrameworksDelegatedTaskDataModel>;
  description: Scalars['String'];
  evidenceId?: Maybe<Scalars['String']>;
  frameworkId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  performDate?: Maybe<Scalars['String']>;
  performer: FrameworksDelegatedTaskCollaboratorModel;
  performerComment?: Maybe<Scalars['String']>;
  requestor: FrameworksDelegatedTaskCollaboratorModel;
  requestorComment: Scalars['String'];
  resolveDate?: Maybe<Scalars['String']>;
  resolver?: Maybe<FrameworksDelegatedTaskCollaboratorModel>;
  resolverComment?: Maybe<Scalars['String']>;
  source: DelegatedTaskSources;
  status: FrameworksDelegatedTaskStatus;
  title: Scalars['String'];
  type: FrameworksDelegatedTaskType;
  vicaStepId?: Maybe<Scalars['String']>;
  workspaceId: Scalars['String'];
};

export enum DelegatedTaskSources {
  FrameworkModule = 'FRAMEWORK_MODULE',
  VicaModule = 'VICA_MODULE'
}

export type DeleteAllFilesInput = {
  fileIds: Array<Scalars['String']>;
};

export type DeleteIntegrationInput = {
  appId: Scalars['String'];
  endpointMappingName: Scalars['String'];
};

export type DetailsModel = {
  account: Scalars['String'];
  identity?: Maybe<Scalars['String']>;
  role: Scalars['String'];
  status?: Maybe<Scalars['String']>;
};

export type DeviceIdentityModel = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export type DeviceModel = {
  additional: Array<NameStatusModel>;
  cj: Array<IdNameLogoModel>;
  deviceType: Scalars['String'];
  hostname: Scalars['String'];
  id: Scalars['String'];
  identity: DeviceIdentityModel;
  lastEvent: Scalars['String'];
  name: Scalars['String'];
  origin: Array<IdNameLogoModel>;
  osType: Scalars['String'];
};

export type DevicesFilterModel = ApplicationFilter | DateRangeFilter | EmailFilter | NameFilter | TypeFilter;

export type DevicesResponseModel = {
  devices: Array<DeviceModel>;
  pageInfo: PageInfo;
};

export type DialogFramworkModel = {
  added: Scalars['Boolean'];
  color?: Maybe<Scalars['String']>;
  createdBy: Scalars['String'];
  id: Scalars['String'];
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  progress: Scalars['Float'];
};

export type DiscoverySourceFilter = {
  discoverySource?: Maybe<Array<Scalars['String']>>;
};

export type DiscoveryStatusFilter = {
  discoveryStatus?: Maybe<Array<Scalars['String']>>;
};

export type DocApproverCreateGroupsInput = {
  actors: Array<NewDocumentActorInput>;
  isRequired: Scalars['Boolean'];
  message: Scalars['String'];
  name: Scalars['String'];
};

export type DocApproverCreateInput = {
  eta: Scalars['Float'];
  groups: Array<DocApproverCreateGroupsInput>;
  order: Scalars['Float'];
};

export type DocApproverGroupsInput = {
  actors: Array<NewDocumentActorInput>;
  id?: InputMaybe<Scalars['String']>;
  isRequired: Scalars['Boolean'];
  message?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type DocApproverGroupsModel = {
  actors: Array<NewDocumentActorModel>;
  id?: Maybe<Scalars['String']>;
  isRequired: Scalars['Boolean'];
  message?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type DocApproverInput = {
  eta: Scalars['Float'];
  groups: Array<DocApproverGroupsInput>;
  id?: InputMaybe<Scalars['String']>;
  order: Scalars['Float'];
};

export type DocApproverModel = {
  eta: Scalars['Float'];
  groups: Array<DocApproverGroupsModel>;
  id?: Maybe<Scalars['String']>;
  order: Scalars['Float'];
};

export type DocumentExecutorActorActionModel = {
  date: Scalars['String'];
  type: Scalars['String'];
};

export type DocumentExecutorActorModel = {
  actions: Array<DocumentExecutorActorActionModel>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

export type DocumentExecutorGroupModel = {
  actors: Array<DocumentExecutorActorModel>;
  id: Scalars['String'];
  isRequired: Scalars['Boolean'];
  performedByEmail?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export type DocumentExecutorModel = {
  approveSteps: Array<DocumentExecutorStepModel>;
  currentStepId: Scalars['String'];
  documentId: Scalars['String'];
  documentVersionId: Scalars['String'];
  id: Scalars['String'];
  recipientSteps: Array<DocumentExecutorStepModel>;
  sender: Scalars['String'];
  startDate: Scalars['String'];
  status: Scalars['String'];
  workspaceId: Scalars['String'];
};

export type DocumentExecutorRecipientActionDataModel = {
  fieldId: Scalars['String'];
  value: Scalars['String'];
};

export type DocumentExecutorRecipientActionModel = {
  data?: Maybe<DocumentExecutorRecipientActionDataModel>;
  date: Scalars['String'];
  type: Scalars['String'];
};

export type DocumentExecutorRecipientModel = {
  actions: Array<DocumentExecutorRecipientActionModel>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  status: Scalars['String'];
};

export type DocumentExecutorStepModel = {
  endDate?: Maybe<Scalars['String']>;
  eta: Scalars['Float'];
  groups?: Maybe<Array<DocumentExecutorGroupModel>>;
  id: Scalars['String'];
  recipients?: Maybe<Array<DocumentExecutorRecipientModel>>;
  startDate?: Maybe<Scalars['String']>;
};

export type DocumentInput = {
  links: Array<DocumentLinkInput>;
  type: Scalars['String'];
};

export type DocumentLinkInput = {
  fileName: Scalars['String'];
  lastUpdate: Scalars['String'];
  link: Scalars['String'];
  policyId?: InputMaybe<Scalars['String']>;
};

export type DocumentLinkModel = {
  fileName: Scalars['String'];
  lastUpdate: Scalars['String'];
  link: Scalars['String'];
  policyId?: Maybe<Scalars['String']>;
};

export type DocumentModel = {
  links: Array<DocumentLinkModel>;
  type: Scalars['String'];
};

export type DownloadFileModel = {
  file: Scalars['String'];
  filename: Scalars['String'];
  filetype: Scalars['String'];
};

export type DutyApplicationInput = {
  applicationAccessId: Scalars['ID'];
  applicationId?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  type: Scalars['String'];
};

export type DutyApplicationModel = {
  applicationAccessId: Scalars['ID'];
  applicationId?: Maybe<Scalars['ID']>;
  name: Scalars['String'];
  type: Scalars['String'];
};

export type DutyInput = {
  application: DutyApplicationInput;
  category: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  roles: Array<DutyRoleInput>;
};

export type DutyModel = {
  application: DutyApplicationModel;
  category: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  roles: Array<DutyRoleModel>;
};

export type DutyRoleInput = {
  permissions?: InputMaybe<Array<Scalars['String']>>;
  role: Scalars['String'];
};

export type DutyRoleModel = {
  permissions?: Maybe<Array<Scalars['String']>>;
  role: Scalars['String'];
};

export type DutyRuleInput = {
  active: Scalars['Boolean'];
  conflictExceptions?: InputMaybe<Array<ConflictExceptionInput>>;
  firstDuty: IdNameInput;
  id: Scalars['ID'];
  name: Scalars['String'];
  secondDuty: IdNameInput;
  securityMitigation?: InputMaybe<Scalars['String']>;
  securityRisk?: InputMaybe<Scalars['String']>;
  severityLevel: Scalars['String'];
};

export type DutyRuleModel = {
  active: Scalars['Boolean'];
  conflictExceptions?: Maybe<Array<ConflictExceptionModel>>;
  firstDuty: IdNameModel;
  id: Scalars['ID'];
  name: Scalars['String'];
  secondDuty: IdNameModel;
  securityMitigation?: Maybe<Scalars['String']>;
  securityRisk?: Maybe<Scalars['String']>;
  severityLevel: Scalars['String'];
};

export type EditControlInput = {
  category: Scalars['String'];
  description: Array<Scalars['String']>;
  evidences?: InputMaybe<Array<EvidenceInput>>;
  foundInFrameworksCounter?: InputMaybe<Scalars['Float']>;
  group: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  organizationId?: InputMaybe<Scalars['String']>;
  origin: Scalars['Boolean'];
  visibility: Scalars['String'];
};

export type EditableHtmlInput = {
  id: Scalars['String'];
  innerHTML?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type EditableHtmlModel = {
  id: Scalars['String'];
  innerHTML?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type Editor = {
  avatar?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

export type EmailFilter = {
  email?: Maybe<Array<Scalars['String']>>;
};

export type EmailInput = {
  email: Scalars['String'];
};

export type EmailNameInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

export type EmailNameModel = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

export type EmployeeForReleaseModel = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

export type EtaConfigInput = {
  etaExecution: Scalars['Float'];
  etaManager: Scalars['Float'];
  etaSign: Scalars['Float'];
  etaVendor: Scalars['Float'];
  etaVerify: Scalars['Float'];
};

export type EtaConfigModel = {
  etaExecution: Scalars['Float'];
  etaManager: Scalars['Float'];
  etaSign: Scalars['Float'];
  etaVendor: Scalars['Float'];
  etaVerify: Scalars['Float'];
};

export type EventModel = {
  name: Scalars['String'];
  parameters: Array<EventParameterModel>;
  type: Scalars['String'];
};

export type EventNameFilter = {
  eventName?: Maybe<Array<Scalars['String']>>;
};

export type EventParameterModel = {
  name: Scalars['String'];
  value: Scalars['String'];
};

export type EvidenceAssetInputDto = {
  data: Scalars['JSON'];
  evidenceId: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
  workspaceId: Scalars['String'];
};

export type EvidenceAssetModel = {
  data: Scalars['JSON'];
  id: Scalars['String'];
  lastUpdate: Scalars['String'];
  type: Scalars['String'];
};

export type EvidenceAssetNewModel = {
  data: Scalars['JSON'];
  evidenceId: Scalars['String'];
  id: Scalars['String'];
  lastUpdate: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type EvidenceAssetSmallModel = {
  active: Scalars['Boolean'];
  data: Scalars['JSON'];
  id: Scalars['String'];
  type: Scalars['String'];
  uploadDate: Scalars['String'];
};

export type EvidenceAssetsModel = {
  assetId: Scalars['String'];
  fileName: Scalars['String'];
};

export type EvidenceAssetsModelInput = {
  assetId: Scalars['String'];
  fileName: Scalars['String'];
};

export type EvidenceAssetsNcrInput = {
  fileData: Scalars['String'];
  fileName: Scalars['String'];
};

export type EvidenceAutoFileDto = {
  data?: Maybe<Scalars['JSON']>;
  evidenceId: Scalars['String'];
  id: Scalars['String'];
  lastCollected?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  tableFields: Array<Scalars['String']>;
  type: Scalars['String'];
};

export type EvidenceAutoFileDtoPagination = {
  data?: Maybe<Scalars['JSON']>;
  evidenceId: Scalars['String'];
  id: Scalars['String'];
  lastCollected?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  pageInfo: PageInfo;
  tableFields: Array<Scalars['String']>;
  type: Scalars['String'];
};

export type EvidenceCollectorDataModel = {
  controlId?: Maybe<Scalars['String']>;
  frameworkId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type EvidenceCollectorModel = {
  data: Array<EvidenceCollectorDataModel>;
  type: Scalars['String'];
};

export type EvidenceCountModel = {
  ids: Array<Scalars['String']>;
  total: Scalars['Float'];
};

export type EvidenceFileDto = {
  dateCollected: Scalars['String'];
  id: Scalars['String'];
  monitoring: Scalars['Float'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type EvidenceInput = {
  categories: Array<Scalars['String']>;
  collectorId?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  foundInControlsCounter?: InputMaybe<Scalars['Float']>;
  id: Scalars['String'];
  name: Scalars['String'];
  organizationId?: InputMaybe<Scalars['String']>;
  origin: Scalars['Boolean'];
  visibility: Scalars['String'];
};

export type EvidenceManualFileDto = {
  data?: Maybe<Scalars['JSON']>;
  id: Scalars['String'];
  lastCollected?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  type: Scalars['String'];
};

export type EvidenceModel = {
  category: Scalars['String'];
  description: Scalars['String'];
  evidences: EvidencesFilesDto;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type EvidenceNodeInput = {
  data: Array<AutomationSaveEvidenceDto>;
  type: Scalars['String'];
};

export type EvidenceNodeModel = {
  data: Array<AutomationSaveEvidenceModel>;
  type: Scalars['String'];
};

export type EvidenceResponseModel = {
  evidences: Array<EvidenceSoloModel>;
  pageInfo: PageInfo;
};

export type EvidenceSoloModel = {
  application: Array<IdNameLogoModel>;
  basic: Scalars['Boolean'];
  description: Scalars['String'];
  files: Array<EvidenceFileDto>;
  frameworks: Array<IdNameLogoModel>;
  historyDate: Scalars['String'];
  id: Scalars['ID'];
  isAutomatic: Scalars['Boolean'];
  lastCollected: Scalars['String'];
  name: Scalars['String'];
  tables: Array<EvidenceTableDto>;
};

export type EvidenceTableDto = {
  data: Scalars['JSON'];
  dateCollected: Scalars['String'];
  id: Scalars['String'];
  monitoring: Scalars['Float'];
  type: Scalars['String'];
};

export type EvidenceVicaStepModel = {
  stepId: Scalars['String'];
  stepName: Scalars['String'];
};

export type EvidenceWcMapperInput = {
  data: Array<AutomationSaveEvidenceDto>;
  type: Scalars['String'];
};

export type EvidenceWithNameInput = {
  controlId: Scalars['String'];
  controlName?: InputMaybe<Scalars['String']>;
  evidenceId: Scalars['String'];
  evidenceName?: InputMaybe<Scalars['String']>;
  frameworkId: Scalars['String'];
  frameworkName?: InputMaybe<Scalars['String']>;
};

export type EvidenceWithNameModel = {
  controlId: Scalars['String'];
  controlName?: Maybe<Scalars['String']>;
  evidenceId: Scalars['String'];
  evidenceName?: Maybe<Scalars['String']>;
  frameworkId: Scalars['String'];
  frameworkName?: Maybe<Scalars['String']>;
};

export type EvidencesFilesDto = {
  automatically: Array<EvidenceAutoFileDto>;
  manual: Array<EvidenceManualFileDto>;
};

export type EvidencesFilterModel = DateRangeFilter | FrameworkFilter | MonitoringFilter | NameFilter;

export type EvidencesRow = {
  evidenceAssets: Array<EvidenceAssetModel>;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type EvidencesWithFilterModel = {
  evidences: Array<BuilderEvidenceModel>;
  pageInfo: PageInfo;
};

export type ExportCsvFieldInput = {
  fieldKey: Scalars['String'];
  fieldTitle: Scalars['String'];
};

export type ExportCsvFieldModel = {
  fieldKey: Scalars['String'];
  fieldTitle: Scalars['String'];
};

export type ExportEmployeesCsvInputDto = {
  columnConfig: Array<Scalars['String']>;
  filters?: InputMaybe<Scalars['JSON']>;
  search: Scalars['String'];
};

export type ExtendedAggregationDeviceModel = {
  id: Scalars['String'];
  identity: DeviceIdentityModel;
  lastSeen: Scalars['String'];
  model: Scalars['String'];
  name: Scalars['String'];
  origin: Array<IdNameLogoModel>;
  os: Scalars['String'];
  profiles: Array<Scalars['String']>;
  serialNumber: Scalars['String'];
  sourceInfo: Array<SourceInfoDeviceModel>;
  type: Scalars['String'];
};

export type ExtendedAppInfo = {
  availableOptions: AvailableOptions;
  certifications: Array<Scalars['String']>;
  description: Scalars['String'];
  detailsId: Scalars['String'];
  documentationLink: Scalars['String'];
  endpointMappingName: Scalars['String'];
  id: Scalars['String'];
  logo: Scalars['String'];
  name: Scalars['String'];
  originalName?: Maybe<Scalars['String']>;
  releaseDate?: Maybe<Scalars['String']>;
  securityScope: Scalars['String'];
  status: Scalars['String'];
  type: Scalars['String'];
};

export type ExtendedLicenseInput = {
  availableCollaborators: Scalars['Float'];
  availableTargetsVulnerabilityScan?: InputMaybe<Scalars['Float']>;
  availableWorkspaces: Scalars['Float'];
  collaboratorRules: Array<AdminOrganizationCollabRuleInput>;
  createdDate: Scalars['String'];
  creatorDetails: CreatorDetailsInput;
  creatorId: Scalars['String'];
  expiry: Scalars['Float'];
  expiryUnit: Scalars['String'];
  id: Scalars['String'];
  issued: Scalars['Boolean'];
  issuedDetails?: InputMaybe<LicenseIssuedDetailsInput>;
  notes: Scalars['String'];
  subscription: Scalars['String'];
  used: Scalars['Boolean'];
  usedDetails?: InputMaybe<LicenseUsedByInput>;
  wizardId: Array<Scalars['String']>;
  workspaces: Array<LicenseWorkspaceSetupInput>;
};

export type ExtendedLicenseModel = {
  availableCollaborators: Scalars['Float'];
  availableTargetsVulnerabilityScan?: Maybe<Scalars['Float']>;
  availableWorkspaces: Scalars['Float'];
  collaboratorRules: Array<AdminOrganizationCollabRule>;
  createdDate: Scalars['String'];
  creatorDetails: CreatorDetails;
  creatorId: Scalars['String'];
  expiry: Scalars['Float'];
  expiryUnit: Scalars['String'];
  id: Scalars['String'];
  issued: Scalars['Boolean'];
  issuedDetails?: Maybe<LicenseIssuedDetailsModel>;
  notes: Scalars['String'];
  subscription: Scalars['String'];
  used: Scalars['Boolean'];
  usedDetails?: Maybe<LicenseUsedByModel>;
  wizardId: Array<Scalars['String']>;
  workspaces: Array<LicenseWorkspaceSetupModel>;
};

export type FieldIdValueDto = {
  fieldId: Scalars['String'];
  value: Scalars['String'];
};

export type FileIdDto = {
  fileId: Scalars['String'];
};

export type FileIdFileNameModelInput = {
  fileId: Scalars['String'];
  fileName: Scalars['String'];
};

export type FileModel = {
  accessRules?: Maybe<Array<RuleModel>>;
  automationId?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['String']>;
  creatorId?: Maybe<Scalars['String']>;
  data?: Maybe<DataModel>;
  description?: Maybe<Scalars['String']>;
  documentId?: Maybe<Scalars['String']>;
  editorId?: Maybe<Scalars['String']>;
  folderId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastEditDate?: Maybe<Scalars['String']>;
  latest?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  origin?: Maybe<Scalars['Boolean']>;
  parentId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  type: Scalars['String'];
  version?: Maybe<Scalars['Float']>;
  visible?: Maybe<Scalars['Boolean']>;
  workspaceId?: Maybe<Scalars['String']>;
};

export type FilePolicyInput = {
  file: Scalars['String'];
  name: Scalars['String'];
};

export type FilesPolicyInput = {
  editableTemplates: Array<EditableHtmlInput>;
  templates: Array<FilePolicyInput>;
};

export type Filter = {
  name: Scalars['String'];
  values: Array<Scalars['String']>;
};

export enum FilterIndex {
  AccessDetails = 'accessDetails',
  Account = 'account',
  Accounts = 'accounts',
  Active = 'active',
  ActiveStatus = 'activeStatus',
  ActorCallerType = 'actorCallerType',
  ActorEmail = 'actorEmail',
  ActorKey = 'actorKey',
  ActorPublicId = 'actorPublicId',
  AppName = 'appName',
  Application = 'application',
  Asset = 'asset',
  Assigment = 'assigment',
  Category = 'category',
  Condition = 'condition',
  ConnectionType = 'connectionType',
  ConsentGrantDetails = 'consentGrantDetails',
  Control = 'control',
  DateRange = 'dateRange',
  Details = 'details',
  Device = 'device',
  DiscoveryName = 'discoveryName',
  DiscoverySource = 'discoverySource',
  DiscoveryStatus = 'discoveryStatus',
  Email = 'email',
  EventName = 'eventName',
  EventType = 'eventType',
  Framework = 'framework',
  FrameworksName = 'frameworksName',
  Group = 'group',
  Hardware = 'hardware',
  Id = 'id',
  Identity = 'identity',
  IssueSeverity = 'issueSeverity',
  Item = 'item',
  LastEvent = 'lastEvent',
  Monitoring = 'monitoring',
  Name = 'name',
  OrganizationId = 'organizationId',
  Origin = 'origin',
  Os = 'os',
  PostureName = 'postureName',
  Privilege = 'privilege',
  Profile = 'profile',
  PublicId = 'publicId',
  Rating = 'rating',
  Region = 'region',
  Requestor = 'requestor',
  Role = 'role',
  Severity = 'severity',
  Status = 'status',
  Subscription = 'subscription',
  Target = 'target',
  Type = 'type',
  User = 'user',
  Value = 'value',
  WorkspaceId = 'workspaceId'
}

export type FilterInput = {
  accountId?: InputMaybe<Array<Scalars['String']>>;
  active?: InputMaybe<Array<Scalars['String']>>;
  actorCallerType?: InputMaybe<Array<Scalars['String']>>;
  actorEmail?: InputMaybe<Array<Scalars['String']>>;
  appName?: InputMaybe<Array<Scalars['String']>>;
  application?: InputMaybe<Array<Scalars['String']>>;
  applicationId?: InputMaybe<Array<Scalars['String']>>;
  archived?: InputMaybe<Array<Scalars['String']>>;
  asset?: InputMaybe<Array<Scalars['String']>>;
  assetId?: InputMaybe<Array<Scalars['String']>>;
  assignment?: InputMaybe<Array<Scalars['String']>>;
  blocked?: InputMaybe<Array<Scalars['String']>>;
  category?: InputMaybe<Array<Scalars['String']>>;
  control?: InputMaybe<Array<Scalars['String']>>;
  controlId?: InputMaybe<Array<Scalars['String']>>;
  created?: InputMaybe<Array<Scalars['String']>>;
  dateFrom?: InputMaybe<Array<Scalars['String']>>;
  dateRange?: InputMaybe<Array<Scalars['String']>>;
  dateTo?: InputMaybe<Array<Scalars['String']>>;
  deletedDate?: InputMaybe<Array<Scalars['String']>>;
  department?: InputMaybe<Array<Scalars['String']>>;
  email?: InputMaybe<Array<Scalars['String']>>;
  eventName?: InputMaybe<Array<Scalars['String']>>;
  evidenceId?: InputMaybe<Array<Scalars['String']>>;
  expired?: InputMaybe<Array<Scalars['String']>>;
  expiredOn?: InputMaybe<Array<Scalars['String']>>;
  filled?: InputMaybe<Array<Scalars['String']>>;
  framework?: InputMaybe<Array<Scalars['String']>>;
  group?: InputMaybe<Array<Scalars['String']>>;
  hardware?: InputMaybe<Array<Scalars['String']>>;
  hardwareId?: InputMaybe<Array<Scalars['String']>>;
  hasFiles?: InputMaybe<Array<Scalars['String']>>;
  hash?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Array<Scalars['String']>>;
  identity?: InputMaybe<Array<Scalars['String']>>;
  input?: InputMaybe<Array<Scalars['String']>>;
  issueSeverity?: InputMaybe<Array<Scalars['String']>>;
  issued?: InputMaybe<Array<Scalars['String']>>;
  jobTitle?: InputMaybe<Array<Scalars['String']>>;
  lastModified?: InputMaybe<Array<Scalars['String']>>;
  lastRun?: InputMaybe<Array<Scalars['String']>>;
  mfa?: InputMaybe<Array<Scalars['String']>>;
  model?: InputMaybe<Array<Scalars['String']>>;
  monitoring?: InputMaybe<Array<Scalars['String']>>;
  name?: InputMaybe<Array<Scalars['String']>>;
  nameLike?: InputMaybe<Array<Scalars['String']>>;
  notAnalysed?: InputMaybe<Array<Scalars['String']>>;
  organizationId?: InputMaybe<Array<Scalars['String']>>;
  origin?: InputMaybe<Array<Scalars['Boolean']>>;
  os?: InputMaybe<Array<Scalars['String']>>;
  privilege?: InputMaybe<Array<Scalars['String']>>;
  privilegeId?: InputMaybe<Array<Scalars['String']>>;
  publicId?: InputMaybe<Array<Scalars['String']>>;
  rating?: InputMaybe<Array<Scalars['String']>>;
  recipients?: InputMaybe<Array<Scalars['String']>>;
  regexName?: InputMaybe<Array<Scalars['String']>>;
  regexNameOrId?: InputMaybe<Array<Scalars['String']>>;
  region?: InputMaybe<Array<Scalars['String']>>;
  reviewed?: InputMaybe<Array<Scalars['String']>>;
  risk?: InputMaybe<Array<Scalars['String']>>;
  riskRegisterId?: InputMaybe<Array<Scalars['String']>>;
  role?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  severity?: InputMaybe<Array<Scalars['String']>>;
  severityLevel?: InputMaybe<Array<Scalars['String']>>;
  softwareId?: InputMaybe<Array<Scalars['String']>>;
  status?: InputMaybe<Array<Scalars['String']>>;
  subscription?: InputMaybe<Array<Scalars['String']>>;
  tag?: InputMaybe<Array<Scalars['String']>>;
  target?: InputMaybe<Array<Scalars['String']>>;
  type?: InputMaybe<Array<Scalars['String']>>;
  used?: InputMaybe<Array<Scalars['String']>>;
  visibility?: InputMaybe<Array<Scalars['String']>>;
  withNcr?: InputMaybe<Array<Scalars['String']>>;
  workspaceId?: InputMaybe<Array<Scalars['String']>>;
};

export type FinishTrainingSectionResponseModel = {
  duration: Scalars['Float'];
  nextSection?: Maybe<Scalars['String']>;
  readyToFinish: Scalars['Boolean'];
};

export type FolderModel = {
  children: Array<FolderModel>;
  id: Scalars['String'];
  lastEditDate: Scalars['String'];
  name: Scalars['String'];
};

export type FrameworkControlModel = {
  assignments: Array<IdNameLogoModel>;
  category: Scalars['String'];
  description: Array<Scalars['String']>;
  evidenceCollected: Array<Scalars['String']>;
  evidenceRequired: Array<Scalars['String']>;
  evidences: Array<EvidenceModel>;
  frameworks: Array<IdNameLogoModel>;
  id: Scalars['String'];
  name: Scalars['String'];
  status: Scalars['String'];
};

export type FrameworkControlsCountDto = {
  complete: Scalars['Float'];
  disabled: Scalars['Float'];
  inProgress: Scalars['Float'];
};

export type FrameworkFilter = {
  framework?: Maybe<Array<Scalars['String']>>;
};

export type FrameworkInfoModel = {
  controlsCount: Scalars['Float'];
  description: Scalars['String'];
  evidence: EvidenceCountModel;
  id: Scalars['String'];
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  origin: Scalars['String'];
  type?: Maybe<Scalars['String']>;
  wfId: Scalars['String'];
};

export type FrameworkModel = {
  auditPercent: Scalars['Float'];
  controlsCount: Scalars['Float'];
  evidence: EvidenceCountModel;
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  origin: Scalars['String'];
  wfId: Scalars['String'];
};

export type FrameworkMonitoringModel = {
  frameworkId: Scalars['String'];
  frameworkName: Scalars['String'];
  logo?: Maybe<Scalars['String']>;
};

export type FrameworkOverviewModel1 = {
  applications: Array<IdNameLogoModel>;
  controls: FrameworkControlsCountDto;
  evidence: Scalars['Float'];
  frameworks: Array<FrameworkSmallInfo>;
  id: Scalars['String'];
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  nameLogo?: Maybe<Scalars['String']>;
  statistics: ReportViewStatisticsModel;
  status: ReportViewStatusModel;
};

export type FrameworkOverviewRowModel = {
  applications: Array<AppInfo>;
  completeControls: FrameworkControlsCountDto;
  evidencePercent: Scalars['Float'];
  id: Scalars['String'];
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  nameLogo?: Maybe<Scalars['String']>;
};

export type FrameworkQsModel = {
  id: Scalars['String'];
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  shortData: Array<Scalars['JSON']>;
  wfId?: Maybe<Scalars['String']>;
};

export type FrameworkResponseModel = {
  assignments: Array<Scalars['String']>;
  filters: Array<Filter>;
  frameworkInfo: FrameworkInfoModel;
  groups?: Maybe<Array<ControlGroupModel>>;
  pageInfo: PageInfo;
};

export type FrameworkShortDataAnalyseModel = {
  controls: Array<IdNameModel>;
  id: Scalars['String'];
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type FrameworkShortDataAnalyseResponseModel = {
  frameworks: Array<FrameworkShortDataAnalyseModel>;
};

export type FrameworkSmallInfo = {
  controls: Scalars['Float'];
  evidencePercent: Scalars['Float'];
  id: Scalars['String'];
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type FrameworksControlsEvidencesShortModel = {
  controls: Array<ControlsEvidencesShortModel>;
  id: Scalars['String'];
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type FrameworksDelegatedTaskCollaboratorInput = {
  collaboratorId: Scalars['String'];
  email: Scalars['String'];
  fullName: Scalars['String'];
};

export type FrameworksDelegatedTaskCollaboratorModel = {
  collaboratorId: Scalars['String'];
  email: Scalars['String'];
  fullName: Scalars['String'];
};

export type FrameworksDelegatedTaskDataAttachedFilesFileInput = {
  addedToEvidence: Scalars['Boolean'];
  fileId: Scalars['String'];
  fileName: Scalars['String'];
};

export type FrameworksDelegatedTaskDataAttachedFilesFileModel = {
  addedToEvidence: Scalars['Boolean'];
  fileId: Scalars['String'];
  fileName: Scalars['String'];
};

export type FrameworksDelegatedTaskDataFilesListInput = {
  files: Array<FrameworksDelegatedTaskDataAttachedFilesFileInput>;
};

export type FrameworksDelegatedTaskDataInput = {
  attachedFiles?: InputMaybe<Array<FrameworksDelegatedTaskDataAttachedFilesFileInput>>;
};

export type FrameworksDelegatedTaskDataModel = {
  attachedFiles?: Maybe<Array<FrameworksDelegatedTaskDataAttachedFilesFileModel>>;
};

export enum FrameworksDelegatedTaskStatus {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Created = 'CREATED',
  Declined = 'DECLINED',
  Performed = 'PERFORMED'
}

export enum FrameworksDelegatedTaskType {
  ProvideFiles = 'PROVIDE_FILES'
}

export type FrameworksDelegatedTasksCollaboratorInput = {
  collaboratorId: Scalars['String'];
  fullName: Scalars['String'];
};

export type FrameworksDelegatedTasksCollaboratorModel = {
  collaboratorId: Scalars['String'];
  fullName: Scalars['String'];
};

export type FrameworksStoreResponseModel = {
  frameworks: Array<DialogFramworkModel>;
  pageInfo: PageInfo;
};

export type FullNcrReportFirstPage = {
  address: Scalars['String'];
  auditLead: Scalars['String'];
  auditStandard: Scalars['String'];
  auditTeam: Array<Scalars['String']>;
  auditType: Scalars['String'];
  auditeeRepresentative: Scalars['String'];
  clientID: Scalars['String'];
  datesOfAudit: Array<Scalars['String']>;
  majorNcr: Scalars['Float'];
  minorNcr: Scalars['Float'];
  organization: Scalars['String'];
  reportDate: Scalars['String'];
};

export type FullNcrReportHeader = {
  approvalDate: Scalars['String'];
  approver: Scalars['String'];
  auditCommittee: Scalars['String'];
  classification: Scalars['String'];
  logo?: Maybe<Scalars['String']>;
  owner: Scalars['String'];
  status: Scalars['String'];
  title: Scalars['String'];
  version: Scalars['String'];
};

export type FullNcrReportPreviewModel = {
  firstPage: FullNcrReportFirstPage;
  header: FullNcrReportHeader;
  ncrList: Array<NcrModel>;
};

export type FullReportModel = {
  NCRs: Array<IdStatusTypeModel>;
  report: GeneratedReportModel;
};

export type FuturePaymentModel = {
  discountPercentage: Scalars['Float'];
  futurePaymentDate: Scalars['String'];
  items: Array<ItemModel>;
  periodEnd: Scalars['String'];
  periodStart: Scalars['String'];
  retryCount: Scalars['Float'];
  variant: Scalars['String'];
  vatPercentage: Scalars['Float'];
};

export type GeneralApplicationInfo = {
  certifications: Array<Scalars['String']>;
  description: Scalars['String'];
  documentationLink: Scalars['String'];
  endpointMappingName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  securityScope: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type GeneralApplicationsModel = {
  accounts: Scalars['Float'];
  appInfo: GeneralApplicationInfo;
  assets: Scalars['Float'];
  discoveryStatus: Scalars['String'];
  groups: Scalars['Float'];
  id: Scalars['String'];
  issues: IssuerCounterByAppId;
  lastIntegrationDate: Scalars['String'];
  postureTabsName: Array<Scalars['String']>;
  workspaceId: Scalars['String'];
};

export type GeneralMonitoringUpdateInput = {
  active: Scalars['Boolean'];
  monitoring: Array<MonitoringMonitoringInput>;
  monitoringId: Scalars['String'];
  notifications: Array<NotificationInput>;
  preRequisites: Array<PreRequisiteInput>;
};

export type GeneralResponse = {
  message: Scalars['String'];
};

export type GenerateFileByHtmlInput = {
  editor?: InputMaybe<Scalars['JSON']>;
  innerHtml?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  organizationId: Scalars['String'];
  variables?: InputMaybe<Array<DataVariableModelInput>>;
};

export type GeneratedReportModel = {
  archived: Scalars['Boolean'];
  auditor?: Maybe<IdNameEmailModel>;
  auditorTeam?: Maybe<Array<IdNameEmailModel>>;
  framework: IdNameLogoModel;
  generated: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  ncrEnabled: Scalars['Boolean'];
  reportStatus: Scalars['String'];
  reportType: Scalars['String'];
};

export type GeneratedReportPaginationModel = {
  pageInfo: PageInfo;
  reports: Array<GeneratedReportModel>;
};

export type GetAccessManagementAppsResponse = {
  apps: Array<AccessManagementApp>;
  pageInfo: PageInfo;
};

export type GetAdminRolesResponseModel = {
  permissions: Array<AdminPermissionModel>;
  roles: Array<WorkspaceRoleModel>;
};

export type GetAppHistoryResponseModel = {
  histories: Array<AppHistoryModel>;
  pageInfo: PageInfo;
};

export type GetAppLogsResponseModel = {
  logs: Array<AppLogModel>;
  pageInfo: PageInfo;
};

export type GetAutocompleteValues = {
  count: Scalars['Float'];
  page: Scalars['Float'];
  search: Scalars['String'];
};

export type GetCreateOrganizationDataModel = {
  countries: Array<CountryModel>;
  industries: Array<Scalars['String']>;
  notCompletedOrganization?: Maybe<NotCompletedOrganization>;
};

export type GetDataByCollection = {
  data: Array<Scalars['JSON']>;
  pageInfo: PageInfo;
};

export type GetEmployeeJobInfosResponseModel = {
  jobInfos: Array<HrEmployeeJobInfoModel>;
  pageInfo: PageInfo;
};

export type GetEmployeesResponseModel = {
  employees: Array<HrEmployeeModel>;
  pageInfo: PageInfo;
};

export type GetExportCsvFieldResponseInput = {
  fields: Array<ExportCsvFieldInput>;
};

export type GetExportCsvFieldResponseModel = {
  fields: Array<ExportCsvFieldModel>;
};

export type GetExtendedCollabResponseModel = {
  collab: AccountsExtendedCollabModel;
  orgs: Array<AccountsSmallOrganization>;
};

export type GetFullDocumentResponseModel = {
  executor?: Maybe<DocumentExecutorModel>;
  file?: Maybe<NewDocumentModel>;
};

export type GetHistoryResponse = {
  histories: Array<ScanHistoryModel>;
  pageInfo: PageInfo;
};

export type GetInitIntegrationsData = {
  availableApps: Array<AvailableAppModel>;
  installedApps: Array<InstalledAppType>;
};

export type GetIntegrationAppByIdResponseModel = {
  app: InstalledAppType;
  availableApps: Array<AvailableAppModel>;
};

export type GetKycArchiveTargetsPagingResponseModel = {
  archive: Array<KycArchivedTargetModel>;
  pageInfo: PageInfo;
};

export type GetKycDictionariesModel = {
  country: Array<KycDictionaryModel>;
};

export type GetKycMatchesPagingModel = {
  matches: Array<KycMatchModel>;
  pageInfo: PageInfo;
};

export type GetKycRequestsPagingModel = {
  pageInfo: PageInfo;
  requests: Array<KycRefactorRequestModel>;
};

export type GetKycTargetsFieldsResponseInput = {
  fields: Array<KycTargetFieldInput>;
};

export type GetKycTargetsFieldsResponseModel = {
  fields: Array<KycTargetFieldModel>;
};

export type GetKycTargetsPagingResponseModel = {
  clients: Array<TKycTargetModel>;
  pageInfo: PageInfo;
};

export type GetKycTemplateHistoryPagingModel = {
  histories: Array<KycTemplateCsvHistoryModel>;
  pageInfo: PageInfo;
};

export type GetKycTemplatesPagingModel = {
  pageInfo: PageInfo;
  templates: Array<KycRefactorTemplateModel>;
};

export type GetManagedAppsResponseModel = {
  apps: Array<ManagedApplicationModel>;
};

export type GetMonitoringModel = {
  collaborators: Array<IdNameMonitoringModel>;
  crownJewels: Array<IdNameMonitoringModel>;
  identities: Array<IdNameAvatar>;
  items: Array<MonitoringModel>;
  pageInfo: PageInfo;
  profiles: Array<IdNameMonitoringModel>;
};

export type GetOrganizationResponseModel = {
  organizations: Array<RedesignOrganization>;
  pageInfo: PageInfo;
};

export type GetOrganizationUsersModel = {
  collaborators: Array<OrganizationExtendedCollaboratorModel>;
};

export type GetRiskByIdModel = {
  frameworks: Array<FrameworksControlsEvidencesShortModel>;
  registry: RiskRegistryModel;
  risk: RiskModel;
};

export type GetRoleNamesModel = {
  roles: Array<Scalars['String']>;
};

export type GetShortLicensesByAdminModel = {
  filters: Array<Filter>;
  licenses: Array<SmallLicenseModel>;
  pageInfo: PageInfo;
};

export type GetShortOrgsByAdminModel = {
  filters: Array<Filter>;
  orgs: Array<AdminSmallOrganizationModel>;
  pageInfo: PageInfo;
};

export type GetSmallTargetsResponse = {
  pageInfo: PageInfo;
  targets: Array<SmallTargetModel>;
};

export type GetTargetExceptionResponseModel = {
  exceptions: Array<KycExceptionModel>;
  pageInfo: PageInfo;
};

export type GetTargetHistoryResponseModel = {
  historyLogs: Array<KycHistoryLogModel>;
};

export type GetVicaTaskCategoriesResponse = {
  categories: Array<VicaCategoryModel>;
  pageInfo: PageInfo;
};

export type GetVicaTasksByCategoryResponse = {
  tasks: Array<VicaTaskModel>;
};

export type GetWorkspaceByIdResponseModel = {
  organization: RedesignOrganization;
  workspace: RedesignWorkspace;
};

export type GetWorkspacesResponseModel = {
  pageInfo: PageInfo;
  workspaces: Array<RedesignWorkspace>;
};

export type GradeInput = {
  impact?: InputMaybe<Scalars['Float']>;
  probability?: InputMaybe<Scalars['Float']>;
};

export type GradeModel = {
  impact?: Maybe<Scalars['Float']>;
  probability?: Maybe<Scalars['Float']>;
};

export type GroupFilter = {
  group?: Maybe<Array<Scalars['String']>>;
};

export type GroupFilterModel = AppNameFilter | NameFilter | TypeFilter;

export type GroupModel = {
  accounts: Array<IdNameLogoModel>;
  appInfo: IdNameLogoModel;
  assets: Array<IdNameLogoModel>;
  description: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  permissions: Array<IdNameLogoModel>;
  type: Scalars['String'];
};

export type GroupsResponseModel = {
  filters: Array<Filter>;
  groups: Array<GroupModel>;
  pageInfo: PageInfo;
};

export type HardwareFilterModel = AppNameFilter | NameFilter | OsFilter | TypeFilter;

export type HardwareModel = {
  accounts: Array<IdNameLogoModel>;
  app: IdNameLogoModel;
  id: Scalars['String'];
  manufacturer?: Maybe<Scalars['String']>;
  meta?: Maybe<Scalars['JSON']>;
  model?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  os?: Maybe<Scalars['String']>;
  osVersion?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  wiFiMacAddress?: Maybe<Scalars['String']>;
};

export type HardwarePaginationModel = {
  hardwares: Array<HardwareModel>;
  pageInfo: PageInfo;
};

export type HistoryAnalyseDetailsModel = {
  date: Scalars['String'];
  details: Scalars['JSON'];
  name: Scalars['String'];
  solution?: Maybe<Scalars['JSON']>;
};

export type HistoryAnalyseDetailsSolutionModel = {
  description: Scalars['String'];
  step: Scalars['String'];
  subSteps?: Maybe<Array<HistoryAnalyseDetailsSolutionModel>>;
};

export type HistoryScanResult = {
  id: Scalars['String'];
  progress: Scalars['Float'];
  requested_targets: Array<HistoryScanResultRequestedTarget>;
  resolved_targets: Array<HistoryScanResultResolvedTarget>;
  results: Array<HistoryScanResultResult>;
  risks?: Maybe<HistoryScanResultRisks>;
  skipped_targets: Array<HistoryScanResultSkippedTarget>;
  state: Scalars['String'];
  type: Scalars['String'];
};

export type HistoryScanResultRequestedTarget = {
  label: Scalars['String'];
  target: Scalars['String'];
  target_id: Scalars['String'];
};

export type HistoryScanResultResolvedTarget = {
  label: Scalars['String'];
  resolved_target: Scalars['String'];
  target: Scalars['String'];
  target_id: Scalars['String'];
};

export type HistoryScanResultResult = {
  companyReportFileId?: Maybe<Scalars['String']>;
  contentType: Scalars['String'];
  content_type?: Maybe<Scalars['String']>;
  originReportFileId?: Maybe<Scalars['String']>;
  resultId: Scalars['String'];
  result_id?: Maybe<Scalars['String']>;
};

export type HistoryScanResultRisks = {
  closed: Array<Risk>;
  new_open: Array<Risk>;
  still_open: Array<Risk>;
};

export type HistoryScanResultSkippedTarget = {
  label: Scalars['String'];
  skipped_reason: Scalars['String'];
  target: Scalars['String'];
  target_id: Scalars['String'];
};

export type HrEmployeeAccountAppModel = {
  id: Scalars['String'];
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type HrEmployeeAccountAppModelInput = {
  id: Scalars['String'];
  logo?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type HrEmployeeAccountModel = {
  app: HrEmployeeAccountAppModel;
  id: Scalars['String'];
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type HrEmployeeAccountModelInput = {
  app: HrEmployeeAccountAppModelInput;
  id: Scalars['String'];
  logo?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type HrEmployeeContactInfoAddressModel = {
  city: Scalars['String'];
  country?: Maybe<Scalars['String']>;
  street: Scalars['String'];
  zip: Scalars['String'];
};

export type HrEmployeeContactInfoAddressModelInput = {
  city: Scalars['String'];
  country?: InputMaybe<Scalars['String']>;
  street: Scalars['String'];
  zip: Scalars['String'];
};

export type HrEmployeeContactInfoContactModel = {
  type?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

export type HrEmployeeContactInfoContactModelInput = {
  type?: InputMaybe<Scalars['String']>;
  value: Scalars['String'];
};

export type HrEmployeeContactInfoEmergencyContactModel = {
  address: Scalars['String'];
  email: Scalars['String'];
  fullName: Scalars['String'];
  phone: Scalars['String'];
  relationType?: Maybe<Scalars['String']>;
};

export type HrEmployeeContactInfoEmergencyContactModelInput = {
  address: Scalars['String'];
  email: Scalars['String'];
  fullName: Scalars['String'];
  phone: Scalars['String'];
  relationType?: InputMaybe<Scalars['String']>;
};

export type HrEmployeeContactInfoModel = {
  address: HrEmployeeContactInfoAddressModel;
  contacts: Array<HrEmployeeContactInfoContactModel>;
  emergencyContacts: Array<HrEmployeeContactInfoEmergencyContactModel>;
};

export type HrEmployeeContactInfoModelInput = {
  address: HrEmployeeContactInfoAddressModelInput;
  contacts: Array<HrEmployeeContactInfoContactModelInput>;
  emergencyContacts: Array<HrEmployeeContactInfoEmergencyContactModelInput>;
};

export type HrEmployeeCreateModel = {
  accounts: Array<HrEmployeeAccountModelInput>;
  birthDay?: InputMaybe<Scalars['String']>;
  contactInfo: HrEmployeeContactInfoModelInput;
  customFields: Scalars['JSON'];
  documents: Array<Scalars['String']>;
  employeeId: Scalars['String'];
  ethnicity?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  gender?: InputMaybe<Scalars['String']>;
  hireDate?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  jobInfos: Array<HrEmployeeJobInfoInputCreateModel>;
  lastName: Scalars['String'];
  maritalStatus?: InputMaybe<Scalars['String']>;
  middleName?: InputMaybe<Scalars['String']>;
  nickname?: InputMaybe<Scalars['String']>;
  personalData: HrEmployeePersonalDataModelInput;
  status?: InputMaybe<HrEmployeeStatusModelInput>;
  trainings: Array<HrEmployeeTrainingInput>;
  workEmail: Scalars['String'];
  workspaceId: Scalars['String'];
};

export type HrEmployeeJobInfoInputCreateModel = {
  current: Scalars['Boolean'];
  department: Scalars['String'];
  division?: InputMaybe<Scalars['String']>;
  employmentType: Scalars['String'];
  id: Scalars['String'];
  jobTitle: HrEmployeeJobInfoJobTitleInput;
  location?: InputMaybe<Scalars['String']>;
  manager?: InputMaybe<HrEmployeesManagerModelInput>;
  startDate: Scalars['String'];
};

export type HrEmployeeJobInfoJobTitleInput = {
  count: Scalars['Float'];
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  jobType?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  requirements?: InputMaybe<Scalars['String']>;
  workspaceId: Scalars['String'];
};

export type HrEmployeeJobInfoJobTitleModel = {
  description?: Maybe<Scalars['String']>;
  jobType?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  requirements?: Maybe<Scalars['String']>;
};

export type HrEmployeeJobInfoJobTitleModelInput = {
  description?: InputMaybe<Scalars['String']>;
  jobType?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  requirements?: InputMaybe<Scalars['String']>;
};

export type HrEmployeeJobInfoModel = {
  current: Scalars['Boolean'];
  department: Scalars['String'];
  division?: Maybe<Scalars['String']>;
  employmentType: Scalars['String'];
  id: Scalars['String'];
  jobTitle: HrEmployeeJobInfoJobTitleModel;
  location?: Maybe<Scalars['String']>;
  manager?: Maybe<HrEmployeesManagerModel>;
  startDate: Scalars['String'];
};

export type HrEmployeeJobInfoModelInput = {
  current: Scalars['Boolean'];
  department: Scalars['String'];
  division?: InputMaybe<Scalars['String']>;
  employmentType: Scalars['String'];
  id: Scalars['String'];
  jobTitle: HrEmployeeJobInfoJobTitleModelInput;
  location?: InputMaybe<Scalars['String']>;
  manager?: InputMaybe<HrEmployeesManagerModelInput>;
  startDate: Scalars['String'];
};

export type HrEmployeeJobTitleModel = {
  count: Scalars['Float'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  jobType?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  requirements?: Maybe<Scalars['String']>;
  workspaceId: Scalars['String'];
};

export type HrEmployeeJobTitleModelInput = {
  count: Scalars['Float'];
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  jobType?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  requirements?: InputMaybe<Scalars['String']>;
  workspaceId: Scalars['String'];
};

export type HrEmployeeModel = {
  accounts: Array<HrEmployeeAccountModel>;
  birthDay?: Maybe<Scalars['String']>;
  collaborator?: Maybe<WorkspaceCollaboratorModel>;
  contactInfo: HrEmployeeContactInfoModel;
  customFields: Scalars['JSON'];
  documents: Array<Scalars['String']>;
  employeeId: Scalars['String'];
  ethnicity?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  gender?: Maybe<Scalars['String']>;
  hireDate?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  jobInfos: Array<HrEmployeeJobInfoModel>;
  lastName: Scalars['String'];
  maritalStatus?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  personalData: HrEmployeePersonalDataModel;
  status?: Maybe<HrEmployeeStatusModel>;
  trainings: Array<HrEmployeeTraining>;
  workEmail: Scalars['String'];
  workspaceId: Scalars['String'];
};

export type HrEmployeeModelInput = {
  accounts: Array<HrEmployeeAccountModelInput>;
  birthDay?: InputMaybe<Scalars['String']>;
  collaborator?: InputMaybe<WorkspaceCollaboratorInput>;
  contactInfo: HrEmployeeContactInfoModelInput;
  customFields: Scalars['JSON'];
  documents: Array<Scalars['String']>;
  employeeId: Scalars['String'];
  ethnicity?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  gender?: InputMaybe<Scalars['String']>;
  hireDate?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  jobInfos: Array<HrEmployeeJobInfoModelInput>;
  lastName: Scalars['String'];
  maritalStatus?: InputMaybe<Scalars['String']>;
  middleName?: InputMaybe<Scalars['String']>;
  nickname?: InputMaybe<Scalars['String']>;
  personalData: HrEmployeePersonalDataModelInput;
  status?: InputMaybe<HrEmployeeStatusModelInput>;
  trainings: Array<HrEmployeeTrainingInput>;
  workEmail: Scalars['String'];
  workspaceId: Scalars['String'];
};

export type HrEmployeePersonalDataEducationModel = {
  degree?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  fieldOfStudy: Scalars['String'];
  schoolName: Scalars['String'];
  startDate?: Maybe<Scalars['String']>;
};

export type HrEmployeePersonalDataEducationModelInput = {
  degree?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  fieldOfStudy: Scalars['String'];
  schoolName: Scalars['String'];
  startDate?: InputMaybe<Scalars['String']>;
};

export type HrEmployeePersonalDataModel = {
  education: Array<HrEmployeePersonalDataEducationModel>;
  veteranStatus: HrEmployeePersonalDataVeteranStatusModel;
};

export type HrEmployeePersonalDataModelInput = {
  education: Array<HrEmployeePersonalDataEducationModelInput>;
  veteranStatus: HrEmployeePersonalDataVeteranStatusModelInput;
};

export type HrEmployeePersonalDataVeteranStatusModel = {
  activeDutyWartimeOrCampaignBadgeVeteran: Scalars['Boolean'];
  armedForcesServiceMedalVeteran: Scalars['Boolean'];
  disabledVeteran: Scalars['Boolean'];
  recentlySeparatedVeteran: Scalars['Boolean'];
};

export type HrEmployeePersonalDataVeteranStatusModelInput = {
  activeDutyWartimeOrCampaignBadgeVeteran: Scalars['Boolean'];
  armedForcesServiceMedalVeteran: Scalars['Boolean'];
  disabledVeteran: Scalars['Boolean'];
  recentlySeparatedVeteran: Scalars['Boolean'];
};

export type HrEmployeeStatusModel = {
  backgroundColor: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  textColor: Scalars['String'];
};

export type HrEmployeeStatusModelInput = {
  backgroundColor: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  textColor: Scalars['String'];
};

export type HrEmployeeTraining = {
  completionDate: Scalars['String'];
  completionStatus: Scalars['String'];
  name: Scalars['String'];
  status: Scalars['String'];
};

export type HrEmployeeTrainingInput = {
  completionDate: Scalars['String'];
  completionStatus: Scalars['String'];
  name: Scalars['String'];
  status: Scalars['String'];
};

export type HrEmployeesManagerModel = {
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

export type HrEmployeesManagerModelInput = {
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
};

export enum HrIssuesStatus {
  InProgress = 'IN_PROGRESS',
  Reported = 'REPORTED',
  Resolved = 'RESOLVED'
}

export type HrRequestEditProfileDataInput = {
  editProfile: Array<HrRequestEditProfileInput>;
};

export type HrRequestEditProfileDataModel = {
  editProfile: Array<HrRequestEditProfileModel>;
};

export type HrRequestEditProfileInput = {
  fieldName: Scalars['String'];
  fieldValue: Scalars['String'];
};

export type HrRequestEditProfileModel = {
  fieldName: Scalars['String'];
  fieldValue: Scalars['String'];
};

export type HrRequestRequestorInput = {
  employeeId: Scalars['String'];
  fullName: Scalars['String'];
};

export type HrRequestRequestorModel = {
  employeeId: Scalars['String'];
  fullName: Scalars['String'];
};

export type HrRequestResolverInput = {
  collaboratorFullName: Scalars['String'];
  employeeFullName?: InputMaybe<Scalars['String']>;
  employeeId?: InputMaybe<Scalars['String']>;
  publicId: Scalars['String'];
};

export type HrRequestResolverModel = {
  collaboratorFullName: Scalars['String'];
  employeeFullName?: Maybe<Scalars['String']>;
  employeeId?: Maybe<Scalars['String']>;
  publicId: Scalars['String'];
};

export enum HrRequestStatus {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Created = 'CREATED',
  Rejected = 'REJECTED'
}

export type HrSettingsModel = {
  contactType: Array<Scalars['String']>;
  country: Array<Scalars['String']>;
  customFields: Scalars['JSON'];
  degree: Scalars['JSON'];
  department: Scalars['JSON'];
  division: Scalars['JSON'];
  eligibleForRehire: Array<Scalars['String']>;
  employmentType: Scalars['JSON'];
  ethnicity: Array<Scalars['String']>;
  gender: Array<Scalars['String']>;
  jobTitle: Array<HrEmployeeJobTitleModel>;
  jobType: Array<Scalars['String']>;
  location: Scalars['JSON'];
  maritalStatus: Array<Scalars['String']>;
  relationshipType: Scalars['JSON'];
  status: Array<HrEmployeeStatusModel>;
  terminationReason: Array<Scalars['String']>;
  terminationType: Array<Scalars['String']>;
  timeOffType: Array<Scalars['String']>;
  workspaceId: Scalars['String'];
};

export enum HrTimeOffRouteType {
  Initial = 'INITIAL',
  Recall = 'RECALL',
  Revocation = 'REVOCATION'
}

export enum HrTimeOffStatus {
  Approval = 'APPROVAL',
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Created = 'CREATED',
  Rejected = 'REJECTED'
}

export enum HrTimeOffStepsStatus {
  Acknowledged = 'ACKNOWLEDGED',
  Approved = 'APPROVED',
  Created = 'CREATED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Skipped = 'SKIPPED'
}

export enum HrTimeOffStepsType {
  Creation = 'CREATION',
  HrManagerAcknowledgement = 'HR_MANAGER_ACKNOWLEDGEMENT',
  HrManagerApproval = 'HR_MANAGER_APPROVAL',
  ManagerAcknowledgement = 'MANAGER_ACKNOWLEDGEMENT',
  ManagerApproval = 'MANAGER_APPROVAL'
}

export type IdFilter = {
  id?: Maybe<Array<Scalars['String']>>;
};

export type IdMessage = {
  id: Scalars['String'];
  message: Scalars['String'];
};

export type IdNameAvatar = {
  avatar?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type IdNameEmailInput = {
  email: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type IdNameEmailModel = {
  email: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type IdNameInput = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export type IdNameLogo = {
  id: Scalars['String'];
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type IdNameLogoInput = {
  id: Scalars['String'];
  logo?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type IdNameLogoModel = {
  id: Scalars['String'];
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type IdNameLogoStatusModel = {
  id: Scalars['String'];
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  status: Scalars['Float'];
};

export type IdNameModel = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export type IdNameMonitoringModel = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export type IdNamePaginatedModel = {
  pageInfo: PageInfo;
  result: Array<IdNameModel>;
};

export type IdNameTypeInput = {
  id: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type IdNameTypeModel = {
  id: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type IdStatusTypeModel = {
  id: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type IdentitiesResponse = {
  identities: Array<IdentityDetails>;
  pageInfo: PageInfo;
};

export type IdentityDetails = {
  accounts: Array<IdNameLogoModel>;
  email?: Maybe<Scalars['String']>;
  identity: IdNameLogoModel;
};

export type IdentityFilter = {
  identity?: Maybe<Array<Scalars['String']>>;
};

export type IdentityInput = {
  avatar?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type IdentitySmallModel = {
  avatar?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

export type IdsModel = {
  ids: Array<Scalars['String']>;
};

export type ImportCsvFieldInput = {
  csvField?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  fieldKey?: InputMaybe<Scalars['String']>;
  fieldTitle?: InputMaybe<Scalars['String']>;
  isDisabled?: InputMaybe<Scalars['Boolean']>;
  isKey?: InputMaybe<Scalars['Boolean']>;
  isRequired?: InputMaybe<Scalars['Boolean']>;
};

export type ImportCsvFieldModel = {
  csvField?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  fieldKey?: Maybe<Scalars['String']>;
  fieldTitle?: Maybe<Scalars['String']>;
  isDisabled?: Maybe<Scalars['Boolean']>;
  isKey?: Maybe<Scalars['Boolean']>;
  isRequired?: Maybe<Scalars['Boolean']>;
};

export type ImportCsvFieldsWithId = {
  fields: Array<ImportCsvFieldModel>;
  fileId: Scalars['String'];
};

export type ImportCsvPerformResponse = {
  duplicatesCount?: Maybe<Scalars['Float']>;
  errorMessage?: Maybe<Scalars['String']>;
  errorRow?: Maybe<Scalars['Float']>;
  message?: Maybe<Scalars['String']>;
  successCount?: Maybe<Scalars['Float']>;
};

export type InputAnyFilter = {
  filters?: InputMaybe<Scalars['JSON']>;
};

export type IntegrationDetails = {
  appId: Scalars['String'];
  discoveryStatus?: Maybe<Scalars['String']>;
  hris: Scalars['Boolean'];
  idp: Scalars['Boolean'];
  name: Scalars['String'];
  ownerEmail?: Maybe<Scalars['String']>;
};

export type IntegrationResponse = {
  filters: Array<Filter>;
  integrationsAppInfo: Array<IntegrationsAppInfo>;
};

export type IntegrationTypeConfig = {
  applicationId: Scalars['String'];
  applicationPrefix: Scalars['String'];
};

export type IntegrationTypeConfigInput = {
  applicationId: Scalars['String'];
  applicationPrefix: Scalars['String'];
};

export type IntegrationsAppInfo = {
  appInfo: ExtendedAppInfo;
  integrationDetails: Array<IntegrationDetails>;
};

export type IntegrationsInput = {
  filters?: InputMaybe<FilterInput>;
};

export type InventoryDeviceModel = {
  accounts: Array<Scalars['String']>;
  additional: Array<NameStatusModel>;
  deviceType: Scalars['String'];
  hostname: Scalars['String'];
  id: Scalars['String'];
  lastEvent: Scalars['String'];
  name: Scalars['String'];
  origin: Array<IdNameLogoModel>;
  osType: Scalars['String'];
};

export type InventoryDeviceResponseModel = {
  devices: Array<InventoryDeviceModel>;
  pageInfo: PageInfo;
};

export type IssueAccountInput = {
  email: Scalars['String'];
  identity?: InputMaybe<IssueIdentityInput>;
};

export type IssueFilterModel = CategoryFilter | IdentityFilter | SeverityFilter | StatusFilter;

export type IssueIdentityInput = {
  lastName: Scalars['String'];
  name: Scalars['String'];
  roles: Scalars['String'];
  status: Scalars['String'];
};

export type IssueInput = {
  account: IssueAccountInput;
  appId: Scalars['String'];
  appName: Scalars['String'];
  assignedIdentityId: Scalars['String'];
  categoryName: Scalars['String'];
  description: Scalars['String'];
  name: Scalars['String'];
  policyId: Scalars['String'];
  policyName: Scalars['String'];
  severity: Scalars['String'];
  status: Scalars['String'];
  workspaceId: Scalars['String'];
};

export type IssueModel = {
  assignee: AssigneeModel;
  category: CategoryModel;
  dateTime: Scalars['String'];
  description: Scalars['String'];
  details: DetailsModel;
  id: Scalars['ID'];
  name: Scalars['String'];
  origin: ApplicationModel;
  policy: IssuePolicyModel;
  severity: Scalars['String'];
  solutions: Array<Scalars['JSON']>;
  status: Scalars['String'];
};

export type IssuePolicyModel = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export type IssueResponseModel = {
  identities: Array<IdentitySmallModel>;
  issue?: Maybe<IssueModel>;
};

export type IssuerCounterByAppId = {
  appId: Scalars['String'];
  severity: IssuesCountModel;
};

export type IssuesCountModel = {
  high: Scalars['Float'];
  low: Scalars['Float'];
  medium: Scalars['Float'];
};

export type IssuesInput = {
  issues: Array<IssueInput>;
};

export type ItemModel = {
  cost: Scalars['Float'];
  currency: Scalars['String'];
  name: Scalars['String'];
  quantity: Scalars['Float'];
  subscriptionType: Scalars['String'];
  type: Scalars['String'];
};

export type ItemsDto = {
  fileIds: Array<Scalars['String']>;
  folderIds: Array<Scalars['String']>;
};

export type JobTitleByAdminInput = {
  description: Scalars['String'];
  id: Scalars['String'];
  requirements: Scalars['String'];
  title: Scalars['String'];
  type: Scalars['String'];
};

export type JobTitleByAdminModel = {
  description: Scalars['String'];
  id: Scalars['String'];
  requirements: Scalars['String'];
  title: Scalars['String'];
  type: Scalars['String'];
};

export type KafkaMessageModel = {
  organizationId?: Maybe<Scalars['String']>;
  payload: Scalars['String'];
  publicId?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  workspaceId?: Maybe<Scalars['String']>;
};

export type KycArchivedTargetInput = {
  archivedDate: Scalars['String'];
  archivedReason: Scalars['String'];
  fields: Array<KycTargetFieldInput>;
  id: Scalars['String'];
  risk: Scalars['String'];
  targetType: Scalars['String'];
};

export type KycArchivedTargetModel = {
  archivedDate: Scalars['String'];
  archivedReason: Scalars['String'];
  fields: Array<KycTargetFieldModel>;
  id: Scalars['String'];
  risk: Scalars['String'];
  targetType: Scalars['String'];
};

export type KycCsvFieldModel = {
  csvField: Scalars['String'];
  templateField: Scalars['String'];
};

export type KycCsvFieldWithAliasModel = {
  csvField: Scalars['String'];
  isKey: Scalars['Boolean'];
  mappedField: Scalars['String'];
};

export type KycDeleteTemplateDataModel = {
  archivedClientsCount: Scalars['Float'];
  clientsCount: Scalars['Float'];
};

export type KycDictionaryModel = {
  key: Scalars['String'];
  order: Scalars['Float'];
  value: Scalars['String'];
};

export type KycExceptionModel = {
  checkId: Scalars['String'];
  createdDate: Scalars['String'];
  creator: Scalars['String'];
  deleted: Scalars['Boolean'];
  deletedBy?: Maybe<Scalars['String']>;
  deletedDate?: Maybe<Scalars['String']>;
  entityCaption: Scalars['String'];
  entityId: Scalars['String'];
  id: Scalars['String'];
  limited: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
  score: Scalars['Float'];
  targetId: Scalars['String'];
  till?: Maybe<Scalars['String']>;
};

export type KycFormFieldDto = {
  ext?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  required: Scalars['Boolean'];
  system: Scalars['Boolean'];
  type: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type KycFormFieldInput = {
  ext?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  required: Scalars['Boolean'];
  system: Scalars['Boolean'];
  type: Scalars['String'];
  value?: InputMaybe<Scalars['String']>;
};

export type KycFormInput = {
  fields: Array<KycFormFieldInput>;
  organization: IdNameLogoInput;
};

export type KycFormModel = {
  fields: Array<KycFormFieldDto>;
  organization: IdNameLogoModel;
};

export type KycFormModelRefactor = {
  description: Scalars['String'];
  fields: Array<TKycTemplateFieldFillableModel>;
  name: Scalars['String'];
  organization: IdNameLogoModel;
};

export type KycHistoryLogModel = {
  action: Scalars['String'];
  date: Scalars['String'];
  id: Scalars['String'];
  targetId: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type KycMatchModel = {
  checkName: Scalars['String'];
  createdDate: Scalars['String'];
  id: Scalars['String'];
  screeningId: Scalars['String'];
  status: Scalars['String'];
  targetId: Scalars['String'];
  targetName: Scalars['String'];
  templateId?: Maybe<Scalars['String']>;
  templateName?: Maybe<Scalars['String']>;
  templateType?: Maybe<Scalars['String']>;
};

export type KycOtsResultModel = {
  entityCaption: Scalars['String'];
  entityId: Scalars['String'];
  score: Scalars['Float'];
};

export type KycOneTimeScreeningModel = {
  checkId: Scalars['String'];
  checkName: Scalars['String'];
  endDate?: Maybe<Scalars['String']>;
  matchingRatio?: Maybe<Scalars['Float']>;
  results?: Maybe<Array<KycOtsResultModel>>;
  startDate?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  targetName: Scalars['String'];
  targetStatus: Scalars['String'];
  targetType: Scalars['String'];
  templateName?: Maybe<Scalars['String']>;
  workspaceId: Scalars['String'];
};

export type KycQuotesDto = {
  count: Scalars['Float'];
  isLimitEnabled: Scalars['Boolean'];
  total: Scalars['Float'];
};

export type KycRedirectUrlDto = {
  message: Scalars['String'];
  redirectUrl?: Maybe<Scalars['String']>;
};

export type KycRefactorRequestModel = {
  createdTargetId?: Maybe<Scalars['String']>;
  filledFields: Array<TKycTemplateFieldFillableModel>;
  id: Scalars['String'];
  requestType: Scalars['String'];
  responseDate?: Maybe<Scalars['String']>;
  sendDate?: Maybe<Scalars['String']>;
  sendTo: Scalars['String'];
  status: Scalars['String'];
  templateId: Scalars['String'];
  templateType?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

export type KycRefactorTemplateModel = {
  description: Scalars['String'];
  fields: Array<TKycTemplateFieldModel>;
  id: Scalars['String'];
  lastScreeningDate?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  nextScreeningDate?: Maybe<Scalars['String']>;
  screeningSettings: TKycTemplateScreeningSettingsModel;
  type: Scalars['String'];
};

export type KycRefactorTemplateModelInput = {
  description: Scalars['String'];
  fields: Array<TKycTemplateFieldModelInput>;
  id: Scalars['String'];
  lastScreeningDate?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  nextScreeningDate?: InputMaybe<Scalars['String']>;
  screeningSettings: TKycTemplateScreeningSettingsModelInput;
  type: Scalars['String'];
};

export type KycRefactorUpdateTargetInput = {
  fields: Array<KycUpdateTargetValueInput>;
  id: Scalars['String'];
};

export type KycRequestModel = {
  createdDate: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  fields: Array<KycFormFieldDto>;
  id: Scalars['String'];
  isAnalysed: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  result: Scalars['JSON'];
  status: Scalars['String'];
  templateType: Scalars['String'];
  updatedDate?: Maybe<Scalars['String']>;
  zipFileId?: Maybe<Scalars['String']>;
};

export type KycRequestPagination = {
  pageInfo: PageInfo;
  requests: Array<KycRequestModel>;
};

export type KycScreeningFullInfoModel = {
  exceptions?: Maybe<Array<KycExceptionModel>>;
  screening: KycScreeningModel;
  target: TKycTargetModel;
};

export type KycScreeningFullResultModel = {
  result: Scalars['String'];
};

export type KycScreeningInput = {
  checkId: Scalars['String'];
  checkName: Scalars['String'];
  endDate?: InputMaybe<Scalars['String']>;
  exceptionCount?: InputMaybe<Scalars['Float']>;
  id: Scalars['String'];
  latestScreeningId?: InputMaybe<Scalars['String']>;
  matchingRatio?: InputMaybe<Scalars['Float']>;
  result?: InputMaybe<Array<KycScreeningResultInput>>;
  startDate?: InputMaybe<Scalars['String']>;
  status: Scalars['String'];
  targetId: Scalars['String'];
  targetName: Scalars['String'];
  targetType: Scalars['String'];
  templateId?: InputMaybe<Scalars['String']>;
  templateName?: InputMaybe<Scalars['String']>;
};

export type KycScreeningModel = {
  checkId: Scalars['String'];
  checkName: Scalars['String'];
  endDate?: Maybe<Scalars['String']>;
  exceptionCount?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  latestScreeningId?: Maybe<Scalars['String']>;
  matchingRatio?: Maybe<Scalars['Float']>;
  result?: Maybe<Array<KycScreeningResultModel>>;
  startDate?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  targetId: Scalars['String'];
  targetName: Scalars['String'];
  targetType: Scalars['String'];
  templateId?: Maybe<Scalars['String']>;
  templateName?: Maybe<Scalars['String']>;
};

export type KycScreeningPagingResponseModel = {
  pageInfo: PageInfo;
  screenings: Array<KycScreeningModel>;
};

export type KycScreeningResultInput = {
  entityCaption: Scalars['String'];
  entityId: Scalars['String'];
  exceptionId?: InputMaybe<Scalars['String']>;
  matchedObject?: InputMaybe<Scalars['JSON']>;
  score: Scalars['Float'];
};

export type KycScreeningResultModel = {
  entityCaption: Scalars['String'];
  entityId: Scalars['String'];
  exceptionId?: Maybe<Scalars['String']>;
  matchedObject?: Maybe<Scalars['JSON']>;
  score: Scalars['Float'];
};

export type KycScreeningResultPagingModel = {
  pageInfo: PageInfo;
  result: Array<KycScreeningResultModel>;
};

export type KycTargetFieldInput = {
  checkAlias: Array<CheckAliasModelInput>;
  dictionary?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  order: Scalars['Float'];
  required: Scalars['Boolean'];
  requiredForTemplate: Scalars['Boolean'];
  system: Scalars['Boolean'];
  systemAlias?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
  value?: InputMaybe<Scalars['String']>;
};

export type KycTargetFieldModel = {
  checkAlias: Array<CheckAliasModel>;
  dictionary?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  order: Scalars['Float'];
  required: Scalars['Boolean'];
  requiredForTemplate: Scalars['Boolean'];
  system: Scalars['Boolean'];
  systemAlias?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type KycTemplateCsvHistoryModel = {
  createdBy: Scalars['String'];
  createdByName: Scalars['String'];
  createdDate: Scalars['String'];
  fileId: Scalars['String'];
  fileName: Scalars['String'];
  id: Scalars['String'];
  result?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  templateId: Scalars['String'];
};

export type KycTemplateFieldDto = {
  name: Scalars['String'];
  required: Scalars['Boolean'];
  system: Scalars['Boolean'];
  type: Scalars['String'];
};

export type KycTemplateFieldInput = {
  name: Scalars['String'];
  required: Scalars['Boolean'];
  system: Scalars['Boolean'];
  type: Scalars['String'];
};

export type KycTemplateInput = {
  description?: InputMaybe<Scalars['String']>;
  fields: Array<KycTemplateFieldInput>;
  id: Scalars['String'];
  name: Scalars['String'];
  system: Scalars['Boolean'];
  type: Scalars['String'];
};

export type KycTemplateModel = {
  description?: Maybe<Scalars['String']>;
  fields: Array<KycTemplateFieldDto>;
  id: Scalars['String'];
  name: Scalars['String'];
  system: Scalars['Boolean'];
  type: Scalars['String'];
};

export type KycTemplatePagination = {
  pageInfo: PageInfo;
  templates: Array<KycTemplateModel>;
};

export type KycTemplateSystemFields = {
  company: Array<KycTemplateFieldDto>;
  person: Array<KycTemplateFieldDto>;
};

export type KycTokenDto = {
  redirectUrl: Scalars['String'];
  token: Scalars['String'];
};

export type KycUpdateTargetValueInput = {
  fileName?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  value: Scalars['String'];
};

export type LastUpdateInput = {
  date?: InputMaybe<Scalars['String']>;
  publicId: Scalars['ID'];
};

export type LastUpdateModel = {
  date?: Maybe<Scalars['String']>;
  publicId: Scalars['ID'];
};

export type LicenseIssuedDetailsInput = {
  firstName: Scalars['String'];
  issuedBy: Scalars['String'];
  issuedDate: Scalars['String'];
  lastName: Scalars['String'];
};

export type LicenseIssuedDetailsModel = {
  firstName: Scalars['String'];
  issuedBy: Scalars['String'];
  issuedDate: Scalars['String'];
  lastName: Scalars['String'];
};

export type LicenseUsedByInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  publicId: Scalars['String'];
  usedBy: Scalars['String'];
  usedDate: Scalars['String'];
  usedOrganizationId: Scalars['String'];
  usedOrganizationName: Scalars['String'];
};

export type LicenseUsedByModel = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  publicId: Scalars['String'];
  usedBy: Scalars['String'];
  usedDate: Scalars['String'];
  usedOrganizationId: Scalars['String'];
  usedOrganizationName: Scalars['String'];
};

export type LicenseWorkspaceSetupInput = {
  collaborators: Array<WorkspaceCollabModelInput>;
  name: Scalars['String'];
};

export type LicenseWorkspaceSetupModel = {
  collaborators: Array<WorkspaceCollabModel1>;
  name: Scalars['String'];
};

export type LoginInputRequest = {
  password: Scalars['String'];
  username: Scalars['String'];
};

export type LoginResponse = {
  organizations: Array<OrganizationModel>;
  publicId?: Maybe<Scalars['String']>;
  workspaces: Array<Workspace>;
};

export type LoginResponseModel = {
  isEmailVerified: Scalars['Boolean'];
  isGoogleAuthConfigComplete: Scalars['Boolean'];
};

export type MainAssetsApproveRequestWithCommentInput = {
  requestId: Scalars['String'];
  resolution: Scalars['String'];
};

export type MainAssetsApproveRequestWithCommentWithStatusInput = {
  requestId: Scalars['String'];
  resolution: Scalars['String'];
  status: PhysicalAssetStatusInput;
};

export type MainAssetsCreateAndAssignRequestInput = {
  assetId: Scalars['String'];
  customFields: Scalars['JSON'];
  requestId: Scalars['String'];
  resolution?: InputMaybe<Scalars['String']>;
};

export type MainAssetsRequestInput = {
  assetType: AssetsRequestAssetType;
  comment?: InputMaybe<Scalars['String']>;
  data: Array<PortalAssetRequestDataInput>;
  id: Scalars['String'];
  requestDate: Scalars['String'];
  requestor: AssetRequestRequestorInput;
  resolution?: InputMaybe<Scalars['String']>;
  resolveDate?: InputMaybe<Scalars['String']>;
  resolver?: InputMaybe<AssetRequestRequestorInput>;
  status: AssetsRequestStatus;
  type: AssetsRequestType;
  workspaceId: Scalars['String'];
};

export type MainAssetsRequestModel = {
  assetType: AssetsRequestAssetType;
  comment?: Maybe<Scalars['String']>;
  data: Array<PortalAssetRequestDataModel>;
  id: Scalars['String'];
  requestDate: Scalars['String'];
  requestor: AssetRequestRequestorModel;
  resolution?: Maybe<Scalars['String']>;
  resolveDate?: Maybe<Scalars['String']>;
  resolver?: Maybe<AssetRequestRequestorModel>;
  status: AssetsRequestStatus;
  type: AssetsRequestType;
  workspaceId: Scalars['String'];
};

export type MainAssetsRequestPagingModel = {
  pageInfo: PageInfo;
  result: Array<MainAssetsRequestModel>;
};

export type MainAssetsRequestRequestorPagingModel = {
  pageInfo: PageInfo;
  result: Array<AssetRequestRequestorModel>;
};

export type MainAssetsRequestWithAssetModel = {
  asset?: Maybe<MainAssetsRequestsAssetModel>;
  request: MainAssetsRequestModel;
};

export type MainAssetsRequestsAssetModel = MainAssetsRequestsPhysicalAssetModel;

export type MainAssetsRequestsFilters = {
  requestDate?: InputMaybe<Array<Scalars['String']>>;
  requestIdLike?: InputMaybe<Scalars['String']>;
  requestorId?: InputMaybe<Array<Scalars['String']>>;
  status?: InputMaybe<Array<AssetsRequestStatus>>;
  type?: InputMaybe<Array<AssetsRequestType>>;
};

export type MainAssetsRequestsPhysicalAssetModel = {
  assetId: Scalars['String'];
  assetType: AssetsRequestAssetType;
  assigned?: Maybe<Scalars['String']>;
  assignedTo?: Maybe<Scalars['String']>;
  category: Scalars['String'];
  customFields?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  manufacture: Scalars['String'];
  model: Scalars['String'];
  serial: Scalars['String'];
  status: PhysicalAssetStatusModel;
  workspaceId: Scalars['String'];
};

export enum MainCoverImageType {
  Exam = 'EXAM',
  Training = 'TRAINING'
}

export type MainCreateTrainingAssignmentInput = {
  endDate?: InputMaybe<Scalars['String']>;
  postExam?: InputMaybe<MainCreateTrainingAssignmentPostExamInput>;
  recipient: TrainingCollaboratorInput;
  startDate?: InputMaybe<Scalars['String']>;
  training?: InputMaybe<MainCreateTrainingAssignmentTrainingInput>;
};

export type MainCreateTrainingAssignmentPostExamInput = {
  examId: Scalars['String'];
  examPassingPoints: Scalars['Float'];
  timeToPass: Scalars['Float'];
};

export type MainCreateTrainingAssignmentTrainingInput = {
  limitMaxDuration: Scalars['Float'];
  limitMinDuration: Scalars['Float'];
  trainingId: Scalars['String'];
};

export type MainCreateTrainingInputDto = {
  category: Scalars['String'];
  content: Array<TrainingContentNewModelInput>;
  coverImage?: InputMaybe<TrainingCoverImageInput>;
  description: Scalars['String'];
  exam?: InputMaybe<TrainingShortExamInput>;
  level: MainTrainingLevel;
  limitMaxDuration: Scalars['Float'];
  limitMinDuration: Scalars['Float'];
  name: Scalars['String'];
  workspaceId: Scalars['String'];
};

export type MainFrameworkControlDelegatedTasksCounterInput = {
  approved: Scalars['Float'];
  created: Scalars['Float'];
  declined: Scalars['Float'];
  performed: Scalars['Float'];
};

export type MainFrameworkControlDelegatedTasksCounterModel = {
  approved: Scalars['Float'];
  created: Scalars['Float'];
  declined: Scalars['Float'];
  performed: Scalars['Float'];
};

export type MainFrameworksCreateDelegatedTaskInput = {
  controlId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  evidenceId?: InputMaybe<Scalars['String']>;
  frameworkId?: InputMaybe<Scalars['String']>;
  performer: FrameworksDelegatedTaskCollaboratorInput;
  requestorComment?: InputMaybe<Scalars['String']>;
  source: DelegatedTaskSources;
  title: Scalars['String'];
  vicaStepId?: InputMaybe<Scalars['String']>;
};

export type MainFrameworksDelegatedTaskPagingModel = {
  pageInfo: PageInfo;
  result: Array<DelegatedTaskModel>;
};

export type MainFrameworksDelegatedTasksCollaboratorAutocompleteModel = {
  pageInfo: PageInfo;
  result: Array<FrameworksDelegatedTasksCollaboratorModel>;
};

export type MainFrameworksDelegatedTasksFilter = {
  createdDate?: InputMaybe<Array<Scalars['String']>>;
  evidence?: InputMaybe<Array<Scalars['String']>>;
  performDate?: InputMaybe<Array<Scalars['String']>>;
  performer?: InputMaybe<Array<Scalars['String']>>;
  requestor?: InputMaybe<Array<Scalars['String']>>;
  resolveDate?: InputMaybe<Array<Scalars['String']>>;
  resolver?: InputMaybe<Array<Scalars['String']>>;
  status?: InputMaybe<Array<Scalars['String']>>;
  taskIdLike?: InputMaybe<Scalars['String']>;
};

export type MainHrIssueModel = {
  anonymous: Scalars['Boolean'];
  description: Scalars['String'];
  id: Scalars['String'];
  issueType: Scalars['String'];
  offender?: Maybe<HrRequestRequestorModel>;
  requestDate: Scalars['String'];
  requestor?: Maybe<HrRequestRequestorModel>;
  resolution?: Maybe<Scalars['String']>;
  resolveDate?: Maybe<Scalars['String']>;
  resolver?: Maybe<HrRequestResolverModel>;
  status: HrIssuesStatus;
  workspaceId: Scalars['String'];
};

export type MainHrIssuePagingModel = {
  pageInfo: PageInfo;
  result: Array<MainHrIssueModel>;
};

export type MainHrIssuesFilter = {
  issueIdLike?: InputMaybe<Scalars['String']>;
  issueType?: InputMaybe<Array<Scalars['String']>>;
  offender?: InputMaybe<Array<Scalars['String']>>;
  requestor?: InputMaybe<Array<Scalars['String']>>;
  status?: InputMaybe<Array<HrIssuesStatus>>;
};

export type MainHrRequestInput = {
  data: HrRequestEditProfileDataInput;
  id: Scalars['String'];
  requestDate: Scalars['String'];
  requestor: HrRequestRequestorInput;
  resolveDate?: InputMaybe<Scalars['String']>;
  resolver?: InputMaybe<HrRequestResolverInput>;
  status: MainHrRequestStatus;
  type: MainHrRequestType;
  workspaceId: Scalars['String'];
};

export type MainHrRequestModel = {
  data: HrRequestEditProfileDataModel;
  id: Scalars['String'];
  requestDate: Scalars['String'];
  requestor: HrRequestRequestorModel;
  resolveDate?: Maybe<Scalars['String']>;
  resolver?: Maybe<HrRequestResolverModel>;
  status: MainHrRequestStatus;
  type: MainHrRequestType;
  workspaceId: Scalars['String'];
};

export type MainHrRequestPagingModel = {
  pageInfo: PageInfo;
  result: Array<MainHrRequestModel>;
};

export type MainHrRequestResponseModel = {
  employee?: Maybe<PortalHrEmployeeModel>;
  request: MainHrRequestModel;
};

export enum MainHrRequestStatus {
  Approved = 'APPROVED',
  Created = 'CREATED',
  Rejected = 'REJECTED'
}

export enum MainHrRequestType {
  EditProfile = 'EDIT_PROFILE'
}

export type MainHrRequestorAutocompleteModel = {
  pageInfo: PageInfo;
  result: Array<HrRequestRequestorModel>;
};

export type MainHrRequestsFilter = {
  requestDate?: InputMaybe<Array<Scalars['String']>>;
  requestIdLike: Scalars['String'];
  requestType?: InputMaybe<Array<Scalars['String']>>;
  requestorId?: InputMaybe<Array<Scalars['String']>>;
  status?: InputMaybe<Array<Scalars['String']>>;
};

export type MainHrTimeOffEmployeesAutocompleteModel = {
  pageInfo: PageInfo;
  result: Array<HrRequestRequestorModel>;
};

export type MainHrTimeOffRequestInput = {
  approvalRoutes: Array<PortalHrTimeOffRequestApprovalRoutesInput>;
  attachments?: InputMaybe<Array<PortalHrTimeOffRequestAttachmentsInput>>;
  comment?: InputMaybe<Scalars['String']>;
  currentRouteType: Scalars['String'];
  currentStepNumber: Scalars['Float'];
  endDate?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  requestDate: Scalars['String'];
  requestor: PortalHrTimeOffRequestRequestorInput;
  startDate: Scalars['String'];
  status: HrTimeOffStatus;
  type: Scalars['String'];
};

export type MainHrTimeOffRequestModel = {
  approvalRoutes: Array<PortalHrTimeOffRequestApprovalRoutesModel>;
  attachments?: Maybe<Array<PortalHrTimeOffRequestAttachmentsModel>>;
  comment?: Maybe<Scalars['String']>;
  currentRouteType: Scalars['String'];
  currentStepNumber: Scalars['Float'];
  endDate?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  requestDate: Scalars['String'];
  requestor: PortalHrTimeOffRequestRequestorModel;
  startDate: Scalars['String'];
  status: HrTimeOffStatus;
  type: Scalars['String'];
};

export type MainHrTimeOffRequestPagingModel = {
  pageInfo: PageInfo;
  result: Array<MainHrTimeOffRequestModel>;
};

export type MainHrTimeOffRequestsFilter = {
  employee?: InputMaybe<Array<Scalars['String']>>;
  endDate?: InputMaybe<Array<Scalars['String']>>;
  requestDate?: InputMaybe<Array<Scalars['String']>>;
  startDate?: InputMaybe<Array<Scalars['String']>>;
  status?: InputMaybe<Array<Scalars['String']>>;
  timeOffIdLike: Scalars['String'];
  type?: InputMaybe<Array<Scalars['String']>>;
};

export type MainLayoutSupportMessageInput = {
  email: Scalars['String'];
  message: Scalars['String'];
  name: Scalars['String'];
};

export type MainQuestionsFullDataFilter = {
  examId: Scalars['String'];
  questionIds: Array<Scalars['String']>;
};

export type MainQuestionsFullDataFilterInput = {
  filters: Array<MainQuestionsFullDataFilter>;
};

export type MainQuestionsShortDataFilterInput = {
  examCategory?: InputMaybe<Array<Scalars['String']>>;
  examLevel?: InputMaybe<Array<Scalars['String']>>;
  examName?: InputMaybe<Array<Scalars['String']>>;
  excludeExamId?: InputMaybe<Array<Scalars['String']>>;
  questionNameLike?: InputMaybe<Scalars['String']>;
  questionType?: InputMaybe<Array<Scalars['String']>>;
  status?: InputMaybe<Array<Scalars['String']>>;
};

export type MainSectionsFullDataFilter = {
  sectionIds: Array<Scalars['String']>;
  trainingId: Scalars['String'];
};

export type MainSectionsFullDataFilterInput = {
  filters: Array<MainSectionsFullDataFilter>;
};

export type MainSectionsShortDataFilterInput = {
  excludeTrainingId?: InputMaybe<Array<Scalars['String']>>;
  sectionNameLike?: InputMaybe<Scalars['String']>;
  sectionType?: InputMaybe<Array<Scalars['String']>>;
  status?: InputMaybe<Array<Scalars['String']>>;
  trainingCategory?: InputMaybe<Array<Scalars['String']>>;
  trainingLevel?: InputMaybe<Array<Scalars['String']>>;
  trainingName?: InputMaybe<Array<Scalars['String']>>;
};

export type MainTrainingAssignmentCancelInfoModel = {
  collaboratorId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  reason: Scalars['String'];
};

export type MainTrainingAssignmentExamAutocompleteInput = {
  category: Scalars['String'];
  id: Scalars['String'];
  level: TrainingExamLevel;
  name: Scalars['String'];
};

export type MainTrainingAssignmentExamAutocompleteModel = {
  category: Scalars['String'];
  id: Scalars['String'];
  level: TrainingExamLevel;
  name: Scalars['String'];
};

export type MainTrainingAssignmentExamValidationInput = {
  questionId: Scalars['String'];
  status: MainTrainingAssignmentPostExamAnswerStatusForValidation;
  validation: AnswerValidationInput;
};

export type MainTrainingAssignmentFilterInput = {
  assignmentIdLike?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Array<Scalars['String']>>;
  examName?: InputMaybe<Array<Scalars['String']>>;
  recipient?: InputMaybe<Array<Scalars['String']>>;
  requestor?: InputMaybe<Array<Scalars['String']>>;
  startDate?: InputMaybe<Array<Scalars['String']>>;
  status?: InputMaybe<Array<Scalars['String']>>;
  trainingName?: InputMaybe<Array<Scalars['String']>>;
  type?: InputMaybe<Array<Scalars['String']>>;
};

export type MainTrainingAssignmentModel = {
  actualStartDate?: Maybe<Scalars['String']>;
  canceledInfo?: Maybe<MainTrainingAssignmentCancelInfoModel>;
  completeDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  postExam?: Maybe<MainTrainingAssignmentPostExamModel>;
  recipient: TrainingCollaboratorModel;
  requestDate: Scalars['String'];
  requestor: TrainingCollaboratorModel;
  startDate: Scalars['String'];
  status: TrainingAssignmentStatus;
  training?: Maybe<MainTrainingAssignmentTrainingModel>;
  workspaceId: Scalars['String'];
};

export type MainTrainingAssignmentPostExamAnswerModel = {
  answer?: Maybe<Array<Scalars['String']>>;
  answerDate?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  options?: Maybe<Array<TrainingExamQuestionOptionModel>>;
  order: Scalars['Float'];
  points?: Maybe<Scalars['Float']>;
  question: Scalars['String'];
  questionId: Scalars['String'];
  status: TrainingAssignmentExamAnswerStatus;
  type: TrainingExamQuestionType;
  validation?: Maybe<MainTrainingAssignmentPostExamAnswerValidationModel>;
};

export enum MainTrainingAssignmentPostExamAnswerStatusForValidation {
  Failed = 'FAILED',
  PartiallyPassed = 'PARTIALLY_PASSED',
  Passed = 'PASSED'
}

export type MainTrainingAssignmentPostExamAnswerValidationModel = {
  collaboratorId?: Maybe<Scalars['String']>;
  correctAnswer?: Maybe<Array<Scalars['String']>>;
  email?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  points?: Maybe<Scalars['Float']>;
  type: MainTrainingAssignmentPostExamAnswerValidationType;
  validationDate: Scalars['String'];
};

export enum MainTrainingAssignmentPostExamAnswerValidationType {
  Key = 'KEY',
  User = 'USER'
}

export type MainTrainingAssignmentPostExamModel = {
  completeDate?: Maybe<Scalars['String']>;
  examCategory: Scalars['String'];
  examCover?: Maybe<TrainingCoverImageModel>;
  examDescription: Scalars['String'];
  examLevel: TrainingExamLevel;
  examName: Scalars['String'];
  examPassingPoints?: Maybe<Scalars['Float']>;
  examVersion: Scalars['Float'];
  examVersionId: Scalars['String'];
  questions?: Maybe<Array<MainTrainingAssignmentPostExamAnswerModel>>;
  startDate?: Maybe<Scalars['String']>;
  status: TrainingAssignmentObjectStatus;
  timeToPass: Scalars['Float'];
  totalPoints?: Maybe<Scalars['Float']>;
  totalQuestions: Scalars['Float'];
};

export type MainTrainingAssignmentTrainingAutocompleteInput = {
  category: Scalars['String'];
  id: Scalars['String'];
  level: MainTrainingLevel;
  name: Scalars['String'];
};

export type MainTrainingAssignmentTrainingAutocompleteModel = {
  category: Scalars['String'];
  id: Scalars['String'];
  level: MainTrainingLevel;
  name: Scalars['String'];
};

export type MainTrainingAssignmentTrainingContentDataModel = {
  fileId?: Maybe<Scalars['String']>;
  innerHtml?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type MainTrainingAssignmentTrainingContentModel = {
  data: MainTrainingAssignmentTrainingContentDataModel;
  order: Scalars['Float'];
  sectionId: Scalars['String'];
  sectionName: Scalars['String'];
  status: MainTrainingProgressStatus;
  type: MainTrainingContentType;
};

export type MainTrainingAssignmentTrainingModel = {
  completeDate?: Maybe<Scalars['String']>;
  content: Array<MainTrainingAssignmentTrainingContentModel>;
  limitMaxDuration: Scalars['Float'];
  limitMinDuration: Scalars['Float'];
  startDate?: Maybe<Scalars['String']>;
  status: TrainingAssignmentObjectStatus;
  trainingCategory: Scalars['String'];
  trainingCover?: Maybe<TrainingCoverImageModel>;
  trainingDescription: Scalars['String'];
  trainingLevel: MainTrainingLevel;
  trainingName: Scalars['String'];
  trainingVersion: Scalars['Float'];
  trainingVersionId: Scalars['String'];
};

export type MainTrainingAssignmentsExamsAutocompleteModel = {
  pageInfo: PageInfo;
  result: Array<MainTrainingAssignmentExamAutocompleteModel>;
};

export type MainTrainingAssignmentsPagingModel = {
  pageInfo: PageInfo;
  result: Array<MainTrainingShortAssignmentModel>;
};

export type MainTrainingAssignmentsRecipientsAutocompleteModel = {
  pageInfo: PageInfo;
  result: Array<TrainingCollaboratorAutocompleteModel>;
};

export type MainTrainingAssignmentsRequestorsAutocompleteModel = {
  pageInfo: PageInfo;
  result: Array<TrainingCollaboratorAutocompleteModel>;
};

export type MainTrainingAssignmentsTrainingsAutocompleteModel = {
  pageInfo: PageInfo;
  result: Array<MainTrainingAssignmentTrainingAutocompleteModel>;
};

export type MainTrainingCategoriesAutocompleteModel = {
  pageInfo: PageInfo;
  result: Array<Scalars['String']>;
};

export enum MainTrainingContentType {
  Editor = 'EDITOR',
  File = 'FILE',
  VideoFile = 'VIDEO_FILE',
  VideoLink = 'VIDEO_LINK'
}

export enum MainTrainingContentTypeSectionAddDialog {
  Editor = 'EDITOR',
  File = 'FILE',
  Video = 'VIDEO'
}

export enum MainTrainingCoverImageType {
  FileId = 'FILE_ID',
  Url = 'URL'
}

export type MainTrainingExamInput = {
  category: Scalars['String'];
  coverImage: TrainingCoverImageInput;
  createdDate: Scalars['String'];
  creator: TrainingCollaboratorInput;
  description: Scalars['String'];
  editor?: InputMaybe<TrainingCollaboratorInput>;
  examId: Scalars['String'];
  examPassingPoints: Scalars['Float'];
  id: Scalars['String'];
  latest: Scalars['Boolean'];
  level: TrainingExamLevel;
  name: Scalars['String'];
  questions: Array<TrainingExamQuestionInput>;
  status: MainTrainingExamStatus;
  timeToPass: Scalars['Float'];
  totalPoints: Scalars['Float'];
  updatedDate: Scalars['String'];
  version: Scalars['Float'];
  workspaceId: Scalars['String'];
};

export type MainTrainingExamModel = {
  category: Scalars['String'];
  coverImage: TrainingCoverImageModel;
  createdDate: Scalars['String'];
  creator: TrainingCollaboratorModel;
  description: Scalars['String'];
  editor?: Maybe<TrainingCollaboratorModel>;
  examId: Scalars['String'];
  examPassingPoints: Scalars['Float'];
  id: Scalars['String'];
  latest: Scalars['Boolean'];
  level: TrainingExamLevel;
  name: Scalars['String'];
  questions: Array<TrainingExamQuestionModel>;
  status: MainTrainingExamStatus;
  timeToPass: Scalars['Float'];
  totalPoints: Scalars['Float'];
  updatedDate: Scalars['String'];
  version: Scalars['Float'];
  workspaceId: Scalars['String'];
};

export enum MainTrainingExamStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type MainTrainingExamsCategoriesAutocompleteModel = {
  pageInfo: PageInfo;
  result: Array<Scalars['String']>;
};

export type MainTrainingExamsFilterInput = {
  category?: InputMaybe<Array<Scalars['String']>>;
  createdDate?: InputMaybe<Array<Scalars['String']>>;
  examNameLike?: InputMaybe<Scalars['String']>;
  lastUpdate?: InputMaybe<Array<Scalars['String']>>;
  level?: InputMaybe<Array<Scalars['String']>>;
  status?: InputMaybe<Array<Scalars['String']>>;
};

export type MainTrainingExamsPagingModel = {
  pageInfo: PageInfo;
  result: Array<MainTrainingExamModel>;
};

export enum MainTrainingLevel {
  Basic = 'BASIC',
  High = 'HIGH',
  Medium = 'MEDIUM'
}

export type MainTrainingModel = {
  category: Scalars['String'];
  content: Array<TrainingContentNewModel>;
  coverImage?: Maybe<TrainingCoverImageModel>;
  createdDate: Scalars['String'];
  creator: TrainingCollaboratorModel;
  description: Scalars['String'];
  editor?: Maybe<TrainingCollaboratorModel>;
  exam?: Maybe<TrainingShortExamModel>;
  id: Scalars['String'];
  latest: Scalars['Boolean'];
  level: MainTrainingLevel;
  limitMaxDuration: Scalars['Float'];
  limitMinDuration: Scalars['Float'];
  name: Scalars['String'];
  status: MainTrainingStatus;
  trainingId: Scalars['String'];
  updatedDate?: Maybe<Scalars['String']>;
  version: Scalars['Float'];
  workspaceId: Scalars['String'];
};

export type MainTrainingModelInput = {
  category: Scalars['String'];
  content: Array<TrainingContentNewModelInput>;
  coverImage?: InputMaybe<TrainingCoverImageInput>;
  createdDate: Scalars['String'];
  creator: TrainingCollaboratorInput;
  description: Scalars['String'];
  editor?: InputMaybe<TrainingCollaboratorInput>;
  exam?: InputMaybe<TrainingShortExamInput>;
  id: Scalars['String'];
  latest: Scalars['Boolean'];
  level: MainTrainingLevel;
  limitMaxDuration: Scalars['Float'];
  limitMinDuration: Scalars['Float'];
  name: Scalars['String'];
  status: MainTrainingStatus;
  trainingId: Scalars['String'];
  updatedDate?: InputMaybe<Scalars['String']>;
  version: Scalars['Float'];
  workspaceId: Scalars['String'];
};

export enum MainTrainingProgressStatus {
  Done = 'DONE',
  InProgress = 'IN_PROGRESS',
  Todo = 'TODO'
}

export type MainTrainingShortAssignmentModel = {
  endDate?: Maybe<Scalars['String']>;
  examName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  recipient: Scalars['String'];
  requestDate: Scalars['String'];
  requestor: Scalars['String'];
  startDate?: Maybe<Scalars['String']>;
  status: TrainingAssignmentStatus;
  trainingName?: Maybe<Scalars['String']>;
};

export type MainTrainingShortTemplateInput = {
  category: Scalars['String'];
  coverImage?: InputMaybe<TrainingCoverImageInput>;
  description: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type MainTrainingShortTemplateModel = {
  category: Scalars['String'];
  coverImage?: Maybe<TrainingCoverImageModel>;
  description: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export enum MainTrainingStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type MainTrainingTemplateFilterInput = {
  category?: InputMaybe<Array<Scalars['String']>>;
  templateNameLike?: InputMaybe<Scalars['String']>;
};

export type MainTrainingTemplateInput = {
  category: Scalars['String'];
  content: Array<TrainingContentNewModelInput>;
  coverImage?: InputMaybe<TrainingCoverImageInput>;
  description: Scalars['String'];
  exam?: InputMaybe<TrainingTemplateExamInput>;
  id: Scalars['String'];
  level: MainTrainingLevel;
  limitMaxDuration: Scalars['Float'];
  limitMinDuration: Scalars['Float'];
  name: Scalars['String'];
};

export type MainTrainingTemplateModel = {
  category: Scalars['String'];
  content: Array<TrainingContentNewModel>;
  coverImage?: Maybe<TrainingCoverImageModel>;
  description: Scalars['String'];
  exam?: Maybe<TrainingTemplateExamModel>;
  id: Scalars['String'];
  level: MainTrainingLevel;
  limitMaxDuration: Scalars['Float'];
  limitMinDuration: Scalars['Float'];
  name: Scalars['String'];
};

export type MainTrainingTemplatesPagingModel = {
  pageInfo: PageInfo;
  result: Array<MainTrainingShortTemplateModel>;
};

export type MainTrainingsExamQuestionOptionModel = {
  correct: Scalars['Boolean'];
  option: Scalars['String'];
  order: Scalars['Float'];
  points: Scalars['Float'];
};

export type MainTrainingsFilterInput = {
  category?: InputMaybe<Array<Scalars['String']>>;
  createdDate?: InputMaybe<Array<Scalars['String']>>;
  lastUpdate?: InputMaybe<Array<Scalars['String']>>;
  level?: InputMaybe<Array<Scalars['String']>>;
  status?: InputMaybe<Array<Scalars['String']>>;
  trainingNameLike?: InputMaybe<Scalars['String']>;
};

export type MainTrainingsGetExamsAutocomplete = {
  category: Scalars['String'];
  examId: Scalars['String'];
  examPassingPoints: Scalars['Float'];
  level: Scalars['String'];
  name: Scalars['String'];
  timeToPass: Scalars['Float'];
  totalPoints: Scalars['Float'];
};

export type MainTrainingsGetExamsAutocompletePaginatedResponseModel = {
  pageInfo: PageInfo;
  result: Array<MainTrainingsGetExamsAutocomplete>;
};

export type MainTrainingsGetTrainingsAutocomplete = {
  category: Scalars['String'];
  level: Scalars['String'];
  limitMinDuration: Scalars['Float'];
  name: Scalars['String'];
  trainingId: Scalars['String'];
};

export type MainTrainingsGetTrainingsAutocompletePaginatedResponseModel = {
  pageInfo: PageInfo;
  result: Array<MainTrainingsGetTrainingsAutocomplete>;
};

export type MainTrainingsPagingModel = {
  pageInfo: PageInfo;
  result: Array<MainTrainingModel>;
};

export type MainTrainingsQuestionsFullDataForImportModel = {
  description: Scalars['String'];
  options: Array<MainTrainingsExamQuestionOptionModel>;
  order: Scalars['Float'];
  points: Scalars['Float'];
  pointsAutoCount: Scalars['Boolean'];
  question: Scalars['String'];
  type: TrainingExamQuestionType;
};

export type MainTrainingsQuestionsFullDataForImportResponseModel = {
  result: Array<MainTrainingsQuestionsFullDataForImportModel>;
};

export type MainTrainingsQuestionsShortDataForImportPaginatedResponseModel = {
  pageInfo: PageInfo;
  result: Array<MainTrainingsQuestionsShortDataForImportResponseModel>;
};

export type MainTrainingsQuestionsShortDataForImportResponseModel = {
  examCategory: Scalars['String'];
  examId: Scalars['String'];
  examLevel: TrainingExamLevel;
  examName: Scalars['String'];
  examStatus: MainTrainingExamStatus;
  questions?: Maybe<Array<QuestionShortDataModel>>;
  updatedDate?: Maybe<Scalars['String']>;
};

export type MainTrainingsSectionsFullDataForImportModel = {
  data: TrainingContentDataModel;
  name: Scalars['String'];
  type: MainTrainingContentType;
};

export type MainTrainingsSectionsFullDataForImportResponseModel = {
  result: Array<MainTrainingsSectionsFullDataForImportModel>;
};

export type MainTrainingsSectionsShortDataForImportPaginatedResponseModel = {
  pageInfo: PageInfo;
  result: Array<MainTrainingsSectionsShortDataForImportResponseModel>;
};

export type MainTrainingsSectionsShortDataForImportResponseModel = {
  sections?: Maybe<Array<SectionShortDataModel>>;
  trainingCategory: Scalars['String'];
  trainingId: Scalars['String'];
  trainingLevel: MainTrainingLevel;
  trainingName: Scalars['String'];
  trainingStatus: MainTrainingStatus;
  updatedDate?: Maybe<Scalars['String']>;
};

export type MainUploadCoverImageResponse = {
  imageId: Scalars['String'];
  thumbnailId: Scalars['String'];
};

export type MainVicaCategoryCollaboratorAutocompleteModel = {
  pageInfo: PageInfo;
  result: Array<MainVicaCategoryCollaboratorModel>;
};

export type MainVicaCategoryCollaboratorInput = {
  collaboratorId: Scalars['String'];
  email: Scalars['String'];
  fullName: Scalars['String'];
};

export type MainVicaCategoryCollaboratorModel = {
  collaboratorId: Scalars['String'];
  email: Scalars['String'];
  fullName: Scalars['String'];
};

export type MainVicaCategoryInput = {
  delegatedTasks: Scalars['Float'];
  name: Scalars['String'];
  order: Scalars['Float'];
  progress: MainVicaCategoryProgressInput;
  supervisor?: InputMaybe<MainVicaCategoryCollaboratorInput>;
};

export type MainVicaCategoryModel = {
  delegatedTasks: Scalars['Float'];
  name: Scalars['String'];
  order: Scalars['Float'];
  progress: MainVicaCategoryProgressModel;
  supervisor?: Maybe<MainVicaCategoryCollaboratorModel>;
};

export type MainVicaCategoryProgressInput = {
  completedSteps: Scalars['Float'];
  totalSteps: Scalars['Float'];
};

export type MainVicaCategoryProgressModel = {
  completedSteps: Scalars['Float'];
  totalSteps: Scalars['Float'];
};

export type MainVicaCategoryStepActionsInput = {
  data: Scalars['String'];
  title: Scalars['String'];
  type: MainVicaStepActionType;
};

export type MainVicaCategoryStepActionsModel = {
  data: Scalars['String'];
  title: Scalars['String'];
  type: MainVicaStepActionType;
};

export type MainVicaCategoryStepDelegatedTaskInput = {
  approved: Scalars['Float'];
  created: Scalars['Float'];
  declined: Scalars['Float'];
  performed: Scalars['Float'];
};

export type MainVicaCategoryStepDelegatedTaskModel = {
  approved: Scalars['Float'];
  created: Scalars['Float'];
  declined: Scalars['Float'];
  performed: Scalars['Float'];
};

export type MainVicaCategoryStepFrameworkControlInput = {
  evidenceName: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type MainVicaCategoryStepFrameworkControlModel = {
  evidenceName: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type MainVicaCategoryStepFrameworkInput = {
  controls: Array<MainVicaCategoryStepFrameworkControlInput>;
  id: Scalars['String'];
  logo: Scalars['String'];
  name: Scalars['String'];
};

export type MainVicaCategoryStepFrameworkModel = {
  controls: Array<MainVicaCategoryStepFrameworkControlModel>;
  id: Scalars['String'];
  logo: Scalars['String'];
  name: Scalars['String'];
};

export type MainVicaCategoryStepInput = {
  actions: Array<MainVicaCategoryStepActionsInput>;
  delegatedTasks?: InputMaybe<MainVicaCategoryStepDelegatedTaskInput>;
  description: Scalars['String'];
  evidenceId: Scalars['String'];
  frameworks: Array<MainVicaCategoryStepFrameworkInput>;
  id: Scalars['String'];
  instruction: Scalars['String'];
  name: Scalars['String'];
  orderInCategory?: InputMaybe<Scalars['Float']>;
  responsible?: InputMaybe<Array<MainVicaCategoryCollaboratorInput>>;
  status: MainVicaStepStatus;
};

export type MainVicaCategoryStepModel = {
  actions: Array<MainVicaCategoryStepActionsModel>;
  delegatedTasks?: Maybe<MainVicaCategoryStepDelegatedTaskModel>;
  description: Scalars['String'];
  evidenceId: Scalars['String'];
  frameworks: Array<MainVicaCategoryStepFrameworkModel>;
  id: Scalars['String'];
  instruction: Scalars['String'];
  name: Scalars['String'];
  orderInCategory?: Maybe<Scalars['Float']>;
  responsible?: Maybe<Array<MainVicaCategoryCollaboratorModel>>;
  status: MainVicaStepStatus;
};

export type MainVicaCategoryStepsFilter = {
  frameworks?: InputMaybe<Array<Scalars['String']>>;
  responsible?: InputMaybe<Array<Scalars['String']>>;
  status?: InputMaybe<Array<Scalars['String']>>;
};

export type MainVicaCreateDelegatedTaskInput = {
  controlId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  evidenceId?: InputMaybe<Scalars['String']>;
  frameworkId?: InputMaybe<Scalars['String']>;
  performer: FrameworksDelegatedTaskCollaboratorInput;
  requestorComment?: InputMaybe<Scalars['String']>;
  source: DelegatedTaskSources;
  title: Scalars['String'];
  vicaStepId?: InputMaybe<Scalars['String']>;
};

export type MainVicaDelegatedTaskCollaboratorAutocompleteModel = {
  pageInfo: PageInfo;
  result: Array<MainVicaDelegatedTaskCollaboratorModel>;
};

export type MainVicaDelegatedTaskCollaboratorInput = {
  collaboratorId: Scalars['String'];
  fullName: Scalars['String'];
};

export type MainVicaDelegatedTaskCollaboratorModel = {
  collaboratorId: Scalars['String'];
  fullName: Scalars['String'];
};

export type MainVicaDelegatedTaskInput = {
  controlId?: InputMaybe<Scalars['String']>;
  createdDate: Scalars['String'];
  data?: InputMaybe<FrameworksDelegatedTaskDataInput>;
  description: Scalars['String'];
  evidenceId?: InputMaybe<Scalars['String']>;
  frameworkId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  performDate?: InputMaybe<Scalars['String']>;
  performer: FrameworksDelegatedTaskCollaboratorInput;
  performerComment?: InputMaybe<Scalars['String']>;
  requestor: FrameworksDelegatedTaskCollaboratorInput;
  requestorComment: Scalars['String'];
  resolveDate?: InputMaybe<Scalars['String']>;
  resolver?: InputMaybe<FrameworksDelegatedTaskCollaboratorInput>;
  resolverComment?: InputMaybe<Scalars['String']>;
  source: DelegatedTaskSources;
  status: FrameworksDelegatedTaskStatus;
  title: Scalars['String'];
  type: FrameworksDelegatedTaskType;
  vicaStepId?: InputMaybe<Scalars['String']>;
  workspaceId: Scalars['String'];
};

export type MainVicaDelegatedTaskModel = {
  controlId?: Maybe<Scalars['String']>;
  createdDate: Scalars['String'];
  data?: Maybe<FrameworksDelegatedTaskDataModel>;
  description: Scalars['String'];
  evidenceId?: Maybe<Scalars['String']>;
  frameworkId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  performDate?: Maybe<Scalars['String']>;
  performer: FrameworksDelegatedTaskCollaboratorModel;
  performerComment?: Maybe<Scalars['String']>;
  requestor: FrameworksDelegatedTaskCollaboratorModel;
  requestorComment: Scalars['String'];
  resolveDate?: Maybe<Scalars['String']>;
  resolver?: Maybe<FrameworksDelegatedTaskCollaboratorModel>;
  resolverComment?: Maybe<Scalars['String']>;
  source: DelegatedTaskSources;
  status: FrameworksDelegatedTaskStatus;
  title: Scalars['String'];
  type: FrameworksDelegatedTaskType;
  vicaStepId?: Maybe<Scalars['String']>;
  workspaceId: Scalars['String'];
};

export type MainVicaDelegatedTaskPagingModel = {
  pageInfo: PageInfo;
  result: Array<MainVicaDelegatedTaskModel>;
};

export type MainVicaGetCategoriesWithFilterResponseModel = {
  result: Array<MainVicaCategoryModel>;
};

export type MainVicaGetCategoryStepsWithFilterResponseModel = {
  result: Array<MainVicaCategoryStepModel>;
};

export type MainVicaGetWorkspaceCollaboratorsResponseModel = {
  result: Array<MainVicaCategoryCollaboratorModel>;
};

export enum MainVicaStepActionType {
  Link = 'LINK',
  Template = 'TEMPLATE',
  Upload = 'UPLOAD'
}

export enum MainVicaStepStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED'
}

export type ManagedApplicationConfigInput = {
  accountMappingConfig: AccountMappingConfigInput;
  collectionConfigs: Array<CollectionConfigInput>;
  collectionPrefix: Scalars['String'];
};

export type ManagedApplicationModel = {
  applicationGroup?: Maybe<Scalars['String']>;
  certifications: Array<Scalars['String']>;
  config?: Maybe<Config>;
  description?: Maybe<Scalars['String']>;
  documentationLink?: Maybe<Scalars['String']>;
  endpointMappingName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  releaseDate?: Maybe<Scalars['String']>;
  securityScope?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type ManagedApplicationModelInput = {
  applicationGroup?: InputMaybe<Scalars['String']>;
  certifications: Array<Scalars['String']>;
  config?: InputMaybe<ManagedApplicationConfigInput>;
  description?: InputMaybe<Scalars['String']>;
  documentationLink?: InputMaybe<Scalars['String']>;
  endpointMappingName?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  logo?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  releaseDate?: InputMaybe<Scalars['String']>;
  securityScope?: InputMaybe<Scalars['String']>;
  status: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
};

export type Message = {
  message: Scalars['String'];
};

export type MessageResponseModel = {
  isSent: Scalars['Boolean'];
};

export type MonitoringFilter = {
  monitoring?: Maybe<Array<Scalars['String']>>;
};

export type MonitoringFilterModel = ApplicationFilter | FrameworkFilter | NameFilter;

export type MonitoringInput = {
  filter: TMonitoringFilterInput;
  pageInfo?: InputMaybe<SharedPaginationInput>;
};

export type MonitoringItemModel = {
  data: Array<ResultUnion>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type MonitoringModel = {
  applications: Array<ApplicationsMonitoringModel>;
  description?: Maybe<Scalars['String']>;
  findings: Scalars['Float'];
  frameworks: Array<FrameworkMonitoringModel>;
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  monitoring: Array<MonitoringItemModel>;
  name: Scalars['String'];
  notifications: Array<NotificationModel>;
  originalTypeName: Scalars['String'];
  preRequisites: Array<PreRequisiteModel>;
  severity: Scalars['String'];
};

export type MonitoringMonitoringInput = {
  id: Scalars['String'];
  type: Scalars['String'];
  valuesId: Array<Scalars['String']>;
};

export type Mutation = {
  acceptInvite: Message;
  activateAutomation: Message;
  activateOrganizationByAdmin: Message;
  activateUserByAdmin: Message;
  addApplication: Message;
  addAssetSettingsByAdmin: Array<AssetSettingByAdminModel>;
  addAssigneeToAnalyse: Message;
  addAssignmentToControl: IdMessage;
  addAutomation: Message;
  addAutomationList: QsAutomationsResponse;
  addBuilderControl: BuilderControlModel;
  addBuilderEvidence: BuilderEvidenceModel;
  addComment: Comment;
  addConflicts: Message;
  addControlsAndEvidencesFromFiles: Message;
  addCrownJewels: CrownJewel;
  addCustomTextToEvidence: IdMessage;
  addFramework: BuilderFrameworkModel;
  addFrameworkToWorkspace: Message;
  addGapFromFiles: Message;
  addIntergation: AddIntegrationResponse;
  addJobRecord: HrEmployeeJobInfoModel;
  addKycTargetToBlackList: Message;
  addNewIdentity: Message;
  addOrganizationBusinessWithBilling: NotCompletedOrganization;
  addOrganizationBusinessWithoutPayment: CreateOrganizationResponseModel;
  addOrganizationEnterprise: CreateOrganizationResponseModel;
  addOrganizationFree: CreateOrganizationResponseModel;
  addPlaybookToWorkspace: Message;
  addPolicy: BuilderPolicyModel;
  addPolicyToWid: IdMessage;
  addProfile: ProfileInfo;
  addQSPolicies: AddPolicyQsModelResponse;
  addQSPolicyAssets: Array<FileModel>;
  addQSWFAssign: FrameworkQsModel;
  addTemplate: AdminEmailTemplate;
  addVendorFile: VendorDocument;
  addWorkspace: NewWorkspaceWithShortCollabsModel;
  adminAddBuilderControl: AdminBuilderControlModel;
  adminAddBuilderEvidence: AdminBuilderEvidenceModel;
  adminAddFramework: AdminBuilderFrameworkModel;
  adminAddPolicy: AdminBuilderPolicyModel;
  adminChangeFrameworkName: Message;
  adminChangeFrameworkVisibility: Message;
  adminCreateDocument: FileModel;
  adminCreateDocumentsRefactor: NewDocumentModel;
  adminDeleteAllFile: Message;
  adminDeleteControl: Message;
  adminDeleteDocument: Message;
  adminDeleteDocumentsRefactor: Message;
  adminDeleteEvidence: Message;
  adminDeleteFramework: Message;
  adminDeletePolicy: Message;
  adminEditBuilderControl: AdminBuilderControlModel;
  adminEditBuilderEvidence: AdminBuilderEvidenceModel;
  adminGenerateRecoveryCodesByPublicId: Array<Scalars['String']>;
  adminLinkControl: AdminLinkControlResponseModel;
  adminLinkEvidence: AdminLinkControlResponseModel;
  adminLogout: GeneralResponse;
  adminUnlinkControl: Message;
  adminUnlinkEvidence: Message;
  adminUpdateDocument: FileModel;
  adminUpdateDocumentsRefactor: NewDocumentModel;
  adminUpdateFramework: AdminBuilderFrameworkModel;
  adminUpdatePolicy: AdminBuilderPolicyModel;
  adminUploadFile: Message;
  adoptFrameworkToWorkspace: NewFrameworkModel;
  allowConflictCustom: Message;
  allowConflictStandard: Message;
  approveApproveStageByStageId: GetFullDocumentResponseModel;
  approveSignStageByStageId: GetFullDocumentResponseModel;
  archiveReportByUser: Message;
  assignStageToMainControl: Message;
  blockOrganizationByAdmin: Message;
  blockUserByAdmin: Message;
  cancelRequest: Message;
  changeAccessManagementStatus: Message;
  changeAssetStatus: PhysicalAssetModel;
  changeDocumentStageEta: GetFullDocumentResponseModel;
  changeFrameworkName: Message;
  changeFrameworkVisibility: Message;
  changeName: GeneralResponse;
  changePassword: GeneralResponse;
  changeReviewedControlByAuditor: ChangeReviewControlModel;
  changeRisksModel: RisksPaginationModel;
  changeStatusNCRByAuditor: NcrModel;
  createAccessManagementAppByVendor: AccessManagementApp;
  createAccountByInvitation: Message;
  createAdminRole: Message;
  createAppDuty: DutyModel;
  createByTemplateTask: Message;
  createCampaignReviewInstruction: Message;
  createCertificateAsset: CertificateAssetModel;
  createCertificateAssetSettingRow: CertificateAssetSettingsModel;
  createDocument: Message;
  createDutyRule: DutyRuleModel;
  createFastSnapshotPage: IdMessage;
  createFolder: Message;
  createHrEmployee: Message;
  createHrEmployeeSetting: Message;
  createHrSettingsJobTitle: HrEmployeeJobTitleModel;
  createIssue: GeneralResponse;
  createIssues: GeneralResponse;
  createKycTargetException: KycScreeningFullInfoModel;
  createKycTemplate: KycRefactorTemplateModel;
  createMessage: Message;
  createMessagePublicId: Message;
  createNcr: NcrModel;
  createNewAccessManagementApp: AccessManagementApp;
  createNewDocument: Message;
  createPermissionByAdmin: Message;
  createPhysicalAsset: PhysicalAssetModel;
  createPhysicalAssetSettingRow: PhysicalAssetSettingsModel;
  createPolicy: Message;
  createReport: IdMessage;
  createRisk: RiskModel;
  createRiskRegistry: RiskRegistryModel;
  createRisksModels: RiskModelModel;
  createRole: Message;
  createSaasAsset: SaasAssetModel;
  createSaasAssetSettingRow: SaasAssetSettingsModel;
  createScreeningCreatedMessage: Message;
  createSoftwareAsset: SoftwareAssetModel;
  createSoftwareAssetSettingRow: SoftwareAssetSettingsModel;
  createTarget: Message;
  createTargetVulnerability: SmallTargetModel;
  createUploadedFiles: Array<FileModel>;
  createVendor: VendorModel;
  createVendorsSettingRow: VendorsSettingsModel;
  createVirtualAsset: VirtualAssetModel;
  createVirtualAssetSettingRow: VirtualAssetSettingsModel;
  createWCMapper: Message;
  deactivateAutomation: Message;
  declineInvite: Message;
  deleteAccessManagementCustomAppById: Message;
  deleteAllFile: Message;
  deleteAllFileORG: Message;
  deleteAppDuty: Message;
  deleteApplication: Message;
  deleteAssetFromNCRByUser: NcrModel;
  deleteAssignmentToControl: Message;
  deleteAuditorsInSnapshot: Message;
  deleteAutomationById: Message;
  deleteCampaignReviewInstruction: Message;
  deleteCertificateAsset: Message;
  deleteCertificateAssetSettingRow: CertificateAssetSettingsModel;
  deleteConflictException: DutyRuleModel;
  deleteControl: Message;
  deleteCrownJewel: Scalars['String'];
  deleteDutyRule: Message;
  deleteEvidence: Message;
  deleteEvidenceFile: Message;
  deleteFolder: Message;
  deleteFramework: Message;
  deleteHrEmployeeById: Message;
  deleteHrEmployeeSetting: Message;
  deleteIdentity: Message;
  deleteIntegration: Message;
  deleteItems: Message;
  deleteJobRecord: Message;
  deleteKycArchivedTarget: Message;
  deleteKycTemplate: Message;
  deleteLicense: Message;
  deleteNCR: Message;
  deleteNewDocument: Message;
  deleteNotCompletedOrganization: Message;
  deleteOrganizationByAdmin: Message;
  deletePermissionByAdmin: Message;
  deletePhysicalAsset: Message;
  deletePhysicalAssetSettingRow: PhysicalAssetSettingsModel;
  deletePolicy: Message;
  deletePolicyEditableAsset: Message;
  deletePolicyEvidenceFile: Message;
  deleteProfile: GeneralResponse;
  deleteReport: Message;
  deleteRiskById: Message;
  deleteRiskRegistry: Message;
  deleteRisksModel: Message;
  deleteRole: Message;
  deleteRoleByAdmin: Message;
  deleteSaasAsset: Message;
  deleteSaasAssetSettingRow: SaasAssetSettingsModel;
  deleteSettingsJobTitle: Message;
  deleteSoftwareAsset: Message;
  deleteSoftwareAssetSettingRow: SoftwareAssetSettingsModel;
  deleteTarget: Message;
  deleteTargetException: Message;
  deleteTemplate: Message;
  deleteUserByAdmin: Message;
  deleteVendor: Message;
  deleteVendorById: Message;
  deleteVendorFile: Message;
  deleteVendorsSettingRow: VendorsSettingsModel;
  deleteVirtualAsset: Message;
  deleteVirtualAssetSettingRow: VirtualAssetSettingsModel;
  deleteWCAssign: Message;
  deleteWorkspace: Message;
  deleteWorkspaceByAdmin: Message;
  deleteWorkspaceCollaborator: Message;
  deleteWorkspaceInvite: Message;
  denyConflict: RulesConflictModel;
  disableGoogleAuth: Message;
  docsLogout: GeneralResponse;
  editAccessManagementApp: AccessManagementApp;
  editAppDuty: DutyModel;
  editAssetSettingsByAdmin: Array<AssetSettingByAdminModel>;
  editBuilderControl: BuilderControlModel;
  editBuilderEvidence: BuilderEvidenceModel;
  editCertificateAssetSettingRow: CertificateAssetSettingsModel;
  editConflictException: DutyRuleModel;
  editDutyRule: DutyRuleModel;
  editHrSettingsJobTitle: HrEmployeeJobTitleModel;
  editPhysicalAssetSettingRow: PhysicalAssetSettingsModel;
  editRole: Message;
  editRoleByAdmin: Message;
  editSaasAssetSettingRow: SaasAssetSettingsModel;
  editSodScheduler: SodSchedulerModel;
  editSoftwareAssetSettingRow: SoftwareAssetSettingsModel;
  editVendorsSettingRow: VendorsSettingsModel;
  editVirtualAssetSettingRow: VirtualAssetSettingsModel;
  emailVerify: RegistrationResponse;
  fillFillableFieldOnSignStage: GetFullDocumentResponseModel;
  generateFileByHtml: UploadFileResponseModel;
  generateNewToken: Message;
  getCsvFieldsAccessManagement: ImportCsvFieldsWithId;
  getCsvFieldsCertificate: ImportCsvFieldsWithId;
  getCsvFieldsCollaborators: ImportCsvFieldsWithId;
  getCsvFieldsEmployees: ImportCsvFieldsWithId;
  getCsvFieldsPhysicalAssets: ImportCsvFieldsWithId;
  getCsvFieldsRisks: ImportCsvFieldsWithId;
  getCsvFieldsSAAS: ImportCsvFieldsWithId;
  getCsvFieldsSoftware: ImportCsvFieldsWithId;
  getCsvFieldsVendors: ImportCsvFieldsWithId;
  getCsvFieldsVirtual: ImportCsvFieldsWithId;
  getDataForCreateReport: ReportViewModel;
  getIssuesCount: IssuesCountModel;
  importCsvRuleset: Message;
  initialValidateGoogleAuthorization: Array<Scalars['String']>;
  invalidateDocument: GetFullDocumentResponseModel;
  inviteMemberIntoWorkspace: GetWorkspaceCollabsAndInvitesResponseModel;
  kycAnalyseRestart: Message;
  kycCancelRequestById: Message;
  kycChangeRequestStatus: KycRequestModel;
  kycCreateTemplate: KycTemplateModel;
  kycDeleteTemplate: Message;
  kycGenerateTokenByTemplateId: KycTokenDto;
  kycRejectFormByToken: Message;
  kycSendRequestsToEmails: Message;
  kycSetLimit: KycQuotesDto;
  kycSubmitFormByToken: KycRedirectUrlDto;
  kycUpdateTemplate: KycTemplateModel;
  leaveResponseToNCRByUser: NcrModel;
  licenseCreateMulti: IdsModel;
  licenseCreateOne: CreateOneLicenseResponseModel;
  linkControl: BuilderControlModel;
  linkEvidence: BuilderEvidenceModel;
  login: LoginResponseModel;
  loginAdmin: LoginResponseModel;
  loginByRecoveryCode: SharedLoginDataResponse;
  loginDocs: LoginResponseModel;
  loginDocsCode: SharedLoginDataResponse;
  logout: GeneralResponse;
  mainAssetsApproveRequestRemoveAsset: IdMessage;
  mainAssetsApproveRequestRequestAsset: IdMessage;
  mainAssetsAssignNotAssignedAsset: IdMessage;
  mainAssetsCreateAndAssignAsset: IdMessage;
  mainAssetsReassignAsset: IdMessage;
  mainAssetsRequestsReject: Message;
  mainFrameworksApproveTaskById: DelegatedTaskModel;
  mainFrameworksCancelTaskById: DelegatedTaskModel;
  mainFrameworksCreateDelegatedTask: Message;
  mainFrameworksDeclineTaskById: DelegatedTaskModel;
  mainHrApproveRequest: Message;
  mainHrApproveTimeOffRequest: Message;
  mainHrDeleteRequest: Message;
  mainHrRejectRequest: Message;
  mainHrRejectTimeOffRequest: Message;
  mainHrSetIssueStatusInProgress: Message;
  mainHrSetIssueStatusResolved: Message;
  mainHrSkipTimeOffRequest: Message;
  mainTrainingUploadFile: IdNameModel;
  mainTrainingsAcceptValidationReviewByAssignmentIdAndExamType: Message;
  mainTrainingsCancelTrainingAssignment: Message;
  mainTrainingsChangeExamName: Message;
  mainTrainingsChangeTrainingName: Message;
  mainTrainingsChangeTrainingStatus: Message;
  mainTrainingsCreateExam: MainTrainingExamModel;
  mainTrainingsCreateTraining: MainTrainingModel;
  mainTrainingsCreateTrainingAssignment: MainTrainingAssignmentModel;
  mainTrainingsMoveExamToArchive: Message;
  mainTrainingsRestoreExamFromArchive: Message;
  mainTrainingsUpdateExam: MainTrainingExamModel;
  mainTrainingsUpdateTraining: MainTrainingModel;
  mainUploadCoverImage: MainUploadCoverImageResponse;
  mainVicaApproveDelegatedTaskById: DelegatedTaskModel;
  mainVicaCancelDelegatedTaskById: DelegatedTaskModel;
  mainVicaChangeStepStatus: Message;
  mainVicaCreateDelegatedTask: Message;
  mainVicaDeclineDelegatedTaskById: DelegatedTaskModel;
  mainVicaUpdateCategorySupervisor: Message;
  mainVicaUpdateStepResponsibleCollaborators: Message;
  makeDocDraftCopy: GetFullDocumentResponseModel;
  moveItems: Message;
  moveKycTargetToArchive: Message;
  moveNewItems: Message;
  performCsvAccessManagement: ImportCsvPerformResponse;
  performCsvByFileId: Message;
  performCsvCertificate: ImportCsvPerformResponse;
  performCsvCollaborators: ImportCsvPerformResponse;
  performCsvEmployees: ImportCsvPerformResponse;
  performCsvPhysicalAssets: ImportCsvPerformResponse;
  performCsvRisks: ImportCsvPerformResponse;
  performCsvSAAS: ImportCsvPerformResponse;
  performCsvSoftware: ImportCsvPerformResponse;
  performCsvVendors: ImportCsvPerformResponse;
  performCsvVirtual: ImportCsvPerformResponse;
  portalApproveApproveStageByStageId: GetFullDocumentResponseModel;
  portalApproveSignStageByStageId: GetFullDocumentResponseModel;
  portalAssetsCancelAssetRequest: Message;
  portalAssetsCreateRequestAddAsset: IdMessage;
  portalAssetsCreateRequestRemoveAsset: IdMessage;
  portalAssetsCreateRequestRequestAsset: IdMessage;
  portalFillFillableFieldOnSignStage: GetFullDocumentResponseModel;
  portalFinishTraining: Message;
  portalFinishTrainingSection: FinishTrainingSectionResponseModel;
  portalHrApproveTimeOffRequest: Message;
  portalHrCancelMyTimeOffRequest: Message;
  portalHrCancelRequest: Message;
  portalHrCreateEditRequest: Message;
  portalHrCreateIssue: PortalHrIssueModel;
  portalHrCreateTimeOffRequest: Message;
  portalHrRejectTimeOffRequest: Message;
  portalHrUpdateMyTimeOffRequest: Message;
  portalRejectApproveStageByStageId: GetFullDocumentResponseModel;
  portalRejectSignStageByStageId: GetFullDocumentResponseModel;
  portalRequiredActionsPerformActionProvideFiles: Message;
  portalStartTraining: Message;
  portalTrainingsExamSaveAnswer: PortalTrainingExamSubmitAnswerResponse;
  portalTrainingsExamSkipAnswer: PortalTrainingExamSubmitAnswerResponse;
  portalTrainingsFinishExam: PortalTrainingExamFinishResponse;
  portalTrainingsStartExam: Message;
  portalUpdateFullDocumentByDocs: GetFullDocumentResponseModel;
  portalUpdateTrainingDuration: Message;
  portalUploadFile: Message;
  previewEditableDocument: GetFullDocumentResponseModel;
  reconfigureGoogleAuth: ReconfigureGoogleAuthResponseModel;
  refreshReport: GeneralResponse;
  registration: Message;
  rejectApproveStageByStageId: GetFullDocumentResponseModel;
  rejectKycForm: Message;
  rejectSignStageByStageId: GetFullDocumentResponseModel;
  releaseAccessManagementApp: Scalars['String'];
  releaseCertificateAssets: Message;
  releaseHrEmployees: Message;
  releaseLicense: Message;
  releasePhysicalAssets: Message;
  releaseRiskRegistry: Message;
  releaseSaasAssets: Message;
  releaseSoftwareAssets: Message;
  releaseTargetScans: Message;
  releaseVendors: Message;
  releaseVirtualAssets: Message;
  removeAssetSettingsByAdmin: Array<AssetSettingByAdminModel>;
  removeAssigneeFromAnalyse: Message;
  removeEvidenceAsset: Message;
  removeFrameworkFromWorkspace: Message;
  removePlaybookFromWorkspace: Message;
  removePolicyFromWid: Message;
  renameItem: Message;
  resendEmailVerificationCode: Message;
  resendWorkspaceInvite: Message;
  resetPassword: Message;
  restartSignStageByStageIdAndGroupId: GetFullDocumentResponseModel;
  restartSignStageByStageIdAndRecipient: GetFullDocumentResponseModel;
  restoreKycTargetFromArchive: Message;
  restoreKycTargetFromBlackList: Message;
  restoreNewItem: Message;
  runAutomationById: Message;
  runCampaignReviewInstruction: Message;
  runRuleCheck: Array<RulesConflictModel>;
  runTarget: Message;
  sendDocsSupportMessage: MessageResponseModel;
  sendMessageToSupportMainLayout: MessageResponseModel;
  sendSupportMessage: MessageResponseModel;
  sendTemplateToClient: Message;
  sendToNextStepByStageId: GetFullDocumentResponseModel;
  setAccountIdentity: GeneralResponse;
  setDocumentAsEvidenceAsset: Message;
  setEvidenceStatus: Scalars['String'];
  setIssueAssignee: GeneralResponse;
  setIssueStatus: GeneralResponse;
  setKycTargetVerified: Message;
  setPlaybookActive: Message;
  setReportShareSettings: ReportShareSettingsModel;
  setSnapshotReportResponseByUser: Message;
  setTaskCategoryResponsible: Message;
  setTaskCollabs: Message;
  startCollector: Message;
  startNewDocumentExecution: GetFullDocumentResponseModel;
  startOneTimeScreening: KycOneTimeScreeningModel;
  startResearch: Message;
  startTargetScreening: Message;
  stopAutomation: Message;
  submitKycForm: Message;
  terminateExecutor: Message;
  toggleCampaignReviewInstructionStatus: Message;
  toggleWCMapperActivity: Message;
  transferOrganizationOwnership: Message;
  transferOrganizationOwnershipByAdmin: Message;
  twoFactorLogin: SharedLoginDataResponse;
  twoFactorLoginAdmin: SharedLoginDataResponse;
  twoFactorResendEmail: Message;
  unlinkControl: Message;
  unlinkEvidence: Message;
  updateAccessManagementAppNameAndVendor: Message;
  updateApplication: Message;
  updateAuditors: Message;
  updateAutomation: Message;
  updateAvailableCollabsCounterByAdmin: Message;
  updateAvailableVulTargetsCounterByAdmin: Message;
  updateAvailableWorkspacesCounterByAdmin: Message;
  updateCampaignReviewInstruction: Message;
  updateCampaignReviewRows: Message;
  updateCampaignReviewRowsDocs: Message;
  updateCertificateAsset: CertificateAssetModel;
  updateConfig: Message;
  updateConfigurationPolicyMapper: Message;
  updateCrownJewel: CrownJewel;
  updateCustomFramework: Message;
  updateDocument: Message;
  updateEditableAsset: IdMessage;
  updateEmployeeHireDate: Message;
  updateEmployeeStatus: Message;
  updateEmployeesTree: Array<SmallPersonModel>;
  updateFullDocument: GetFullDocumentResponseModel;
  updateFullDocumentByDocs: GetFullDocumentResponseModel;
  updateHrEmployee: Message;
  updateHrEmployeeSetting: Message;
  updateIntergation: Message;
  updateJobRecord: HrEmployeeJobInfoModel;
  updateKycTargetRisk: Message;
  updateKycTargetValues: Message;
  updateKycTemplate: KycRefactorTemplateModel;
  updateMonitoring: GeneralResponse;
  updateNCR: NcrModel;
  updateNewDocumentData: NewDocumentModel;
  updateNewDocumentEditors: NewDocumentModel;
  updateNewDocumentName: NewDocumentModel;
  updateNewDocumentRecipients: NewDocumentModel;
  updateNewDocumentStatus: NewDocumentModel;
  updateNonCustomAccessManagementAppRow: Message;
  updateOrgCollabsRulesByAdmin: Message;
  updateOrgSubscriptionByAdmin: Message;
  updateOrgSubscriptionExpiryByAdmin: Message;
  updateOrgTrialUsedByAdmin: Message;
  updateOrganizationBillingInfo: BillingModel;
  updateOrganizationLogo: Message;
  updateOrganizationName: Message;
  updateOrganizationWizardsByAdmin: Message;
  updatePassword: Message;
  updatePermissionByAdmin: Message;
  updatePhysicalAsset: PhysicalAssetModel;
  updatePlaybookAnalyse: Message;
  updatePolicy: BuilderPolicyModel;
  updateReport: GeneralResponse;
  updateReportInfo: NcrReportConfigModel;
  updateReportStatus: Message;
  updateRiskRegistry: RiskRegistryModel;
  updateRisksByRegistryId: UpdatedRisksModel;
  updateRisksModel: RiskModelModel;
  updateSaasAsset: SaasAssetModel;
  updateSoftwareAsset: SoftwareAssetModel;
  updateTarget: SmallTargetModel;
  updateTemplate: AdminEmailTemplate;
  updateUserProfile: Scalars['String'];
  updateUserRole: Message;
  updateVendor: VendorModel;
  updateVirtualAsset: VirtualAssetModel;
  updateWCMapper: Message;
  updateWorkspaceAccountMappingConfigByAdmin: Message;
  updateWorkspaceCollaboratorRole: Message;
  updateWorkspaceName: Message;
  updateWorkspaceProfileMappingConfigByAdmin: Message;
  uploadAssetsToNCRByUser: NcrModel;
  uploadEditableAsset: IdMessage;
  uploadEvidenceAsset: EvidenceAutoFileDto;
  uploadEvidenceFile: Message;
  uploadFile: Message;
  uploadFileORG: Message;
  uploadKycCsvFile: UploadCsvFileResponseModel;
  uploadPolicyEvidenceFile: IdMessage;
  verifyActorChanges: Message;
  verifyActorChangesDocs: Message;
  vicaAdminAddFromFiles: VicaAdminCategoriesResponseModel;
  vicaAdminChangeCategoriesOrder: Array<VicaAdminOrderModel>;
  vicaAdminChangeTasksOrder: Array<VicaAdminOrderModel>;
  vicaAdminCreateCategory: VicaAdminCategoryModel;
  vicaAdminCreateTask: VicaAdminTaskModel;
  vicaAdminDeleteCategory: Message;
  vicaAdminDeleteTask: Message;
  vicaAdminUpdateCategory: VicaAdminCategoryModel;
  vicaAdminUpdateTask: VicaAdminTaskModel;
  workerConfirmSignStage?: Maybe<Message>;
  workerConfirmStage?: Maybe<Message>;
  workerUploadFile: Message;
  workerUploadNewFileForReview: Message;
};


export type MutationAcceptInviteArgs = {
  inviteId: Scalars['String'];
};


export type MutationActivateAutomationArgs = {
  data: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationActivateOrganizationByAdminArgs = {
  id: Scalars['String'];
};


export type MutationActivateUserByAdminArgs = {
  id: Scalars['String'];
};


export type MutationAddApplicationArgs = {
  application: ManagedApplicationModelInput;
};


export type MutationAddAssetSettingsByAdminArgs = {
  asset: Scalars['String'];
  field: Scalars['String'];
  jobTitle?: InputMaybe<JobTitleByAdminInput>;
  status?: InputMaybe<StatusByAdminInput>;
  variant: Scalars['String'];
};


export type MutationAddAssigneeToAnalyseArgs = {
  organizationId: Scalars['String'];
  playbookId: Scalars['String'];
  publicId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationAddAssignmentToControlArgs = {
  controlId: Scalars['String'];
  frameworkId: Scalars['String'];
  userId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationAddAutomationArgs = {
  data: AutomationInput;
  workspaceId: Scalars['String'];
};


export type MutationAddAutomationListArgs = {
  automations: Array<QsAutomationInput>;
  wizardId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationAddBuilderControlArgs = {
  data: ControlInput;
  organizationId: Scalars['String'];
};


export type MutationAddBuilderEvidenceArgs = {
  data: AddEvidenceInput;
  organizationId: Scalars['String'];
};


export type MutationAddCommentArgs = {
  authorId: Scalars['String'];
  controlId: Scalars['String'];
  frameworkId: Scalars['String'];
  text: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationAddConflictsArgs = {
  conflicts: Array<RulesConflictInput>;
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationAddControlsAndEvidencesFromFilesArgs = {
  files: AdminBuilderFilesInput;
};


export type MutationAddCrownJewelsArgs = {
  data: AddCrownJewelRequest;
  workspaceId: Scalars['String'];
};


export type MutationAddCustomTextToEvidenceArgs = {
  data: EvidenceAssetInputDto;
  workspaceId: Scalars['String'];
};


export type MutationAddFrameworkArgs = {
  data: AddFrameworkInput;
  organizationId: Scalars['String'];
};


export type MutationAddFrameworkToWorkspaceArgs = {
  frameworkId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationAddGapFromFilesArgs = {
  files: AdminBuilderGapFilesInput;
};


export type MutationAddIntergationArgs = {
  createVendor?: InputMaybe<AddIntegrationVendorInput>;
  data: AddIntegrationInput;
  vendorId?: InputMaybe<Scalars['String']>;
  workspaceId: Scalars['String'];
};


export type MutationAddJobRecordArgs = {
  id: Scalars['String'];
  jobRecord: HrEmployeeJobInfoInputCreateModel;
  workspaceId: Scalars['String'];
};


export type MutationAddKycTargetToBlackListArgs = {
  description: Scalars['String'];
  targetId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationAddNewIdentityArgs = {
  newIdentity: NewIdentityInput;
  workspaceId: Scalars['String'];
};


export type MutationAddOrganizationBusinessWithBillingArgs = {
  billingData: CreateOrganizationBillingInfoInput;
  calculatedTotal: Scalars['Float'];
  data: CreateOrganizationDto;
};


export type MutationAddOrganizationBusinessWithoutPaymentArgs = {
  data: CreateOrganizationDto;
};


export type MutationAddOrganizationEnterpriseArgs = {
  data: CreateOrganizationDto;
};


export type MutationAddOrganizationFreeArgs = {
  data: CreateOrganizationDto;
};


export type MutationAddPlaybookToWorkspaceArgs = {
  config: AnalyseConfigInput;
  id: Scalars['String'];
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationAddPolicyArgs = {
  data: AddPolicyInput;
  organizationId: Scalars['String'];
};


export type MutationAddPolicyToWidArgs = {
  configuration?: InputMaybe<Scalars['JSON']>;
  policyId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationAddProfileArgs = {
  data: AddProfileInput;
  workspaceId: Scalars['String'];
};


export type MutationAddQsPoliciesArgs = {
  config: Scalars['JSON'];
  organizationId: Scalars['String'];
  policyIds: Array<Scalars['String']>;
  wizardId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationAddQsPolicyAssetsArgs = {
  array: Array<QsPolicyAssetInputDto>;
  organizationId: Scalars['String'];
  wizardId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationAddQswfAssignArgs = {
  frameworkId: Scalars['String'];
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationAddTemplateArgs = {
  template: AdminEmailTemplateInput;
};


export type MutationAddVendorFileArgs = {
  file: Scalars['String'];
  fileName: Scalars['String'];
  organizationId: Scalars['String'];
  type: Scalars['String'];
  vendorId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationAddWorkspaceArgs = {
  organizationId: Scalars['String'];
  workspaceName: Scalars['String'];
};


export type MutationAdminAddBuilderControlArgs = {
  data: AdminControlInput;
};


export type MutationAdminAddBuilderEvidenceArgs = {
  data: AdminAddEvidenceInput;
};


export type MutationAdminAddFrameworkArgs = {
  data: AdminAddFrameworkInput;
};


export type MutationAdminAddPolicyArgs = {
  data: AdminAddPolicyInput;
};


export type MutationAdminChangeFrameworkNameArgs = {
  data: AdminChangeFrameworkNameInput;
};


export type MutationAdminChangeFrameworkVisibilityArgs = {
  data: AdminChangeFrameworkVisibilityInput;
};


export type MutationAdminCreateDocumentArgs = {
  newValue: AdminCreateOrUpdateDocumentDto;
};


export type MutationAdminCreateDocumentsRefactorArgs = {
  id: Scalars['String'];
  name: Scalars['String'];
};


export type MutationAdminDeleteAllFileArgs = {
  fileIds: AdminDeleteAllFilesInput;
};


export type MutationAdminDeleteControlArgs = {
  data: Scalars['String'];
};


export type MutationAdminDeleteDocumentArgs = {
  id: Scalars['String'];
};


export type MutationAdminDeleteDocumentsRefactorArgs = {
  id: Scalars['String'];
};


export type MutationAdminDeleteEvidenceArgs = {
  data: Scalars['String'];
};


export type MutationAdminDeleteFrameworkArgs = {
  data: Scalars['String'];
};


export type MutationAdminDeletePolicyArgs = {
  data: Scalars['String'];
};


export type MutationAdminEditBuilderControlArgs = {
  data: AdminEditControlInput;
};


export type MutationAdminEditBuilderEvidenceArgs = {
  data: AdminEvidenceInput;
};


export type MutationAdminGenerateRecoveryCodesByPublicIdArgs = {
  publicId: Scalars['String'];
};


export type MutationAdminLinkControlArgs = {
  data: AdminUnlinkControlInput;
};


export type MutationAdminLinkEvidenceArgs = {
  data: AdminUnlinkEvidenceInput;
};


export type MutationAdminUnlinkControlArgs = {
  data: AdminUnlinkControlInput;
};


export type MutationAdminUnlinkEvidenceArgs = {
  data: AdminUnlinkEvidenceInput;
};


export type MutationAdminUpdateDocumentArgs = {
  newValue: AdminCreateOrUpdateDocumentDto;
};


export type MutationAdminUpdateDocumentsRefactorArgs = {
  document: NewDocumentInput;
  id: Scalars['String'];
};


export type MutationAdminUpdateFrameworkArgs = {
  data: AdminAddFrameworkInput;
};


export type MutationAdminUpdatePolicyArgs = {
  data: AdminPolicyInput;
};


export type MutationAdminUploadFileArgs = {
  file: Scalars['String'];
};


export type MutationAdoptFrameworkToWorkspaceArgs = {
  frameworkId: Scalars['String'];
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationAllowConflictCustomArgs = {
  conflict: RulesConflictInput;
  data: UpdateConflictExceptionInput;
  organizationId: Scalars['String'];
  readers: Array<ReleaseActorInput>;
  reviewers: Array<ReleaseActorInput>;
  signers: Array<ReleaseActorInput>;
  workspaceId: Scalars['String'];
};


export type MutationAllowConflictStandardArgs = {
  conflict: RulesConflictInput;
  data: ConflictExceptionInput;
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationApproveApproveStageByStageIdArgs = {
  documentId: Scalars['String'];
  stageId: Scalars['String'];
};


export type MutationApproveSignStageByStageIdArgs = {
  documentId: Scalars['String'];
  stageId: Scalars['String'];
};


export type MutationArchiveReportByUserArgs = {
  reportId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationAssignStageToMainControlArgs = {
  email: Scalars['String'];
  executorId: Scalars['String'];
  stageId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationBlockOrganizationByAdminArgs = {
  id: Scalars['String'];
  reason: Scalars['String'];
};


export type MutationBlockUserByAdminArgs = {
  id: Scalars['String'];
  reason: Scalars['String'];
};


export type MutationCancelRequestArgs = {
  requestId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationChangeAccessManagementStatusArgs = {
  appId: Scalars['String'];
  newStatus: Scalars['Boolean'];
  workspaceId: Scalars['String'];
};


export type MutationChangeAssetStatusArgs = {
  assetId: Scalars['String'];
  assignedTo?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['String'];
  status: PhysicalAssetStatusInputOld;
  workspaceId: Scalars['String'];
};


export type MutationChangeDocumentStageEtaArgs = {
  documentId: Scalars['String'];
  stageId: Scalars['String'];
  timeInMs: Scalars['Float'];
  workspaceId: Scalars['String'];
};


export type MutationChangeFrameworkNameArgs = {
  data: ChangeFrameworkNameInput;
  organizationId: Scalars['String'];
};


export type MutationChangeFrameworkVisibilityArgs = {
  data: ChangeFrameworkVisibilityInput;
  organizationId: Scalars['String'];
};


export type MutationChangeNameArgs = {
  data: ChangeNameInput;
};


export type MutationChangePasswordArgs = {
  data: ChangePasswordInput;
};


export type MutationChangeReviewedControlByAuditorArgs = {
  controlId: Scalars['String'];
  frameworkId: Scalars['String'];
  reportId: Scalars['String'];
  reviewed: Scalars['Boolean'];
  workspaceId: Scalars['String'];
};


export type MutationChangeRisksModelArgs = {
  modelId: Scalars['String'];
  organizationId: Scalars['String'];
  pageInfo: PaginationInput;
  registryId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationChangeStatusNcrByAuditorArgs = {
  comment?: InputMaybe<Scalars['String']>;
  controlId: Scalars['String'];
  frameworkId: Scalars['String'];
  ncrId: Scalars['String'];
  reportId: Scalars['String'];
  status: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationCreateAccessManagementAppByVendorArgs = {
  app: CreateAccessManagementAppByVendorInput;
  workspaceId: Scalars['String'];
};


export type MutationCreateAccountByInvitationArgs = {
  data: CreateAccountByInviteDto;
};


export type MutationCreateAdminRoleArgs = {
  role: CreateRoleInputModel;
};


export type MutationCreateAppDutyArgs = {
  duty: DutyInput;
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationCreateByTemplateTaskArgs = {
  data: TemplateTaskRequestInput;
  organizationId: Scalars['String'];
  taskId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationCreateCampaignReviewInstructionArgs = {
  instruction: CampaignReviewInstructionInput;
  workspaceId: Scalars['String'];
};


export type MutationCreateCertificateAssetArgs = {
  asset: CertificateAssetInput;
  file: Scalars['String'];
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationCreateCertificateAssetSettingRowArgs = {
  field: Scalars['String'];
  organizationId: Scalars['String'];
  title: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationCreateDocumentArgs = {
  newValue: CreateOrUpdateDocumentDto;
  workspaceId: Scalars['String'];
};


export type MutationCreateDutyRuleArgs = {
  organizationId: Scalars['String'];
  rule: DutyRuleInput;
  workspaceId: Scalars['String'];
};


export type MutationCreateFastSnapshotPageArgs = {
  data: ReportInput;
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationCreateFolderArgs = {
  fatherId: Scalars['String'];
  name: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationCreateHrEmployeeArgs = {
  employee: HrEmployeeCreateModel;
  workspaceId: Scalars['String'];
};


export type MutationCreateHrEmployeeSettingArgs = {
  field: Scalars['String'];
  value: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationCreateHrSettingsJobTitleArgs = {
  jobTitle: CreateJobTitleInput;
  workspaceId: Scalars['String'];
};


export type MutationCreateIssueArgs = {
  data: IssueInput;
};


export type MutationCreateIssuesArgs = {
  data: IssuesInput;
};


export type MutationCreateKycTargetExceptionArgs = {
  data: CreateTargetExceptionDto;
  workspaceId: Scalars['String'];
};


export type MutationCreateKycTemplateArgs = {
  template: KycRefactorTemplateModelInput;
  workspaceId: Scalars['String'];
};


export type MutationCreateMessageArgs = {
  workspaceId: Scalars['String'];
};


export type MutationCreateMessagePublicIdArgs = {
  publicId: Scalars['String'];
};


export type MutationCreateNcrArgs = {
  ncrControl: NcrInput;
};


export type MutationCreateNewAccessManagementAppArgs = {
  app: CreateNewAccessManagementAppInput;
  workspaceId: Scalars['String'];
};


export type MutationCreateNewDocumentArgs = {
  file?: InputMaybe<UploadNewFileDto>;
  newValue: CreateNewDocumentDto;
  workspaceId: Scalars['String'];
};


export type MutationCreatePermissionByAdminArgs = {
  permission: AdminPermissionInput;
};


export type MutationCreatePhysicalAssetArgs = {
  asset: PhysicalAssetInput;
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationCreatePhysicalAssetSettingRowArgs = {
  field: Scalars['String'];
  organizationId: Scalars['String'];
  status?: InputMaybe<PhysicalAssetStatusInputOld>;
  title: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationCreatePolicyArgs = {
  configuration: Scalars['JSON'];
  description: Scalars['String'];
  name: Scalars['String'];
  organizationId: Scalars['String'];
  templates: FilesPolicyInput;
  workspaceId: Scalars['String'];
};


export type MutationCreateReportArgs = {
  controls: Array<NewReportActiveControlInput>;
  organizationId: Scalars['String'];
  report: NewReportInput;
  workspaceId: Scalars['String'];
};


export type MutationCreateRiskArgs = {
  organizationId: Scalars['String'];
  registryId: Scalars['String'];
  risk: RiskInput;
  workspaceId: Scalars['String'];
};


export type MutationCreateRiskRegistryArgs = {
  organizationId: Scalars['String'];
  registry: RiskRegistryInput;
  workspaceId: Scalars['String'];
};


export type MutationCreateRisksModelsArgs = {
  organizationId: Scalars['String'];
  riskModel: RiskModelInput;
  workspaceId: Scalars['String'];
};


export type MutationCreateRoleArgs = {
  data: CreateUpdateRoleRequestInput;
};


export type MutationCreateSaasAssetArgs = {
  asset: SaasAssetInput;
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationCreateSaasAssetSettingRowArgs = {
  field: Scalars['String'];
  organizationId: Scalars['String'];
  title: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationCreateScreeningCreatedMessageArgs = {
  workspaceId: Scalars['String'];
};


export type MutationCreateSoftwareAssetArgs = {
  asset: SoftwareAssetInput;
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationCreateSoftwareAssetSettingRowArgs = {
  field: Scalars['String'];
  organizationId: Scalars['String'];
  title: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationCreateTargetArgs = {
  data: CreateTargetDto;
  workspaceId: Scalars['String'];
};


export type MutationCreateTargetVulnerabilityArgs = {
  organizationId: Scalars['String'];
  target: CreateTargetInput;
  workspaceId: Scalars['String'];
};


export type MutationCreateUploadedFilesArgs = {
  items: UploadFileArrayDto;
  workspaceId: Scalars['String'];
};


export type MutationCreateVendorArgs = {
  employee: VendorInput;
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationCreateVendorsSettingRowArgs = {
  field: Scalars['String'];
  organizationId: Scalars['String'];
  title: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationCreateVirtualAssetArgs = {
  asset: VirtualAssetInput;
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationCreateVirtualAssetSettingRowArgs = {
  field: Scalars['String'];
  organizationId: Scalars['String'];
  title: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationCreateWcMapperArgs = {
  data: CreateWcMapperInput;
  workspaceId: Scalars['String'];
};


export type MutationDeactivateAutomationArgs = {
  data: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationDeclineInviteArgs = {
  inviteId: Scalars['String'];
};


export type MutationDeleteAccessManagementCustomAppByIdArgs = {
  id: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationDeleteAllFileArgs = {
  fileIds: DeleteAllFilesInput;
  workspaceId: Scalars['String'];
};


export type MutationDeleteAllFileOrgArgs = {
  fileIds: DeleteAllFilesInput;
  organizationId: Scalars['String'];
};


export type MutationDeleteAppDutyArgs = {
  appId: Scalars['String'];
  id: Scalars['String'];
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationDeleteApplicationArgs = {
  applicationId: Scalars['String'];
};


export type MutationDeleteAssetFromNcrByUserArgs = {
  assetId: Scalars['String'];
  ncrId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationDeleteAssignmentToControlArgs = {
  assignmentId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationDeleteAuditorsInSnapshotArgs = {
  id: Scalars['String'];
  reportId: Scalars['String'];
};


export type MutationDeleteAutomationByIdArgs = {
  data: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationDeleteCampaignReviewInstructionArgs = {
  id: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationDeleteCertificateAssetArgs = {
  assetId: Scalars['String'];
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationDeleteCertificateAssetSettingRowArgs = {
  field: Scalars['String'];
  oldTitle: Scalars['String'];
  organizationId: Scalars['String'];
  title: Scalars['String'];
  withHistoryChange?: InputMaybe<Scalars['Boolean']>;
  workspaceId: Scalars['String'];
};


export type MutationDeleteConflictExceptionArgs = {
  exception: ConflictExceptionInput;
  organizationId: Scalars['String'];
  ruleId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationDeleteControlArgs = {
  data: Scalars['String'];
  organizationId: Scalars['String'];
};


export type MutationDeleteCrownJewelArgs = {
  id: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationDeleteDutyRuleArgs = {
  id: Scalars['String'];
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationDeleteEvidenceArgs = {
  data: Scalars['String'];
  organizationId: Scalars['String'];
};


export type MutationDeleteEvidenceFileArgs = {
  fileId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationDeleteFolderArgs = {
  folderId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationDeleteFrameworkArgs = {
  data: Scalars['String'];
  organizationId: Scalars['String'];
};


export type MutationDeleteHrEmployeeByIdArgs = {
  id: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationDeleteHrEmployeeSettingArgs = {
  field: Scalars['String'];
  newValue: Scalars['String'];
  updateHistory: Scalars['Boolean'];
  value: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationDeleteIdentityArgs = {
  identityId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationDeleteIntegrationArgs = {
  data: DeleteIntegrationInput;
  workspaceId: Scalars['String'];
};


export type MutationDeleteItemsArgs = {
  items: ItemsDto;
  workspaceId: Scalars['String'];
};


export type MutationDeleteJobRecordArgs = {
  id: Scalars['String'];
  jobRecordId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationDeleteKycArchivedTargetArgs = {
  targetId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationDeleteKycTemplateArgs = {
  isDeleteTargets: Scalars['Boolean'];
  templateId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationDeleteLicenseArgs = {
  id: Scalars['String'];
};


export type MutationDeleteNcrArgs = {
  ncrControlId: Scalars['String'];
};


export type MutationDeleteNewDocumentArgs = {
  docId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationDeleteOrganizationByAdminArgs = {
  id: Scalars['String'];
};


export type MutationDeletePermissionByAdminArgs = {
  permissionName: Scalars['String'];
};


export type MutationDeletePhysicalAssetArgs = {
  assetId: Scalars['String'];
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationDeletePhysicalAssetSettingRowArgs = {
  field: Scalars['String'];
  oldTitle: Scalars['String'];
  organizationId: Scalars['String'];
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  withHistoryChange?: InputMaybe<Scalars['Boolean']>;
  workspaceId: Scalars['String'];
};


export type MutationDeletePolicyArgs = {
  data: Scalars['String'];
  organizationId: Scalars['String'];
};


export type MutationDeletePolicyEditableAssetArgs = {
  id: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationDeletePolicyEvidenceFileArgs = {
  fileId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationDeleteProfileArgs = {
  id: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationDeleteReportArgs = {
  id: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationDeleteRiskByIdArgs = {
  organizationId: Scalars['String'];
  registryId: Scalars['String'];
  riskId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationDeleteRiskRegistryArgs = {
  organizationId: Scalars['String'];
  registryId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationDeleteRisksModelArgs = {
  organizationId: Scalars['String'];
  riskModelId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationDeleteRoleArgs = {
  roleId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationDeleteRoleByAdminArgs = {
  roleId: Scalars['String'];
};


export type MutationDeleteSaasAssetArgs = {
  assetId: Scalars['String'];
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationDeleteSaasAssetSettingRowArgs = {
  field: Scalars['String'];
  oldTitle: Scalars['String'];
  organizationId: Scalars['String'];
  title: Scalars['String'];
  withHistoryChange?: InputMaybe<Scalars['Boolean']>;
  workspaceId: Scalars['String'];
};


export type MutationDeleteSettingsJobTitleArgs = {
  history: Scalars['Boolean'];
  jobTitle: HrEmployeeJobTitleModelInput;
  replaceJobTitleId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationDeleteSoftwareAssetArgs = {
  assetId: Scalars['String'];
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationDeleteSoftwareAssetSettingRowArgs = {
  field: Scalars['String'];
  oldTitle: Scalars['String'];
  organizationId: Scalars['String'];
  title: Scalars['String'];
  withHistoryChange?: InputMaybe<Scalars['Boolean']>;
  workspaceId: Scalars['String'];
};


export type MutationDeleteTargetArgs = {
  targetId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationDeleteTargetExceptionArgs = {
  exceptionId: Scalars['String'];
  targetId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationDeleteTemplateArgs = {
  id: Scalars['String'];
};


export type MutationDeleteUserByAdminArgs = {
  id: Scalars['String'];
};


export type MutationDeleteVendorArgs = {
  employeeId: Scalars['String'];
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationDeleteVendorByIdArgs = {
  id: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationDeleteVendorFileArgs = {
  fileId: Scalars['String'];
  organizationId: Scalars['String'];
  vendorId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationDeleteVendorsSettingRowArgs = {
  field: Scalars['String'];
  oldTitle: Scalars['String'];
  organizationId: Scalars['String'];
  title: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationDeleteVirtualAssetArgs = {
  assetId: Scalars['String'];
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationDeleteVirtualAssetSettingRowArgs = {
  field: Scalars['String'];
  oldTitle: Scalars['String'];
  organizationId: Scalars['String'];
  title: Scalars['String'];
  withHistoryChange?: InputMaybe<Scalars['Boolean']>;
  workspaceId: Scalars['String'];
};


export type MutationDeleteWcAssignArgs = {
  collectorId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationDeleteWorkspaceArgs = {
  workspaceId: Scalars['String'];
};


export type MutationDeleteWorkspaceByAdminArgs = {
  id: Scalars['String'];
};


export type MutationDeleteWorkspaceCollaboratorArgs = {
  publicId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationDeleteWorkspaceInviteArgs = {
  email: Scalars['String'];
  inviteId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationDenyConflictArgs = {
  conflict: RulesConflictInput;
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationEditAccessManagementAppArgs = {
  app: AccessManagementAppEditRequestInput;
  workspaceId: Scalars['String'];
};


export type MutationEditAppDutyArgs = {
  duty: DutyInput;
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationEditAssetSettingsByAdminArgs = {
  asset: Scalars['String'];
  field: Scalars['String'];
  jobTitle?: InputMaybe<JobTitleByAdminInput>;
  oldTitle: Scalars['String'];
  status?: InputMaybe<StatusByAdminInput>;
  title: Scalars['String'];
};


export type MutationEditBuilderControlArgs = {
  data: EditControlInput;
  organizationId: Scalars['String'];
};


export type MutationEditBuilderEvidenceArgs = {
  data: EvidenceInput;
  organizationId: Scalars['String'];
};


export type MutationEditCertificateAssetSettingRowArgs = {
  field: Scalars['String'];
  oldTitle: Scalars['String'];
  organizationId: Scalars['String'];
  title: Scalars['String'];
  withHistoryChange?: InputMaybe<Scalars['Boolean']>;
  workspaceId: Scalars['String'];
};


export type MutationEditConflictExceptionArgs = {
  exception: ConflictExceptionInput;
  organizationId: Scalars['String'];
  ruleId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationEditDutyRuleArgs = {
  organizationId: Scalars['String'];
  rule: DutyRuleInput;
  workspaceId: Scalars['String'];
};


export type MutationEditHrSettingsJobTitleArgs = {
  history: Scalars['Boolean'];
  jobTitle: HrEmployeeJobTitleModelInput;
  workspaceId: Scalars['String'];
};


export type MutationEditPhysicalAssetSettingRowArgs = {
  field: Scalars['String'];
  oldTitle: Scalars['String'];
  organizationId: Scalars['String'];
  status?: InputMaybe<PhysicalAssetStatusCountInput>;
  title: Scalars['String'];
  withHistoryChange?: InputMaybe<Scalars['Boolean']>;
  workspaceId: Scalars['String'];
};


export type MutationEditRoleArgs = {
  data: CreateUpdateRoleRequestInput;
};


export type MutationEditRoleByAdminArgs = {
  role: UpdateAdminRoleRequestInput;
};


export type MutationEditSaasAssetSettingRowArgs = {
  field: Scalars['String'];
  oldTitle: Scalars['String'];
  organizationId: Scalars['String'];
  title: Scalars['String'];
  withHistoryChange?: InputMaybe<Scalars['Boolean']>;
  workspaceId: Scalars['String'];
};


export type MutationEditSodSchedulerArgs = {
  organizationId: Scalars['String'];
  schedulerData: SodSchedulerInput;
  workspaceId: Scalars['String'];
};


export type MutationEditSoftwareAssetSettingRowArgs = {
  field: Scalars['String'];
  oldTitle: Scalars['String'];
  organizationId: Scalars['String'];
  title: Scalars['String'];
  withHistoryChange?: InputMaybe<Scalars['Boolean']>;
  workspaceId: Scalars['String'];
};


export type MutationEditVendorsSettingRowArgs = {
  field: Scalars['String'];
  oldTitle: Scalars['String'];
  organizationId: Scalars['String'];
  title: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationEditVirtualAssetSettingRowArgs = {
  field: Scalars['String'];
  oldTitle: Scalars['String'];
  organizationId: Scalars['String'];
  title: Scalars['String'];
  withHistoryChange?: InputMaybe<Scalars['Boolean']>;
  workspaceId: Scalars['String'];
};


export type MutationEmailVerifyArgs = {
  email: Scalars['String'];
  verificationCode: Scalars['String'];
};


export type MutationFillFillableFieldOnSignStageArgs = {
  documentId: Scalars['String'];
  stageId: Scalars['String'];
  values: Array<FieldIdValueDto>;
};


export type MutationGenerateFileByHtmlArgs = {
  data: GenerateFileByHtmlInput;
  workspaceId: Scalars['String'];
};


export type MutationGenerateNewTokenArgs = {
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationGetCsvFieldsAccessManagementArgs = {
  file: Scalars['String'];
  name: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationGetCsvFieldsCertificateArgs = {
  file: Scalars['String'];
  name: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationGetCsvFieldsCollaboratorsArgs = {
  file: Scalars['String'];
  name: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationGetCsvFieldsEmployeesArgs = {
  file: Scalars['String'];
  name: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationGetCsvFieldsPhysicalAssetsArgs = {
  file: Scalars['String'];
  name: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationGetCsvFieldsRisksArgs = {
  file: Scalars['String'];
  name: Scalars['String'];
  registryId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationGetCsvFieldsSaasArgs = {
  file: Scalars['String'];
  name: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationGetCsvFieldsSoftwareArgs = {
  file: Scalars['String'];
  name: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationGetCsvFieldsVendorsArgs = {
  file: Scalars['String'];
  name: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationGetCsvFieldsVirtualArgs = {
  file: Scalars['String'];
  name: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationGetDataForCreateReportArgs = {
  frameworkId: Scalars['String'];
  name: Scalars['String'];
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationGetIssuesCountArgs = {
  workspaceId: Scalars['String'];
};


export type MutationImportCsvRulesetArgs = {
  file: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationInitialValidateGoogleAuthorizationArgs = {
  code: Scalars['String'];
  secret: Scalars['String'];
};


export type MutationInvalidateDocumentArgs = {
  documentId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationInviteMemberIntoWorkspaceArgs = {
  email: Scalars['String'];
  roles: RolesArrayInput;
  senderPublicId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationKycAnalyseRestartArgs = {
  ids: Array<Scalars['String']>;
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationKycCancelRequestByIdArgs = {
  id: Scalars['String'];
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationKycChangeRequestStatusArgs = {
  id: Scalars['String'];
  organizationId: Scalars['String'];
  status: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationKycCreateTemplateArgs = {
  organizationId: Scalars['String'];
  template: KycTemplateInput;
  workspaceId: Scalars['String'];
};


export type MutationKycDeleteTemplateArgs = {
  id: Scalars['String'];
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationKycGenerateTokenByTemplateIdArgs = {
  organizationId: Scalars['String'];
  redirectUrl: Scalars['String'];
  templateId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationKycRejectFormByTokenArgs = {
  token: Scalars['String'];
};


export type MutationKycSendRequestsToEmailsArgs = {
  emails: Array<Scalars['String']>;
  id: Scalars['String'];
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationKycSetLimitArgs = {
  limitEnabled: Scalars['Boolean'];
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationKycSubmitFormByTokenArgs = {
  form: KycFormInput;
  token: Scalars['String'];
};


export type MutationKycUpdateTemplateArgs = {
  organizationId: Scalars['String'];
  template: KycTemplateInput;
  workspaceId: Scalars['String'];
};


export type MutationLeaveResponseToNcrByUserArgs = {
  controlId: Scalars['String'];
  data: SetCorrectiveActionInput;
  frameworkId: Scalars['String'];
  ncrId: Scalars['String'];
  reportId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationLicenseCreateMultiArgs = {
  count: Scalars['String'];
  license: ExtendedLicenseInput;
};


export type MutationLicenseCreateOneArgs = {
  email: Scalars['String'];
  license: ExtendedLicenseInput;
};


export type MutationLinkControlArgs = {
  data: UnlinkControlInput;
  organizationId: Scalars['String'];
};


export type MutationLinkEvidenceArgs = {
  data: UnlinkEvidenceInput;
  organizationId: Scalars['String'];
};


export type MutationLoginArgs = {
  data: LoginInputRequest;
};


export type MutationLoginAdminArgs = {
  data: LoginInputRequest;
};


export type MutationLoginByRecoveryCodeArgs = {
  recoveryCode: Scalars['String'];
};


export type MutationLoginDocsArgs = {
  email: Scalars['String'];
};


export type MutationLoginDocsCodeArgs = {
  code: Scalars['String'];
  email: Scalars['String'];
};


export type MutationMainAssetsApproveRequestRemoveAssetArgs = {
  data: MainAssetsApproveRequestWithCommentWithStatusInput;
  workspaceId: Scalars['String'];
};


export type MutationMainAssetsApproveRequestRequestAssetArgs = {
  data: MainAssetsApproveRequestWithCommentInput;
  workspaceId: Scalars['String'];
};


export type MutationMainAssetsAssignNotAssignedAssetArgs = {
  data: MainAssetsApproveRequestWithCommentInput;
  workspaceId: Scalars['String'];
};


export type MutationMainAssetsCreateAndAssignAssetArgs = {
  data: MainAssetsCreateAndAssignRequestInput;
  workspaceId: Scalars['String'];
};


export type MutationMainAssetsReassignAssetArgs = {
  data: MainAssetsApproveRequestWithCommentInput;
  workspaceId: Scalars['String'];
};


export type MutationMainAssetsRequestsRejectArgs = {
  data: MainAssetsApproveRequestWithCommentInput;
  workspaceId: Scalars['String'];
};


export type MutationMainFrameworksApproveTaskByIdArgs = {
  selectedAttachments: FrameworksDelegatedTaskDataFilesListInput;
  taskId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationMainFrameworksCancelTaskByIdArgs = {
  reason: Scalars['String'];
  taskId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationMainFrameworksCreateDelegatedTaskArgs = {
  task: MainFrameworksCreateDelegatedTaskInput;
  workspaceId: Scalars['String'];
};


export type MutationMainFrameworksDeclineTaskByIdArgs = {
  reason: Scalars['String'];
  taskId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationMainHrApproveRequestArgs = {
  id: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationMainHrApproveTimeOffRequestArgs = {
  comment: Scalars['String'];
  requestId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationMainHrDeleteRequestArgs = {
  id: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationMainHrRejectRequestArgs = {
  id: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationMainHrRejectTimeOffRequestArgs = {
  comment: Scalars['String'];
  requestId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationMainHrSetIssueStatusInProgressArgs = {
  issueId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationMainHrSetIssueStatusResolvedArgs = {
  comment: Scalars['String'];
  issueId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationMainHrSkipTimeOffRequestArgs = {
  comment: Scalars['String'];
  requestId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationMainTrainingUploadFileArgs = {
  fileBase64: Scalars['String'];
  fileName: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationMainTrainingsAcceptValidationReviewByAssignmentIdAndExamTypeArgs = {
  assignmentId: Scalars['String'];
  examType: TrainingAssignmentExamType;
  questions: Array<MainTrainingAssignmentExamValidationInput>;
  workspaceId: Scalars['String'];
};


export type MutationMainTrainingsCancelTrainingAssignmentArgs = {
  assignmentId: Scalars['String'];
  reason: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationMainTrainingsChangeExamNameArgs = {
  examId: Scalars['String'];
  name: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationMainTrainingsChangeTrainingNameArgs = {
  name: Scalars['String'];
  trainingId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationMainTrainingsChangeTrainingStatusArgs = {
  status: MainTrainingStatus;
  trainingId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationMainTrainingsCreateExamArgs = {
  exam: MainTrainingExamInput;
  workspaceId: Scalars['String'];
};


export type MutationMainTrainingsCreateTrainingArgs = {
  data: MainCreateTrainingInputDto;
  workspaceId: Scalars['String'];
};


export type MutationMainTrainingsCreateTrainingAssignmentArgs = {
  data: MainCreateTrainingAssignmentInput;
  workspaceId: Scalars['String'];
};


export type MutationMainTrainingsMoveExamToArchiveArgs = {
  examId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationMainTrainingsRestoreExamFromArchiveArgs = {
  examId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationMainTrainingsUpdateExamArgs = {
  exam: MainTrainingExamInput;
  workspaceId: Scalars['String'];
};


export type MutationMainTrainingsUpdateTrainingArgs = {
  data: MainTrainingModelInput;
  workspaceId: Scalars['String'];
};


export type MutationMainUploadCoverImageArgs = {
  file: Scalars['String'];
  format: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationMainVicaApproveDelegatedTaskByIdArgs = {
  selectedAttachments: FrameworksDelegatedTaskDataFilesListInput;
  taskId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationMainVicaCancelDelegatedTaskByIdArgs = {
  reason: Scalars['String'];
  taskId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationMainVicaChangeStepStatusArgs = {
  status: MainVicaStepStatus;
  stepId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationMainVicaCreateDelegatedTaskArgs = {
  task: MainVicaCreateDelegatedTaskInput;
  workspaceId: Scalars['String'];
};


export type MutationMainVicaDeclineDelegatedTaskByIdArgs = {
  reason: Scalars['String'];
  taskId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationMainVicaUpdateCategorySupervisorArgs = {
  categoryId: Scalars['String'];
  supervisor: MainVicaCategoryCollaboratorInput;
  workspaceId: Scalars['String'];
};


export type MutationMainVicaUpdateStepResponsibleCollaboratorsArgs = {
  responsible: Array<MainVicaCategoryCollaboratorInput>;
  stepId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationMakeDocDraftCopyArgs = {
  documentId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationMoveItemsArgs = {
  items: ItemsDto;
  newFatherId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationMoveKycTargetToArchiveArgs = {
  description: Scalars['String'];
  targetId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationMoveNewItemsArgs = {
  items: ItemsDto;
  newFatherId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationPerformCsvAccessManagementArgs = {
  fields: Array<ImportCsvFieldInput>;
  fileId: Scalars['String'];
  id: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationPerformCsvByFileIdArgs = {
  config: Array<KycCsvFieldWithAliasModel>;
  fileId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationPerformCsvCertificateArgs = {
  fields: Array<ImportCsvFieldInput>;
  fileId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationPerformCsvCollaboratorsArgs = {
  fields: Array<ImportCsvFieldInput>;
  fileId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationPerformCsvEmployeesArgs = {
  fields: Array<ImportCsvFieldInput>;
  fileId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationPerformCsvPhysicalAssetsArgs = {
  fields: Array<ImportCsvFieldInput>;
  fileId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationPerformCsvRisksArgs = {
  fields: Array<ImportCsvFieldInput>;
  fileId: Scalars['String'];
  registryId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationPerformCsvSaasArgs = {
  fields: Array<ImportCsvFieldInput>;
  fileId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationPerformCsvSoftwareArgs = {
  fields: Array<ImportCsvFieldInput>;
  fileId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationPerformCsvVendorsArgs = {
  fields: Array<ImportCsvFieldInput>;
  fileId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationPerformCsvVirtualArgs = {
  fields: Array<ImportCsvFieldInput>;
  fileId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationPortalApproveApproveStageByStageIdArgs = {
  documentId: Scalars['String'];
  stageId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationPortalApproveSignStageByStageIdArgs = {
  documentId: Scalars['String'];
  stageId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationPortalAssetsCancelAssetRequestArgs = {
  requestId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationPortalAssetsCreateRequestAddAssetArgs = {
  data: RequestAddAssetInput;
  workspaceId: Scalars['String'];
};


export type MutationPortalAssetsCreateRequestRemoveAssetArgs = {
  data: RequestRemoveAssetInput;
  workspaceId: Scalars['String'];
};


export type MutationPortalAssetsCreateRequestRequestAssetArgs = {
  data: RequestRequestAssetInput;
  workspaceId: Scalars['String'];
};


export type MutationPortalFillFillableFieldOnSignStageArgs = {
  documentId: Scalars['String'];
  stageId: Scalars['String'];
  values: Array<FieldIdValueDto>;
  workspaceId: Scalars['String'];
};


export type MutationPortalFinishTrainingArgs = {
  assignmentId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationPortalFinishTrainingSectionArgs = {
  assignmentId: Scalars['String'];
  duration: Scalars['Float'];
  sectionId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationPortalHrApproveTimeOffRequestArgs = {
  comment: Scalars['String'];
  requestId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationPortalHrCancelMyTimeOffRequestArgs = {
  timeOffId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationPortalHrCancelRequestArgs = {
  requestId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationPortalHrCreateEditRequestArgs = {
  request: PortalHrEditRequestInputDto;
  workspaceId: Scalars['String'];
};


export type MutationPortalHrCreateIssueArgs = {
  issue: PortalHrCreateIssueInputDto;
  workspaceId: Scalars['String'];
};


export type MutationPortalHrCreateTimeOffRequestArgs = {
  data: PortalHrCreateTimeOffRequestInputDto;
  workspaceId: Scalars['String'];
};


export type MutationPortalHrRejectTimeOffRequestArgs = {
  comment: Scalars['String'];
  requestId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationPortalHrUpdateMyTimeOffRequestArgs = {
  data: PortalHrCreateTimeOffRequestInputDto;
  timeOffId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationPortalRejectApproveStageByStageIdArgs = {
  documentId: Scalars['String'];
  stageId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationPortalRejectSignStageByStageIdArgs = {
  documentId: Scalars['String'];
  stageId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationPortalRequiredActionsPerformActionProvideFilesArgs = {
  data: PerformActionProvideFilesInputDto;
  workspaceId: Scalars['String'];
};


export type MutationPortalStartTrainingArgs = {
  id: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationPortalTrainingsExamSaveAnswerArgs = {
  answer: Array<Scalars['String']>;
  assignmentId: Scalars['String'];
  questionId: Scalars['String'];
  type: TrainingAssignmentExamType;
  workspaceId: Scalars['String'];
};


export type MutationPortalTrainingsExamSkipAnswerArgs = {
  assignmentId: Scalars['String'];
  questionId: Scalars['String'];
  type: TrainingAssignmentExamType;
  workspaceId: Scalars['String'];
};


export type MutationPortalTrainingsFinishExamArgs = {
  assignmentId: Scalars['String'];
  type: TrainingAssignmentExamType;
  workspaceId: Scalars['String'];
};


export type MutationPortalTrainingsStartExamArgs = {
  assignmentId: Scalars['String'];
  type: TrainingAssignmentExamType;
  workspaceId: Scalars['String'];
};


export type MutationPortalUpdateFullDocumentByDocsArgs = {
  approvers: Array<DocApproverInput>;
  data: NewDocDataInput;
  documentId: Scalars['String'];
  editors: Array<NewDocumentActorInput>;
  name: Scalars['String'];
  recipients: Array<RecipientInput>;
  workspaceId: Scalars['String'];
};


export type MutationPortalUpdateTrainingDurationArgs = {
  assignmentId: Scalars['String'];
  duration: Scalars['Float'];
  workspaceId: Scalars['String'];
};


export type MutationPortalUploadFileArgs = {
  file: Scalars['String'];
};


export type MutationPreviewEditableDocumentArgs = {
  approvers: Array<DocApproverInput>;
  data: NewDocDataInput;
  documentId: Scalars['String'];
  editors: Array<NewDocumentActorInput>;
  name: Scalars['String'];
  recipients: Array<RecipientInput>;
  workspaceId: Scalars['String'];
};


export type MutationRefreshReportArgs = {
  id: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationRegistrationArgs = {
  data: RegistrationInputRequest;
};


export type MutationRejectApproveStageByStageIdArgs = {
  documentId: Scalars['String'];
  stageId: Scalars['String'];
};


export type MutationRejectKycFormArgs = {
  token: Scalars['String'];
};


export type MutationRejectSignStageByStageIdArgs = {
  documentId: Scalars['String'];
  stageId: Scalars['String'];
};


export type MutationReleaseAccessManagementAppArgs = {
  controlId: Scalars['String'];
  evidenceId: Scalars['String'];
  frameworkId: Scalars['String'];
  id: Scalars['String'];
  organizationId: Scalars['String'];
  readers: Array<ReleaseActorInput>;
  reviewers: Array<ReleaseActorInput>;
  signers: Array<ReleaseActorInput>;
  workspaceId: Scalars['String'];
};


export type MutationReleaseCertificateAssetsArgs = {
  controlId: Scalars['String'];
  evidenceId: Scalars['String'];
  frameworkId: Scalars['String'];
  organizationId: Scalars['String'];
  readers: Array<ReleaseActorInput>;
  reviewers: Array<ReleaseActorInput>;
  signers: Array<ReleaseActorInput>;
  workspaceId: Scalars['String'];
};


export type MutationReleaseHrEmployeesArgs = {
  controlId: Scalars['String'];
  evidenceId: Scalars['String'];
  frameworkId: Scalars['String'];
  organizationId: Scalars['String'];
  readers: Array<ReleaseActorInput>;
  reviewers: Array<ReleaseActorInput>;
  signers: Array<ReleaseActorInput>;
  workspaceId: Scalars['String'];
};


export type MutationReleaseLicenseArgs = {
  email: Scalars['String'];
  id: Scalars['String'];
  note: Scalars['String'];
};


export type MutationReleasePhysicalAssetsArgs = {
  controlId: Scalars['String'];
  evidenceId: Scalars['String'];
  frameworkId: Scalars['String'];
  organizationId: Scalars['String'];
  readers: Array<ReleaseActorInput>;
  reviewers: Array<ReleaseActorInput>;
  signers: Array<ReleaseActorInput>;
  workspaceId: Scalars['String'];
};


export type MutationReleaseRiskRegistryArgs = {
  controlId: Scalars['String'];
  evidenceId: Scalars['String'];
  frameworkId: Scalars['String'];
  organizationId: Scalars['String'];
  readers: Array<ReleaseActorInput>;
  registryId: Scalars['String'];
  reviewers: Array<ReleaseActorInput>;
  signers: Array<ReleaseActorInput>;
  workspaceId: Scalars['String'];
};


export type MutationReleaseSaasAssetsArgs = {
  controlId: Scalars['String'];
  evidenceId: Scalars['String'];
  frameworkId: Scalars['String'];
  organizationId: Scalars['String'];
  readers: Array<ReleaseActorInput>;
  reviewers: Array<ReleaseActorInput>;
  signers: Array<ReleaseActorInput>;
  workspaceId: Scalars['String'];
};


export type MutationReleaseSoftwareAssetsArgs = {
  controlId: Scalars['String'];
  evidenceId: Scalars['String'];
  frameworkId: Scalars['String'];
  organizationId: Scalars['String'];
  readers: Array<ReleaseActorInput>;
  reviewers: Array<ReleaseActorInput>;
  signers: Array<ReleaseActorInput>;
  workspaceId: Scalars['String'];
};


export type MutationReleaseTargetScansArgs = {
  evidenceId: Scalars['String'];
  targetId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationReleaseVendorsArgs = {
  controlId: Scalars['String'];
  evidenceId: Scalars['String'];
  frameworkId: Scalars['String'];
  organizationId: Scalars['String'];
  readers: Array<ReleaseActorInput>;
  reviewers: Array<ReleaseActorInput>;
  signers: Array<ReleaseActorInput>;
  workspaceId: Scalars['String'];
};


export type MutationReleaseVirtualAssetsArgs = {
  controlId: Scalars['String'];
  evidenceId: Scalars['String'];
  frameworkId: Scalars['String'];
  organizationId: Scalars['String'];
  readers: Array<ReleaseActorInput>;
  reviewers: Array<ReleaseActorInput>;
  signers: Array<ReleaseActorInput>;
  workspaceId: Scalars['String'];
};


export type MutationRemoveAssetSettingsByAdminArgs = {
  asset: Scalars['String'];
  field: Scalars['String'];
  newJobType?: InputMaybe<Scalars['String']>;
  variant: Scalars['String'];
};


export type MutationRemoveAssigneeFromAnalyseArgs = {
  organizationId: Scalars['String'];
  playbookId: Scalars['String'];
  publicId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationRemoveEvidenceAssetArgs = {
  assetId: Scalars['String'];
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationRemoveFrameworkFromWorkspaceArgs = {
  wfId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationRemovePlaybookFromWorkspaceArgs = {
  id: Scalars['String'];
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationRemovePolicyFromWidArgs = {
  policyId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationRenameItemArgs = {
  itemId: Scalars['String'];
  itemName: Scalars['String'];
  itemType: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationResendEmailVerificationCodeArgs = {
  email: Scalars['String'];
};


export type MutationResendWorkspaceInviteArgs = {
  email: Scalars['String'];
  inviteId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationResetPasswordArgs = {
  data: EmailInput;
};


export type MutationRestartSignStageByStageIdAndGroupIdArgs = {
  documentId: Scalars['String'];
  groupId: Scalars['String'];
  stageId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationRestartSignStageByStageIdAndRecipientArgs = {
  documentId: Scalars['String'];
  recipientEmail: Scalars['String'];
  stageId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationRestoreKycTargetFromArchiveArgs = {
  description: Scalars['String'];
  targetId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationRestoreKycTargetFromBlackListArgs = {
  description: Scalars['String'];
  targetId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationRestoreNewItemArgs = {
  fileId: Scalars['String'];
  newFatherId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationRunAutomationByIdArgs = {
  data: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationRunCampaignReviewInstructionArgs = {
  id: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationRunRuleCheckArgs = {
  id: Scalars['String'];
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationRunTargetArgs = {
  targetId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationSendDocsSupportMessageArgs = {
  data: SupportMessageInput;
  workspaceId: Scalars['String'];
};


export type MutationSendMessageToSupportMainLayoutArgs = {
  data: MainLayoutSupportMessageInput;
};


export type MutationSendSupportMessageArgs = {
  data: SupportMessageInput;
  workspaceId: Scalars['String'];
};


export type MutationSendTemplateToClientArgs = {
  emails: Array<Scalars['String']>;
  organizationId: Scalars['String'];
  templateId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationSendToNextStepByStageIdArgs = {
  documentId: Scalars['String'];
  stageId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationSetAccountIdentityArgs = {
  accId: Scalars['String'];
  appId: Scalars['String'];
  identity?: InputMaybe<IdentityInput>;
  newStatus: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationSetDocumentAsEvidenceAssetArgs = {
  documentId: Scalars['String'];
  evidenceId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationSetEvidenceStatusArgs = {
  evidenceId: Scalars['String'];
  organizationId: Scalars['String'];
  status: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationSetIssueAssigneeArgs = {
  assigneeId: Scalars['String'];
  id: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationSetIssueStatusArgs = {
  id: Scalars['String'];
  newStatus: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationSetKycTargetVerifiedArgs = {
  screeningId: Scalars['String'];
  targetId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationSetPlaybookActiveArgs = {
  active: Scalars['Boolean'];
  organizationId: Scalars['String'];
  playbookId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationSetReportShareSettingsArgs = {
  data: ReportShareSettingsInput;
  id: Scalars['String'];
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationSetSnapshotReportResponseByUserArgs = {
  reportId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationSetTaskCategoryResponsibleArgs = {
  categoryId: Scalars['String'];
  responsiblePublicId?: InputMaybe<Scalars['String']>;
  workspaceId: Scalars['String'];
};


export type MutationSetTaskCollabsArgs = {
  collabIds: SetTaskCollabsInput;
  taskId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationStartCollectorArgs = {
  collectorId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationStartNewDocumentExecutionArgs = {
  approvers: Array<DocApproverInput>;
  data: NewDocDataInput;
  documentId: Scalars['String'];
  editors: Array<NewDocumentActorInput>;
  name: Scalars['String'];
  recipients: Array<RecipientInput>;
  workspaceId: Scalars['String'];
};


export type MutationStartOneTimeScreeningArgs = {
  data: CreateTargetDto;
  matchingRatio: Scalars['Float'];
  workspaceId: Scalars['String'];
};


export type MutationStartResearchArgs = {
  data: StartResearchInput;
  workspaceId: Scalars['String'];
};


export type MutationStartTargetScreeningArgs = {
  targetId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationStopAutomationArgs = {
  data: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationSubmitKycFormArgs = {
  fields: Array<TKycTemplateFieldFillableModelInput>;
  token: Scalars['String'];
};


export type MutationTerminateExecutorArgs = {
  id: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationToggleCampaignReviewInstructionStatusArgs = {
  active: Scalars['Boolean'];
  id: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationToggleWcMapperActivityArgs = {
  assignId: Scalars['String'];
  newStatus: Scalars['Boolean'];
  workspaceId: Scalars['String'];
};


export type MutationTransferOrganizationOwnershipArgs = {
  organizationId: Scalars['String'];
  transferFromPublicId: Scalars['String'];
  transferToPublicId: Scalars['String'];
};


export type MutationTransferOrganizationOwnershipByAdminArgs = {
  organizationId: Scalars['String'];
  transferFromPublicId: Scalars['String'];
  transferToPublicId: Scalars['String'];
};


export type MutationTwoFactorLoginArgs = {
  TwoFactorCode: Scalars['String'];
};


export type MutationTwoFactorLoginAdminArgs = {
  TwoFactorCode: Scalars['String'];
};


export type MutationUnlinkControlArgs = {
  data: UnlinkControlInput;
  organizationId: Scalars['String'];
};


export type MutationUnlinkEvidenceArgs = {
  data: UnlinkEvidenceInput;
  organizationId: Scalars['String'];
};


export type MutationUpdateAccessManagementAppNameAndVendorArgs = {
  id: Scalars['String'];
  name: Scalars['String'];
  vendorId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationUpdateApplicationArgs = {
  application: ManagedApplicationModelInput;
};


export type MutationUpdateAuditorsArgs = {
  data: UpdateAuditorsInput;
  organizationId: Scalars['String'];
  reportId: Scalars['String'];
};


export type MutationUpdateAutomationArgs = {
  data: AutomationInput;
  workspaceId: Scalars['String'];
};


export type MutationUpdateAvailableCollabsCounterByAdminArgs = {
  id: Scalars['String'];
  newValue: Scalars['String'];
};


export type MutationUpdateAvailableVulTargetsCounterByAdminArgs = {
  id: Scalars['String'];
  newValue: Scalars['String'];
};


export type MutationUpdateAvailableWorkspacesCounterByAdminArgs = {
  id: Scalars['String'];
  newValue: Scalars['String'];
};


export type MutationUpdateCampaignReviewInstructionArgs = {
  instruction: CampaignReviewInstructionInput;
  workspaceId: Scalars['String'];
};


export type MutationUpdateCampaignReviewRowsArgs = {
  data: UpdateRowStatusOrCommentDtoRequestDto;
  email: Scalars['String'];
  executorId: Scalars['String'];
  stageId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationUpdateCampaignReviewRowsDocsArgs = {
  data: UpdateRowStatusOrCommentDtoRequestDto;
  executorId: Scalars['String'];
  stageId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationUpdateCertificateAssetArgs = {
  asset: CertificateAssetInput;
  assetId: Scalars['String'];
  file?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationUpdateConfigArgs = {
  data: ConfigInput;
  workspaceId: Scalars['String'];
};


export type MutationUpdateConfigurationPolicyMapperArgs = {
  configuration: Scalars['JSON'];
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
  wpId: Scalars['String'];
};


export type MutationUpdateCrownJewelArgs = {
  data: UpdateCrownJewelRequest;
  workspaceId: Scalars['String'];
};


export type MutationUpdateCustomFrameworkArgs = {
  framework: BuilderFrameworkInput;
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationUpdateDocumentArgs = {
  newValue: CreateOrUpdateDocumentDto;
  workspaceId: Scalars['String'];
};


export type MutationUpdateEditableAssetArgs = {
  fileName: Scalars['String'];
  id: Scalars['String'];
  innerHTML: Scalars['String'];
  policyId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationUpdateEmployeeHireDateArgs = {
  hireDate: Scalars['String'];
  id: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationUpdateEmployeeStatusArgs = {
  id: Scalars['String'];
  status: HrEmployeeStatusModelInput;
  workspaceId: Scalars['String'];
};


export type MutationUpdateEmployeesTreeArgs = {
  deleted: Array<Scalars['String']>;
  employees: Array<UpdateEmployeesTreeDto>;
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationUpdateFullDocumentArgs = {
  approvers: Array<DocApproverInput>;
  data: NewDocDataInput;
  documentId: Scalars['String'];
  editors: Array<NewDocumentActorInput>;
  name: Scalars['String'];
  recipients: Array<RecipientInput>;
  workspaceId: Scalars['String'];
};


export type MutationUpdateFullDocumentByDocsArgs = {
  approvers: Array<DocApproverInput>;
  data: NewDocDataInput;
  documentId: Scalars['String'];
  editors: Array<NewDocumentActorInput>;
  name: Scalars['String'];
  recipients: Array<RecipientInput>;
};


export type MutationUpdateHrEmployeeArgs = {
  employee: HrEmployeeModelInput;
  workspaceId: Scalars['String'];
};


export type MutationUpdateHrEmployeeSettingArgs = {
  field: Scalars['String'];
  newValue: Scalars['String'];
  updateHistory: Scalars['Boolean'];
  value: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationUpdateIntergationArgs = {
  data: UpdateIntegrationInput;
  workspaceId: Scalars['String'];
};


export type MutationUpdateJobRecordArgs = {
  id: Scalars['String'];
  jobRecord: HrEmployeeJobInfoModelInput;
  workspaceId: Scalars['String'];
};


export type MutationUpdateKycTargetRiskArgs = {
  risk: Scalars['String'];
  targetId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationUpdateKycTargetValuesArgs = {
  data: KycRefactorUpdateTargetInput;
  workspaceId: Scalars['String'];
};


export type MutationUpdateKycTemplateArgs = {
  template: KycRefactorTemplateModelInput;
  workspaceId: Scalars['String'];
};


export type MutationUpdateMonitoringArgs = {
  data: GeneralMonitoringUpdateInput;
  workspaceId: Scalars['String'];
};


export type MutationUpdateNcrArgs = {
  ncrControl: NcrInput;
};


export type MutationUpdateNewDocumentDataArgs = {
  data: NewDocDataInput;
  documentId: Scalars['String'];
};


export type MutationUpdateNewDocumentEditorsArgs = {
  documentId: Scalars['String'];
  editors: Array<NewDocumentActorInput>;
};


export type MutationUpdateNewDocumentNameArgs = {
  documentId: Scalars['String'];
  name: Scalars['String'];
};


export type MutationUpdateNewDocumentRecipientsArgs = {
  documentId: Scalars['String'];
  recipients: Array<RecipientInput>;
};


export type MutationUpdateNewDocumentStatusArgs = {
  documentId: Scalars['String'];
  status: Scalars['String'];
};


export type MutationUpdateNonCustomAccessManagementAppRowArgs = {
  accessManagementAppId: Scalars['String'];
  account: AccessManagementAppAccountEditRequestType;
  applicationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationUpdateOrgCollabsRulesByAdminArgs = {
  id: Scalars['String'];
  newValue: AdminOrganizationCollabRuleInputArray;
};


export type MutationUpdateOrgSubscriptionByAdminArgs = {
  id: Scalars['String'];
  subscription: Scalars['String'];
};


export type MutationUpdateOrgSubscriptionExpiryByAdminArgs = {
  expiry: Scalars['String'];
  id: Scalars['String'];
};


export type MutationUpdateOrgTrialUsedByAdminArgs = {
  id: Scalars['String'];
  isUsed: Scalars['String'];
};


export type MutationUpdateOrganizationBillingInfoArgs = {
  billingData: CreateOrganizationBillingInfoInput;
  orgId: Scalars['String'];
};


export type MutationUpdateOrganizationLogoArgs = {
  newLogo: Scalars['String'];
  organizationId: Scalars['String'];
};


export type MutationUpdateOrganizationNameArgs = {
  newName: Scalars['String'];
  organizationId: Scalars['String'];
};


export type MutationUpdateOrganizationWizardsByAdminArgs = {
  id: Scalars['String'];
  wizards: UpdateWizardsInput;
};


export type MutationUpdatePasswordArgs = {
  data: ChangePasswordOutsideInput;
};


export type MutationUpdatePermissionByAdminArgs = {
  permission: AdminPermissionInput;
};


export type MutationUpdatePhysicalAssetArgs = {
  asset: PhysicalAssetInput;
  assetId: Scalars['String'];
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationUpdatePlaybookAnalyseArgs = {
  config: AnalyseConfigInput;
  organizationId: Scalars['String'];
  playbookId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationUpdatePolicyArgs = {
  data: PolicyInput;
  organizationId: Scalars['String'];
};


export type MutationUpdateReportArgs = {
  data: ReportUpdateInput;
  id: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationUpdateReportInfoArgs = {
  data: NcrReportConfigInput;
  reportId: Scalars['String'];
};


export type MutationUpdateReportStatusArgs = {
  reportId: Scalars['String'];
  status: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationUpdateRiskRegistryArgs = {
  organizationId: Scalars['String'];
  registry: RiskRegistryInput;
  workspaceId: Scalars['String'];
};


export type MutationUpdateRisksByRegistryIdArgs = {
  deleteIds: Array<Scalars['String']>;
  organizationId: Scalars['String'];
  registryId: Scalars['String'];
  risks: Array<RiskInput>;
  workspaceId: Scalars['String'];
};


export type MutationUpdateRisksModelArgs = {
  organizationId: Scalars['String'];
  riskModel: RiskModelInput;
  workspaceId: Scalars['String'];
};


export type MutationUpdateSaasAssetArgs = {
  asset: SaasAssetInput;
  assetId: Scalars['String'];
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationUpdateSoftwareAssetArgs = {
  asset: SoftwareAssetInput;
  assetId: Scalars['String'];
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationUpdateTargetArgs = {
  target: UpdateTargetInput;
  workspaceId: Scalars['String'];
};


export type MutationUpdateTemplateArgs = {
  template: AdminEmailTemplateInput;
};


export type MutationUpdateUserProfileArgs = {
  data: UpdateUserProfileRequest;
};


export type MutationUpdateUserRoleArgs = {
  publicId: Scalars['String'];
  roles: RolesArrayInput;
  workspaceId: Scalars['String'];
};


export type MutationUpdateVendorArgs = {
  employee: VendorInput;
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationUpdateVirtualAssetArgs = {
  asset: VirtualAssetInput;
  assetId: Scalars['String'];
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationUpdateWcMapperArgs = {
  data: CreateWcMapperInput;
  workspaceId: Scalars['String'];
};


export type MutationUpdateWorkspaceAccountMappingConfigByAdminArgs = {
  id: Scalars['String'];
  newValue: Scalars['String'];
};


export type MutationUpdateWorkspaceCollaboratorRoleArgs = {
  newRole: Scalars['String'];
  publicId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationUpdateWorkspaceNameArgs = {
  newName: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationUpdateWorkspaceProfileMappingConfigByAdminArgs = {
  id: Scalars['String'];
  newValue: UpdateProfileMappingInputUpdateProfileMappingInput;
};


export type MutationUploadAssetsToNcrByUserArgs = {
  controlId: Scalars['String'];
  data: Array<EvidenceAssetsNcrInput>;
  frameworkId: Scalars['String'];
  ncrId: Scalars['String'];
  reportId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationUploadEditableAssetArgs = {
  fileName: Scalars['String'];
  innerHTML: Scalars['String'];
  policyId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationUploadEvidenceAssetArgs = {
  data: EvidenceAssetInputDto;
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationUploadEvidenceFileArgs = {
  file: Scalars['String'];
  fileDescription: EvidenceAssetInputDto;
  workspaceId: Scalars['String'];
};


export type MutationUploadFileArgs = {
  file: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationUploadFileOrgArgs = {
  file: Scalars['String'];
  organizationId: Scalars['String'];
};


export type MutationUploadKycCsvFileArgs = {
  file: Scalars['String'];
  fileName: Scalars['String'];
  templateId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationUploadPolicyEvidenceFileArgs = {
  file: Scalars['String'];
  fileName: Scalars['String'];
  policyId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationVerifyActorChangesArgs = {
  email: Scalars['String'];
  stageId: Scalars['String'];
  verifyComment?: InputMaybe<Scalars['String']>;
  workspaceId: Scalars['String'];
};


export type MutationVerifyActorChangesDocsArgs = {
  signatureId?: InputMaybe<Scalars['String']>;
  stageId: Scalars['String'];
  verifyComment?: InputMaybe<Scalars['String']>;
  workspaceId: Scalars['String'];
};


export type MutationVicaAdminAddFromFilesArgs = {
  files: VicaTasksFilesInput;
};


export type MutationVicaAdminChangeCategoriesOrderArgs = {
  order: Array<VicaAdminOrderInput>;
};


export type MutationVicaAdminChangeTasksOrderArgs = {
  categoryId: Scalars['String'];
  frameworkView: Scalars['Boolean'];
  order: Array<VicaAdminOrderInput>;
};


export type MutationVicaAdminCreateCategoryArgs = {
  category: VicaAdminCategoryInput;
  orders: Array<VicaAdminOrderInput>;
};


export type MutationVicaAdminCreateTaskArgs = {
  categoryId: Scalars['String'];
  frameworkView: Scalars['Boolean'];
  task: VicaAdminTaskInput;
};


export type MutationVicaAdminDeleteCategoryArgs = {
  categoryId: Scalars['String'];
};


export type MutationVicaAdminDeleteTaskArgs = {
  categoryId: Scalars['String'];
  frameworkView: Scalars['Boolean'];
  taskId: Scalars['String'];
};


export type MutationVicaAdminUpdateCategoryArgs = {
  category: VicaAdminCategoryInput;
  orders: Array<VicaAdminOrderInput>;
  tasks?: InputMaybe<Array<VicaAdminTaskInput>>;
};


export type MutationVicaAdminUpdateTaskArgs = {
  categoryId: Scalars['String'];
  frameworkView: Scalars['Boolean'];
  moveToCategoryId?: InputMaybe<Scalars['String']>;
  task: VicaAdminTaskInput;
};


export type MutationWorkerConfirmSignStageArgs = {
  data: WorkerConfirmSignatureDto;
  workspaceId: Scalars['String'];
};


export type MutationWorkerConfirmStageArgs = {
  id: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type MutationWorkerUploadFileArgs = {
  file: Scalars['String'];
};


export type MutationWorkerUploadNewFileForReviewArgs = {
  data: WorkerUploadNewFileDto;
  workspaceId: Scalars['String'];
};

export type NcrInput = {
  clause?: InputMaybe<Scalars['String']>;
  clauseDescription?: InputMaybe<Scalars['String']>;
  controlId: Scalars['String'];
  createAuditorId?: InputMaybe<Scalars['String']>;
  createDate?: InputMaybe<Scalars['String']>;
  frameworkId: Scalars['String'];
  id: Scalars['String'];
  observed?: InputMaybe<Scalars['String']>;
  reportId: Scalars['String'];
  requestHistory?: InputMaybe<Array<RequestHistoryModelInput>>;
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  workspaceId: Scalars['String'];
};

export type NcrWithUsersModel = {
  NCRs: Array<NcrModel>;
  users: Array<IdNameEmailModel>;
};

export type NameCountInput = {
  count?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
};

export type NameCountModel = {
  count?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
};

export type NameFilter = {
  name?: Maybe<Array<Scalars['String']>>;
};

export type NameLogoInput = {
  logo?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type NameLogoModel = {
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type NameStatusModel = {
  name: Scalars['String'];
  status: Scalars['Boolean'];
};

export type NcrModel = {
  clause?: Maybe<Scalars['String']>;
  clauseDescription?: Maybe<Scalars['String']>;
  controlId: Scalars['String'];
  createAuditorId?: Maybe<Scalars['String']>;
  createDate?: Maybe<Scalars['String']>;
  frameworkId: Scalars['String'];
  id: Scalars['String'];
  observed?: Maybe<Scalars['String']>;
  reportId: Scalars['String'];
  requestHistory?: Maybe<Array<RequestHistoryModel>>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  workspaceId: Scalars['String'];
};

export type NcrReportConfigInput = {
  address: Scalars['String'];
  approvalDate?: InputMaybe<Scalars['String']>;
  approver: Scalars['String'];
  auditCommittee: Scalars['String'];
  auditStandard?: InputMaybe<Scalars['String']>;
  auditType: Scalars['String'];
  auditeeRepresentative: Scalars['String'];
  classification: Scalars['String'];
  clientID?: InputMaybe<Scalars['String']>;
  logo?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<Scalars['String']>;
  owner: Scalars['String'];
  status: Scalars['String'];
  title: Scalars['String'];
  version: Scalars['String'];
};

export type NcrReportConfigModel = {
  address: Scalars['String'];
  approvalDate?: Maybe<Scalars['String']>;
  approver: Scalars['String'];
  auditCommittee: Scalars['String'];
  auditStandard?: Maybe<Scalars['String']>;
  auditType: Scalars['String'];
  auditeeRepresentative: Scalars['String'];
  classification: Scalars['String'];
  clientID?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  organization?: Maybe<Scalars['String']>;
  owner: Scalars['String'];
  status: Scalars['String'];
  title: Scalars['String'];
  version: Scalars['String'];
};

export type NewControlEvidencesPaginationModel = {
  control: NewControlModel;
  evidences: Array<NewEvidenceModel>;
  framework: NewFrameworkModel;
};

export type NewControlModel = {
  collaborators: Array<IdNameModel>;
  delegatedTasks?: Maybe<MainFrameworkControlDelegatedTasksCounterModel>;
  description: Array<Scalars['String']>;
  evidenceTotal: Scalars['Float'];
  evidencesFinished: Array<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type NewControlPaginationModel = {
  controls: Array<NewControlModel>;
  framework: NewFrameworkModel;
  pageInfo: PageInfo;
};

export type NewDocDataInput = {
  editor?: InputMaybe<Scalars['JSON']>;
  innerHtml?: InputMaybe<Scalars['String']>;
  pdfFileId?: InputMaybe<Scalars['String']>;
  variables?: InputMaybe<Array<NewDocDataVariableInput>>;
};

export type NewDocDataModel = {
  editor?: Maybe<Scalars['JSON']>;
  innerHtml?: Maybe<Scalars['String']>;
  pdfFileId?: Maybe<Scalars['String']>;
  variables?: Maybe<Array<NewDocDataVariableModel>>;
};

export type NewDocDataVariableInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  order: Scalars['Float'];
  title: Scalars['String'];
  type: Scalars['String'];
  value?: InputMaybe<Scalars['String']>;
};

export type NewDocDataVariableModel = {
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  order: Scalars['Float'];
  title: Scalars['String'];
  type: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type NewDocumentActorInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

export type NewDocumentActorModel = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

export type NewDocumentInput = {
  accessRules?: InputMaybe<Array<AccessRuleInput>>;
  approvers?: InputMaybe<Array<DocApproverInput>>;
  createdDate?: InputMaybe<Scalars['String']>;
  creatorId?: InputMaybe<Scalars['String']>;
  currentStepEndDate?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<NewDocDataInput>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  deletedDate?: InputMaybe<Scalars['String']>;
  documentId?: InputMaybe<Scalars['String']>;
  editors?: InputMaybe<Array<NewDocumentActorInput>>;
  folderId?: InputMaybe<Scalars['String']>;
  generatedFileId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  lastModified?: InputMaybe<Scalars['String']>;
  latest?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  origin?: InputMaybe<Scalars['Boolean']>;
  recipients?: InputMaybe<Array<RecipientInput>>;
  sender?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  type: Scalars['String'];
  updater?: InputMaybe<NewDocumentActorInput>;
  version?: InputMaybe<Scalars['Float']>;
  visible?: InputMaybe<Scalars['Boolean']>;
  workspaceId?: InputMaybe<Scalars['String']>;
  workspaceName?: InputMaybe<Scalars['String']>;
};

export type NewDocumentModel = {
  accessRules?: Maybe<Array<AccessRuleModel>>;
  approvers?: Maybe<Array<DocApproverModel>>;
  createdDate?: Maybe<Scalars['String']>;
  creatorId?: Maybe<Scalars['String']>;
  currentStepEndDate?: Maybe<Scalars['String']>;
  data?: Maybe<NewDocDataModel>;
  deleted?: Maybe<Scalars['Boolean']>;
  deletedDate?: Maybe<Scalars['String']>;
  documentId?: Maybe<Scalars['String']>;
  editors?: Maybe<Array<NewDocumentActorModel>>;
  folderId?: Maybe<Scalars['String']>;
  generatedFileId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastModified?: Maybe<Scalars['String']>;
  latest?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  origin?: Maybe<Scalars['Boolean']>;
  recipients?: Maybe<Array<RecipientModel>>;
  sender?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  type: Scalars['String'];
  updater?: Maybe<NewDocumentActorModel>;
  version?: Maybe<Scalars['Float']>;
  visible?: Maybe<Scalars['Boolean']>;
  workspaceId?: Maybe<Scalars['String']>;
  workspaceName?: Maybe<Scalars['String']>;
};

export type NewEvidenceModel = {
  automations: Array<EvidenceAutoFileDto>;
  description: Scalars['String'];
  files: Array<EvidenceAutoFileDto>;
  id: Scalars['String'];
  name: Scalars['String'];
  statements: Array<EvidenceAutoFileDto>;
  status: Scalars['String'];
  vicaStep?: Maybe<EvidenceVicaStepModel>;
};

export type NewEvidenceReportModel = {
  automations: Array<EvidenceAutoFileDto>;
  files: Array<EvidenceAutoFileDto>;
  statements: Array<EvidenceAutoFileDto>;
};

export type NewFrameworkModel = {
  controls: Scalars['Float'];
  controlsCompleted: Scalars['Float'];
  createdBy: Scalars['String'];
  description: Scalars['String'];
  evidences: Scalars['Float'];
  evidencesFinished: Array<Scalars['String']>;
  gap: Scalars['Float'];
  id: Scalars['String'];
  isAdded: Scalars['Boolean'];
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  type: Scalars['String'];
  wfId: Scalars['String'];
};

export type NewFrameworkPaginationModel = {
  frameworks: Array<NewFrameworkModel>;
  pageInfo: PageInfo;
};

export type NewIdentityInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

export type NewOrganizationModel = {
  blocked: Scalars['Boolean'];
  blockedReason?: Maybe<Scalars['String']>;
  configuration: OrganizationConfig;
  id: Scalars['String'];
  logo: Scalars['String'];
  name: Scalars['String'];
  subscription: Scalars['String'];
  subscriptionExpiry: Scalars['String'];
  trialUsed: Scalars['Boolean'];
};

export type NewOrganizationWithWorkspacesPaginationAndInvitesCounterModel = {
  invitesCounter: Scalars['Float'];
  organizations: Array<OrganizationWithWorkspacesAndShortCollabsModel>;
  pageInfo: PageInfo;
};

export type NewReportActiveControl = {
  active: Scalars['Boolean'];
  evidences: Array<NewReportActiveEvidence>;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type NewReportActiveControlInput = {
  active: Scalars['Boolean'];
  evidences: Array<NewReportActiveEvidenceInput>;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type NewReportActiveEvidence = {
  active: Scalars['Boolean'];
  assets: Array<NewReportActiveEvidenceAsset>;
  id: Scalars['String'];
  name: Scalars['String'];
  status: Scalars['String'];
};

export type NewReportActiveEvidenceAsset = {
  active: Scalars['Boolean'];
  data?: Maybe<Scalars['JSON']>;
  id: Scalars['String'];
  lastUpdate: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type NewReportActiveEvidenceAssetInput = {
  active: Scalars['Boolean'];
  data?: InputMaybe<Scalars['JSON']>;
  id: Scalars['String'];
  lastUpdate: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type NewReportActiveEvidenceInput = {
  active: Scalars['Boolean'];
  assets: Array<NewReportActiveEvidenceAssetInput>;
  id: Scalars['String'];
  name: Scalars['String'];
  status: Scalars['String'];
};

export type NewReportInput = {
  auditorEmail: Scalars['String'];
  frameworkId: Scalars['String'];
  name: Scalars['String'];
  reportType: Scalars['String'];
  useNcr: Scalars['Boolean'];
};

export type NewWorkspaceModel = {
  id: Scalars['String'];
  name: Scalars['String'];
  organizationId: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  subscription: Scalars['String'];
};

export type NewWorkspacePaginationModel = {
  pageInfo: PageInfo;
  workspaces: Array<NewWorkspaceModel>;
};

export type NewWorkspaceWithShortCollabsModel = {
  collaborators: Array<WorkspaceShortCollaboratorModel>;
  id: Scalars['String'];
  name: Scalars['String'];
  organizationId: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  subscription: Scalars['String'];
};

export type NotCompletedOrganization = {
  billing: BillingModel;
  blocked: Scalars['Boolean'];
  blockedReason?: Maybe<Scalars['String']>;
  collaborators: Array<OrganizationShortCollaboratorModel>;
  configuration: OrganizationConfig;
  id: Scalars['String'];
  logo: Scalars['String'];
  name: Scalars['String'];
  organizationDetails: Scalars['JSON'];
  subscription: Scalars['String'];
  subscriptionExpiry: Scalars['String'];
  trialUsed: Scalars['Boolean'];
};

export type NotificationInput = {
  active: Scalars['Boolean'];
  assignees: Array<Scalars['String']>;
  id: Scalars['String'];
};

export type NotificationModel = {
  data: Array<IdNameMonitoringModel>;
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  type: Scalars['String'];
};

export type OrganizationAuditorSpaceModel = {
  auditorVariants: Array<AuditorVariantsModel>;
  id: Scalars['String'];
  lastUpdate: Scalars['String'];
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  reports: Array<ReportRowAuditSpaceModel>;
};

export type OrganizationConfig = {
  availableCollaboratorsCount: Scalars['Float'];
  availableTargetsVulnerabilityScan?: Maybe<Scalars['Float']>;
  availableWizards: Array<Scalars['String']>;
  availableWorkspaceCount: Scalars['Float'];
};

export type OrganizationConfigurationModel = {
  availableCollaboratorsCount: Scalars['Float'];
  availableCollaboratorsRules: Array<AvailableCollaboratorsRulesModel>;
  availableWizards?: Maybe<Array<Scalars['String']>>;
  availableWorkspaceCount: Scalars['Float'];
};

export type OrganizationExtendedCollaboratorModel = {
  createDate?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastLoginDate?: Maybe<Scalars['String']>;
  lastName: Scalars['String'];
  publicId: Scalars['String'];
  role?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export type OrganizationModel = {
  blocked: Scalars['Boolean'];
  blockedReason?: Maybe<Scalars['String']>;
  collaborators: Array<Collaborator>;
  configuration?: Maybe<OrganizationConfigurationModel>;
  id: Scalars['String'];
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  subscription: Scalars['String'];
  subscriptionExpiry: Scalars['String'];
  trialUsed: Scalars['Boolean'];
};

export type OrganizationRequesterModel = {
  outsideCollaborator?: Maybe<Scalars['Boolean']>;
  publicId: Scalars['String'];
  role?: Maybe<Scalars['String']>;
};

export type OrganizationShortCollaboratorModel = {
  publicId: Scalars['String'];
  role?: Maybe<Scalars['String']>;
};

export type OrganizationWithWorkspacesAndShortCollabsModel = {
  blocked: Scalars['Boolean'];
  blockedReason?: Maybe<Scalars['String']>;
  collaborators: Array<OrganizationShortCollaboratorModel>;
  configuration: OrganizationConfig;
  id: Scalars['String'];
  logo: Scalars['String'];
  name: Scalars['String'];
  pageInfo: PageInfo;
  requester: OrganizationRequesterModel;
  subscription: Scalars['String'];
  subscriptionExpiry: Scalars['String'];
  trialUsed: Scalars['Boolean'];
  workspaces: Array<NewWorkspaceWithShortCollabsModel>;
};

export type OsFilter = {
  os?: Maybe<Array<Scalars['String']>>;
};

export type OverviewResponseModel = {
  accounts: Scalars['Float'];
  assets: Scalars['Float'];
  automationRules: Scalars['Float'];
  crownJewels: Scalars['Float'];
  devices: Scalars['Float'];
  events: Scalars['Float'];
  framework?: Maybe<FrameworkOverviewModel1>;
  groups: Scalars['Float'];
  identities: Scalars['Float'];
  integrations: Array<IdNameLogoStatusModel>;
  monitoringRules: Scalars['Float'];
  profiles: Scalars['Float'];
  tpa: Scalars['Float'];
};

export type PageInfo = {
  count: Scalars['Int'];
  groupBy?: Maybe<Scalars['String']>;
  page: Scalars['Int'];
  sort?: Maybe<Scalars['String']>;
  total: Scalars['Int'];
};

export type PageModel = {
  page: Scalars['String'];
};

export type PageModelInput = {
  page: Scalars['String'];
};

export type PaginationInfoInput = {
  count: Scalars['Int'];
  page: Scalars['Int'];
};

export type PaginationInput = {
  count: Scalars['Int'];
  filters?: InputMaybe<FilterInput>;
  groupBy?: InputMaybe<Scalars['String']>;
  page: Scalars['Int'];
  sort?: InputMaybe<Scalars['String']>;
};

export type PaginationInputAnyFilter = {
  count: Scalars['Int'];
  filters?: InputMaybe<Scalars['JSON']>;
  groupBy?: InputMaybe<Scalars['String']>;
  page: Scalars['Int'];
  sort?: InputMaybe<Scalars['String']>;
};

export type PaymentHistoryModel = {
  discountPercentage: Scalars['Float'];
  futurePaymentDate: Scalars['String'];
  invoiceFileId?: Maybe<Scalars['String']>;
  items: Array<ItemModel>;
  periodEnd: Scalars['String'];
  periodStart: Scalars['String'];
  receiptFileId?: Maybe<Scalars['String']>;
  retryCount: Scalars['Float'];
  status: Scalars['String'];
  statusChangedDate: Scalars['String'];
  transactionNumber: Scalars['String'];
  variant: Scalars['String'];
  vatPercentage: Scalars['Float'];
};

export type PaymentMethodModel = {
  cardExpiration?: Maybe<Scalars['String']>;
  cardMask?: Maybe<Scalars['String']>;
  cardType?: Maybe<Scalars['String']>;
  lastFourDigits: Scalars['String'];
  paymentMethodName: Scalars['String'];
};

export type PerformActionProvideFilesDataInputDto = {
  attachedFiles?: InputMaybe<Array<FileIdFileNameModelInput>>;
};

export type PerformActionProvideFilesInputDto = {
  data: PerformActionProvideFilesDataInputDto;
  performerComment?: InputMaybe<Scalars['String']>;
  taskId: Scalars['String'];
};

export type PhysicalAssetHistoryActionInput = {
  employee?: InputMaybe<IdNameInput>;
  name: Scalars['String'];
};

export type PhysicalAssetHistoryActionModel = {
  employee?: Maybe<IdNameModel>;
  name: Scalars['String'];
};

export type PhysicalAssetHistoryInput = {
  action?: InputMaybe<PhysicalAssetHistoryActionInput>;
  actor?: InputMaybe<IdNameInput>;
  date: Scalars['String'];
  status: PhysicalAssetStatusInputOld;
};

export type PhysicalAssetHistoryModel = {
  action?: Maybe<PhysicalAssetHistoryActionModel>;
  actor?: Maybe<IdNameModel>;
  date: Scalars['String'];
  status: PhysicalAssetStatusModelOld;
};

export type PhysicalAssetInput = {
  added: Scalars['String'];
  assetId?: InputMaybe<Scalars['String']>;
  assigned?: InputMaybe<Scalars['String']>;
  assignedTo?: InputMaybe<WorkspaceCollaboratorInput>;
  category: Scalars['String'];
  customFields?: InputMaybe<Scalars['JSON']>;
  id: Scalars['ID'];
  manufacture: Scalars['String'];
  model: Scalars['String'];
  returned?: InputMaybe<Scalars['String']>;
  serial: Scalars['String'];
  status: PhysicalAssetStatusInputOld;
  statuses: Array<PhysicalAssetHistoryInput>;
};

export type PhysicalAssetModel = {
  added: Scalars['String'];
  assetId?: Maybe<Scalars['String']>;
  assigned?: Maybe<Scalars['String']>;
  assignedTo?: Maybe<WorkspaceCollaboratorModel>;
  category: Scalars['String'];
  customFields?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  manufacture: Scalars['String'];
  model: Scalars['String'];
  returned?: Maybe<Scalars['String']>;
  serial: Scalars['String'];
  status: PhysicalAssetStatusModelOld;
  statuses: Array<PhysicalAssetHistoryModel>;
};

export type PhysicalAssetNameCountInput = {
  count: Scalars['Float'];
  name: Scalars['String'];
};

export type PhysicalAssetNameCountModel = {
  count: Scalars['Float'];
  name: Scalars['String'];
};

export type PhysicalAssetSettingsInput = {
  category: Array<PhysicalAssetNameCountInput>;
  customFields: Array<Scalars['String']>;
  manufacture: Array<PhysicalAssetNameCountInput>;
  model: Array<PhysicalAssetNameCountInput>;
  status: Array<PhysicalAssetStatusCountInput>;
};

export type PhysicalAssetSettingsModel = {
  category: Array<PhysicalAssetNameCountModel>;
  customFields: Array<Scalars['String']>;
  manufacture: Array<PhysicalAssetNameCountModel>;
  model: Array<PhysicalAssetNameCountModel>;
  status: Array<PhysicalAssetStatusCountModel>;
};

export type PhysicalAssetStatusCountInput = {
  count: Scalars['Float'];
  name: Scalars['String'];
  status: Scalars['String'];
};

export type PhysicalAssetStatusCountModel = {
  count: Scalars['Float'];
  name: Scalars['String'];
  status: Scalars['String'];
};

export type PhysicalAssetStatusInput = {
  name: Scalars['String'];
  status: PhysicalAssetsStatus;
};

export type PhysicalAssetStatusInputOld = {
  name: Scalars['String'];
  status: Scalars['String'];
};

export type PhysicalAssetStatusModel = {
  name: Scalars['String'];
  status: PhysicalAssetsStatus;
};

export type PhysicalAssetStatusModelOld = {
  name: Scalars['String'];
  status: Scalars['String'];
};

export type PhysicalAssetsFilterModel = NameFilter;

export type PhysicalAssetsPaginationModel = {
  data: Array<PhysicalAssetModel>;
  pageInfo: PageInfo;
};

export enum PhysicalAssetsStatus {
  Archived = 'ARCHIVED',
  Deployable = 'DEPLOYABLE',
  Deployed = 'DEPLOYED',
  Pending = 'PENDING',
  Undeployable = 'UNDEPLOYABLE'
}

export type PlaybookModel = {
  active: Scalars['Boolean'];
  assignees: Array<IdNameLogoModel>;
  description: Scalars['String'];
  id: Scalars['String'];
  lastRun: Scalars['String'];
  lastRunStatus: Scalars['String'];
  name: Scalars['String'];
};

export type PlaybookResponseModel = {
  pageInfo: PageInfo;
  playbooks: Array<PlaybookModel>;
};

export type PlaybookStoreItemModel = {
  added: Scalars['Boolean'];
  config: AnalyseConfigModel;
  id: Scalars['String'];
  name: Scalars['String'];
  origin: Scalars['String'];
};

export type PlaybookStoreResponseModel = {
  pageInfo: PageInfo;
  playbooks: Array<PlaybookStoreItemModel>;
};

export type PoliciesFilterModel = FrameworkFilter | NameFilter;

export type PoliciesWithFilterModel = {
  pageInfo: PageInfo;
  policies: Array<BuilderPolicyModel>;
};

export type PolicyAssetHistoryModel = {
  historyId: Scalars['String'];
  id: Scalars['String'];
  innerHTML?: Maybe<Scalars['String']>;
  lastUpload?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  type: Scalars['String'];
  userName: Scalars['String'];
};

export type PolicyAssetHistoryResponse = {
  histories: Array<PolicyAssetHistoryModel>;
  pageInfo: PageInfo;
};

export type PolicyFileDto = {
  id: Scalars['String'];
  innerHTML?: Maybe<Scalars['String']>;
  lastUpload?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  type: Scalars['String'];
};

export type PolicyInput = {
  configuration: Scalars['JSON'];
  description: Scalars['String'];
  editableTemplates: Array<EditableHtmlInput>;
  frameworks: Array<NameLogoInput>;
  id: Scalars['String'];
  name: Scalars['String'];
  organizationId: Scalars['String'];
  origin: Scalars['Boolean'];
  pipeLinesCounter: Scalars['Float'];
  tag: Array<Scalars['String']>;
  templates: Array<PolicyTemplateInput>;
  visibility: Scalars['String'];
};

export type PolicyModel = {
  configurationMapper: Scalars['JSON'];
  configurationPolicy: Scalars['JSON'];
  description: Scalars['String'];
  files: Array<PolicyFileDto>;
  filesCount: Scalars['Float'];
  frameworks: Array<NameLogoModel>;
  id: Scalars['String'];
  name: Scalars['String'];
  origin: Scalars['String'];
  pipelines: Scalars['Float'];
  templates: Array<TemplateFileDto>;
  wpId: Scalars['String'];
};

export type PolicyModelWithPagination = {
  pageInfo: PageInfo;
  policies: Array<PolicyModel>;
};

export type PolicyQsModel = {
  automationData: QsPolicyAutomationDataModel;
  configurationPolicy: Scalars['JSON'];
  editableTemplates: Array<EditableHtmlModel>;
  policyDesc: Scalars['String'];
  policyId: Scalars['String'];
  policyName: Scalars['String'];
  wpConfig?: Maybe<Scalars['JSON']>;
  wpId?: Maybe<Scalars['String']>;
};

export type PolicyStoreModel = {
  added: Scalars['Boolean'];
  configuration: Scalars['JSON'];
  created: Scalars['String'];
  description: Scalars['String'];
  frameworks: Array<NameLogoModel>;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type PolicyStoreResponse = {
  array: Array<PolicyStoreModel>;
  pageInfo: PageInfo;
};

export type PolicyTemplateInput = {
  fileId: Scalars['String'];
  fileName: Scalars['String'];
};

export type PortalAssetRequestDataInput = {
  fieldName: Scalars['String'];
  fieldValue?: InputMaybe<Scalars['String']>;
};

export type PortalAssetRequestDataModel = {
  fieldName: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};

export type PortalAssetsFilter = {
  category?: InputMaybe<Array<Scalars['String']>>;
  manufacture?: InputMaybe<Array<Scalars['String']>>;
  model?: InputMaybe<Array<Scalars['String']>>;
  nameLike?: InputMaybe<Scalars['String']>;
};

export type PortalAssetsRequestInput = {
  assetType: AssetsRequestAssetType;
  comment?: InputMaybe<Scalars['String']>;
  data: Array<PortalAssetRequestDataInput>;
  id: Scalars['String'];
  requestDate: Scalars['String'];
  resolution?: InputMaybe<Scalars['String']>;
  resolveDate?: InputMaybe<Scalars['String']>;
  resolver?: InputMaybe<AssetRequestRequestorInput>;
  status: AssetsRequestStatus;
  type: AssetsRequestType;
  workspaceId: Scalars['String'];
};

export type PortalAssetsRequestModel = {
  assetType: AssetsRequestAssetType;
  comment?: Maybe<Scalars['String']>;
  data: Array<PortalAssetRequestDataModel>;
  id: Scalars['String'];
  requestDate: Scalars['String'];
  resolution?: Maybe<Scalars['String']>;
  resolveDate?: Maybe<Scalars['String']>;
  resolver?: Maybe<AssetRequestRequestorModel>;
  status: AssetsRequestStatus;
  type: AssetsRequestType;
  workspaceId: Scalars['String'];
};

export type PortalAssetsRequestPagingModel = {
  pageInfo: PageInfo;
  result: Array<PortalAssetsRequestModel>;
};

export type PortalAssetsRequestsFilters = {
  requestDate?: InputMaybe<Array<Scalars['String']>>;
  requestIdLike?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Array<AssetsRequestStatus>>;
  type?: InputMaybe<Array<AssetsRequestType>>;
};

export type PortalAssignmentsFilters = {
  assignmentIdLike?: InputMaybe<Scalars['String']>;
  createdDate?: InputMaybe<Array<Scalars['String']>>;
  dueDate?: InputMaybe<Array<Scalars['String']>>;
  examName?: InputMaybe<Array<Scalars['String']>>;
  requestor?: InputMaybe<Array<Scalars['String']>>;
  startDate?: InputMaybe<Array<Scalars['String']>>;
  status?: InputMaybe<Array<TrainingAssignmentStatus>>;
  trainingName?: InputMaybe<Array<Scalars['String']>>;
  type?: InputMaybe<Array<Scalars['String']>>;
};

export type PortalHrCreateIssueInputDto = {
  anonymous: Scalars['Boolean'];
  description: Scalars['String'];
  issueType: Scalars['String'];
  offender?: InputMaybe<HrRequestRequestorInput>;
};

export type PortalHrCreateTimeOffRequestInputDto = {
  attachments: Array<PortalHrTimeOffRequestAttachmentsInput>;
  comment: Scalars['String'];
  endDate?: InputMaybe<Scalars['String']>;
  startDate: Scalars['String'];
  type: Scalars['String'];
};

export type PortalHrEditRequestEditProfile = {
  fieldName: Scalars['String'];
  fieldValue: Scalars['String'];
};

export type PortalHrEditRequestInputDto = {
  data: PortalHrEditRequestInputDtoData;
  requestType: RequestType;
};

export type PortalHrEditRequestInputDtoData = {
  editProfile: Array<PortalHrEditRequestEditProfile>;
};

export type PortalHrEmployeeModel = {
  birthDay?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  department: Scalars['String'];
  employeeId: Scalars['String'];
  employeeStatus: HrEmployeeStatusModel;
  employmentType: Scalars['String'];
  firstName: Scalars['String'];
  hireDate: Scalars['String'];
  id: Scalars['String'];
  jobTitle: Scalars['String'];
  lastName: Scalars['String'];
  manager?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  workEmail: Scalars['String'];
  workMobilePhone: Scalars['String'];
  zip?: Maybe<Scalars['String']>;
};

export type PortalHrEmployeesAutocompleteModel = {
  pageInfo: PageInfo;
  result: Array<HrRequestRequestorModel>;
};

export type PortalHrIssueInput = {
  anonymous: Scalars['Boolean'];
  description: Scalars['String'];
  id: Scalars['String'];
  issueType: Scalars['String'];
  offender?: InputMaybe<HrRequestRequestorInput>;
  requestDate: Scalars['String'];
  requestor: HrRequestRequestorInput;
  resolution?: InputMaybe<Scalars['String']>;
  resolveDate?: InputMaybe<Scalars['String']>;
  resolver?: InputMaybe<HrRequestResolverInput>;
  status: HrIssuesStatus;
  workspaceId: Scalars['String'];
};

export type PortalHrIssueModel = {
  anonymous: Scalars['Boolean'];
  description: Scalars['String'];
  id: Scalars['String'];
  issueType: Scalars['String'];
  offender?: Maybe<HrRequestRequestorModel>;
  requestDate: Scalars['String'];
  requestor: HrRequestRequestorModel;
  resolution?: Maybe<Scalars['String']>;
  resolveDate?: Maybe<Scalars['String']>;
  resolver?: Maybe<HrRequestResolverModel>;
  status: HrIssuesStatus;
  workspaceId: Scalars['String'];
};

export type PortalHrIssueOffenderAutocompleteModel = {
  pageInfo: PageInfo;
  result: Array<HrRequestRequestorModel>;
};

export type PortalHrIssuesFilter = {
  anonymous?: InputMaybe<Array<Scalars['String']>>;
  issueIdLike: Scalars['String'];
  issueType?: InputMaybe<Array<Scalars['String']>>;
  offender?: InputMaybe<Array<Scalars['String']>>;
  requestDate?: InputMaybe<Array<Scalars['String']>>;
  status?: InputMaybe<Array<Scalars['String']>>;
};

export type PortalHrIssuesPagingModel = {
  pageInfo: PageInfo;
  result: Array<PortalHrIssueModel>;
};

export type PortalHrJobHistoryModel = {
  department: Scalars['String'];
  division: Scalars['String'];
  effectiveDate: Scalars['String'];
  employmentType: Scalars['String'];
  jobTitle: Scalars['String'];
  location: Scalars['String'];
  manager?: Maybe<Scalars['String']>;
};

export type PortalHrJobHistoryPaginatedResponse = {
  pageInfo: PageInfo;
  result: Array<PortalHrJobHistoryModel>;
};

export type PortalHrMyTimeOffFilter = {
  endDate?: InputMaybe<Array<Scalars['String']>>;
  requestDate?: InputMaybe<Array<Scalars['String']>>;
  startDate?: InputMaybe<Array<Scalars['String']>>;
  status?: InputMaybe<Array<Scalars['String']>>;
  timeOffIdLike: Scalars['String'];
  type?: InputMaybe<Array<Scalars['String']>>;
};

export type PortalHrRequestInput = {
  data: HrRequestEditProfileDataInput;
  id: Scalars['String'];
  requestDate: Scalars['String'];
  requestor: HrRequestRequestorInput;
  resolveDate?: InputMaybe<Scalars['String']>;
  resolver?: InputMaybe<HrRequestResolverInput>;
  status: HrRequestStatus;
  type: RequestType;
  workspaceId: Scalars['String'];
};

export type PortalHrRequestModel = {
  data: HrRequestEditProfileDataModel;
  id: Scalars['String'];
  requestDate: Scalars['String'];
  requestor: HrRequestRequestorModel;
  resolveDate?: Maybe<Scalars['String']>;
  resolver?: Maybe<HrRequestResolverModel>;
  status: HrRequestStatus;
  type: RequestType;
  workspaceId: Scalars['String'];
};

export type PortalHrRequestPagingModel = {
  pageInfo: PageInfo;
  result: Array<PortalHrRequestModel>;
};

export type PortalHrRequestsFilter = {
  requestDate?: InputMaybe<Array<Scalars['String']>>;
  requestIdLike: Scalars['String'];
  requestType?: InputMaybe<Array<Scalars['String']>>;
  status?: InputMaybe<Array<Scalars['String']>>;
};

export type PortalHrTimeOffEmployeesAutocompleteModel = {
  pageInfo: PageInfo;
  result: Array<HrRequestRequestorModel>;
};

export type PortalHrTimeOffFilter = {
  employee?: InputMaybe<Array<Scalars['String']>>;
  endDate?: InputMaybe<Array<Scalars['String']>>;
  requestDate?: InputMaybe<Array<Scalars['String']>>;
  startDate?: InputMaybe<Array<Scalars['String']>>;
  status?: InputMaybe<Array<Scalars['String']>>;
  timeOffIdLike: Scalars['String'];
  type?: InputMaybe<Array<Scalars['String']>>;
};

export type PortalHrTimeOffRequestApprovalRoutesInput = {
  routeType: HrTimeOffRouteType;
  steps: Array<PortalHrTimeOffRequestApprovalRoutesStepsInput>;
};

export type PortalHrTimeOffRequestApprovalRoutesModel = {
  routeType: HrTimeOffRouteType;
  steps: Array<PortalHrTimeOffRequestApprovalRoutesStepsModel>;
};

export type PortalHrTimeOffRequestApprovalRoutesStepsInput = {
  comment?: InputMaybe<Scalars['String']>;
  resolveDate?: InputMaybe<Scalars['String']>;
  resolver?: InputMaybe<PortalHrTimeOffRequestRequestorInput>;
  status: HrTimeOffStepsStatus;
  stepNumber: Scalars['Float'];
  type: HrTimeOffStepsType;
};

export type PortalHrTimeOffRequestApprovalRoutesStepsModel = {
  comment?: Maybe<Scalars['String']>;
  resolveDate?: Maybe<Scalars['String']>;
  resolver?: Maybe<PortalHrTimeOffRequestRequestorModel>;
  status: HrTimeOffStepsStatus;
  stepNumber: Scalars['Float'];
  type: HrTimeOffStepsType;
};

export type PortalHrTimeOffRequestAttachmentsInput = {
  fileId: Scalars['String'];
  fileName: Scalars['String'];
};

export type PortalHrTimeOffRequestAttachmentsModel = {
  fileId: Scalars['String'];
  fileName: Scalars['String'];
};

export type PortalHrTimeOffRequestInput = {
  approvalRoutes: Array<PortalHrTimeOffRequestApprovalRoutesInput>;
  attachments?: InputMaybe<Array<PortalHrTimeOffRequestAttachmentsInput>>;
  comment?: InputMaybe<Scalars['String']>;
  currentRouteType: Scalars['String'];
  currentStepNumber: Scalars['Float'];
  endDate?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  requestDate: Scalars['String'];
  requestor: PortalHrTimeOffRequestRequestorInput;
  startDate: Scalars['String'];
  status: HrTimeOffStatus;
  type: Scalars['String'];
};

export type PortalHrTimeOffRequestModel = {
  approvalRoutes: Array<PortalHrTimeOffRequestApprovalRoutesModel>;
  attachments?: Maybe<Array<PortalHrTimeOffRequestAttachmentsModel>>;
  comment?: Maybe<Scalars['String']>;
  currentRouteType: Scalars['String'];
  currentStepNumber: Scalars['Float'];
  endDate?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  requestDate: Scalars['String'];
  requestor: PortalHrTimeOffRequestRequestorModel;
  startDate: Scalars['String'];
  status: HrTimeOffStatus;
  type: Scalars['String'];
};

export type PortalHrTimeOffRequestPagingModel = {
  pageInfo: PageInfo;
  result: Array<PortalHrTimeOffRequestModel>;
};

export type PortalHrTimeOffRequestRequestorInput = {
  collaboratorFullName?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  employeeFullName?: InputMaybe<Scalars['String']>;
  employeeId?: InputMaybe<Scalars['String']>;
  publicId?: InputMaybe<Scalars['String']>;
};

export type PortalHrTimeOffRequestRequestorModel = {
  collaboratorFullName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  employeeFullName?: Maybe<Scalars['String']>;
  employeeId?: Maybe<Scalars['String']>;
  publicId?: Maybe<Scalars['String']>;
};

export type PortalHrTimeOffRequestSettingsInput = {
  timeOffType: Array<Scalars['String']>;
};

export type PortalHrTimeOffRequestSettingsModel = {
  timeOffType: Array<Scalars['String']>;
};

export type PortalPhysicalAssetModel = {
  assetId: Scalars['String'];
  assigned?: Maybe<Scalars['String']>;
  category: Scalars['String'];
  customFields?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  manufacture: Scalars['String'];
  model: Scalars['String'];
  serial: Scalars['String'];
  workspaceId: Scalars['String'];
};

export type PortalPhysicalAssetsPagingModel = {
  pageInfo: PageInfo;
  result: Array<PortalPhysicalAssetModel>;
};

export type PortalPhysicalAssetsSettingsInput = {
  category: Array<Scalars['String']>;
  manufacture: Array<Scalars['String']>;
  model: Array<Scalars['String']>;
};

export type PortalPhysicalAssetsSettingsModel = {
  category: Array<Scalars['String']>;
  manufacture: Array<Scalars['String']>;
  model: Array<Scalars['String']>;
};

export type PortalRequiredActionInput = {
  createdDate: Scalars['String'];
  data?: InputMaybe<FrameworksDelegatedTaskDataInput>;
  description: Scalars['String'];
  id: Scalars['String'];
  performDate?: InputMaybe<Scalars['String']>;
  performerComment?: InputMaybe<Scalars['String']>;
  requestor: FrameworksDelegatedTaskCollaboratorInput;
  requestorComment: Scalars['String'];
  resolveDate?: InputMaybe<Scalars['String']>;
  resolver?: InputMaybe<FrameworksDelegatedTaskCollaboratorInput>;
  resolverComment?: InputMaybe<Scalars['String']>;
  source: DelegatedTaskSources;
  status: RequiredActionsStatus;
  title: Scalars['String'];
  type: RequiredActionsType;
  workspaceId: Scalars['String'];
};

export type PortalRequiredActionModel = {
  createdDate: Scalars['String'];
  data?: Maybe<FrameworksDelegatedTaskDataModel>;
  description: Scalars['String'];
  id: Scalars['String'];
  performDate?: Maybe<Scalars['String']>;
  performerComment?: Maybe<Scalars['String']>;
  requestor: FrameworksDelegatedTaskCollaboratorModel;
  requestorComment: Scalars['String'];
  resolveDate?: Maybe<Scalars['String']>;
  resolver?: Maybe<FrameworksDelegatedTaskCollaboratorModel>;
  resolverComment?: Maybe<Scalars['String']>;
  source: DelegatedTaskSources;
  status: RequiredActionsStatus;
  title: Scalars['String'];
  type: RequiredActionsType;
  workspaceId: Scalars['String'];
};

export type PortalRequiredActionsCollaboratorAutocompleteModel = {
  pageInfo: PageInfo;
  result: Array<PortalRequiredActionsCollaboratorModel>;
};

export type PortalRequiredActionsCollaboratorInput = {
  collaboratorId: Scalars['String'];
  fullName: Scalars['String'];
};

export type PortalRequiredActionsCollaboratorModel = {
  collaboratorId: Scalars['String'];
  fullName: Scalars['String'];
};

export type PortalRequiredActionsFilter = {
  createdDate?: InputMaybe<Array<Scalars['String']>>;
  performDate?: InputMaybe<Array<Scalars['String']>>;
  requestor?: InputMaybe<Array<Scalars['String']>>;
  resolveDate?: InputMaybe<Array<Scalars['String']>>;
  resolver?: InputMaybe<Array<Scalars['String']>>;
  status?: InputMaybe<Array<Scalars['String']>>;
  taskIdLike?: InputMaybe<Scalars['String']>;
  taskType?: InputMaybe<Array<Scalars['String']>>;
};

export type PortalRequiredActionsPagingModel = {
  pageInfo: PageInfo;
  result: Array<PortalRequiredActionModel>;
};

export type PortalTrainingContentModel = {
  data: TrainingContentDataModel;
  order: Scalars['Float'];
  sectionId: Scalars['String'];
  sectionName: Scalars['String'];
  status: TrainingContentStatus;
  type: MainTrainingContentType;
};

export type PortalTrainingExamFinishResponse = {
  exam?: Maybe<PortalTrainingsAssignmentsExamModel>;
  examStatus: TrainingAssignmentObjectStatus;
};

export type PortalTrainingExamSubmitAnswerResponse = {
  readyToFinish: Scalars['Boolean'];
  skippedQuestions: Scalars['Float'];
};

export type PortalTrainingModel = {
  completeDate?: Maybe<Scalars['String']>;
  content: Array<PortalTrainingContentModel>;
  duration: Scalars['Float'];
  limitMaxDuration: Scalars['Float'];
  limitMinDuration: Scalars['Float'];
  startDate?: Maybe<Scalars['String']>;
  status: TrainingAssignmentObjectStatus;
  trainingCategory: Scalars['String'];
  trainingCover?: Maybe<TrainingCoverImageModel>;
  trainingDescription: Scalars['String'];
  trainingLevel: MainTrainingLevel;
  trainingName: Scalars['String'];
  trainingVersion: Scalars['Float'];
  trainingVersionId: Scalars['String'];
};

export type PortalTrainingsAssignmentModel = {
  actualStartDate?: Maybe<Scalars['String']>;
  canceledInfo?: Maybe<MainTrainingAssignmentCancelInfoModel>;
  completeDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  postExam?: Maybe<MainTrainingAssignmentPostExamModel>;
  recipient: TrainingCollaboratorModel;
  requestDate: Scalars['String'];
  requestor: TrainingCollaboratorModel;
  startDate: Scalars['String'];
  status: TrainingAssignmentStatus;
  training?: Maybe<MainTrainingAssignmentTrainingModel>;
  workspaceId: Scalars['String'];
};

export type PortalTrainingsAssignmentsExamInput = {
  completeDate?: InputMaybe<Scalars['String']>;
  examCategory: Scalars['String'];
  examCover: TrainingCoverImageInput;
  examDescription: Scalars['String'];
  examLevel: TrainingExamLevel;
  examName: Scalars['String'];
  examPassingPoints?: InputMaybe<Scalars['Float']>;
  examVersion: Scalars['Float'];
  examVersionId: Scalars['String'];
  questions: Array<PortalTrainingsAssignmentsExamQuestionInput>;
  startDate?: InputMaybe<Scalars['String']>;
  status: TrainingAssignmentObjectStatus;
  timeToPass: Scalars['Float'];
  totalPoints?: InputMaybe<Scalars['Float']>;
};

export type PortalTrainingsAssignmentsExamModel = {
  completeDate?: Maybe<Scalars['String']>;
  examCategory: Scalars['String'];
  examCover: TrainingCoverImageModel;
  examDescription: Scalars['String'];
  examLevel: TrainingExamLevel;
  examName: Scalars['String'];
  examPassingPoints?: Maybe<Scalars['Float']>;
  examVersion: Scalars['Float'];
  examVersionId: Scalars['String'];
  questions: Array<PortalTrainingsAssignmentsExamQuestionModel>;
  startDate?: Maybe<Scalars['String']>;
  status: TrainingAssignmentObjectStatus;
  timeToPass: Scalars['Float'];
  totalPoints?: Maybe<Scalars['Float']>;
};

export type PortalTrainingsAssignmentsExamQuestionInput = {
  answer?: InputMaybe<Array<Scalars['String']>>;
  answerDate?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  options: Array<PortalTrainingsAssignmentsExamQuestionOptionInput>;
  order: Scalars['Float'];
  points?: InputMaybe<Scalars['Float']>;
  question: Scalars['String'];
  questionId: Scalars['String'];
  status: TrainingAssignmentExamAnswerStatus;
  type: TrainingExamQuestionType;
  validation?: InputMaybe<PortalTrainingsAssignmentsExamQuestionValidationInput>;
};

export type PortalTrainingsAssignmentsExamQuestionModel = {
  answer?: Maybe<Array<Scalars['String']>>;
  answerDate?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  options: Array<PortalTrainingsAssignmentsExamQuestionOptionModel>;
  order: Scalars['Float'];
  points?: Maybe<Scalars['Float']>;
  question: Scalars['String'];
  questionId: Scalars['String'];
  status: TrainingAssignmentExamAnswerStatus;
  type: TrainingExamQuestionType;
  validation?: Maybe<PortalTrainingsAssignmentsExamQuestionValidationModel>;
};

export type PortalTrainingsAssignmentsExamQuestionOptionInput = {
  correct?: InputMaybe<Scalars['Boolean']>;
  option: Scalars['String'];
  order: Scalars['Float'];
  points?: InputMaybe<Scalars['Float']>;
};

export type PortalTrainingsAssignmentsExamQuestionOptionModel = {
  correct?: Maybe<Scalars['Boolean']>;
  option: Scalars['String'];
  order: Scalars['Float'];
  points?: Maybe<Scalars['Float']>;
};

export type PortalTrainingsAssignmentsExamQuestionValidationInput = {
  collaboratorId?: InputMaybe<Scalars['String']>;
  correctAnswer?: InputMaybe<Array<Scalars['String']>>;
  email?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  points?: InputMaybe<Scalars['Float']>;
  type: MainTrainingAssignmentPostExamAnswerValidationType;
  validationDate: Scalars['String'];
};

export type PortalTrainingsAssignmentsExamQuestionValidationModel = {
  collaboratorId?: Maybe<Scalars['String']>;
  correctAnswer?: Maybe<Array<Scalars['String']>>;
  email?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  points?: Maybe<Scalars['Float']>;
  type: MainTrainingAssignmentPostExamAnswerValidationType;
  validationDate: Scalars['String'];
};

export type PortalTrainingsAssignmentsPagingModel = {
  pageInfo: PageInfo;
  result: Array<PortalTrainingsShortAssignmentModel>;
};

export type PortalTrainingsShortAssignmentModel = {
  endDate?: Maybe<Scalars['String']>;
  examName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  requestor: Scalars['String'];
  startDate: Scalars['String'];
  status: TrainingAssignmentStatus;
  trainingName?: Maybe<Scalars['String']>;
};

export type PostureFilterModel = DiscoveryStatusFilter | NameFilter | SeverityFilter;

export type PreRequisiteInput = {
  id: Scalars['String'];
  type: Scalars['String'];
  valuesId: Array<Scalars['String']>;
};

export type PreRequisiteModel = {
  data: Array<ResultUnion>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type PresettingsPolicyAutomationDataModel = {
  automationName: Scalars['String'];
  automationStages: Array<StageModel>;
  evidence: EvidenceNodeModel;
  trigger: TriggerModel;
};

export type Privilege = {
  accountsCount: Scalars['Int'];
  appInfo: AppInfo;
  assetsCount: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type PrivilegeFilter = {
  privilege?: Maybe<Array<Scalars['String']>>;
};

export type PrivilegeFilterModel = AppNameFilter | NameFilter | TypeFilter;

export type Privileges = {
  filters: Array<Filter>;
  pageInfo: PageInfo;
  privileges: Array<Privilege>;
};

export type PrivilegesFilteredInput = {
  filter: FilterInput;
  pageInfo: SharedPaginationInput;
};

export type ProbabilityImpactModel = {
  description: Scalars['String'];
  quality: Scalars['String'];
  quantitative: Scalars['Float'];
};

export type ProbabilityInput = {
  description: Scalars['String'];
  quality: Scalars['String'];
  quantitative: Scalars['Float'];
};

export type ProfileFilter = {
  profile?: Maybe<Array<Scalars['String']>>;
};

export type ProfileFilterModel = ApplicationFilter | CategoryFilter | ProfileFilter;

export type ProfileInfo = {
  applications?: Maybe<Scalars['Int']>;
  assets?: Maybe<Scalars['Int']>;
  assigned?: Maybe<Scalars['Int']>;
  category: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  identities: Array<IdentitySmallModel>;
  lastEditor?: Maybe<Editor>;
  lastUpdate?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  privileges?: Maybe<Scalars['Int']>;
  providers?: Maybe<Scalars['Int']>;
};

export type ProfilesMappingSchemaInput = {
  appName: Scalars['String'];
  groupsName: Array<Scalars['String']>;
};

export type ProfilesMappingSchemaModel = {
  appName: Scalars['String'];
  groupsName: Array<Scalars['String']>;
};

export type PublicIdFilter = {
  publicId?: Maybe<Array<Scalars['String']>>;
};

export type QsAutomationInput = {
  automation: AutomationInput;
  templateId: Scalars['String'];
};

export type QsAutomationsResponse = {
  ids: Array<QsIdsModel>;
  message: Scalars['String'];
};

export type QsIdsModel = {
  autoId: Scalars['String'];
  templateId: Scalars['String'];
};

export type QsModel = {
  frameworks: Array<FrameworkQsModel>;
  id: Scalars['String'];
  interpolation: Scalars['JSON'];
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  percentage: Scalars['Float'];
  policies: Array<PolicyQsModel>;
};

export type QsPolicyAssetInputDto = {
  filename: Scalars['String'];
  innerHTML?: InputMaybe<Scalars['String']>;
  policyId: Scalars['String'];
};

export type QsPolicyAutomationDataModel = {
  assets: Array<FileModel>;
  automationName: Scalars['String'];
  automationStages: Array<StageModel>;
  evidence: EvidenceNodeModel;
  isUsed: Scalars['Boolean'];
  trigger: TriggerModel;
};

export type QsResponse = {
  collaborators: Array<ActorModel>;
  packages: Array<QsModel>;
  pageInfo: PageInfo;
};

export type Query = {
  accounts: AccountsResponseModel;
  accountsFilter: Array<AccountFilterModel>;
  adminAccountsFilter: Array<AdminAccountsFilterModel>;
  adminGetAllControlsDialogData: AdminControlsWithFilterModel;
  adminGetAllEvidencesDialogData: AdminEvidencesWithFilterModel;
  adminGetBuilderData: AdminBuilderResponseModel;
  adminGetCompanyControlsDialogData: AdminControlsWithFilterModel;
  adminGetCompanyEvidencesDialogData: AdminEvidencesWithFilterModel;
  adminGetControlsByFrameworkId: Array<AdminBuilderControlModel>;
  adminGetDocumentByIdRefactor: NewDocumentModel;
  adminGetDocumentsRefactor: Array<NewDocumentModel>;
  adminGetFilesByFolder: Array<FileModel>;
  adminGetPrivateControlsDialogData: AdminControlsWithFilterModel;
  adminGetPrivateEvidencesDialogData: AdminEvidencesWithFilterModel;
  adminGetPrivatePolicies: AdminPoliciesWithFilterModel;
  adminGetPublicAndPrivateControlsDialogData: AdminControlsWithFilterModel;
  adminGetPublicAndPrivateControlsWithFilterPag: AdminControlsWithFilterModel;
  adminGetPublicAndPrivateEvidencesDialogData: AdminEvidencesWithFilterModel;
  adminGetPublicAndPrivateEvidencesWithFilterPag: AdminEvidencesWithFilterModel;
  adminGetPublicControlsDialogData: AdminControlsWithFilterModel;
  adminGetPublicEvidencesDialogData: AdminEvidencesWithFilterModel;
  adminLicenseFilter: Array<AdminLicensesFilterModel>;
  adminOrganizationsFilter: Array<AdminOrganizationsFilterModel>;
  analysisFilter: Array<AnalysisFilterModel>;
  appConfigFilter: Array<AppConfigFilterModel>;
  applicationsFilter: Array<PostureFilterModel>;
  assetFilter: Array<AssetFilterModel>;
  assets: Assets;
  auditLogsFilter: Array<AuditLogsFilterModel>;
  autocompleteCollaborators: WorkspaceCollaboratorWithRolePaginatedResponse;
  autocompleteEmployeesEmailName: Array<EmailNameModel>;
  autocompleteHrManagers: Array<IdNameModel>;
  autocompleteKycTemplatesByMatches: RespKycTemplateAutocompleteModel;
  autocompleteKycTemplatesByScreenings: RespKycTemplateAutocompleteModel;
  autocompleteKycTemplatesByTargets: RespKycTemplateAutocompleteModel;
  autocompleteRecipientsEmailName: RespAutocompleteRecipientsModel;
  automationsFilter: Array<AutomationsFilterModel>;
  availableCategories: Array<Scalars['String']>;
  checkCollaboratorIsNotAssigned: CheckEmployeeCollaboratorDto;
  checkTransactionStatus: TransactionStatusModel;
  cjAvailableCategory: Array<CjAvailableCategory>;
  crownJewelList: CrownJewelsResponse;
  crownJewelsFilter: Array<CrownJewelsFilterModel>;
  deleteFile: GeneralResponse;
  devicesFilter: Array<DevicesFilterModel>;
  downloadAppLogFile: DownloadFileModel;
  downloadAuditorEvidenceFile: DownloadFileModel;
  downloadAuditorEvidenceFileDocs: DownloadFileModel;
  downloadCollectorAssetPdf: DownloadFileModel;
  downloadEvidenceFile: DownloadFileModel;
  downloadFile?: Maybe<DownloadFileModel>;
  downloadPolicyEvidenceFile: DownloadFileModel;
  downloadReportCollectorAsset: DownloadFileModel;
  downloadReportCollectorAssetByAuditor: DownloadFileModel;
  evidencesFilter: Array<EvidencesFilterModel>;
  exportClientsByTemplate: IdMessage;
  exportCsvAccessManagementApp: Scalars['String'];
  exportCsvCertificateAssets: Scalars['String'];
  exportCsvEmployees: Scalars['String'];
  exportCsvPhysicalAssets: Scalars['String'];
  exportCsvRisks: Scalars['String'];
  exportCsvRuleset: Scalars['String'];
  exportCsvSaasAssets: Scalars['String'];
  exportCsvSoftwareAssets: Scalars['String'];
  exportCsvTargets: IdMessage;
  exportCsvVendors: Scalars['String'];
  exportCsvVirtualAssets: Scalars['String'];
  getAccessManagementAppById: AccessManagementApp;
  getAccessManagementApps: GetAccessManagementAppsResponse;
  getAccessManagementAvailableFieldsForExport: GetExportCsvFieldResponseModel;
  getAddedApps: AddedAppResponseModel;
  getAdminRoles: GetAdminRolesResponseModel;
  getAdoptedFrameworks: Array<NewFrameworkModel>;
  getAggregationDevices: DevicesResponseModel;
  getAllCollectorsDialogData: CollectorPaginationModel;
  getAllComplianceEvidences: EvidenceResponseModel;
  getAllComplianceEvidencesWithFilter: EvidenceResponseModel;
  getAllControlsDialogData: ControlsWithFilterModel;
  getAllDevices: InventoryDeviceResponseModel;
  getAllEmailTemplatesAdmin: Array<AdminEmailTemplate>;
  getAllEvidencesDialogData: EvidencesWithFilterModel;
  getAllFrameworks: Array<FrameworkModel>;
  getAllIdentities: IdentitiesResponse;
  getAllPolicies: Array<PolicyModel>;
  getAllPoliciesWithPagination: PolicyModelWithPagination;
  getAllReportsRows: ReportRowPaginationModel;
  getAnalysisHistoryByFrameworkIdControlId: AnalyseHistoryFrameworkResponseModel;
  getAnalysisHistoryByFrameworkIdControlIdHistoryId: AnalyseHistoryFrameworkModel;
  getAppDuties: AppDutiesPaginationModel;
  getAppHistory: GetAppHistoryResponseModel;
  getAppLogs: GetAppLogsResponseModel;
  getAppLogsToDate: GetAppLogsResponseModel;
  getAssetsSettingsByAdmin: Array<AssetSettingByAdminModel>;
  getAssignmentsToControlStore: AssignmentsControlResponseModel;
  getAuditLogs: AuditLogsByFiltersPaginationModel;
  getAuditorReportById: ReportReturnOldModel;
  getAuditorTableEvidence: AutoDataAssetAuditSpaceModel;
  getAuditorsVariantsByAuditor: Array<AuditorVariantsModel>;
  getAutoAssetData: AutoDataAssetModel;
  getAutomationById: Automation;
  getAutomationEvidences: AutomationGetEvidencesResponseModel;
  getAutomationHistory: AutomationHistoryResponseModel;
  getAvailableCategoriesByApp: AvailableCategoryListModel;
  getAvailableFrameworks: NewFrameworkPaginationModel;
  getBuilderData: BuilderResponseModel;
  getCampaignReviewInstructionById: CampaignReviewInstructionModel;
  getCampaignReviewInstructionWithPaging: GetInstructionsWIthPagingResponseModel;
  getCampaignReviewStageById: CampaignReviewExecutorStageType;
  getCertificateAssetById: CertificateAssetModel;
  getCertificateAssetSettings: CertificateAssetSettingsModel;
  getCertificateAssets: CertificateAssetsPaginationModel;
  getCertificatesAvailableFieldsForExport: GetExportCsvFieldResponseModel;
  getCollectorHistory: CollectorHistoryPaginationModel;
  getCollectors: CollectorPaginationModel;
  getComments: CommentsModel;
  getCompanyCollectorsDialogData: CollectorPaginationModel;
  getCompanyControlsDialogData: ControlsWithFilterModel;
  getCompanyEvidencesDialogData: EvidencesWithFilterModel;
  getConfig: ConfigResponse;
  getConfigsByApp: AppSettingsResponseModel;
  getControlByIdFrameworkId: NewControlEvidencesPaginationModel;
  getControlFrameworkById: ControlResponseModel;
  getControlsByFramework: NewControlPaginationModel;
  getControlsByFrameworkId: Array<BuilderControlModel>;
  getCreateOrganizationData: GetCreateOrganizationDataModel;
  getCrownJewelById: CrownJewel;
  getCurrentProfile: UserProfileResponse;
  getDataByCollection: GetDataByCollection;
  getDataForAllowedConflict: DataForAllowedConflictModel;
  getDataForCreateDuty: DataForCreateDutyModel;
  getDataForCreateJobTitleByAdmin: DataForCreateJobTitleByAdmin;
  getDataForCreateReportSnapshot: Array<NewReportActiveControl>;
  getDataForCreateRule: DataForCreateRuleModel;
  getDataForDenyConflict: DataForDenyConflictModel;
  getDataForRelease: ReleaseDataModel;
  getDataForReleaseWithEmployees: ReleaseDataWithEmployeesModel;
  getDeleteTemplateData: KycDeleteTemplateDataModel;
  getDocsMyDocumentsAutocompleteSender: GetAutocompleteSenderResponseModel;
  getDocsMyDocumentsAutocompleteWorkspaceNames: GetAutocompleteWorkspaceResponseModel;
  getDocsSharedDocumentsAutocompleteWorkspaceNames: GetAutocompleteWorkspaceResponseModel;
  getDocumentById: FileModel;
  getDocumentsTree: Scalars['String'];
  getDutiesRuleset: RulesetPaginationModel;
  getDutyRuleById: DutyRuleModel;
  getEditableAsset: EditableHtmlModel;
  getEditableAssetHistoryList: PolicyAssetHistoryResponse;
  getEmployeesAvailableFieldsForExport: GetExportCsvFieldResponseModel;
  getEmployeesTree: Array<SmallPersonModel>;
  getEmployeesUsedCities: AutocompleteResponseModel;
  getEmployeesUsedManagers: AutocompleteHrManagersResponse;
  getEmployeesUsedStreetsAutocomplete: AutocompleteResponseModel;
  getEvidenceAssetById: EvidenceAutoFileDto;
  getExtendedCollabByAdmin: GetExtendedCollabResponseModel;
  getExtendedDevice: ExtendedAggregationDeviceModel;
  getExtendedLicenseByAdmin: ExtendedLicenseModel;
  getExtendedOrganizationByAdmin: AdminOrganizationModel;
  getFilesByFolder: Array<FileModel>;
  getFinalApproverByStageIdAndExcId: FinalApprover;
  getFrameworkById: FrameworkResponseModel;
  getFrameworkZip: Message;
  getFrameworksControlsEvidencesShortModel: Array<FrameworksControlsEvidencesShortModel>;
  getFrameworksControlsToAnalyse: FrameworkShortDataAnalyseResponseModel;
  getFrameworksStore: FrameworksStoreResponseModel;
  getFrameworksToReportCreate: ReportFrameworksResponseModel;
  getFullCampaignReviewExecutorById: CampaignReviewFullExecutorModel;
  getFullDocumentWithExecutor: GetFullDocumentResponseModel;
  getFullDocumentWithExecutorForDocs: GetFullDocumentResponseModel;
  getFullNcrReportPreview: FullNcrReportPreviewModel;
  getFullNcrReportPreviewByUser: FullNcrReportPreviewModel;
  getGroups: GroupsResponseModel;
  getHardwares: HardwarePaginationModel;
  getHrEmployeeById: HrEmployeeModel;
  getHrEmployeeJobInfosById: GetEmployeeJobInfosResponseModel;
  getHrEmployeesList: GetEmployeesResponseModel;
  getHrEmployeesSettings: HrSettingsModel;
  getImportCsvHrManagementTemplate: Scalars['String'];
  getInitIntegrationsData: GetInitIntegrationsData;
  getIntegrationAppById: GetIntegrationAppByIdResponseModel;
  getIntegrationDataByCollectionReports: GetDataByCollection;
  getIntegrationsReport: ReportViewAppsModel;
  getIntegrationsReportByAuditor: ReportViewAppsModelByAuditor;
  getIntergations: IntegrationResponse;
  getInviteByIdForAccept: AcceptInviteModel;
  getInvites: Array<WorkspaceInviteModel>;
  getIssueById?: Maybe<IssueResponseModel>;
  getKycArchiveWithFilterAndPaging: GetKycArchiveTargetsPagingResponseModel;
  getKycAvailableFieldsForExport: GetExportCsvFieldResponseModel;
  getKycAvailableSystemFieldsForExport: GetExportCsvFieldResponseModel;
  getKycClientsFieldsByWorkspaceId: GetKycTargetsFieldsResponseModel;
  getKycClientsWithFilterAndPaging: GetKycTargetsPagingResponseModel;
  getKycDictionaries: GetKycDictionariesModel;
  getKycForm: KycFormModelRefactor;
  getKycMatches: GetKycMatchesPagingModel;
  getKycOtsFullResultByEntityId: KycScreeningFullResultModel;
  getKycRequestById: KycRefactorRequestModel;
  getKycRequestsPaging: GetKycRequestsPagingModel;
  getKycScreeningById: KycScreeningModel;
  getKycScreeningFullInfoById: KycScreeningFullInfoModel;
  getKycScreeningFullResultByEntityId: KycScreeningFullResultModel;
  getKycScreeningResults: KycScreeningResultPagingModel;
  getKycScreeningsWithFilterAndPaging: KycScreeningPagingResponseModel;
  getKycTargetById: TKycTargetModel;
  getKycTargetExceptions: GetTargetExceptionResponseModel;
  getKycTemplateById: KycRefactorTemplateModel;
  getKycTemplateConfig: GetTemplateConfigResponseModel;
  getKycTemplateHistory: GetKycTemplateHistoryPagingModel;
  getKycTemplates: GetKycTemplatesPagingModel;
  getLicensesByAdmin: GetShortLicensesByAdminModel;
  getManagedApps: GetManagedAppsResponseModel;
  getManagedAppsByAdmin: GetManagedAppsResponseModel;
  getNCRsByControlByAuditor: NcrWithUsersModel;
  getNcrByControlId: NcrModel;
  getNewDocumentById: NewDocumentModel;
  getNewTemplateById: NewDocumentModel;
  getOrganizationBilling: BillingModel;
  getOrganizationById: RedesignOrganization;
  getOrganizationCollaborators: GetOrganizationUsersModel;
  getOrganizations: GetOrganizationResponseModel;
  getOrganizationsByAdmin: GetShortOrgsByAdminModel;
  getOrganizationsWithWorkspacesWithPagination: NewOrganizationWithWorkspacesPaginationAndInvitesCounterModel;
  getOriginTemplateById: FileModel;
  getOverviewData: OverviewResponseModel;
  getPhysicalAssetById: PhysicalAssetModel;
  getPhysicalAssetSettings: PhysicalAssetSettingsModel;
  getPhysicalAssets: PhysicalAssetsPaginationModel;
  getPhysicalAssetsAvailableFieldsForExport: GetExportCsvFieldResponseModel;
  getPlaybookConfig: AnalyseConfigResponseModel;
  getPlaybookHistory: AnalyseHistoryResponseModel;
  getPlaybookHistoryDetails: HistoryAnalyseDetailsModel;
  getPlaybooks: PlaybookResponseModel;
  getPlaybooksStore: PlaybookStoreResponseModel;
  getPoliciesStore: PolicyStoreResponse;
  getPrivateCollectorsDialogData: CollectorPaginationModel;
  getPrivateControlsDialogData: ControlsWithFilterModel;
  getPrivateEvidencesDialogData: EvidencesWithFilterModel;
  getPrivatePolicies: PoliciesWithFilterModel;
  getPublicAndPrivateControlsDialogData: ControlsWithFilterModel;
  getPublicAndPrivateEvidencesDialogData: EvidencesWithFilterModel;
  getPublicCollectorsDialogData: CollectorPaginationModel;
  getPublicControlsDialogData: ControlsWithFilterModel;
  getPublicEvidencesDialogData: EvidencesWithFilterModel;
  getQSPackages: QsResponse;
  getQuickStarts: Array<QuickStartSmallModel>;
  getRedesignWorkspaceById: GetWorkspaceByIdResponseModel;
  getReport: FullReportModel;
  getReportAssetCollectorDataByUser: EvidenceAutoFileDtoPagination;
  getReportByIdByAuditor: ReportReturnNewModel;
  getReportControlByAuditor: ReportControlNewModel;
  getReportControlById: ReportControlPaginationModel;
  getReportControls: ReportControlPaginationModel;
  getReportControlsByAuditor: ReportControlPaginationNewModel;
  getReportOrganizationsByAuditor: ReportOrganizationPagination;
  getReportShareSettings: ReportShareSettingsModel;
  getReportView: ReportViewModel;
  getReports: GeneratedReportPaginationModel;
  getReportsByOrganizationIdByAuditor: ReportSmallPagination;
  getRiskByIdAndRegistryId: GetRiskByIdModel;
  getRiskRegisters: RiskRegistriesPaginationModel;
  getRiskRegisteryById: RiskRegistryModel;
  getRisksAvailableFieldsForExport: GetExportCsvFieldResponseModel;
  getRisksByRegistry: RisksPaginationModel;
  getRisksModelById: RiskModelModel;
  getRisksModels: Array<RiskModelModel>;
  getRoleNamesByAppAccessId: GetRoleNamesModel;
  getRoles: RolesResponseModel;
  getRulesConflicts: RulesConflictPaginationModel;
  getSaasAssetById: SaasAssetModel;
  getSaasAssetSettings: SaasAssetSettingsModel;
  getSaasAssets: SaasAssetsPaginationModel;
  getSaasAvailableFieldsForExport: GetExportCsvFieldResponseModel;
  getSharedShortDocumentsPagingDocs: RespShortDocumentWithFilterPagingModel;
  getShortAutomations: ShortAutomationResponseModel;
  getShortCollabsByAdmin: ShortCollabsResponse;
  getShortCollectors: ShortCollectorsResponseModel;
  getShortDocumentsByFolderIdWithFilterPaging: RespShortDocumentWithFilterPagingModel;
  getShortDocumentsByWorkEmailWithFilterPaging: RespShortDocumentWithFilterPagingModel;
  getShortDocumentsPagingDocs: RespShortDocumentWithFilterPagingModel;
  getShortEmployees: Array<TShortEmployee>;
  getShortPhysicalAssets: ShortPhysicalAssetModel;
  getSmallCampaignReviewExecutors: GetSmallCampaignReviewExecutorsResponseModel;
  getSmallOrgsAndWorkspacesForSelect: GetSmallOrgsAndWorkspacesResponseModel;
  getSmallTargetById: SmallTargetModel;
  getSmallTargets: GetSmallTargetsResponse;
  getSodSchedulerData: SodSchedulerDataPaginationModel;
  getSoftwareAssetById: SoftwareAssetModel;
  getSoftwareAssetSettings: SoftwareAssetSettingsModel;
  getSoftwareAssets: SoftwareAssetsPaginationModel;
  getSoftwareAssetsAvailableFieldsForExport: GetExportCsvFieldResponseModel;
  getSoftwaresByFilters: SoftwareByFiltersModel;
  getTargetHistory: GetTargetHistoryResponseModel;
  getTargetScanHistory: GetHistoryResponse;
  getToken: Message;
  getUsedRecipients: UsedRecipientsResponseModel;
  getVendorById: VendorModel;
  getVendors: VendorsPaginationModel;
  getVendorsAvailableFieldsForExport: GetExportCsvFieldResponseModel;
  getVendorsSettings: VendorsSettingsModel;
  getVicaCategoriesWithPaging: GetVicaTaskCategoriesResponse;
  getVicaResponsibleAutocomplete: AutocompleteIdNameResponse;
  getVicaTaskCollabAutocomplete: AutocompleteIdNameResponse;
  getVicaTaskFrameworksAutocomplete: AutocompleteIdNameResponse;
  getVicaTasksByCategory: GetVicaTasksByCategoryResponse;
  getVirtualAssetById: VirtualAssetModel;
  getVirtualAssetSettings: VirtualAssetSettingsModel;
  getVirtualAssets: VirtualAssetsPaginationModel;
  getVirtualAssetsAvailableFieldsForExport: GetExportCsvFieldResponseModel;
  getWorkspaceUsersById: GetWorkspaceCollabsAndInvitesResponseModel;
  getWorkspaces: GetWorkspacesResponseModel;
  getWorkspacesWithPaginationByOrganizationId: NewWorkspacePaginationModel;
  groupFilter: Array<GroupFilterModel>;
  hardwareFilter: Array<HardwareFilterModel>;
  importCsvAccessManagementAppTemplate: Scalars['String'];
  importCsvRulesetTemplate: Scalars['String'];
  importCsvTemplateCertificateAssets: Scalars['String'];
  importCsvTemplateCollaborators: Scalars['String'];
  importCsvTemplatePhysicalAssets: Scalars['String'];
  importCsvTemplateRisks: Scalars['String'];
  importCsvTemplateSaasAssets: Scalars['String'];
  importCsvTemplateSoftwareAssets: Scalars['String'];
  importCsvTemplateVendors: Scalars['String'];
  importCsvTemplateVirtualAssets: Scalars['String'];
  isActorExists: ActorExistsResponseModel;
  issueFilter: Array<IssueFilterModel>;
  kycDownloadRequestById: Scalars['String'];
  kycGetFormByToken: KycFormModel;
  kycGetQuotes: KycQuotesDto;
  kycGetRequestById: KycRequestModel;
  kycGetRequests: KycRequestPagination;
  kycGetTemplateById: KycTemplateModel;
  kycGetTemplateFields: KycTemplateSystemFields;
  kycGetTemplates: KycTemplatePagination;
  kycGetTokenByTemplateId: KycTokenDto;
  mainAssetsGetAssetRequestById: MainAssetsRequestWithAssetModel;
  mainAssetsGetAssetRequestRequestorsAutocomplete: MainAssetsRequestRequestorPagingModel;
  mainAssetsGetRequestsWithFilterPagination: MainAssetsRequestPagingModel;
  mainFrameworksGetDelegatedTaskById: DelegatedTaskModel;
  mainFrameworksGetDelegatedTaskPerformerAutocomplete: MainFrameworksDelegatedTasksCollaboratorAutocompleteModel;
  mainFrameworksGetDelegatedTaskRequestorAutocomplete: MainFrameworksDelegatedTasksCollaboratorAutocompleteModel;
  mainFrameworksGetDelegatedTaskResolverAutocomplete: MainFrameworksDelegatedTasksCollaboratorAutocompleteModel;
  mainFrameworksGetDelegatedTasksWithFilterPagination: MainFrameworksDelegatedTaskPagingModel;
  mainGetSystemCovers: Array<CoverImageModel>;
  mainHrGetAndChangeStepStatusTimeOffRequest: MainHrTimeOffRequestModel;
  mainHrGetIssueById: MainHrIssueModel;
  mainHrGetIssuesList: MainHrIssuePagingModel;
  mainHrGetRequestById: MainHrRequestResponseModel;
  mainHrGetRequestRequestorsAutocomplete: MainHrRequestorAutocompleteModel;
  mainHrGetRequestsWithFilterPagination: MainHrRequestPagingModel;
  mainHrGetTimeOffEmployeesAutocomplete: MainHrTimeOffEmployeesAutocompleteModel;
  mainHrGetTimeOffRequestsWithFilterPagination: MainHrTimeOffRequestPagingModel;
  mainHrIssuesOffendersAutocomplete: IdNamePaginatedModel;
  mainHrIssuesReportersAutocomplete: IdNamePaginatedModel;
  mainTrainingGetAssignmentExamsAutocomplete: MainTrainingAssignmentsExamsAutocompleteModel;
  mainTrainingGetAssignmentRecipientsAutocomplete: MainTrainingAssignmentsRecipientsAutocompleteModel;
  mainTrainingGetAssignmentRequestorsAutocomplete: MainTrainingAssignmentsRequestorsAutocompleteModel;
  mainTrainingGetAssignmentTrainingsAutocomplete: MainTrainingAssignmentsTrainingsAutocompleteModel;
  mainTrainingsGetAssignmentDetails: MainTrainingAssignmentModel;
  mainTrainingsGetAssignmentsWithFilterPagination: MainTrainingAssignmentsPagingModel;
  mainTrainingsGetExamByIdAndVersion: MainTrainingExamModel;
  mainTrainingsGetExamCategoriesAutocomplete: MainTrainingExamsCategoriesAutocompleteModel;
  mainTrainingsGetExamsAutocomplete: MainTrainingsGetExamsAutocompletePaginatedResponseModel;
  mainTrainingsGetExamsWithFilterPagination: MainTrainingExamsPagingModel;
  mainTrainingsGetQuestionsFullDataListForImport: MainTrainingsQuestionsFullDataForImportResponseModel;
  mainTrainingsGetQuestionsShortDataListForImportWithFilterPagination: MainTrainingsQuestionsShortDataForImportPaginatedResponseModel;
  mainTrainingsGetSectionsFullDataListForImport: MainTrainingsSectionsFullDataForImportResponseModel;
  mainTrainingsGetSectionsShortDataListForImportWithFilterPagination: MainTrainingsSectionsShortDataForImportPaginatedResponseModel;
  mainTrainingsGetTemplatesCategoriesAutocomplete: MainTrainingCategoriesAutocompleteModel;
  mainTrainingsGetTrainingByIdAndVersion: MainTrainingModel;
  mainTrainingsGetTrainingTemplateById: MainTrainingTemplateModel;
  mainTrainingsGetTrainingTemplatesWithFilterPagination: MainTrainingTemplatesPagingModel;
  mainTrainingsGetTrainingsAutocomplete: MainTrainingsGetTrainingsAutocompletePaginatedResponseModel;
  mainTrainingsGetTrainingsCategoriesAutocomplete: MainTrainingCategoriesAutocompleteModel;
  mainTrainingsGetTrainingsWithFilterPagination: MainTrainingsPagingModel;
  mainVicaGetCategoriesWithFilter: MainVicaGetCategoriesWithFilterResponseModel;
  mainVicaGetCategoryStepById: MainVicaCategoryStepModel;
  mainVicaGetCategoryStepsWithFilter: MainVicaGetCategoryStepsWithFilterResponseModel;
  mainVicaGetDelegatedTaskById: DelegatedTaskModel;
  mainVicaGetDelegatedTaskPerformerAutocomplete: MainVicaDelegatedTaskCollaboratorAutocompleteModel;
  mainVicaGetDelegatedTaskRequestorAutocomplete: MainVicaDelegatedTaskCollaboratorAutocompleteModel;
  mainVicaGetDelegatedTaskResolverAutocomplete: MainVicaDelegatedTaskCollaboratorAutocompleteModel;
  mainVicaGetDelegatedTasksWithFilterPagination: MainVicaDelegatedTaskPagingModel;
  mainVicaGetStepResponsibleCollaboratorsAutocomplete: MainVicaCategoryCollaboratorAutocompleteModel;
  mainVicaGetWSCollaborators: MainVicaGetWorkspaceCollaboratorsResponseModel;
  mockFilterData: Scalars['JSON'];
  monitoring: GetMonitoringModel;
  monitoringFilter: Array<MonitoringFilterModel>;
  physicalAssetsFilter: Array<PhysicalAssetsFilterModel>;
  policiesFilter: Array<PoliciesFilterModel>;
  portalAssetsGetPhysicalAssetById: PortalPhysicalAssetModel;
  portalAssetsGetPhysicalAssetsSettings: PortalPhysicalAssetsSettingsModel;
  portalAssetsGetPhysicalAssetsSettingsForFilters: PortalPhysicalAssetsSettingsModel;
  portalAssetsGetPhysicalAssetsWithFilterPagination: PortalPhysicalAssetsPagingModel;
  portalAssetsGetRequestById: PortalAssetsRequestModel;
  portalAssetsGetRequestsWithFilterPagination: PortalAssetsRequestPagingModel;
  portalDownloadFile?: Maybe<DownloadFileModel>;
  portalGetAssignmentTrainingById: PortalTrainingModel;
  portalGetDocsMyDocumentsAutocompleteSender: GetAutocompleteSenderResponseModel;
  portalGetFullDocumentWithExecutorForDocs: GetFullDocumentResponseModel;
  portalGetRequiredActionsWithFilterPagination: PortalRequiredActionsPagingModel;
  portalGetSharedShortDocumentsPagingDocs: RespShortDocumentWithFilterPagingModel;
  portalGetShortDocumentsPagingDocs: RespShortDocumentWithFilterPagingModel;
  portalGetSmallOrgsAndWorkspacesForSelect: PortalGetSmallOrgsAndWorkspacesResponseModel;
  portalHrGetAndChangeStepStatusTimeOffRequest: PortalHrTimeOffRequestModel;
  portalHrGetEmployeeAutocomplete: PortalHrEmployeesAutocompleteModel;
  portalHrGetIssueById: PortalHrIssueModel;
  portalHrGetIssueOffenderAutocomplete: PortalHrIssueOffenderAutocompleteModel;
  portalHrGetIssuesWithFilterPagination: PortalHrIssuesPagingModel;
  portalHrGetMyTimeOffRequestsWithFilterPagination: PortalHrTimeOffRequestPagingModel;
  portalHrGetOrgTree: Array<SmallPersonModel>;
  portalHrGetProfile: PortalHrEmployeeModel;
  portalHrGetProfileJobHistory: PortalHrJobHistoryPaginatedResponse;
  portalHrGetRequestById: PortalHrRequestModel;
  portalHrGetRequestsWithFilterPagination: PortalHrRequestPagingModel;
  portalHrGetSettingsCountries: Array<Scalars['String']>;
  portalHrGetTimeOffEmployeesAutocomplete: PortalHrTimeOffEmployeesAutocompleteModel;
  portalHrGetTimeOffRequestById: PortalHrTimeOffRequestModel;
  portalHrGetTimeOffRequestsSettings: PortalHrTimeOffRequestSettingsModel;
  portalHrGetTimeOffRequestsWithFilterPagination: PortalHrTimeOffRequestPagingModel;
  portalRequiredActionsGetTaskById: PortalRequiredActionModel;
  portalRequiredActionsRequestorAutocomplete: PortalRequiredActionsCollaboratorAutocompleteModel;
  portalRequiredActionsResolverAutocomplete: PortalRequiredActionsCollaboratorAutocompleteModel;
  portalTrainingGetAssignmentExamsAutocomplete: MainTrainingAssignmentsExamsAutocompleteModel;
  portalTrainingGetAssignmentRequestorsAutocomplete: MainTrainingAssignmentsRequestorsAutocompleteModel;
  portalTrainingGetAssignmentTrainingsAutocomplete: MainTrainingAssignmentsTrainingsAutocompleteModel;
  portalTrainingsGetAssignmentDetails: PortalTrainingsAssignmentModel;
  portalTrainingsGetAssignmentsWithFilterPagination: PortalTrainingsAssignmentsPagingModel;
  portalTrainingsGetExamByAssignmentId: PortalTrainingsAssignmentsExamModel;
  privilegeFilter: Array<PrivilegeFilterModel>;
  privileges: Privileges;
  profileFilter: Array<ProfileFilterModel>;
  registersFilter: Array<RegistersFilterModel>;
  reportsFilter: Array<ReportsFilterModel>;
  risksFilter: Array<RisksFilterModel>;
  roleFilter: Array<RoleFilterModel>;
  softwareFilter: Array<SoftwareFilterModel>;
  thirdPartyApps: ThirdPartyAppsResponse;
  thirdPartyDetailsSso: ThirdPartySsoResponse;
  thirdPartyDetailsToken: ThirdPartyTokenResponse;
  thirdPartyFilter: Array<ThirdPartyFilterModel>;
  thirdPartySsoFilter: Array<ThirdPartySsoFilterModel>;
  thirdPartyTokenFilter: Array<ThirdPartyTokenFilterModel>;
  tpaFilter: Array<TpaFilterModel>;
  userProfile: UserProfileResponse;
  vicaAdminGetCategories: VicaAdminCategoriesResponseModel;
  vicaAdminGetTaskById: VicaAdminTaskModel;
  vicaAdminGetTasksByCategoryId: Array<VicaAdminTaskModel>;
  vulnerabilityFilter: Array<VulnerabilityFilterModel>;
  workerDownloadFile?: Maybe<WorkerDownloadFileModel>;
  workerGetStages: WorkerStagesResponseModel;
  workerGetStagesWithFilter: WorkerStagesWithFilterResponseModel;
  workspaces: LoginResponse;
};


export type QueryAccountsArgs = {
  data: AccountsInput;
  workspaceId: Scalars['String'];
};


export type QueryAccountsFilterArgs = {
  data: CommonFilterDto;
  workspaceId: Scalars['String'];
};


export type QueryAdminAccountsFilterArgs = {
  data: CommonFilterDto;
  workspaceId: Scalars['String'];
};


export type QueryAdminGetAllControlsDialogDataArgs = {
  data: PaginationInput;
  name?: InputMaybe<Scalars['String']>;
};


export type QueryAdminGetAllEvidencesDialogDataArgs = {
  data: PaginationInput;
  name?: InputMaybe<Scalars['String']>;
};


export type QueryAdminGetCompanyControlsDialogDataArgs = {
  data: PaginationInput;
  name: Scalars['String'];
};


export type QueryAdminGetCompanyEvidencesDialogDataArgs = {
  data: PaginationInput;
  name: Scalars['String'];
};


export type QueryAdminGetControlsByFrameworkIdArgs = {
  data: Scalars['String'];
};


export type QueryAdminGetDocumentByIdRefactorArgs = {
  id: Scalars['String'];
};


export type QueryAdminGetPrivateControlsDialogDataArgs = {
  data: PaginationInput;
  name: Scalars['String'];
};


export type QueryAdminGetPrivateEvidencesDialogDataArgs = {
  data: PaginationInput;
  name: Scalars['String'];
};


export type QueryAdminGetPrivatePoliciesArgs = {
  data: PaginationInput;
};


export type QueryAdminGetPublicAndPrivateControlsDialogDataArgs = {
  data: PaginationInput;
  name: Scalars['String'];
};


export type QueryAdminGetPublicAndPrivateControlsWithFilterPagArgs = {
  data: PaginationInput;
};


export type QueryAdminGetPublicAndPrivateEvidencesDialogDataArgs = {
  data: PaginationInput;
  name: Scalars['String'];
};


export type QueryAdminGetPublicAndPrivateEvidencesWithFilterPagArgs = {
  data: PaginationInput;
};


export type QueryAdminGetPublicControlsDialogDataArgs = {
  data: PaginationInput;
  name: Scalars['String'];
};


export type QueryAdminGetPublicEvidencesDialogDataArgs = {
  data: PaginationInput;
  name: Scalars['String'];
};


export type QueryAdminLicenseFilterArgs = {
  data: CommonFilterDto;
  workspaceId: Scalars['String'];
};


export type QueryAdminOrganizationsFilterArgs = {
  data: CommonFilterDto;
  workspaceId: Scalars['String'];
};


export type QueryAnalysisFilterArgs = {
  data: CommonFilterDto;
  workspaceId: Scalars['String'];
};


export type QueryAppConfigFilterArgs = {
  data: CommonFilterDto;
  workspaceId: Scalars['String'];
};


export type QueryApplicationsFilterArgs = {
  data: CommonFilterDto;
  workspaceId: Scalars['String'];
};


export type QueryAssetFilterArgs = {
  data: CommonFilterDto;
  workspaceId: Scalars['String'];
};


export type QueryAssetsArgs = {
  data: AssetsFilteredInput;
  workspaceId: Scalars['String'];
};


export type QueryAuditLogsFilterArgs = {
  data: CommonFilterDto;
  workspaceId: Scalars['String'];
};


export type QueryAutocompleteCollaboratorsArgs = {
  autocompleteInput: AutocompleteInput;
  byAllWorkspaces?: InputMaybe<Scalars['Boolean']>;
  organizationId: Scalars['String'];
  roles?: InputMaybe<Array<CollaboratorRole>>;
  workspaceId: Scalars['String'];
};


export type QueryAutocompleteEmployeesEmailNameArgs = {
  onlyActive: Scalars['Boolean'];
  organizationId: Scalars['String'];
  text: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryAutocompleteHrManagersArgs = {
  onlyActive: Scalars['Boolean'];
  organizationId: Scalars['String'];
  text: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryAutocompleteKycTemplatesByMatchesArgs = {
  page: Scalars['Float'];
  search: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryAutocompleteKycTemplatesByScreeningsArgs = {
  page: Scalars['Float'];
  search: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryAutocompleteKycTemplatesByTargetsArgs = {
  page: Scalars['Float'];
  search: Scalars['String'];
  targetType: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryAutocompleteRecipientsEmailNameArgs = {
  folderId: Scalars['String'];
  page: Scalars['Float'];
  text: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryAutomationsFilterArgs = {
  data: CommonFilterDto;
  workspaceId: Scalars['String'];
};


export type QueryAvailableCategoriesArgs = {
  workspaceId: Scalars['String'];
};


export type QueryCheckCollaboratorIsNotAssignedArgs = {
  workEmail: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryCheckTransactionStatusArgs = {
  transactionNumber: Scalars['String'];
};


export type QueryCjAvailableCategoryArgs = {
  workspaceId: Scalars['String'];
};


export type QueryCrownJewelListArgs = {
  data: CrownJewelsInput;
  workspaceId: Scalars['String'];
};


export type QueryCrownJewelsFilterArgs = {
  data: CommonFilterDto;
  workspaceId: Scalars['String'];
};


export type QueryDeleteFileArgs = {
  id: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryDevicesFilterArgs = {
  data: CommonFilterDto;
  workspaceId: Scalars['String'];
};


export type QueryDownloadAppLogFileArgs = {
  fileId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryDownloadAuditorEvidenceFileArgs = {
  fileId: Scalars['String'];
  filename: Scalars['String'];
};


export type QueryDownloadAuditorEvidenceFileDocsArgs = {
  fileId: Scalars['String'];
  filename: Scalars['String'];
};


export type QueryDownloadCollectorAssetPdfArgs = {
  assetId: Scalars['String'];
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryDownloadEvidenceFileArgs = {
  fileId: Scalars['String'];
  fileName: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryDownloadFileArgs = {
  id: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryDownloadPolicyEvidenceFileArgs = {
  fileId: Scalars['String'];
  fileName?: InputMaybe<Scalars['String']>;
  workspaceId: Scalars['String'];
};


export type QueryDownloadReportCollectorAssetArgs = {
  assetId: Scalars['String'];
  evidenceId: Scalars['String'];
  organizationId: Scalars['String'];
  reportId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryDownloadReportCollectorAssetByAuditorArgs = {
  assetId: Scalars['String'];
  evidenceId: Scalars['String'];
  organizationId: Scalars['String'];
  reportId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryEvidencesFilterArgs = {
  data: CommonFilterDto;
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryExportClientsByTemplateArgs = {
  fieldKeys: Array<Scalars['String']>;
  isDownload: Scalars['Boolean'];
  templateId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryExportCsvAccessManagementAppArgs = {
  fieldKeys: Array<Scalars['String']>;
  id: Scalars['String'];
  isDownload: Scalars['Boolean'];
  workspaceId: Scalars['String'];
};


export type QueryExportCsvCertificateAssetsArgs = {
  fieldKeys: Array<Scalars['String']>;
  isDownload: Scalars['Boolean'];
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryExportCsvEmployeesArgs = {
  data: ExportEmployeesCsvInputDto;
  fieldKeys: Array<Scalars['String']>;
  isDownload: Scalars['Boolean'];
  workspaceId: Scalars['String'];
};


export type QueryExportCsvPhysicalAssetsArgs = {
  fieldKeys: Array<Scalars['String']>;
  isDownload: Scalars['Boolean'];
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryExportCsvRisksArgs = {
  fieldKeys: Array<Scalars['String']>;
  isDownload: Scalars['Boolean'];
  organizationId: Scalars['String'];
  registryId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryExportCsvRulesetArgs = {
  workspaceId: Scalars['String'];
};


export type QueryExportCsvSaasAssetsArgs = {
  fieldKeys: Array<Scalars['String']>;
  isDownload: Scalars['Boolean'];
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryExportCsvSoftwareAssetsArgs = {
  fieldKeys: Array<Scalars['String']>;
  isDownload: Scalars['Boolean'];
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryExportCsvTargetsArgs = {
  fieldKeys: Array<Scalars['String']>;
  targetType: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryExportCsvVendorsArgs = {
  fieldKeys: Array<Scalars['String']>;
  isDownload: Scalars['Boolean'];
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryExportCsvVirtualAssetsArgs = {
  fieldKeys: Array<Scalars['String']>;
  isDownload: Scalars['Boolean'];
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetAccessManagementAppByIdArgs = {
  id: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetAccessManagementAppsArgs = {
  pageInfo: PaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryGetAccessManagementAvailableFieldsForExportArgs = {
  workspaceId: Scalars['String'];
};


export type QueryGetAddedAppsArgs = {
  pageInfo: PaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryGetAdoptedFrameworksArgs = {
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetAggregationDevicesArgs = {
  data: PaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryGetAllCollectorsDialogDataArgs = {
  data: PaginationInput;
  name: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetAllComplianceEvidencesArgs = {
  data: PaginationInput;
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetAllComplianceEvidencesWithFilterArgs = {
  data: PaginationInput;
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetAllControlsDialogDataArgs = {
  data: PaginationInput;
  name: Scalars['String'];
  organizationId: Scalars['String'];
};


export type QueryGetAllDevicesArgs = {
  data: PaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryGetAllEvidencesDialogDataArgs = {
  data: PaginationInput;
  name: Scalars['String'];
  organizationId: Scalars['String'];
};


export type QueryGetAllFrameworksArgs = {
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetAllIdentitiesArgs = {
  pageInfo: PaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryGetAllPoliciesArgs = {
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetAllPoliciesWithPaginationArgs = {
  organizationId: Scalars['String'];
  pageInfo: PaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryGetAllReportsRowsArgs = {
  data: PaginationInput;
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetAnalysisHistoryByFrameworkIdControlIdArgs = {
  controlId: Scalars['String'];
  frameworkId: Scalars['String'];
  organizationId: Scalars['String'];
  pageInfo: PaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryGetAnalysisHistoryByFrameworkIdControlIdHistoryIdArgs = {
  analyseId: Scalars['String'];
  historyId: Scalars['String'];
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetAppDutiesArgs = {
  organizationId: Scalars['String'];
  pageInfo: PaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryGetAppHistoryArgs = {
  appId: Scalars['String'];
  count: Scalars['Float'];
  page: Scalars['Float'];
  workspaceId: Scalars['String'];
};


export type QueryGetAppLogsArgs = {
  appId: Scalars['String'];
  count: Scalars['Float'];
  page: Scalars['Float'];
  workspaceId: Scalars['String'];
};


export type QueryGetAppLogsToDateArgs = {
  appId: Scalars['String'];
  date: Scalars['String'];
  pageInfo: PaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryGetAssetsSettingsByAdminArgs = {
  asset: Scalars['String'];
};


export type QueryGetAssignmentsToControlStoreArgs = {
  controlId: Scalars['String'];
  frameworkId: Scalars['String'];
  pageInfo: PaginationInput;
  text: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetAuditLogsArgs = {
  data: PaginationInput;
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetAuditorReportByIdArgs = {
  organizationId: Scalars['String'];
  pageInfo: PaginationInput;
  reportId: Scalars['String'];
};


export type QueryGetAuditorTableEvidenceArgs = {
  evidenceId: Scalars['String'];
  id: Scalars['String'];
  pageInfo: SharedPaginationInput;
  reportId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetAutoAssetDataArgs = {
  data: PaginationInput;
  id: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetAutomationByIdArgs = {
  data: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetAutomationEvidencesArgs = {
  workspaceId: Scalars['String'];
};


export type QueryGetAutomationHistoryArgs = {
  data: PaginationInfoInput;
  id: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetAvailableCategoriesByAppArgs = {
  appId: Scalars['String'];
  data: SharedPaginationInput;
  name: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetAvailableFrameworksArgs = {
  organizationId: Scalars['String'];
  pageInfo: PaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryGetBuilderDataArgs = {
  organizationId: Scalars['String'];
};


export type QueryGetCampaignReviewInstructionByIdArgs = {
  id: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetCampaignReviewInstructionWithPagingArgs = {
  pageInfo: PaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryGetCampaignReviewStageByIdArgs = {
  executorId: Scalars['String'];
  stageId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetCertificateAssetByIdArgs = {
  id: Scalars['String'];
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetCertificateAssetSettingsArgs = {
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetCertificateAssetsArgs = {
  organizationId: Scalars['String'];
  pageInfo: PaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryGetCertificatesAvailableFieldsForExportArgs = {
  workspaceId: Scalars['String'];
};


export type QueryGetCollectorHistoryArgs = {
  data: PaginationInput;
  id: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetCollectorsArgs = {
  data: PaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryGetCommentsArgs = {
  controlId: Scalars['String'];
  frameworkId: Scalars['String'];
  pageInfo: PaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryGetCompanyCollectorsDialogDataArgs = {
  data: PaginationInput;
  name: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetCompanyControlsDialogDataArgs = {
  data: PaginationInput;
  name: Scalars['String'];
  organizationId: Scalars['String'];
};


export type QueryGetCompanyEvidencesDialogDataArgs = {
  data: PaginationInput;
  name: Scalars['String'];
  organizationId: Scalars['String'];
};


export type QueryGetConfigArgs = {
  workspaceId: Scalars['String'];
};


export type QueryGetConfigsByAppArgs = {
  appId: Scalars['String'];
  pageInfo: PaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryGetControlByIdFrameworkIdArgs = {
  controlId: Scalars['String'];
  frameworkId: Scalars['String'];
  language: Scalars['String'];
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetControlFrameworkByIdArgs = {
  controlId: Scalars['String'];
  language: Scalars['String'];
  wfId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetControlsByFrameworkArgs = {
  frameworkId: Scalars['String'];
  language: Scalars['String'];
  organizationId: Scalars['String'];
  pageInfo: PaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryGetControlsByFrameworkIdArgs = {
  data: Scalars['String'];
  organizationId: Scalars['String'];
};


export type QueryGetCrownJewelByIdArgs = {
  id: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetDataByCollectionArgs = {
  appId: Scalars['String'];
  collectionAlias: Scalars['String'];
  count: Scalars['Float'];
  page: Scalars['Float'];
  search: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetDataForAllowedConflictArgs = {
  account: Scalars['String'];
  organizationId: Scalars['String'];
  ruleId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetDataForCreateDutyArgs = {
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetDataForCreateReportSnapshotArgs = {
  frameworkId: Scalars['String'];
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetDataForCreateRuleArgs = {
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetDataForDenyConflictArgs = {
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetDataForReleaseArgs = {
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetDataForReleaseWithEmployeesArgs = {
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetDeleteTemplateDataArgs = {
  templateId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetDocsMyDocumentsAutocompleteSenderArgs = {
  count: Scalars['Float'];
  nameLike: Scalars['String'];
  page: Scalars['Float'];
};


export type QueryGetDocsMyDocumentsAutocompleteWorkspaceNamesArgs = {
  count: Scalars['Float'];
  nameLike: Scalars['String'];
  page: Scalars['Float'];
};


export type QueryGetDocsSharedDocumentsAutocompleteWorkspaceNamesArgs = {
  count: Scalars['Float'];
  nameLike: Scalars['String'];
  page: Scalars['Float'];
};


export type QueryGetDocumentByIdArgs = {
  fileId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetDocumentsTreeArgs = {
  workspaceId: Scalars['String'];
};


export type QueryGetDutiesRulesetArgs = {
  organizationId: Scalars['String'];
  pageInfo: PaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryGetDutyRuleByIdArgs = {
  id: Scalars['String'];
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetEditableAssetArgs = {
  assetId: Scalars['String'];
  historyId?: InputMaybe<Scalars['String']>;
  policyId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetEditableAssetHistoryListArgs = {
  assetId: Scalars['String'];
  name: Scalars['String'];
  pageInfo: PaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryGetEmployeesAvailableFieldsForExportArgs = {
  workspaceId: Scalars['String'];
};


export type QueryGetEmployeesTreeArgs = {
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetEmployeesUsedCitiesArgs = {
  data: GetAutocompleteValues;
  workspaceId: Scalars['String'];
};


export type QueryGetEmployeesUsedManagersArgs = {
  data: GetAutocompleteValues;
  workspaceId: Scalars['String'];
};


export type QueryGetEmployeesUsedStreetsAutocompleteArgs = {
  data: GetAutocompleteValues;
  workspaceId: Scalars['String'];
};


export type QueryGetEvidenceAssetByIdArgs = {
  id: Scalars['String'];
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetExtendedCollabByAdminArgs = {
  id: Scalars['String'];
};


export type QueryGetExtendedDeviceArgs = {
  data: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetExtendedLicenseByAdminArgs = {
  id: Scalars['String'];
};


export type QueryGetExtendedOrganizationByAdminArgs = {
  id: Scalars['String'];
};


export type QueryGetFilesByFolderArgs = {
  folderId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetFinalApproverByStageIdAndExcIdArgs = {
  executorId: Scalars['String'];
  stageId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetFrameworkByIdArgs = {
  data: PaginationInput;
  language: Scalars['String'];
  organizationId: Scalars['String'];
  wfId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetFrameworkZipArgs = {
  frameworkId: Scalars['String'];
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetFrameworksControlsEvidencesShortModelArgs = {
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetFrameworksControlsToAnalyseArgs = {
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetFrameworksStoreArgs = {
  organizationId: Scalars['String'];
  pageInfo: PaginationInput;
  radio: Scalars['String'];
  text: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetFrameworksToReportCreateArgs = {
  workspaceId: Scalars['String'];
};


export type QueryGetFullCampaignReviewExecutorByIdArgs = {
  id: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetFullDocumentWithExecutorArgs = {
  documentId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetFullDocumentWithExecutorForDocsArgs = {
  documentId: Scalars['String'];
};


export type QueryGetFullNcrReportPreviewArgs = {
  organizationId: Scalars['String'];
  reportId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetFullNcrReportPreviewByUserArgs = {
  organizationId: Scalars['String'];
  reportId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetGroupsArgs = {
  pageInfo: PaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryGetHardwaresArgs = {
  data: PaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryGetHrEmployeeByIdArgs = {
  id: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetHrEmployeeJobInfosByIdArgs = {
  id: Scalars['String'];
  pageInfo: PaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryGetHrEmployeesListArgs = {
  pageInfo: PaginationInputAnyFilter;
  search: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetHrEmployeesSettingsArgs = {
  workspaceId: Scalars['String'];
};


export type QueryGetImportCsvHrManagementTemplateArgs = {
  workspaceId: Scalars['String'];
};


export type QueryGetInitIntegrationsDataArgs = {
  availableName: Scalars['String'];
  installedName: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetIntegrationAppByIdArgs = {
  appId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetIntegrationDataByCollectionReportsArgs = {
  appId: Scalars['String'];
  collectionAlias: Scalars['String'];
  pageInfo: PaginationInput;
  reportId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetIntegrationsReportArgs = {
  reportId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetIntegrationsReportByAuditorArgs = {
  organizationId: Scalars['String'];
  reportId: Scalars['String'];
};


export type QueryGetIntergationsArgs = {
  data: IntegrationsInput;
  workspaceId: Scalars['String'];
};


export type QueryGetInviteByIdForAcceptArgs = {
  inviteId: Scalars['String'];
};


export type QueryGetIssueByIdArgs = {
  id: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetKycArchiveWithFilterAndPagingArgs = {
  pageInfo: PaginationInputAnyFilter;
  workspaceId: Scalars['String'];
};


export type QueryGetKycAvailableFieldsForExportArgs = {
  templateId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetKycAvailableSystemFieldsForExportArgs = {
  clientType: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetKycClientsFieldsByWorkspaceIdArgs = {
  clientType: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetKycClientsWithFilterAndPagingArgs = {
  clientType: Scalars['String'];
  pageInfo: PaginationInputAnyFilter;
  workspaceId: Scalars['String'];
};


export type QueryGetKycFormArgs = {
  token: Scalars['String'];
};


export type QueryGetKycMatchesArgs = {
  pageInfo: PaginationInputAnyFilter;
  workspaceId: Scalars['String'];
};


export type QueryGetKycOtsFullResultByEntityIdArgs = {
  entityId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetKycRequestByIdArgs = {
  requestId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetKycRequestsPagingArgs = {
  pageInfo: PaginationInputAnyFilter;
  workspaceId: Scalars['String'];
};


export type QueryGetKycScreeningByIdArgs = {
  screeningId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetKycScreeningFullInfoByIdArgs = {
  screeningId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetKycScreeningFullResultByEntityIdArgs = {
  entityId: Scalars['String'];
  screeningId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetKycScreeningResultsArgs = {
  pageInfo: PaginationInputAnyFilter;
  screeningId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetKycScreeningsWithFilterAndPagingArgs = {
  pageInfo: PaginationInputAnyFilter;
  workspaceId: Scalars['String'];
};


export type QueryGetKycTargetByIdArgs = {
  targetId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetKycTargetExceptionsArgs = {
  pageInfo: PaginationInputAnyFilter;
  targetId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetKycTemplateByIdArgs = {
  templateId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetKycTemplateConfigArgs = {
  workspaceId: Scalars['String'];
};


export type QueryGetKycTemplateHistoryArgs = {
  pageInfo: PaginationInputAnyFilter;
  templateId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetKycTemplatesArgs = {
  pageInfo: PaginationInputAnyFilter;
  workspaceId: Scalars['String'];
};


export type QueryGetLicensesByAdminArgs = {
  pageInfo: PaginationInput;
};


export type QueryGetNcRsByControlByAuditorArgs = {
  controlId: Scalars['String'];
  organizationId: Scalars['String'];
  reportId: Scalars['String'];
};


export type QueryGetNcrByControlIdArgs = {
  controlId: Scalars['String'];
  frameworkId: Scalars['String'];
  ncrId: Scalars['String'];
  reportId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetNewDocumentByIdArgs = {
  fileId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetNewTemplateByIdArgs = {
  fileId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetOrganizationBillingArgs = {
  organizationId: Scalars['String'];
};


export type QueryGetOrganizationByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetOrganizationCollaboratorsArgs = {
  id: Scalars['String'];
};


export type QueryGetOrganizationsArgs = {
  pageInfo: PaginationInput;
};


export type QueryGetOrganizationsByAdminArgs = {
  pageInfo: PaginationInput;
};


export type QueryGetOrganizationsWithWorkspacesWithPaginationArgs = {
  name: Scalars['String'];
  pageInfo: PaginationInput;
};


export type QueryGetOriginTemplateByIdArgs = {
  templateId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetOverviewDataArgs = {
  dataRange: Scalars['Float'];
  workspaceId: Scalars['String'];
};


export type QueryGetPhysicalAssetByIdArgs = {
  id: Scalars['String'];
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetPhysicalAssetSettingsArgs = {
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetPhysicalAssetsArgs = {
  organizationId: Scalars['String'];
  pageInfo: PaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryGetPhysicalAssetsAvailableFieldsForExportArgs = {
  workspaceId: Scalars['String'];
};


export type QueryGetPlaybookConfigArgs = {
  count: Scalars['Float'];
  id: Scalars['String'];
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetPlaybookHistoryArgs = {
  organizationId: Scalars['String'];
  pageInfo: PaginationInput;
  playbookId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetPlaybookHistoryDetailsArgs = {
  historyId: Scalars['String'];
  organizationId: Scalars['String'];
  playbookId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetPlaybooksArgs = {
  organizationId: Scalars['String'];
  pageInfo: PaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryGetPlaybooksStoreArgs = {
  name: Scalars['String'];
  organizationId: Scalars['String'];
  origin: Scalars['String'];
  pageInfo: PaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryGetPoliciesStoreArgs = {
  created: Scalars['String'];
  organizationId: Scalars['String'];
  pageInfo: PaginationInput;
  text: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetPrivateCollectorsDialogDataArgs = {
  data: PaginationInput;
  name: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetPrivateControlsDialogDataArgs = {
  data: PaginationInput;
  name: Scalars['String'];
  organizationId: Scalars['String'];
};


export type QueryGetPrivateEvidencesDialogDataArgs = {
  data: PaginationInput;
  name: Scalars['String'];
  organizationId: Scalars['String'];
};


export type QueryGetPrivatePoliciesArgs = {
  data: PaginationInput;
  organizationId: Scalars['String'];
};


export type QueryGetPublicAndPrivateControlsDialogDataArgs = {
  data: PaginationInput;
  name: Scalars['String'];
  organizationId: Scalars['String'];
};


export type QueryGetPublicAndPrivateEvidencesDialogDataArgs = {
  data: PaginationInput;
  name: Scalars['String'];
  organizationId: Scalars['String'];
};


export type QueryGetPublicCollectorsDialogDataArgs = {
  data: PaginationInput;
  name: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetPublicControlsDialogDataArgs = {
  data: PaginationInput;
  name: Scalars['String'];
  organizationId: Scalars['String'];
};


export type QueryGetPublicEvidencesDialogDataArgs = {
  data: PaginationInput;
  name: Scalars['String'];
  organizationId: Scalars['String'];
};


export type QueryGetQsPackagesArgs = {
  organizationId: Scalars['String'];
  pageInfo: PaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryGetRedesignWorkspaceByIdArgs = {
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetReportArgs = {
  organizationId: Scalars['String'];
  reportId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetReportAssetCollectorDataByUserArgs = {
  assetId: Scalars['String'];
  evidenceId: Scalars['String'];
  organizationId: Scalars['String'];
  pageInfo: PaginationInput;
  reportId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetReportByIdByAuditorArgs = {
  organizationId: Scalars['String'];
  reportId: Scalars['String'];
};


export type QueryGetReportControlByAuditorArgs = {
  controlId: Scalars['String'];
  organizationId: Scalars['String'];
  reportId: Scalars['String'];
};


export type QueryGetReportControlByIdArgs = {
  controlId: Scalars['String'];
  organizationId: Scalars['String'];
  reportId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetReportControlsArgs = {
  organizationId: Scalars['String'];
  pageInfo: PaginationInputAnyFilter;
  reportId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetReportControlsByAuditorArgs = {
  organizationId: Scalars['String'];
  pageInfo: PaginationInput;
  reportId: Scalars['String'];
};


export type QueryGetReportOrganizationsByAuditorArgs = {
  pageInfo: PaginationInput;
};


export type QueryGetReportShareSettingsArgs = {
  id: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetReportViewArgs = {
  id: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetReportsArgs = {
  organizationId: Scalars['String'];
  pageInfo: PaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryGetReportsByOrganizationIdByAuditorArgs = {
  organizationId: Scalars['String'];
  pageInfo: PaginationInput;
};


export type QueryGetRiskByIdAndRegistryIdArgs = {
  organizationId: Scalars['String'];
  registryId: Scalars['String'];
  riskId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetRiskRegistersArgs = {
  organizationId: Scalars['String'];
  pageInfo: PaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryGetRiskRegisteryByIdArgs = {
  id: Scalars['String'];
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetRisksAvailableFieldsForExportArgs = {
  workspaceId: Scalars['String'];
};


export type QueryGetRisksByRegistryArgs = {
  organizationId: Scalars['String'];
  pageInfo: PaginationInput;
  registryId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetRisksModelByIdArgs = {
  organizationId: Scalars['String'];
  riskModelId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetRisksModelsArgs = {
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetRoleNamesByAppAccessIdArgs = {
  appAccessId: Scalars['String'];
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetRolesArgs = {
  pageInfo: PaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryGetRulesConflictsArgs = {
  organizationId: Scalars['String'];
  pageInfo: PaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryGetSaasAssetByIdArgs = {
  id: Scalars['String'];
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetSaasAssetSettingsArgs = {
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetSaasAssetsArgs = {
  organizationId: Scalars['String'];
  pageInfo: PaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryGetSaasAvailableFieldsForExportArgs = {
  workspaceId: Scalars['String'];
};


export type QueryGetSharedShortDocumentsPagingDocsArgs = {
  pageInfo: PaginationInputAnyFilter;
};


export type QueryGetShortAutomationsArgs = {
  pageInfo: PaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryGetShortCollabsByAdminArgs = {
  pageInfo: PaginationInput;
};


export type QueryGetShortCollectorsArgs = {
  data: PaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryGetShortDocumentsByFolderIdWithFilterPagingArgs = {
  folderId: Scalars['String'];
  pageInfo: PaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryGetShortDocumentsByWorkEmailWithFilterPagingArgs = {
  pageInfo: PaginationInputAnyFilter;
  search: Scalars['String'];
  workEmail: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetShortDocumentsPagingDocsArgs = {
  pageInfo: PaginationInputAnyFilter;
};


export type QueryGetShortEmployeesArgs = {
  workspaceId: Scalars['String'];
};


export type QueryGetShortPhysicalAssetsArgs = {
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetSmallCampaignReviewExecutorsArgs = {
  pageInfo: PaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryGetSmallTargetByIdArgs = {
  id: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetSmallTargetsArgs = {
  pageInfo: PaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryGetSodSchedulerDataArgs = {
  organizationId: Scalars['String'];
  pageInfo: PaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryGetSoftwareAssetByIdArgs = {
  id: Scalars['String'];
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetSoftwareAssetSettingsArgs = {
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetSoftwareAssetsArgs = {
  organizationId: Scalars['String'];
  pageInfo: PaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryGetSoftwareAssetsAvailableFieldsForExportArgs = {
  workspaceId: Scalars['String'];
};


export type QueryGetSoftwaresByFiltersArgs = {
  data: PaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryGetTargetHistoryArgs = {
  targetId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetTargetScanHistoryArgs = {
  pageInfo: PaginationInput;
  scanType: Scalars['String'];
  targetId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetUsedRecipientsArgs = {
  workspaceId: Scalars['String'];
};


export type QueryGetVendorByIdArgs = {
  id: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetVendorsArgs = {
  organizationId: Scalars['String'];
  pageInfo: PaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryGetVendorsAvailableFieldsForExportArgs = {
  workspaceId: Scalars['String'];
};


export type QueryGetVendorsSettingsArgs = {
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetVicaCategoriesWithPagingArgs = {
  pageInfo: PaginationInputAnyFilter;
  search: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetVicaResponsibleAutocompleteArgs = {
  data: GetAutocompleteValues;
  workspaceId: Scalars['String'];
};


export type QueryGetVicaTaskCollabAutocompleteArgs = {
  data: GetAutocompleteValues;
  workspaceId: Scalars['String'];
};


export type QueryGetVicaTaskFrameworksAutocompleteArgs = {
  data: GetAutocompleteValues;
  workspaceId: Scalars['String'];
};


export type QueryGetVicaTasksByCategoryArgs = {
  categoryId: Scalars['String'];
  filtersInput: InputAnyFilter;
  search: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetVirtualAssetByIdArgs = {
  id: Scalars['String'];
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetVirtualAssetSettingsArgs = {
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryGetVirtualAssetsArgs = {
  organizationId: Scalars['String'];
  pageInfo: PaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryGetVirtualAssetsAvailableFieldsForExportArgs = {
  workspaceId: Scalars['String'];
};


export type QueryGetWorkspaceUsersByIdArgs = {
  workspaceId: Scalars['String'];
};


export type QueryGetWorkspacesArgs = {
  id: Scalars['String'];
  pageInfo: PaginationInput;
};


export type QueryGetWorkspacesWithPaginationByOrganizationIdArgs = {
  name: Scalars['String'];
  organizationId: Scalars['String'];
  pageInfo: PaginationInput;
};


export type QueryGroupFilterArgs = {
  data: CommonFilterDto;
  workspaceId: Scalars['String'];
};


export type QueryHardwareFilterArgs = {
  data: CommonFilterDto;
  workspaceId: Scalars['String'];
};


export type QueryImportCsvAccessManagementAppTemplateArgs = {
  id: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryImportCsvRulesetTemplateArgs = {
  workspaceId: Scalars['String'];
};


export type QueryImportCsvTemplateCertificateAssetsArgs = {
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryImportCsvTemplateCollaboratorsArgs = {
  workspaceId: Scalars['String'];
};


export type QueryImportCsvTemplatePhysicalAssetsArgs = {
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryImportCsvTemplateRisksArgs = {
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryImportCsvTemplateSaasAssetsArgs = {
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryImportCsvTemplateSoftwareAssetsArgs = {
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryImportCsvTemplateVendorsArgs = {
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryImportCsvTemplateVirtualAssetsArgs = {
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryIsActorExistsArgs = {
  email: Scalars['String'];
};


export type QueryIssueFilterArgs = {
  data: CommonFilterDto;
  workspaceId: Scalars['String'];
};


export type QueryKycDownloadRequestByIdArgs = {
  id: Scalars['String'];
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryKycGetFormByTokenArgs = {
  token: Scalars['String'];
};


export type QueryKycGetQuotesArgs = {
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryKycGetRequestByIdArgs = {
  id: Scalars['String'];
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryKycGetRequestsArgs = {
  organizationId: Scalars['String'];
  pageInfo: PaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryKycGetTemplateByIdArgs = {
  id: Scalars['String'];
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryKycGetTemplateFieldsArgs = {
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryKycGetTemplatesArgs = {
  organizationId: Scalars['String'];
  pageInfo: PaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryKycGetTokenByTemplateIdArgs = {
  organizationId: Scalars['String'];
  templateId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryMainAssetsGetAssetRequestByIdArgs = {
  requestId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryMainAssetsGetAssetRequestRequestorsAutocompleteArgs = {
  pageRequest: SharedPaginationInput;
  search: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryMainAssetsGetRequestsWithFilterPaginationArgs = {
  filter: MainAssetsRequestsFilters;
  pageRequest: SharedPaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryMainFrameworksGetDelegatedTaskByIdArgs = {
  taskId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryMainFrameworksGetDelegatedTaskPerformerAutocompleteArgs = {
  controlId: Scalars['String'];
  pageRequest: SharedPaginationInput;
  search: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryMainFrameworksGetDelegatedTaskRequestorAutocompleteArgs = {
  controlId: Scalars['String'];
  pageRequest: SharedPaginationInput;
  search: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryMainFrameworksGetDelegatedTaskResolverAutocompleteArgs = {
  controlId: Scalars['String'];
  pageRequest: SharedPaginationInput;
  search: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryMainFrameworksGetDelegatedTasksWithFilterPaginationArgs = {
  controlId: Scalars['String'];
  filter: MainFrameworksDelegatedTasksFilter;
  pageRequest: SharedPaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryMainGetSystemCoversArgs = {
  type: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryMainHrGetAndChangeStepStatusTimeOffRequestArgs = {
  requestId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryMainHrGetIssueByIdArgs = {
  issueId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryMainHrGetIssuesListArgs = {
  filter: MainHrIssuesFilter;
  pageRequest: SharedPaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryMainHrGetRequestByIdArgs = {
  id: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryMainHrGetRequestRequestorsAutocompleteArgs = {
  pageRequest: SharedPaginationInput;
  search: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryMainHrGetRequestsWithFilterPaginationArgs = {
  filter: MainHrRequestsFilter;
  pageRequest: SharedPaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryMainHrGetTimeOffEmployeesAutocompleteArgs = {
  pageRequest: SharedPaginationInput;
  search: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryMainHrGetTimeOffRequestsWithFilterPaginationArgs = {
  filter: MainHrTimeOffRequestsFilter;
  pageRequest: SharedPaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryMainHrIssuesOffendersAutocompleteArgs = {
  pageRequest: SharedPaginationInput;
  search: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryMainHrIssuesReportersAutocompleteArgs = {
  pageRequest: SharedPaginationInput;
  search: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryMainTrainingGetAssignmentExamsAutocompleteArgs = {
  pageRequest: SharedPaginationInput;
  search: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryMainTrainingGetAssignmentRecipientsAutocompleteArgs = {
  pageRequest: SharedPaginationInput;
  search: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryMainTrainingGetAssignmentRequestorsAutocompleteArgs = {
  pageRequest: SharedPaginationInput;
  search: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryMainTrainingGetAssignmentTrainingsAutocompleteArgs = {
  pageRequest: SharedPaginationInput;
  search: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryMainTrainingsGetAssignmentDetailsArgs = {
  assignmentId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryMainTrainingsGetAssignmentsWithFilterPaginationArgs = {
  filter: MainTrainingAssignmentFilterInput;
  pageRequest: SharedPaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryMainTrainingsGetExamByIdAndVersionArgs = {
  examId: Scalars['String'];
  version: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryMainTrainingsGetExamCategoriesAutocompleteArgs = {
  pageRequest: SharedPaginationInput;
  search: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryMainTrainingsGetExamsAutocompleteArgs = {
  includeArchive: Scalars['Boolean'];
  pageRequest: SharedPaginationInput;
  value: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryMainTrainingsGetExamsWithFilterPaginationArgs = {
  filter: MainTrainingExamsFilterInput;
  pageRequest: SharedPaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryMainTrainingsGetQuestionsFullDataListForImportArgs = {
  filters: MainQuestionsFullDataFilterInput;
  workspaceId: Scalars['String'];
};


export type QueryMainTrainingsGetQuestionsShortDataListForImportWithFilterPaginationArgs = {
  filter: MainQuestionsShortDataFilterInput;
  pageRequest: SharedPaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryMainTrainingsGetSectionsFullDataListForImportArgs = {
  filters: MainSectionsFullDataFilterInput;
  workspaceId: Scalars['String'];
};


export type QueryMainTrainingsGetSectionsShortDataListForImportWithFilterPaginationArgs = {
  filter: MainSectionsShortDataFilterInput;
  pageRequest: SharedPaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryMainTrainingsGetTemplatesCategoriesAutocompleteArgs = {
  pageRequest: SharedPaginationInput;
  search: Scalars['String'];
};


export type QueryMainTrainingsGetTrainingByIdAndVersionArgs = {
  trainingId: Scalars['String'];
  version: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryMainTrainingsGetTrainingTemplateByIdArgs = {
  templateId: Scalars['String'];
};


export type QueryMainTrainingsGetTrainingTemplatesWithFilterPaginationArgs = {
  filter: MainTrainingTemplateFilterInput;
  pageRequest: SharedPaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryMainTrainingsGetTrainingsAutocompleteArgs = {
  includeArchive: Scalars['Boolean'];
  pageRequest: SharedPaginationInput;
  value: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryMainTrainingsGetTrainingsCategoriesAutocompleteArgs = {
  data: Scalars['String'];
  pageRequest: SharedPaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryMainTrainingsGetTrainingsWithFilterPaginationArgs = {
  filter: MainTrainingsFilterInput;
  pageRequest: SharedPaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryMainVicaGetCategoriesWithFilterArgs = {
  filters: MainVicaCategoryStepsFilter;
  workspaceId: Scalars['String'];
};


export type QueryMainVicaGetCategoryStepByIdArgs = {
  stepId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryMainVicaGetCategoryStepsWithFilterArgs = {
  category: Scalars['String'];
  filters: MainVicaCategoryStepsFilter;
  workspaceId: Scalars['String'];
};


export type QueryMainVicaGetDelegatedTaskByIdArgs = {
  taskId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryMainVicaGetDelegatedTaskPerformerAutocompleteArgs = {
  pageRequest: SharedPaginationInput;
  search: Scalars['String'];
  vicaStepId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryMainVicaGetDelegatedTaskRequestorAutocompleteArgs = {
  pageRequest: SharedPaginationInput;
  search: Scalars['String'];
  vicaStepId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryMainVicaGetDelegatedTaskResolverAutocompleteArgs = {
  pageRequest: SharedPaginationInput;
  search: Scalars['String'];
  vicaStepId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryMainVicaGetDelegatedTasksWithFilterPaginationArgs = {
  filter: MainFrameworksDelegatedTasksFilter;
  pageRequest: SharedPaginationInput;
  vicaStepId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryMainVicaGetStepResponsibleCollaboratorsAutocompleteArgs = {
  pageRequest: SharedPaginationInput;
  search: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryMainVicaGetWsCollaboratorsArgs = {
  workspaceId: Scalars['String'];
};


export type QueryMockFilterDataArgs = {
  data: CommonFilterDto;
  workspaceId: Scalars['String'];
};


export type QueryMonitoringArgs = {
  data: MonitoringInput;
  workspaceId: Scalars['String'];
};


export type QueryMonitoringFilterArgs = {
  data: CommonFilterDto;
  workspaceId: Scalars['String'];
};


export type QueryPhysicalAssetsFilterArgs = {
  data: CommonFilterDto;
  workspaceId: Scalars['String'];
};


export type QueryPoliciesFilterArgs = {
  data: CommonFilterDto;
  workspaceId: Scalars['String'];
};


export type QueryPortalAssetsGetPhysicalAssetByIdArgs = {
  assetId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryPortalAssetsGetPhysicalAssetsSettingsArgs = {
  workspaceId: Scalars['String'];
};


export type QueryPortalAssetsGetPhysicalAssetsSettingsForFiltersArgs = {
  workspaceId: Scalars['String'];
};


export type QueryPortalAssetsGetPhysicalAssetsWithFilterPaginationArgs = {
  filter: PortalAssetsFilter;
  pageRequest: SharedPaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryPortalAssetsGetRequestByIdArgs = {
  requestId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryPortalAssetsGetRequestsWithFilterPaginationArgs = {
  filter: PortalAssetsRequestsFilters;
  pageRequest: SharedPaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryPortalDownloadFileArgs = {
  id: Scalars['String'];
};


export type QueryPortalGetAssignmentTrainingByIdArgs = {
  id: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryPortalGetDocsMyDocumentsAutocompleteSenderArgs = {
  count: Scalars['Float'];
  nameLike: Scalars['String'];
  page: Scalars['Float'];
  workspaceId: Scalars['String'];
};


export type QueryPortalGetFullDocumentWithExecutorForDocsArgs = {
  documentId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryPortalGetRequiredActionsWithFilterPaginationArgs = {
  filter: PortalRequiredActionsFilter;
  pageRequest: SharedPaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryPortalGetSharedShortDocumentsPagingDocsArgs = {
  pageInfo: PaginationInputAnyFilter;
  workspaceId: Scalars['String'];
};


export type QueryPortalGetShortDocumentsPagingDocsArgs = {
  pageInfo: PaginationInputAnyFilter;
  workspaceId: Scalars['String'];
};


export type QueryPortalHrGetAndChangeStepStatusTimeOffRequestArgs = {
  requestId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryPortalHrGetEmployeeAutocompleteArgs = {
  pageRequest: SharedPaginationInput;
  search: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryPortalHrGetIssueByIdArgs = {
  issueId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryPortalHrGetIssueOffenderAutocompleteArgs = {
  pageRequest: SharedPaginationInput;
  search: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryPortalHrGetIssuesWithFilterPaginationArgs = {
  filter: PortalHrIssuesFilter;
  pageRequest: SharedPaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryPortalHrGetMyTimeOffRequestsWithFilterPaginationArgs = {
  filter: PortalHrMyTimeOffFilter;
  pageRequest: SharedPaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryPortalHrGetOrgTreeArgs = {
  workspaceId: Scalars['String'];
};


export type QueryPortalHrGetProfileArgs = {
  workspaceId: Scalars['String'];
};


export type QueryPortalHrGetProfileJobHistoryArgs = {
  pageRequest: SharedPaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryPortalHrGetRequestByIdArgs = {
  requestId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryPortalHrGetRequestsWithFilterPaginationArgs = {
  filter: PortalHrRequestsFilter;
  pageRequest: SharedPaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryPortalHrGetSettingsCountriesArgs = {
  workspaceId: Scalars['String'];
};


export type QueryPortalHrGetTimeOffEmployeesAutocompleteArgs = {
  pageRequest: SharedPaginationInput;
  search: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryPortalHrGetTimeOffRequestByIdArgs = {
  requestId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryPortalHrGetTimeOffRequestsSettingsArgs = {
  workspaceId: Scalars['String'];
};


export type QueryPortalHrGetTimeOffRequestsWithFilterPaginationArgs = {
  filter: PortalHrTimeOffFilter;
  pageRequest: SharedPaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryPortalRequiredActionsGetTaskByIdArgs = {
  taskId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryPortalRequiredActionsRequestorAutocompleteArgs = {
  pageRequest: SharedPaginationInput;
  search: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryPortalRequiredActionsResolverAutocompleteArgs = {
  pageRequest: SharedPaginationInput;
  search: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryPortalTrainingGetAssignmentExamsAutocompleteArgs = {
  pageRequest: SharedPaginationInput;
  search: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryPortalTrainingGetAssignmentRequestorsAutocompleteArgs = {
  pageRequest: SharedPaginationInput;
  search: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryPortalTrainingGetAssignmentTrainingsAutocompleteArgs = {
  pageRequest: SharedPaginationInput;
  search: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryPortalTrainingsGetAssignmentDetailsArgs = {
  assignmentId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryPortalTrainingsGetAssignmentsWithFilterPaginationArgs = {
  filter: PortalAssignmentsFilters;
  pageRequest: SharedPaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryPortalTrainingsGetExamByAssignmentIdArgs = {
  assignmentId: Scalars['String'];
  type: TrainingAssignmentExamType;
  workspaceId: Scalars['String'];
};


export type QueryPrivilegeFilterArgs = {
  data: CommonFilterDto;
  workspaceId: Scalars['String'];
};


export type QueryPrivilegesArgs = {
  data: PrivilegesFilteredInput;
  workspaceId: Scalars['String'];
};


export type QueryProfileFilterArgs = {
  data: CommonFilterDto;
  workspaceId: Scalars['String'];
};


export type QueryRegistersFilterArgs = {
  data: CommonFilterDto;
  workspaceId: Scalars['String'];
};


export type QueryReportsFilterArgs = {
  data: CommonFilterDto;
  workspaceId: Scalars['String'];
};


export type QueryRisksFilterArgs = {
  data: CommonFilterDto;
  registryId: Scalars['String'];
  workspaceId: Scalars['String'];
};


export type QueryRoleFilterArgs = {
  data: CommonFilterDto;
  workspaceId: Scalars['String'];
};


export type QuerySoftwareFilterArgs = {
  data: CommonFilterDto;
  workspaceId: Scalars['String'];
};


export type QueryThirdPartyAppsArgs = {
  data: ThirdPartyAppsRequest;
  workspaceId: Scalars['String'];
};


export type QueryThirdPartyDetailsSsoArgs = {
  data: ThirdPartySsoTokenRequest;
  workspaceId: Scalars['String'];
};


export type QueryThirdPartyDetailsTokenArgs = {
  data: ThirdPartySsoTokenRequest;
  workspaceId: Scalars['String'];
};


export type QueryThirdPartyFilterArgs = {
  data: CommonFilterDto;
  workspaceId: Scalars['String'];
};


export type QueryThirdPartySsoFilterArgs = {
  data: CommonFilterDto;
  workspaceId: Scalars['String'];
};


export type QueryThirdPartyTokenFilterArgs = {
  data: CommonFilterDto;
  workspaceId: Scalars['String'];
};


export type QueryTpaFilterArgs = {
  data: CommonFilterDto;
  workspaceId: Scalars['String'];
};


export type QueryVicaAdminGetTaskByIdArgs = {
  categoryId: Scalars['String'];
  frameworkView: Scalars['Boolean'];
  taskId: Scalars['String'];
};


export type QueryVicaAdminGetTasksByCategoryIdArgs = {
  categoryId: Scalars['String'];
  frameworkView: Scalars['Boolean'];
};


export type QueryVulnerabilityFilterArgs = {
  data: CommonFilterDto;
  workspaceId: Scalars['String'];
};


export type QueryWorkerDownloadFileArgs = {
  id: Scalars['String'];
};


export type QueryWorkerGetStagesArgs = {
  data: SharedPaginationInput;
  workspaceId: Scalars['String'];
};


export type QueryWorkerGetStagesWithFilterArgs = {
  pageInfo: PaginationInput;
  search: Scalars['String'];
  workspaceId: Scalars['String'];
};

export type QuestionShortDataModel = {
  order?: Maybe<Scalars['Float']>;
  questionId?: Maybe<Scalars['String']>;
  questionName?: Maybe<Scalars['String']>;
  questionType?: Maybe<TrainingExamQuestionType>;
};

export type QuickStartSmallModel = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export type RecipientFieldInput = {
  id: Scalars['String'];
  isRequired?: InputMaybe<Scalars['Boolean']>;
  pageId: Scalars['String'];
  position: RecipientFieldPositionInput;
  size: RecipientFieldSizeInput;
  type: Scalars['String'];
};

export type RecipientFieldModel = {
  id: Scalars['String'];
  isRequired?: Maybe<Scalars['Boolean']>;
  pageId: Scalars['String'];
  position: RecipientFieldPositionModel;
  size: RecipientFieldSizeModel;
  type: Scalars['String'];
};

export type RecipientFieldPositionInput = {
  metaPageHeight?: InputMaybe<Scalars['Float']>;
  x: Scalars['Float'];
  y: Scalars['Float'];
};

export type RecipientFieldPositionModel = {
  metaPageHeight?: Maybe<Scalars['Float']>;
  x: Scalars['Float'];
  y: Scalars['Float'];
};

export type RecipientFieldSizeInput = {
  height: Scalars['Float'];
  width: Scalars['Float'];
};

export type RecipientFieldSizeModel = {
  height: Scalars['Float'];
  width: Scalars['Float'];
};

export type RecipientInput = {
  actor: NewDocumentActorInput;
  eta?: InputMaybe<Scalars['Float']>;
  fields?: InputMaybe<Array<RecipientFieldInput>>;
  message?: InputMaybe<Scalars['String']>;
  order: Scalars['Float'];
  role?: InputMaybe<Scalars['String']>;
};

export type RecipientModel = {
  actor: NewDocumentActorModel;
  eta?: Maybe<Scalars['Float']>;
  fields?: Maybe<Array<RecipientFieldModel>>;
  message?: Maybe<Scalars['String']>;
  order: Scalars['Float'];
  role?: Maybe<Scalars['String']>;
};

export type ReconfigureGoogleAuthResponseModel = {
  qrCode: Scalars['String'];
  secret: Scalars['String'];
};

export type RedesignOrganization = {
  blocked: Scalars['Boolean'];
  blockedReason?: Maybe<Scalars['String']>;
  collaborators: Array<RedesignSmallCollab>;
  configuration: TOrgConfiguration;
  id: Scalars['String'];
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  subscription: Scalars['String'];
  subscriptionExpiry: Scalars['String'];
  trialUsed: Scalars['Boolean'];
  workspaceCount: Scalars['Float'];
};

export type RedesignSmallCollab = {
  publicId: Scalars['String'];
  role: Scalars['String'];
};

export type RedesignWorkspace = {
  collaboratorsCount: Scalars['Float'];
  enabledKycLimit: Scalars['Boolean'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type RegionFilter = {
  region?: Maybe<Array<Scalars['String']>>;
};

export type RegistersFilterModel = NameFilter;

export type RegistrationInputRequest = {
  firstName: Scalars['String'];
  invitationCode: Scalars['String'];
  lastName: Scalars['String'];
  license: Scalars['Boolean'];
  organizationName: Scalars['String'];
  password: Scalars['String'];
  username: Scalars['String'];
};

export type RegistrationResponse = {
  message: Scalars['String'];
  qrCode?: Maybe<Scalars['String']>;
  secret?: Maybe<Scalars['String']>;
};

export type ReleaseActorInput = {
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  publicId?: InputMaybe<Scalars['ID']>;
};

export type ReleaseDataModel = {
  controls: Array<AutomationControlModel>;
  evidences: Array<AutomationEvidenceModel>;
  frameworks: Array<AutomationFrameworkModel>;
};

export type ReleaseDataWithEmployeesModel = {
  controls: Array<AutomationControlModel>;
  employees: Array<EmployeeForReleaseModel>;
  evidences: Array<AutomationEvidenceModel>;
  frameworks: Array<AutomationFrameworkModel>;
};

export type ReportAppModel = {
  config?: Maybe<AvailableAppConfig>;
  description: Scalars['String'];
  id: Scalars['String'];
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type ReportAuditModel = {
  id: Scalars['String'];
  lastUpdate: Scalars['String'];
  name: Scalars['String'];
  status?: Maybe<Scalars['String']>;
};

export type ReportAuditorsInput = {
  email: Scalars['String'];
  fullView: Scalars['Boolean'];
  publicId?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};

export type ReportAuditorsModel = {
  email: Scalars['String'];
  fullView: Scalars['Boolean'];
  publicId: Scalars['String'];
  type: Scalars['String'];
};

export type ReportCategoryUpdate = {
  activeGroup: Scalars['Boolean'];
  controls: Array<ReportControlUpdate>;
  groupName: Scalars['String'];
};

export type ReportConfigModel = {
  approvalDate?: Maybe<Scalars['String']>;
  approver?: Maybe<Scalars['String']>;
  auditCommittee?: Maybe<Scalars['String']>;
  classification?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['JSON']>;
  owner?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  typeOfAudit?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

export type ReportControlModel = {
  description: Array<Scalars['String']>;
  evidences: NewEvidenceReportModel;
  id: Scalars['String'];
  name: Scalars['String'];
  ncr: Array<NcrModel>;
  reviewed: Scalars['Boolean'];
};

export type ReportControlNewModel = {
  description: Array<Scalars['String']>;
  evidences: Array<EvidenceAssetNewModel>;
  id: Scalars['String'];
  name: Scalars['String'];
  reviewed: Scalars['Boolean'];
  smallNCRs: Array<IdStatusTypeModel>;
};

export type ReportControlPaginationModel = {
  controls: Array<ReportControlModel>;
  pageInfo: PageInfo;
  users: Array<IdNameEmailModel>;
};

export type ReportControlPaginationNewModel = {
  controls: Array<ReportControlNewModel>;
  pageInfo: PageInfo;
};

export type ReportControlUpdate = {
  activeControl: Scalars['Boolean'];
  controlId: Scalars['String'];
  evidences: Array<ReportEvidenceUpdate>;
};

export type ReportControlsGroupModel = {
  audits: Array<AuditRow>;
  evidences: Array<EvidencesRow>;
  id: Scalars['String'];
  name: Scalars['String'];
  ncr?: Maybe<NcrModel>;
  reviewed: Scalars['Boolean'];
};

export type ReportEvidenceAssetUpdate = {
  active: Scalars['Boolean'];
  assetId: Scalars['String'];
};

export type ReportEvidenceModel = {
  active: Scalars['Boolean'];
  evidenceAssets: Array<EvidenceAssetSmallModel>;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type ReportEvidenceUpdate = {
  activeEvidence: Scalars['Boolean'];
  evidenceAssets: Array<ReportEvidenceAssetUpdate>;
  evidenceId: Scalars['String'];
};

export type ReportFrameworkModel = {
  id: Scalars['String'];
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type ReportFrameworksResponseModel = {
  frameworks: Array<ReportFrameworkModel>;
};

export type ReportInput = {
  active: Scalars['Boolean'];
  auditorEmail: Scalars['String'];
  auditorFullView: Scalars['Boolean'];
  framework: IdNameLogoInput;
  groups: Array<ReportCategoryUpdate>;
  isNcrEnabled: Scalars['Boolean'];
  name: Scalars['String'];
  reportType: Scalars['String'];
  scheduler: Scalars['Float'];
  updatedBy: Scalars['String'];
  withAudit: Scalars['Boolean'];
};

export type ReportModel = {
  auditors: Array<IdNameTypeModel>;
  createDate?: Maybe<Scalars['String']>;
  framework: IdNameLogoModel;
  id: Scalars['String'];
  name: Scalars['String'];
  ncrEnabled: Scalars['Boolean'];
  reportNCR?: Maybe<ReportConfigModel>;
  reviewedControls: Array<Scalars['String']>;
  smallNCRs: Array<IdStatusTypeModel>;
  status: Scalars['String'];
  totalControls: Scalars['Float'];
  type: Scalars['String'];
  workspaceId: Scalars['String'];
};

export type ReportOrganizationModel = {
  id: Scalars['String'];
  lastUpdate: Scalars['String'];
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  reports: Array<Scalars['String']>;
};

export type ReportOrganizationPagination = {
  organizations: Array<ReportOrganizationModel>;
  pageInfo: PageInfo;
};

export type ReportReturnNewModel = {
  organization: ReportOrganizationModel;
  report: ReportModel;
};

export type ReportReturnOldModel = {
  controls: Array<ReportControlsGroupModel>;
  pageInfo: PageInfo;
  report: ReportRowAuditSpaceModel;
  withAudit: Scalars['Boolean'];
};

export type ReportRowAuditSpaceModel = {
  auditors: Array<IdNameTypeModel>;
  framework: IdNameModel;
  id: Scalars['String'];
  isNCREnabled: Scalars['Boolean'];
  lastReviewed: Scalars['String'];
  lastUpdate: Scalars['String'];
  name: Scalars['String'];
  ncrCount: Scalars['Float'];
  ncrReport?: Maybe<NcrReportConfigModel>;
  organizationId: Scalars['String'];
  reviewedControls: Array<Scalars['String']>;
  shortNCR: Array<ShortNcrModel>;
  snapshotType?: Maybe<Scalars['String']>;
  totalControls: Scalars['Float'];
  workspaceId: Scalars['String'];
};

export type ReportRowModel = {
  active?: Maybe<Scalars['Boolean']>;
  archived: Scalars['Boolean'];
  id: Scalars['ID'];
  lastGenerate?: Maybe<Scalars['String']>;
  lastUpdate?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  reportType?: Maybe<Scalars['String']>;
  scheduler?: Maybe<Scalars['String']>;
  snapshotType?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
};

export type ReportRowPaginationModel = {
  data: Array<ReportRowModel>;
  pageInfo: PageInfo;
};

export type ReportShareSettingsInput = {
  auditors: Array<ReportAuditorsInput>;
  showFull: Scalars['Boolean'];
  showSimple: Scalars['Boolean'];
};

export type ReportShareSettingsModel = {
  auditors: Array<ReportAuditorsModel>;
  hashFull?: Maybe<Scalars['String']>;
  hashSimple?: Maybe<Scalars['String']>;
  showFull: Scalars['Boolean'];
  showSimple: Scalars['Boolean'];
};

export type ReportSmallModel = {
  framework: IdNameLogoModel;
  id: Scalars['String'];
  lastUpdate: Scalars['String'];
  name: Scalars['String'];
  status: Scalars['String'];
  type: Scalars['String'];
  workspaceId: Scalars['String'];
};

export type ReportSmallPagination = {
  organization: ReportOrganizationModel;
  pageInfo: PageInfo;
  reports: Array<ReportSmallModel>;
};

export type ReportUpdateInput = {
  active: Scalars['Boolean'];
  enabledNCR: Scalars['Boolean'];
  groups: Array<ReportCategoryUpdate>;
  name: Scalars['String'];
  scheduler: Scalars['Float'];
  showAudit: Scalars['Boolean'];
  updatedBy: Scalars['String'];
};

export type ReportViewAppsModel = {
  apps: Array<ReportAppModel>;
  report: GeneratedReportModel;
};

export type ReportViewAppsModelByAuditor = {
  apps: Array<ReportAppModel>;
  organization: ReportOrganizationModel;
  report: ReportSmallModel;
};

export type ReportViewCategoryModel = {
  active: Scalars['Boolean'];
  controls: Array<ReportViewControlModel>;
  name: Scalars['String'];
};

export type ReportViewControlModel = {
  active: Scalars['Boolean'];
  audit: Array<ReportAuditModel>;
  evidences: Array<ReportEvidenceModel>;
  id: Scalars['String'];
  name: Scalars['String'];
  reviewed: Scalars['Boolean'];
};

export type ReportViewModel = {
  active: Scalars['Boolean'];
  archived: Scalars['Boolean'];
  auditors: Array<IdNameTypeModel>;
  enabledNCR: Scalars['Boolean'];
  framework: IdNameLogoModel;
  groups: Array<ReportViewCategoryModel>;
  id: Scalars['String'];
  name: Scalars['String'];
  ncrList: Array<NcrModel>;
  ncrReport?: Maybe<NcrReportConfigModel>;
  reportType?: Maybe<Scalars['String']>;
  reviewed: Array<Scalars['String']>;
  scheduler: Scalars['Float'];
  shortNcrList: Array<ShortNcrModel>;
  showAudit: Scalars['Boolean'];
  snapshotType?: Maybe<Scalars['String']>;
  users: Array<IdNameModel>;
  viewType: Scalars['String'];
};

export type ReportViewStatisticsModel = {
  dates: Array<Scalars['String']>;
  issuesChart: Array<ChartRequestDto>;
};

export type ReportViewStatusModel = {
  active: Scalars['Float'];
  counter: Scalars['Float'];
  description: Scalars['String'];
  failed: Scalars['Float'];
  issues: IssuesCountModel;
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  nameLogo?: Maybe<Scalars['String']>;
  passed: Scalars['Float'];
};

export type ReportsFilterModel = NameFilter;

export type RequestAddAssetInput = {
  category: Scalars['String'];
  comment?: InputMaybe<Scalars['String']>;
  manufacture: Scalars['String'];
  model: Scalars['String'];
  serial: Scalars['String'];
};

export type RequestHistoryModel = {
  approveAuditor?: Maybe<Scalars['String']>;
  approveDate?: Maybe<Scalars['String']>;
  causeAnalysis?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  correctiveAction?: Maybe<CorrectiveActionModel>;
  correctiveActionAccepted?: Maybe<Scalars['Boolean']>;
  evidenceAssets?: Maybe<Array<EvidenceAssetsModel>>;
};

export type RequestHistoryModelInput = {
  approveAuditor?: InputMaybe<Scalars['String']>;
  approveDate?: InputMaybe<Scalars['String']>;
  causeAnalysis?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  correctiveAction?: InputMaybe<CorrectiveActionInput>;
  correctiveActionAccepted?: InputMaybe<Scalars['Boolean']>;
  evidenceAssets?: InputMaybe<Array<EvidenceAssetsModelInput>>;
};

export type RequestRemoveAssetInput = {
  assetId: Scalars['String'];
  category: Scalars['String'];
  comment?: InputMaybe<Scalars['String']>;
  manufacture: Scalars['String'];
  model: Scalars['String'];
  serial: Scalars['String'];
};

export type RequestRequestAssetInput = {
  category: Scalars['String'];
  comment: Scalars['String'];
  manufacture?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
};

export enum RequestType {
  EditProfile = 'EDIT_PROFILE'
}

export type RequestorFilter = {
  requestor?: Maybe<Array<Scalars['String']>>;
};

export enum RequiredActionsStatus {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Created = 'CREATED',
  Declined = 'DECLINED',
  Performed = 'PERFORMED'
}

export enum RequiredActionsType {
  ProvideFiles = 'PROVIDE_FILES'
}

export type RespAutocompleteRecipientsModel = {
  pageInfo: PageInfo;
  recipients: Array<NewDocumentActorModel>;
};

export type RespKycTemplateAutocompleteModel = {
  pageInfo: PageInfo;
  templates: Array<IdNameModel>;
};

export type RespShortDocumentWithFilterPagingModel = {
  files: Array<ShortDocumentModel>;
  pageInfo: PageInfo;
};

export type ResultUnion = IdNameAvatar | IdNameLogo | IdNameMonitoringModel;

export type Risk = {
  risk_id: Scalars['String'];
};

export type RiskDefinition = {
  additional_info: RiskDefinitionAddInfo;
  scan_type: Scalars['String'];
  threat_level: Scalars['String'];
  title: Scalars['String'];
};

export type RiskDefinitionAddInfo = {
  details?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type RiskInput = {
  control: TreatmentControlInput;
  description: Scalars['String'];
  id: Scalars['ID'];
  initialGrade: GradeInput;
  name: Scalars['String'];
  residualGrade: GradeInput;
  type: Scalars['String'];
};

export type RiskModel = {
  control: TreatmentControlModel;
  description: Scalars['String'];
  id: Scalars['ID'];
  initialGrade: GradeModel;
  name: Scalars['String'];
  residualGrade: GradeModel;
  type: Scalars['String'];
};

export type RiskModelInput = {
  counter: Scalars['Float'];
  id: Scalars['ID'];
  impacts: Array<ProbabilityInput>;
  isBasic: Scalars['Boolean'];
  left: Scalars['Float'];
  name: Scalars['String'];
  probabilities: Array<ProbabilityInput>;
  right: Scalars['Float'];
  workspaceId: Scalars['String'];
};

export type RiskModelModel = {
  counter: Scalars['Float'];
  id: Scalars['ID'];
  impacts: Array<ProbabilityImpactModel>;
  isBasic: Scalars['Boolean'];
  left: Scalars['Float'];
  name: Scalars['String'];
  probabilities: Array<ProbabilityImpactModel>;
  right: Scalars['Float'];
  workspaceId: Scalars['String'];
};

export type RiskRegistriesPaginationModel = {
  data: Array<RiskRegistryModel>;
  pageInfo: PageInfo;
};

export type RiskRegistryInput = {
  context: Scalars['String'];
  id: Scalars['ID'];
  lastUpdate: LastUpdateInput;
  model: Scalars['String'];
  name: Scalars['String'];
  totalRisks: Scalars['Float'];
};

export type RiskRegistryModel = {
  context: Scalars['String'];
  id: Scalars['ID'];
  lastUpdate: LastUpdateModel;
  model: Scalars['String'];
  name: Scalars['String'];
  totalRisks: Scalars['Float'];
};

export type RisksFilterModel = NameFilter | TypeFilter;

export type RisksPaginationModel = {
  data: Array<RiskModel>;
  frameworks: Array<FrameworksControlsEvidencesShortModel>;
  pageInfo: PageInfo;
  registry: RiskRegistryModel;
};

export type RoleFilterModel = AppNameFilter | NameFilter | TypeFilter;

export type RoleModel = {
  accounts: Array<IdNameLogoModel>;
  appInfo: IdNameLogoModel;
  assets: Array<IdNameLogoModel>;
  description: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type RolesArrayInput = {
  roles: Array<Scalars['String']>;
};

export type RolesResponseModel = {
  filters: Array<Filter>;
  pageInfo: PageInfo;
  roles: Array<RoleModel>;
};

export type RuleModel = {
  rule: Scalars['String'];
};

export type RulesConflictInput = {
  account: Scalars['String'];
  applications: Array<DutyApplicationInput>;
  excepted: Scalars['Boolean'];
  id?: InputMaybe<Scalars['ID']>;
  recipients: Array<ConflictRecipientInput>;
  rule: IdNameInput;
  severityLevel: Scalars['String'];
  status: Scalars['String'];
  verifiedDate: Scalars['String'];
};

export type RulesConflictModel = {
  account: Scalars['String'];
  applications: Array<DutyApplicationModel>;
  excepted: Scalars['Boolean'];
  id?: Maybe<Scalars['ID']>;
  recipients: Array<ConflictRecipientModel>;
  rule: IdNameModel;
  severityLevel: Scalars['String'];
  status: Scalars['String'];
  verifiedDate: Scalars['String'];
};

export type RulesConflictPaginationModel = {
  data: Array<RulesConflictModel>;
  pageInfo: PageInfo;
};

export type RulesetPaginationModel = {
  data: Array<DutyRuleModel>;
  pageInfo: PageInfo;
};

export type SaasAssetInput = {
  billingCycle?: InputMaybe<Scalars['String']>;
  customFields?: InputMaybe<Scalars['JSON']>;
  id: Scalars['ID'];
  integration?: InputMaybe<Scalars['String']>;
  licenses?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  owner?: InputMaybe<Scalars['String']>;
  seeds?: InputMaybe<Scalars['Float']>;
  url?: InputMaybe<Scalars['String']>;
};

export type SaasAssetModel = {
  billingCycle?: Maybe<Scalars['String']>;
  customFields?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  integration?: Maybe<Scalars['String']>;
  licenses?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  owner?: Maybe<Scalars['String']>;
  seeds?: Maybe<Scalars['Float']>;
  url?: Maybe<Scalars['String']>;
};

export type SaasAssetSettingsInput = {
  billingCycle?: InputMaybe<Scalars['JSON']>;
  customFields?: InputMaybe<Scalars['JSON']>;
};

export type SaasAssetSettingsModel = {
  billingCycle?: Maybe<Scalars['JSON']>;
  customFields?: Maybe<Scalars['JSON']>;
};

export type SaasAssetsPaginationModel = {
  data: Array<SaasAssetModel>;
  pageInfo: PageInfo;
};

export type ScanHistoryModel = {
  activeScans: Array<TScanExtendedForHistory>;
  endScanDate: Scalars['String'];
  id: Scalars['String'];
  organizationId?: Maybe<Scalars['String']>;
  originTargetId: Scalars['String'];
  risks: Array<TRisk>;
  startScanDate: Scalars['String'];
  target: Scalars['String'];
  targetId: Scalars['String'];
  workspaceId: Scalars['String'];
};

export type SectionShortDataModel = {
  order?: Maybe<Scalars['Float']>;
  sectionId?: Maybe<Scalars['String']>;
  sectionName?: Maybe<Scalars['String']>;
  sectionType?: Maybe<MainTrainingContentTypeSectionAddDialog>;
};

export type SetCorrectiveActionInput = {
  causeAnalysis: Scalars['String'];
  correctiveAction?: InputMaybe<CorrectiveActionInput>;
};

export type SetTaskCollabsInput = {
  publicIds: Array<Scalars['String']>;
};

export type SeverityFilter = {
  severity?: Maybe<Array<Scalars['String']>>;
};

export type SharedLoginDataResponse = {
  currentUser: UserProfileResponse;
  organizations: Array<OrganizationWithWorkspacesAndShortCollabsModel>;
};

export type SharedPaginationInput = {
  count: Scalars['Int'];
  page: Scalars['Int'];
  sort?: InputMaybe<Scalars['String']>;
};

export type ShortAutomationModel = {
  active: Scalars['Boolean'];
  id: Scalars['String'];
  lastExecutorId?: Maybe<Scalars['String']>;
  lastRunStatus?: Maybe<Scalars['String']>;
  lastRunningDate?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type ShortAutomationResponseModel = {
  automations: Array<ShortAutomationModel>;
  filters: Array<Filter>;
  pageInfo: PageInfo;
};

export type ShortCollabsResponse = {
  collabs: Array<AccountsShortCollabModel>;
  filters: Array<Filter>;
  pageInfo: PageInfo;
};

export type ShortCollectorModel = {
  active?: Maybe<Scalars['Boolean']>;
  appIntegrations?: Maybe<Array<Scalars['String']>>;
  assignId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  evidence?: Maybe<EvidenceNodeModel>;
  id: Scalars['String'];
  lastRun?: Maybe<Scalars['String']>;
  lastRunStatus?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  requiredApps?: Maybe<Array<Scalars['String']>>;
  trigger?: Maybe<TriggerModel>;
};

export type ShortCollectorsResponseModel = {
  collectors: Array<ShortCollectorModel>;
  pageInfo: PageInfo;
};

export type ShortDocumentInput = {
  createdDate?: InputMaybe<Scalars['String']>;
  currentStepEndDate?: InputMaybe<Scalars['String']>;
  deletedDate?: InputMaybe<Scalars['String']>;
  documentId?: InputMaybe<Scalars['String']>;
  folderId?: InputMaybe<Scalars['String']>;
  generatedFileId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  lastModified?: InputMaybe<Scalars['String']>;
  latest?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  origin?: InputMaybe<Scalars['Boolean']>;
  recipients?: InputMaybe<Array<RecipientInput>>;
  sender?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  type: Scalars['String'];
  version?: InputMaybe<Scalars['Float']>;
  workspaceId?: InputMaybe<Scalars['String']>;
  workspaceName?: InputMaybe<Scalars['String']>;
};

export type ShortDocumentModel = {
  createdDate?: Maybe<Scalars['String']>;
  currentStepEndDate?: Maybe<Scalars['String']>;
  deletedDate?: Maybe<Scalars['String']>;
  documentId?: Maybe<Scalars['String']>;
  folderId?: Maybe<Scalars['String']>;
  generatedFileId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastModified?: Maybe<Scalars['String']>;
  latest?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  origin?: Maybe<Scalars['Boolean']>;
  recipients?: Maybe<Array<RecipientModel>>;
  sender?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  type: Scalars['String'];
  version?: Maybe<Scalars['Float']>;
  workspaceId?: Maybe<Scalars['String']>;
  workspaceName?: Maybe<Scalars['String']>;
};

export type ShortNcrModel = {
  controlId: Scalars['String'];
  id: Scalars['String'];
  reportId: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type ShortPhysicalAssetInput = {
  shortPhysicalAssets: Array<SoftwarePhysicalAssetInput>;
};

export type ShortPhysicalAssetModel = {
  shortPhysicalAssets: Array<SoftwarePhysicalAssetModel>;
};

export type SingleEventFiltersModel = {
  name: Scalars['String'];
  values: Array<Scalars['String']>;
};

export type SmallLicenseInput = {
  createdDate: Scalars['String'];
  id: Scalars['String'];
  issued: Scalars['Boolean'];
  subscription: Scalars['String'];
  used: Scalars['Boolean'];
};

export type SmallLicenseModel = {
  createdDate: Scalars['String'];
  id: Scalars['String'];
  issued: Scalars['Boolean'];
  subscription: Scalars['String'];
  used: Scalars['Boolean'];
};

export type SmallPersonModel = {
  id: Scalars['String'];
  jobTitle: Scalars['String'];
  manager?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  workEmail: Scalars['String'];
  workMobilePhone: Scalars['String'];
};

export type SmallTargetModel = {
  configTarget: ConfigTarget;
  id: Scalars['String'];
  lastRuns: TargetLastScansDates;
  name: Scalars['String'];
  status: Scalars['String'];
  statusChangedDate: Scalars['String'];
  target: Scalars['String'];
};

export type SodSchedulerAlertsInput = {
  isCanceled: Scalars['Boolean'];
  isEnded: Scalars['Boolean'];
  isError: Scalars['Boolean'];
};

export type SodSchedulerAlertsModel = {
  isCanceled: Scalars['Boolean'];
  isEnded: Scalars['Boolean'];
  isError: Scalars['Boolean'];
};

export type SodSchedulerDataPaginationModel = {
  data?: Maybe<SodSchedulerModel>;
  history: Array<SodSchedulerHistoryModel>;
  pageInfo: PageInfo;
};

export type SodSchedulerHistoryInput = {
  conflicts: Array<Scalars['String']>;
  lastCheckingDate: Scalars['String'];
  mitigation: Scalars['String'];
  rule: IdNameInput;
  securityRisk: Scalars['String'];
  severityLevel: Scalars['String'];
};

export type SodSchedulerHistoryModel = {
  conflicts: Array<Scalars['String']>;
  lastCheckingDate: Scalars['String'];
  mitigation: Scalars['String'];
  rule: IdNameModel;
  securityRisk: Scalars['String'];
  severityLevel: Scalars['String'];
};

export type SodSchedulerInput = {
  alerts: SodSchedulerAlertsInput;
  email: Scalars['String'];
  endDate: Scalars['String'];
  isAllActiveRules: Scalars['Boolean'];
  repeatNumber: Scalars['Float'];
  repeatTime: Scalars['String'];
  startDate: Scalars['String'];
};

export type SodSchedulerModel = {
  alerts: SodSchedulerAlertsModel;
  email: Scalars['String'];
  endDate: Scalars['String'];
  isAllActiveRules: Scalars['Boolean'];
  repeatNumber: Scalars['Float'];
  repeatTime: Scalars['String'];
  startDate: Scalars['String'];
};

export type SoftwareAssetInput = {
  customFields?: InputMaybe<Scalars['JSON']>;
  id: Scalars['ID'];
  installationThreshold?: InputMaybe<Scalars['Float']>;
  installed?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  physicalAssets?: InputMaybe<Array<SoftwarePhysicalAssetInput>>;
  version?: InputMaybe<Scalars['String']>;
};

export type SoftwareAssetModel = {
  customFields?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  installationThreshold?: Maybe<Scalars['Float']>;
  installed?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  physicalAssets?: Maybe<Array<SoftwarePhysicalAssetModel>>;
  version?: Maybe<Scalars['String']>;
};

export type SoftwareAssetSettingsInput = {
  customFields?: InputMaybe<Scalars['JSON']>;
};

export type SoftwareAssetSettingsModel = {
  customFields?: Maybe<Scalars['JSON']>;
};

export type SoftwareAssetsPaginationModel = {
  data: Array<SoftwareAssetModel>;
  pageInfo: PageInfo;
};

export type SoftwareByFiltersModel = {
  data: Array<SoftwareModel>;
  pageInfo: PageInfo;
};

export type SoftwareFilterModel = AppNameFilter | NameFilter;

export type SoftwareHardwareModel = {
  id: Scalars['String'];
  manufacturer?: Maybe<Scalars['String']>;
  meta?: Maybe<Scalars['JSON']>;
  model?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  os?: Maybe<Scalars['String']>;
  osVersion?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  wiFiMacAddress?: Maybe<Scalars['String']>;
};

export type SoftwareModel = {
  app: IdNameLogoModel;
  applicationId: Scalars['String'];
  hardwares: Array<SoftwareHardwareModel>;
  id: Scalars['String'];
  meta?: Maybe<Scalars['JSON']>;
  name: Scalars['String'];
  originId: Scalars['String'];
  vendor?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
  workspaceId: Scalars['String'];
};

export type SoftwarePhysicalAssetInput = {
  assetId: Scalars['String'];
  id: Scalars['ID'];
};

export type SoftwarePhysicalAssetModel = {
  assetId: Scalars['String'];
  id: Scalars['ID'];
};

export type SourceInfoDeviceModel = {
  account: Scalars['String'];
  firstSeen: Scalars['String'];
  lastSeen: Scalars['String'];
  logo: Scalars['String'];
  name: Scalars['String'];
};

export type SsoTokenFilterInput = {
  accessDetails?: InputMaybe<Array<Scalars['String']>>;
  connectionType?: InputMaybe<Array<Scalars['String']>>;
  consentGrantDetails?: InputMaybe<Array<Scalars['String']>>;
  name?: InputMaybe<Array<Scalars['String']>>;
  requestor?: InputMaybe<Array<Scalars['String']>>;
  user?: InputMaybe<Array<Scalars['String']>>;
};

export type StageInput = {
  actors: Array<ActorInput>;
  eta: Scalars['Float'];
  id: Scalars['String'];
  type: Scalars['String'];
};

export type StageModel = {
  actors: Array<ActorModel>;
  eta: Scalars['Float'];
  id: Scalars['String'];
  type: Scalars['String'];
};

export type StartResearchInput = {
  appId: Scalars['String'];
  endpointMappingName: Scalars['String'];
};

export type StatusByAdminInput = {
  backgroundColor: Scalars['String'];
  id: Scalars['String'];
  textColor: Scalars['String'];
  title: Scalars['String'];
};

export type StatusByAdminModel = {
  backgroundColor: Scalars['String'];
  id: Scalars['String'];
  textColor: Scalars['String'];
  title: Scalars['String'];
};

export type StatusFilter = {
  status?: Maybe<Array<Scalars['String']>>;
};

export type Subscription = {
  subscribeToPublicId: KafkaMessageModel;
  subscribeToWorkspace: KafkaMessageModel;
};


export type SubscriptionSubscribeToPublicIdArgs = {
  publicId: Scalars['String'];
  token: Scalars['String'];
};


export type SubscriptionSubscribeToWorkspaceArgs = {
  organizationId: Scalars['String'];
  publicId: Scalars['String'];
  token: Scalars['String'];
  workspaceId: Scalars['String'];
};

export type SupportMessageInput = {
  message: Scalars['String'];
  subject: Scalars['String'];
  type: Scalars['String'];
};

export type SystemCheckModel = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export type SystemFieldModel = {
  checkAlias: Array<CheckAliasModel>;
  dictionary?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  required: Scalars['Boolean'];
  requiredForTemplate: Scalars['Boolean'];
  systemAlias?: Maybe<Scalars['String']>;
  templateType: Scalars['String'];
  type: Scalars['String'];
};

export type TKycTargetInput = {
  archived: Scalars['Boolean'];
  createdDate: Scalars['String'];
  createdType: Scalars['String'];
  fields: Array<KycTargetFieldInput>;
  id: Scalars['String'];
  lastModified: Scalars['String'];
  risk: Scalars['String'];
  status: Scalars['String'];
  targetType: Scalars['String'];
  templateId: Scalars['String'];
  templateName?: InputMaybe<Scalars['String']>;
};

export type TKycTargetModel = {
  archived: Scalars['Boolean'];
  createdDate: Scalars['String'];
  createdType: Scalars['String'];
  fields: Array<KycTargetFieldModel>;
  id: Scalars['String'];
  lastModified: Scalars['String'];
  risk: Scalars['String'];
  status: Scalars['String'];
  targetType: Scalars['String'];
  templateId: Scalars['String'];
  templateName?: Maybe<Scalars['String']>;
};

export type TKycTemplateFieldFillableModel = {
  checkAlias: Array<CheckAliasModel>;
  dictionary?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  order: Scalars['Float'];
  required: Scalars['Boolean'];
  requiredForTemplate: Scalars['Boolean'];
  system: Scalars['Boolean'];
  systemAlias?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type TKycTemplateFieldFillableModelInput = {
  checkAlias: Array<CheckAliasModelInput>;
  dictionary?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  order: Scalars['Float'];
  required: Scalars['Boolean'];
  requiredForTemplate: Scalars['Boolean'];
  system: Scalars['Boolean'];
  systemAlias?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
  value?: InputMaybe<Scalars['String']>;
};

export type TKycTemplateFieldModel = {
  checkAlias: Array<CheckAliasModel>;
  dictionary?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  order: Scalars['Float'];
  required: Scalars['Boolean'];
  requiredForTemplate: Scalars['Boolean'];
  system: Scalars['Boolean'];
  systemAlias?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type TKycTemplateFieldModelInput = {
  checkAlias: Array<CheckAliasModelInput>;
  dictionary?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  order: Scalars['Float'];
  required: Scalars['Boolean'];
  requiredForTemplate: Scalars['Boolean'];
  system: Scalars['Boolean'];
  systemAlias?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};

export type TKycTemplateScreeningSettingsCheckModel = {
  apply: Scalars['Boolean'];
  id: Scalars['String'];
  matchingRatio: Scalars['Float'];
  name: Scalars['String'];
};

export type TKycTemplateScreeningSettingsCheckModelInput = {
  apply: Scalars['Boolean'];
  id: Scalars['String'];
  matchingRatio: Scalars['Float'];
  name: Scalars['String'];
};

export type TKycTemplateScreeningSettingsModel = {
  checks: Array<TKycTemplateScreeningSettingsCheckModel>;
  repeat: Scalars['Float'];
};

export type TKycTemplateScreeningSettingsModelInput = {
  checks: Array<TKycTemplateScreeningSettingsCheckModelInput>;
  repeat: Scalars['Float'];
};

export type TMappingFieldsSchema = {
  name: Scalars['String'];
  representationName: Scalars['String'];
  sourceName: Scalars['String'];
};

export type TMappingFieldsSchemaInput = {
  name: Scalars['String'];
  representationName: Scalars['String'];
  sourceName: Scalars['String'];
};

export type TMonitoringFilterInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  application?: InputMaybe<Array<Scalars['String']>>;
  framework?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Array<Scalars['String']>>;
  name?: InputMaybe<Array<Scalars['String']>>;
  severity?: InputMaybe<Array<Scalars['String']>>;
};

export type TOrgConfiguration = {
  availableCollaboratorsCount: Scalars['Float'];
  availableCollaboratorsRules: Array<AvailableCollaboratorsRule>;
  availableKycVerificationCount: Scalars['Float'];
  availableTargetsVulnerabilityScan: Scalars['Float'];
  availableWizards: Array<Scalars['String']>;
  availableWorkspaceCount: Scalars['Float'];
};

export type TpaFilterModel = AppNameFilter | NameFilter;

export type TRisk = {
  accepted_by: Array<Scalars['String']>;
  first_detected_at?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  is_accepted: Scalars['Boolean'];
  last_detected_at?: Maybe<Scalars['String']>;
  risk_definition: RiskDefinition;
  status: Scalars['String'];
  tags: Array<Scalars['String']>;
  target: Scalars['String'];
  target_id: Scalars['String'];
};

export type TScanExtendedForHistory = {
  finishScanDate: Scalars['String'];
  scanFailedReason?: Maybe<Scalars['String']>;
  scanId?: Maybe<Scalars['String']>;
  scanResult?: Maybe<HistoryScanResult>;
  scanType: Scalars['String'];
  startScanDate: Scalars['String'];
  status: Scalars['String'];
};

export type TShortEmployee = {
  firstName: Scalars['String'];
  id: Scalars['String'];
  jobTitle?: Maybe<Scalars['String']>;
  lastName: Scalars['String'];
  manager?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  workEmail?: Maybe<Scalars['String']>;
};

export type TargetFilter = {
  target?: Maybe<Array<Scalars['String']>>;
};

export type TargetLastScansDates = {
  TLS_SSL?: Maybe<Scalars['String']>;
  openVas?: Maybe<Scalars['String']>;
  owasp?: Maybe<Scalars['String']>;
  tcpPorts?: Maybe<Scalars['String']>;
};

export type TemplateFileDto = {
  id: Scalars['String'];
  innerHTML?: Maybe<Scalars['String']>;
  lastUpload?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  type: Scalars['String'];
};

export type TemplateTaskRequestInput = {
  config: Scalars['JSON'];
  editor?: InputMaybe<Scalars['JSON']>;
  evidences: Array<IdNameInput>;
  innerHtml?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  readers: Array<ReleaseActorInput>;
  reviewers: Array<ReleaseActorInput>;
  signers: Array<ReleaseActorInput>;
  templateId: Scalars['String'];
  variables?: InputMaybe<Array<DataVariableModelInput>>;
};

export type ThirdPartyApp = {
  description: Scalars['String'];
  discoverySource: IdNameLogoModel;
  id: Scalars['String'];
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  status: Scalars['String'];
};

export type ThirdPartyAppGroup = {
  accesses: Scalars['Float'];
  name: Scalars['String'];
  thirdPartyAccesses: Array<ThirdPartyApp>;
};

export type ThirdPartyAppInfo = {
  certifications: Array<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  documentationLink?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  securityScope?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type ThirdPartyAppsRequest = {
  filter: FilterInput;
  pageInfo: SharedPaginationInput;
};

export type ThirdPartyAppsResponse = {
  pageInfo: PageInfo;
  thirdPartyAccessesGroups: Array<ThirdPartyAppGroup>;
};

export type ThirdPartyFilterModel = DiscoverySourceFilter | NameFilter;

export type ThirdPartySsoFilterModel = ConsentGrantDetailsFilter | UserFilter;

export type ThirdPartySsoResponse = {
  pageInfo: PageInfo;
  rows: Array<ThirdPartySsoRow>;
};

export type ThirdPartySsoRow = {
  date: Scalars['String'];
  grants: Array<Scalars['String']>;
  id: Scalars['String'];
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type ThirdPartySsoTokenRequest = {
  applicationId: Scalars['String'];
  filter: SsoTokenFilterInput;
  pageInfo: SharedPaginationInput;
  thirdPartyId: Array<Scalars['String']>;
  thirdPartyName: Scalars['String'];
};

export type ThirdPartyTokenFilterModel = AccessDetailsFilter | ConnectionTypeFilter | NameFilter | RequestorFilter;

export type ThirdPartyTokenResponse = {
  pageInfo: PageInfo;
  rows: Array<ThirdPartyTokenRow>;
};

export type ThirdPartyTokenRow = {
  date: Scalars['String'];
  details: Scalars['JSON'];
  id: Scalars['String'];
  name: Scalars['String'];
  requester: Scalars['String'];
};

export enum TrainingAssignmentExamAnswerStatus {
  Answered = 'ANSWERED',
  Failed = 'FAILED',
  PartiallyPassed = 'PARTIALLY_PASSED',
  Passed = 'PASSED',
  Skipped = 'SKIPPED',
  Todo = 'TODO',
  Validation = 'VALIDATION'
}

export enum TrainingAssignmentExamType {
  PostExam = 'postExam',
  PreExam = 'preExam'
}

export enum TrainingAssignmentObjectStatus {
  Abandoned = 'ABANDONED',
  Done = 'DONE',
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Passed = 'PASSED',
  SkippedBySystem = 'SKIPPED_BY_SYSTEM',
  Todo = 'TODO',
  Validation = 'VALIDATION'
}

export enum TrainingAssignmentStatus {
  Assigned = 'ASSIGNED',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Passed = 'PASSED',
  Scheduled = 'SCHEDULED',
  Validation = 'VALIDATION'
}

export type TrainingCollaboratorAutocompleteInput = {
  collaboratorId: Scalars['String'];
  fullName: Scalars['String'];
};

export type TrainingCollaboratorAutocompleteModel = {
  collaboratorId: Scalars['String'];
  fullName: Scalars['String'];
};

export type TrainingCollaboratorInput = {
  collaboratorId: Scalars['String'];
  email: Scalars['String'];
  fullName: Scalars['String'];
};

export type TrainingCollaboratorModel = {
  collaboratorId: Scalars['String'];
  email: Scalars['String'];
  fullName: Scalars['String'];
};

export type TrainingContentDataEditorInput = {
  innerHtml: Scalars['String'];
};

export type TrainingContentDataEditorModel = {
  innerHtml: Scalars['String'];
};

export type TrainingContentDataFileInput = {
  fileId: Scalars['String'];
  name: Scalars['String'];
  thumbnail?: InputMaybe<Scalars['String']>;
};

export type TrainingContentDataFileModel = {
  fileId: Scalars['String'];
  name: Scalars['String'];
  thumbnail?: Maybe<Scalars['String']>;
};

export type TrainingContentDataModel = {
  fileId?: Maybe<Scalars['String']>;
  innerHtml?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type TrainingContentDataModelInput = {
  fileId?: InputMaybe<Scalars['String']>;
  innerHtml?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  thumbnail?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type TrainingContentDataVideoFileInput = {
  fileId: Scalars['String'];
  name: Scalars['String'];
};

export type TrainingContentDataVideoFileModel = {
  fileId: Scalars['String'];
  name: Scalars['String'];
};

export type TrainingContentDataVideoLinkInput = {
  url: Scalars['String'];
};

export type TrainingContentDataVideoLinkModel = {
  url: Scalars['String'];
};

export type TrainingContentNewModel = {
  data: TrainingContentDataModel;
  name: Scalars['String'];
  order: Scalars['Float'];
  sectionId: Scalars['String'];
  type: MainTrainingContentType;
};

export type TrainingContentNewModelInput = {
  data: TrainingContentDataModelInput;
  name: Scalars['String'];
  order: Scalars['Float'];
  sectionId: Scalars['String'];
  type: MainTrainingContentType;
};

export enum TrainingContentStatus {
  Done = 'DONE',
  InProgress = 'IN_PROGRESS',
  Todo = 'TODO'
}

export type TrainingCoverImageInput = {
  fileType?: InputMaybe<Scalars['String']>;
  image: Scalars['String'];
  imageName: Scalars['String'];
  thumbnail: Scalars['String'];
  type: MainTrainingCoverImageType;
};

export type TrainingCoverImageModel = {
  fileType?: Maybe<Scalars['String']>;
  image: Scalars['String'];
  imageName: Scalars['String'];
  thumbnail: Scalars['String'];
  type: MainTrainingCoverImageType;
};

export enum TrainingExamLevel {
  Basic = 'BASIC',
  High = 'HIGH',
  Medium = 'MEDIUM'
}

export type TrainingExamQuestionInput = {
  description: Scalars['String'];
  options: Array<TrainingExamQuestionOptionInput>;
  order: Scalars['Float'];
  points: Scalars['Float'];
  pointsAutoCount: Scalars['Boolean'];
  question: Scalars['String'];
  questionId: Scalars['String'];
  type: TrainingExamQuestionType;
};

export type TrainingExamQuestionModel = {
  description: Scalars['String'];
  options: Array<TrainingExamQuestionOptionModel>;
  order: Scalars['Float'];
  points: Scalars['Float'];
  pointsAutoCount: Scalars['Boolean'];
  question: Scalars['String'];
  questionId: Scalars['String'];
  type: TrainingExamQuestionType;
};

export type TrainingExamQuestionOptionInput = {
  correct: Scalars['Boolean'];
  option: Scalars['String'];
  order: Scalars['Float'];
  points: Scalars['Float'];
};

export type TrainingExamQuestionOptionModel = {
  correct?: Maybe<Scalars['Boolean']>;
  option: Scalars['String'];
  order: Scalars['Float'];
  points?: Maybe<Scalars['Float']>;
};

export enum TrainingExamQuestionType {
  Checkboxes = 'CHECKBOXES',
  MultipleChoice = 'MULTIPLE_CHOICE',
  Paragraph = 'PARAGRAPH',
  ShortAnswer = 'SHORT_ANSWER'
}

export type TrainingShortExamInput = {
  examId: Scalars['String'];
  name: Scalars['String'];
  version: Scalars['Float'];
};

export type TrainingShortExamModel = {
  examId: Scalars['String'];
  name: Scalars['String'];
  version: Scalars['Float'];
};

export type TrainingTemplateExamInput = {
  examId: Scalars['String'];
  name: Scalars['String'];
};

export type TrainingTemplateExamModel = {
  examId: Scalars['String'];
  name: Scalars['String'];
};

export type TransactionStatusModel = {
  organizationId?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  workspaceId?: Maybe<Scalars['String']>;
};

export type TreatmentControlInput = {
  actions?: InputMaybe<Scalars['String']>;
  owners: Array<Scalars['String']>;
  scheduler?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type TreatmentControlModel = {
  actions?: Maybe<Scalars['String']>;
  owners: Array<Scalars['String']>;
  scheduler?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type TriggerInput = {
  repeat: Scalars['Float'];
  start: Scalars['String'];
  type: Scalars['String'];
};

export type TriggerModel = {
  repeat: Scalars['Float'];
  start: Scalars['String'];
  type: Scalars['String'];
};

export type TypeFilter = {
  type?: Maybe<Array<Scalars['String']>>;
};

export type UnlinkControlInput = {
  controlId: Scalars['String'];
  frameworkId: Scalars['String'];
};

export type UnlinkEvidenceInput = {
  controlId: Scalars['String'];
  evidenceId: Scalars['String'];
};

export type UpdateAuditorsInput = {
  ids: Array<Scalars['String']>;
};

export type UpdateConflictExceptionInput = {
  account: Scalars['String'];
  active: Scalars['Boolean'];
  allowedDate: Scalars['String'];
  deniedBy: Scalars['String'];
  reason: Scalars['String'];
  resolution: Scalars['String'];
};

export type UpdateCrownJewelRequest = {
  appCrownJewels: Array<AppCrownJewels>;
  color: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type UpdateEmployeesTreeDto = {
  employeeId: Scalars['String'];
  managerId?: InputMaybe<Scalars['String']>;
};

export type UpdateIntegrationInput = {
  applicationId: Scalars['String'];
  detailsId: Scalars['String'];
  endpointMappingName: Scalars['String'];
  hris: Scalars['Boolean'];
  identity: Scalars['Boolean'];
  integration: Scalars['JSON'];
  name: Scalars['String'];
  ownerEmail?: InputMaybe<Scalars['String']>;
  status: Scalars['String'];
  workspaceId: Scalars['String'];
};

export type UpdateProfileMappingInputUpdateProfileMappingInput = {
  scheme: Array<AdminWorkspaceConfigProfileMappingInput>;
};

export type UpdateRowStatusOrCommentDto = {
  applicationAccessId: Scalars['String'];
  applicationAccessName: Scalars['String'];
  applicationId?: InputMaybe<Scalars['String']>;
  data: Array<CampaignReviewExecutorAccountFillableTypeInput>;
  vendorId?: InputMaybe<Scalars['String']>;
  vendorName?: InputMaybe<Scalars['String']>;
};

export type UpdateRowStatusOrCommentDtoRequestDto = {
  appsData: Array<UpdateRowStatusOrCommentDto>;
};

export type UpdateTargetInput = {
  configTarget: ConfigTargetInput;
  id: Scalars['String'];
  name: Scalars['String'];
  target: Scalars['String'];
};

export type UpdateUserProfileRequest = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  publicId: Scalars['String'];
};

export type UpdateWizardsInput = {
  wizardIds: Array<Scalars['String']>;
};

export type UpdatedRisksModel = {
  data: Array<RiskModel>;
  registry: RiskRegistryModel;
};

export type UploadCsvFileResponseModel = {
  fields: Array<KycCsvFieldModel>;
  fileId: Scalars['String'];
  status: Scalars['String'];
};

export type UploadFileArrayDto = {
  files: Array<UploadFileDto>;
};

export type UploadFileDto = {
  documentId: Scalars['String'];
  folderId: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type UploadFileResponseModel = {
  fileId: Scalars['String'];
};

export type UploadNewFileDto = {
  extension: Scalars['String'];
  file: Scalars['String'];
};

export type UsedRecipientsResponseModel = {
  values: Array<IdNameEmailModel>;
};

export type UserFilter = {
  user?: Maybe<Array<Scalars['String']>>;
};

export type UserInfo = {
  accountId: Scalars['String'];
  avatar?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type UserProfileResponse = {
  creationDate?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastLoginDate?: Maybe<Scalars['String']>;
  lastName: Scalars['String'];
  publicId: Scalars['String'];
  status: Scalars['String'];
};

export type VendorDocument = {
  id: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type VendorDocumentInput = {
  id: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type VendorEvaluationInput = {
  evaluator?: InputMaybe<WorkspaceCollaboratorInput>;
  notesAndRecommendations?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  quality?: InputMaybe<Scalars['Float']>;
  service?: InputMaybe<Scalars['Float']>;
};

export type VendorEvaluationModel = {
  evaluator?: Maybe<WorkspaceCollaboratorModel>;
  notesAndRecommendations?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  quality?: Maybe<Scalars['Float']>;
  service?: Maybe<Scalars['Float']>;
};

export type VendorInput = {
  contactPersons?: InputMaybe<Array<ContactPersonInput>>;
  customFields: Scalars['JSON'];
  documentStatus?: InputMaybe<Scalars['String']>;
  documents: Array<VendorDocumentInput>;
  evaluation?: InputMaybe<VendorEvaluationInput>;
  id: Scalars['String'];
  link?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  owner?: InputMaybe<WorkspaceCollaboratorInput>;
  risk?: InputMaybe<Scalars['String']>;
  securityReviewDate?: InputMaybe<Scalars['String']>;
  serviceProvided?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type VendorModel = {
  contactPersons?: Maybe<Array<ContactPersonModel>>;
  customFields: Scalars['JSON'];
  documentStatus?: Maybe<Scalars['String']>;
  documents: Array<VendorDocument>;
  evaluation?: Maybe<VendorEvaluationModel>;
  id: Scalars['String'];
  link?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  owner?: Maybe<WorkspaceCollaboratorModel>;
  risk?: Maybe<Scalars['String']>;
  securityReviewDate?: Maybe<Scalars['String']>;
  serviceProvided?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type VendorsPaginationModel = {
  pageInfo: PageInfo;
  vendors: Array<VendorModel>;
};

export type VendorsSettingsModel = {
  customFields: Array<NameCountModel>;
  risk: Array<NameCountModel>;
  serviceProvided: Array<NameCountModel>;
  type: Array<NameCountModel>;
};

export type VicaAdminCategoriesResponseModel = {
  categories: Array<VicaAdminCategoryModel>;
  flow: Array<VicaAdminOrderModel>;
};

export type VicaAdminCategoryInput = {
  description: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type VicaAdminCategoryModel = {
  description: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type VicaAdminOrderInput = {
  id: Scalars['String'];
  name: Scalars['String'];
  order: Scalars['Float'];
};

export type VicaAdminOrderModel = {
  id: Scalars['String'];
  name: Scalars['String'];
  order: Scalars['Float'];
};

export type VicaAdminTaskInput = {
  actions?: InputMaybe<Array<VicaTaskActionInput>>;
  evidenceIds: Array<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Float']>;
};

export type VicaAdminTaskModel = {
  actions?: Maybe<Array<VicaTaskActionModel>>;
  evidenceIds: Array<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  order?: Maybe<Scalars['Float']>;
};

export type VicaCategoryModel = {
  collaborators: Array<VicaCollabModel>;
  description: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  order: Scalars['Float'];
  progress: Scalars['Float'];
  responsible?: Maybe<VicaCollabModel>;
  tasks: Array<VicaTaskModel>;
};

export type VicaCollabModel = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  publicId: Scalars['String'];
};

export type VicaTaskActionInput = {
  data?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  type: Scalars['String'];
};

export type VicaTaskActionModel = {
  data?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  type: Scalars['String'];
};

export type VicaTaskModel = {
  actions: Array<VicaTaskActionModel>;
  collaborators: Array<VicaCollabModel>;
  evidences: Array<IdNameModel>;
  frameworkNames: Array<IdNameModel>;
  id: Scalars['String'];
  name: Scalars['String'];
  order: Scalars['Float'];
  status: Scalars['String'];
};

export type VicaTasksFilesInput = {
  actionFile?: InputMaybe<Scalars['String']>;
  categoryFile?: InputMaybe<Scalars['String']>;
  taskByFrameworkFile?: InputMaybe<Scalars['String']>;
  taskByProcessFile?: InputMaybe<Scalars['String']>;
};

export type VirtualAssetInput = {
  customFields?: InputMaybe<Scalars['JSON']>;
  id: Scalars['ID'];
  ip?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  owner?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  virtualMachineIp?: InputMaybe<Scalars['String']>;
  virtualMachineName?: InputMaybe<Scalars['String']>;
};

export type VirtualAssetModel = {
  customFields?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  ip?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  owner?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  virtualMachineIp?: Maybe<Scalars['String']>;
  virtualMachineName?: Maybe<Scalars['String']>;
};

export type VirtualAssetSettingsInput = {
  customFields?: InputMaybe<Scalars['JSON']>;
  type?: InputMaybe<Scalars['JSON']>;
};

export type VirtualAssetSettingsModel = {
  customFields?: Maybe<Scalars['JSON']>;
  type?: Maybe<Scalars['JSON']>;
};

export type VirtualAssetsPaginationModel = {
  data: Array<VirtualAssetModel>;
  pageInfo: PageInfo;
};

export type VulnerabilityFilterModel = NameFilter | TargetFilter;

export type WorkerConfirmSignatureDto = {
  signatureId: Scalars['String'];
  stageId: Scalars['String'];
};

export type WorkerDownloadFileModel = {
  file: Scalars['String'];
  filename: Scalars['String'];
  filetype: Scalars['String'];
};

export type WorkerStageArtifactModel = {
  artifactId: Scalars['String'];
  file: FileModel;
  fileName: Scalars['String'];
  lastUpdate?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type WorkerStageDocumentInput = {
  links: Array<WorkerStageDocumentLinkInput>;
  type: Scalars['String'];
};

export type WorkerStageDocumentLinkInput = {
  fileName: Scalars['String'];
  lastUpdate: Scalars['String'];
  link: Scalars['String'];
};

export type WorkerStageDocumentLinkModel = {
  fileName: Scalars['String'];
  lastUpdate: Scalars['String'];
  link: Scalars['String'];
};

export type WorkerStageDocumentModel = {
  links: Array<WorkerStageDocumentLinkModel>;
  type: Scalars['String'];
};

export type WorkerStageItemActorModel = {
  email: Scalars['String'];
  publicId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  statusChangedDate?: Maybe<Scalars['String']>;
};

export type WorkerStageItemActorWithFilterModel = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  publicId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  statusChangedDate?: Maybe<Scalars['String']>;
};

export type WorkerStageItemModel = {
  actor: WorkerStageItemActorModel;
  automationType: Scalars['String'];
  documentName?: Maybe<Scalars['String']>;
  eta: Scalars['Float'];
  executorId: Scalars['String'];
  expirationDate: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  runDate: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  statusChangedDate?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type WorkerStageItemWithFilterModel = {
  actors: Array<WorkerStageItemActorWithFilterModel>;
  eta: Scalars['Float'];
  expirationDate: Scalars['String'];
  id: Scalars['String'];
  runDate: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  statusChangedDate?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type WorkerStageModel = {
  stage: WorkerStageItemModel;
  stageCampaignReview?: Maybe<CampaignReviewExecutorStageActorType>;
  stageDocument?: Maybe<WorkerStageDocumentModel>;
};

export type WorkerStageWithFilterModel = {
  artifacts: Array<WorkerStageArtifactModel>;
  stage: WorkerStageItemWithFilterModel;
};

export type WorkerStagesResponseModel = {
  pageInfo: PageInfo;
  recipients: Array<IdNameEmailModel>;
  stages: Array<WorkerStageModel>;
};

export type WorkerStagesWithFilterResponseModel = {
  pageInfo: PageInfo;
  recipients: Array<IdNameEmailModel>;
  stages: Array<WorkerStageWithFilterModel>;
};

export type WorkerUploadNewFileDto = {
  stageDocument: WorkerStageDocumentInput;
  stageId: Scalars['String'];
};

export type Workspace = {
  availableCollaborators?: Maybe<Scalars['Float']>;
  collaborators: Array<Collaborator>;
  id: Scalars['String'];
  name: Scalars['String'];
  organizationId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  subscription?: Maybe<Scalars['String']>;
  subscriptionExpiry?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type WorkspaceCollabModel = {
  createDate?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastLoginDate?: Maybe<Scalars['String']>;
  lastName: Scalars['String'];
  publicId: Scalars['String'];
  roles: Array<WorkspaceRoleModel>;
  status: Scalars['String'];
};

export type WorkspaceCollaboratorInput = {
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  publicId: Scalars['ID'];
};

export type WorkspaceCollaboratorModel = {
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  publicId: Scalars['ID'];
};

export type WorkspaceCollaboratorWithRolePaginatedResponse = {
  pageInfo: PageInfo;
  result: Array<WorkspaceCollaboratorWithRolesModel>;
};

export type WorkspaceCollaboratorWithRolesInput = {
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  publicId: Scalars['ID'];
  roles: Array<CollaboratorRole>;
};

export type WorkspaceCollaboratorWithRolesModel = {
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  publicId: Scalars['ID'];
  roles: Array<CollaboratorRole>;
};

export type WorkspaceInviteModel = {
  activationDate?: Maybe<Scalars['String']>;
  creationDate: Scalars['String'];
  emailAddress: Scalars['String'];
  expirationDate: Scalars['String'];
  id: Scalars['String'];
  inviteStatus: Scalars['String'];
  organizationId: Scalars['String'];
  organizationName: Scalars['String'];
  roles: Array<Scalars['String']>;
  sender: WorkspaceInviteSenderModel;
  workspaceId: Scalars['String'];
  workspaceName: Scalars['String'];
};

export type WorkspaceInviteSenderModel = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

export type WorkspaceRoleModel = {
  createDate: Scalars['String'];
  id: Scalars['String'];
  lastUpdateDate: Scalars['String'];
  name: Scalars['String'];
  origin: Scalars['Boolean'];
  permissions: Array<Scalars['String']>;
  system: Scalars['Boolean'];
  workspaceId?: Maybe<Scalars['String']>;
};

export type WorkspaceShortCollaboratorModel = {
  publicId: Scalars['String'];
  role?: Maybe<Scalars['String']>;
};

export type AdminCollabModel = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  publicId: Scalars['String'];
  role?: Maybe<Scalars['String']>;
  status: Scalars['Boolean'];
};

export type AdminCreateOrUpdateDocumentDto = {
  data: AdminDataInput;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  type: Scalars['String'];
};

export type AdminInviteModel = {
  email: Scalars['String'];
  inviteId: Scalars['String'];
  roles: Array<Scalars['String']>;
  status: Scalars['String'];
};

export type AdminOrganizationCollabRule = {
  count: Scalars['Float'];
  email?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type AdminOrganizationCollabRuleInput = {
  count: Scalars['Float'];
  email?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};

export type AdminOrganizationCollabRuleInputArray = {
  rules: Array<AdminOrganizationCollabRuleInput>;
};

export type AdminOrganizationConfigModel = {
  availableCollaboratorsCount: Scalars['Float'];
  availableCollaboratorsRules: Array<AdminOrganizationCollabRule>;
  availableTargetsVulnerabilityScan: Scalars['Float'];
  availableWizards: Array<Scalars['String']>;
  availableWorkspaceCount: Scalars['Float'];
};

export type AdminSmallWorkspaceModel = {
  collaborators: Array<AdminCollabModel>;
  config: AdminWorkspaceConfig;
  id: Scalars['String'];
  invites: Array<AdminInviteModel>;
  name: Scalars['String'];
};

export type AdminWorkspaceConfig = {
  accountsMappingSchema: Scalars['String'];
  profilesMappingSchema: Array<AdminWorkspaceConfigProfileMapping>;
};

export type AdminWorkspaceConfigProfileMapping = {
  appName: Scalars['String'];
  groupsName: Array<Scalars['String']>;
};

export type AdminWorkspaceConfigProfileMappingInput = {
  appName: Scalars['String'];
  groupsName: Array<Scalars['String']>;
};

export type CampaignReviewExecutorAccountFillableType = {
  account: Scalars['String'];
  accountId?: Maybe<Scalars['String']>;
  accountType?: Maybe<Scalars['String']>;
  commentManager?: Maybe<Scalars['String']>;
  commentVendor?: Maybe<Scalars['String']>;
  employee?: Maybe<Scalars['String']>;
  employeeId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  publicIdManager?: Maybe<Scalars['String']>;
  publicIdVendor?: Maybe<Scalars['String']>;
  roles: Array<AccessManagementAppAccountRole>;
  status: Scalars['String'];
  statusManager?: Maybe<Scalars['String']>;
  statusVendor?: Maybe<Scalars['String']>;
};

export type CampaignReviewExecutorAccountFillableTypeInput = {
  account: Scalars['String'];
  accountId?: InputMaybe<Scalars['String']>;
  accountType?: InputMaybe<Scalars['String']>;
  commentManager?: InputMaybe<Scalars['String']>;
  commentVendor?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<Scalars['String']>;
  employeeId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  publicIdManager?: InputMaybe<Scalars['String']>;
  publicIdVendor?: InputMaybe<Scalars['String']>;
  roles: Array<AccessManagementAppAccountRoleInput>;
  status: Scalars['String'];
  statusManager?: InputMaybe<Scalars['String']>;
  statusVendor?: InputMaybe<Scalars['String']>;
};

export type CampaignReviewExecutorStageActorAppData = {
  applicationAccessId: Scalars['String'];
  applicationAccessName: Scalars['String'];
  applicationId?: Maybe<Scalars['String']>;
  data: Array<CampaignReviewExecutorAccountFillableType>;
  vendorId?: Maybe<Scalars['String']>;
  vendorName?: Maybe<Scalars['String']>;
};

export type CampaignReviewExecutorStageActorType = {
  appsData?: Maybe<Array<CampaignReviewExecutorStageActorAppData>>;
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  mainControl: Scalars['Boolean'];
  publicId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  statusChangedDate: Scalars['String'];
  verifyRevokeComment?: Maybe<Scalars['String']>;
};

export type CampaignReviewExecutorStageType = {
  actors: Array<CampaignReviewExecutorStageActorType>;
  eta: Scalars['Float'];
  expirationDate: Scalars['String'];
  id: Scalars['String'];
  runDate?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  statusChangedDate?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type ConfigTargetInput = {
  availableScanTypes: Array<Scalars['String']>;
};

export type CreateOneLicenseResponseModel = {
  collabs: Array<WorkspaceCollabModel1>;
  id: Scalars['String'];
};

export type CreateOrUpdateDocumentDto = {
  data: DataInput;
  documentId?: InputMaybe<Scalars['String']>;
  folderId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  type: Scalars['String'];
};

export type CreateRoleInputModel = {
  name: Scalars['String'];
  origin: Scalars['Boolean'];
  permissions: Array<Scalars['String']>;
  system: Scalars['Boolean'];
};

export type CreateUpdateRoleRequestInput = {
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  permissions: Array<Scalars['String']>;
  workspaceId: Scalars['String'];
};

export type CreatorDetails = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

export type CreatorDetailsInput = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

export type DataSnapshotType = {
  appDataSnapshot: Array<AppDataSnapshotType>;
  createdDate: Scalars['String'];
  latest: Scalars['Boolean'];
};

export type FinalApprover = {
  documentId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  publicId?: Maybe<Scalars['String']>;
  signId?: Maybe<Scalars['String']>;
};

export type GetAutocompleteSenderResponseModel = {
  pageInfo: PageInfo;
  values: Array<Scalars['String']>;
};

export type GetAutocompleteWorkspaceResponseModel = {
  pageInfo: PageInfo;
  values: Array<WorkspaceNameIdAutocompleteModel>;
};

export type GetInstructionsWIthPagingResponseModel = {
  instructions: Array<CampaignReviewInstructionModel>;
  pageInfo: PageInfo;
};

export type GetSmallCampaignReviewExecutorsResponseModel = {
  executors: Array<CampaignReviewExecutorSmallModel>;
  pageInfo: PageInfo;
};

export type GetSmallOrgsAndWorkspacesResponseModel = {
  organizations: Array<SmallOrgForSelectModel>;
  portalAccess: Scalars['Boolean'];
};

export type GetTemplateConfigResponseModel = {
  systemChecks: Array<SystemCheckModel>;
  systemFields: Array<SystemFieldModel>;
};

export type GetWorkspaceCollabsAndInvitesResponseModel = {
  availablePermissions: Array<Scalars['String']>;
  collabs: Array<WorkspaceCollabModel>;
  invite: Array<WorkspaceInviteModel>;
  workspaceRoles: Array<WorkspaceRoleModel>;
};

export type InstalledAppType = {
  applicationId: Scalars['String'];
  detailsId: Scalars['String'];
  hris: Scalars['Boolean'];
  identity: Scalars['Boolean'];
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  ownerEmail?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  workspaceId: Scalars['String'];
};

export type MappedApplicationInput = {
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
};

export type MappedApplicationModel = {
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

export type PortalGetSmallOrgsAndWorkspacesResponseModel = {
  organizations: Array<SmallOrgForSelectModel>;
};

export type SmallCampaignReviewExecutorStageType = {
  eta: Scalars['Float'];
  expirationDate: Scalars['String'];
  id: Scalars['String'];
  runDate?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  statusChangedDate?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type SmallOrgForSelectModel = {
  blocked: Scalars['Boolean'];
  configuration: TOrgConfiguration;
  id: Scalars['String'];
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  subscription: Scalars['String'];
  subscriptionExpiry: Scalars['String'];
  workspaces: Array<RedesignWorkspace>;
};

export type UpdateAdminRoleRequestInput = {
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  origin: Scalars['Boolean'];
  permissions: Array<Scalars['String']>;
  system: Scalars['Boolean'];
  workspaceId?: InputMaybe<Scalars['String']>;
};

export type WorkspaceCollabModel1 = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  publicId: Scalars['String'];
};

export type WorkspaceCollabModelInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  publicId: Scalars['String'];
};

export type WorkspaceNameIdAutocompleteModel = {
  workspaceId: Scalars['String'];
  workspaceName: Scalars['String'];
};

export type GetOrganizationsQueryVariables = Exact<{
  pageInfo: PaginationInput;
}>;


export type GetOrganizationsQuery = { getOrganizations: { organizations: Array<{ id: string, name: string, logo?: string | null, subscription: string, subscriptionExpiry: string, trialUsed: boolean, blocked: boolean, blockedReason?: string | null, workspaceCount: number, collaborators: Array<{ publicId: string, role: string }>, configuration: { availableWizards: Array<string>, availableWorkspaceCount: number, availableCollaboratorsCount: number, availableTargetsVulnerabilityScan: number, availableKycVerificationCount: number, availableCollaboratorsRules: Array<{ email?: string | null, type: string, count: number }> } }>, pageInfo: { page: number, count: number, total: number, sort?: string | null } } };

export type GetOrganizationByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetOrganizationByIdQuery = { getOrganizationById: { id: string, name: string, logo?: string | null, subscription: string, subscriptionExpiry: string, trialUsed: boolean, blocked: boolean, blockedReason?: string | null, workspaceCount: number, collaborators: Array<{ publicId: string, role: string }>, configuration: { availableWizards: Array<string>, availableWorkspaceCount: number, availableCollaboratorsCount: number, availableTargetsVulnerabilityScan: number, availableKycVerificationCount: number, availableCollaboratorsRules: Array<{ email?: string | null, type: string, count: number }> } } };

export type GetWorkspacesQueryVariables = Exact<{
  pageInfo: PaginationInput;
  id: Scalars['String'];
}>;


export type GetWorkspacesQuery = { getWorkspaces: { workspaces: Array<{ id: string, name: string, collaboratorsCount: number, enabledKycLimit: boolean }>, pageInfo: { page: number, count: number, total: number, sort?: string | null } } };

export type SendSupportMessageMutationVariables = Exact<{
  data: SupportMessageInput;
  wid: Scalars['String'];
}>;


export type SendSupportMessageMutation = { sendSupportMessage: { isSent: boolean } };

export type GetRedesignWorkspaceByIdQueryVariables = Exact<{
  workspaceId: Scalars['String'];
  organizationId: Scalars['String'];
}>;


export type GetRedesignWorkspaceByIdQuery = { getRedesignWorkspaceById: { workspace: { id: string, name: string, collaboratorsCount: number, enabledKycLimit: boolean }, organization: { id: string, name: string, logo?: string | null, subscription: string, subscriptionExpiry: string, trialUsed: boolean, blocked: boolean, blockedReason?: string | null, workspaceCount: number, collaborators: Array<{ publicId: string, role: string }>, configuration: { availableWizards: Array<string>, availableWorkspaceCount: number, availableCollaboratorsCount: number, availableTargetsVulnerabilityScan: number, availableCollaboratorsRules: Array<{ email?: string | null, type: string, count: number }> } } } };

export type CreateRoleMutationVariables = Exact<{
  data: CreateUpdateRoleRequestInput;
}>;


export type CreateRoleMutation = { createRole: { message: string } };

export type DeleteRoleMutationVariables = Exact<{
  roleId: Scalars['String'];
  workspaceId: Scalars['String'];
}>;


export type DeleteRoleMutation = { deleteRole: { message: string } };

export type EditRoleMutationVariables = Exact<{
  data: CreateUpdateRoleRequestInput;
}>;


export type EditRoleMutation = { editRole: { message: string } };

export type GetInviteByIdForAcceptQueryVariables = Exact<{
  inviteId: Scalars['String'];
}>;


export type GetInviteByIdForAcceptQuery = { getInviteByIdForAccept: { id: string, inviteStatus: string, roles: Array<string>, creationDate: string, expirationDate: string, activationDate?: string | null, emailAddress: string, isUserExists: boolean, workspaceId: string, workspaceName: string, organizationId: string, organizationName: string, sender: { firstName: string, lastName: string, email: string } } };

export type CreateAccountByInvitationMutationVariables = Exact<{
  data: CreateAccountByInviteDto;
}>;


export type CreateAccountByInvitationMutation = { createAccountByInvitation: { message: string } };

export type GetSmallOrgsAndWorkspacesForSelectQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSmallOrgsAndWorkspacesForSelectQuery = { portalGetSmallOrgsAndWorkspacesForSelect: { organizations: Array<{ id: string, name: string, logo?: string | null, subscription: string, subscriptionExpiry: string, blocked: boolean, workspaces: Array<{ id: string, collaboratorsCount: number, name: string, enabledKycLimit: boolean }>, configuration: { availableWizards: Array<string>, availableWorkspaceCount: number, availableCollaboratorsCount: number, availableTargetsVulnerabilityScan: number } }> } };

export type GetCreateOrganizationDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCreateOrganizationDataQuery = { getCreateOrganizationData: { industries: Array<string>, countries: Array<{ name: string, code: string, fields?: Array<{ fieldKey: string, fieldLabel: string, fieldPlaceholder?: string | null }> | null }>, notCompletedOrganization?: { name: string, logo: string, subscription: string, organizationDetails: any, billing: { transactionNumber: string, currentTear: { variant: string, vatPercentage?: number | null, discountPercentage?: number | null, items: Array<{ name: string, quantity: number, cost: number, type: string, subscriptionType: string, currency: string }> }, billingInfo: { firstName: string, lastName: string, email: string, address: string, zip: string, country: string, additionalData: any } } } | null } };

export type AddOrganizationBusinessWithoutPaymentMutationVariables = Exact<{
  data: CreateOrganizationDto;
}>;


export type AddOrganizationBusinessWithoutPaymentMutation = { addOrganizationBusinessWithoutPayment: { workspace: { id: string, name: string, organizationId: string }, organization: { id: string, name: string, logo: string, subscription: string, subscriptionExpiry: string, blocked: boolean, blockedReason?: string | null } } };

export type AddOrganizationBusinessWithBillingMutationVariables = Exact<{
  data: CreateOrganizationDto;
  billingData: CreateOrganizationBillingInfoInput;
  calculatedTotal: Scalars['Float'];
}>;


export type AddOrganizationBusinessWithBillingMutation = { addOrganizationBusinessWithBilling: { name: string, logo: string, subscription: string, organizationDetails: any, billing: { transactionNumber: string, currentTear: { variant: string, vatPercentage?: number | null, discountPercentage?: number | null, items: Array<{ name: string, quantity: number, cost: number, type: string, subscriptionType: string, currency: string }> }, billingInfo: { firstName: string, lastName: string, email: string, address: string, zip: string, country: string, additionalData: any } } } };

export type ChangeUserProfileInfoGqlMutationVariables = Exact<{
  data: ChangeNameInput;
}>;


export type ChangeUserProfileInfoGqlMutation = { changeName: { message: string } };

export type Validate2faCodeMutationVariables = Exact<{
  code: Scalars['String'];
  secret: Scalars['String'];
}>;


export type Validate2faCodeMutation = { initialValidateGoogleAuthorization: Array<string> };

export type ReconfigureGoogleAuthInSettingsMutationVariables = Exact<{ [key: string]: never; }>;


export type ReconfigureGoogleAuthInSettingsMutation = { reconfigureGoogleAuth: { qrCode: string, secret: string } };

export type DisableGoogleAuthMutationVariables = Exact<{ [key: string]: never; }>;


export type DisableGoogleAuthMutation = { disableGoogleAuth: { message: string } };

export type ImportCsvTemplatecollaboratorsQueryVariables = Exact<{
  workspaceId: Scalars['String'];
}>;


export type ImportCsvTemplatecollaboratorsQuery = { importCsvTemplateCollaborators: string };

export type GetCsvFieldsCollaboratorsMutationVariables = Exact<{
  workspaceId: Scalars['String'];
  file: Scalars['String'];
  name: Scalars['String'];
}>;


export type GetCsvFieldsCollaboratorsMutation = { getCsvFieldsCollaborators: { fileId: string, fields: Array<{ fieldKey?: string | null, fieldTitle?: string | null, csvField?: string | null, description?: string | null, isKey?: boolean | null, isRequired?: boolean | null, isDisabled?: boolean | null }> } };

export type PerformCsvCollaboratorsMutationVariables = Exact<{
  workspaceId: Scalars['String'];
  fileId: Scalars['String'];
  fields: Array<ImportCsvFieldInput> | ImportCsvFieldInput;
}>;


export type PerformCsvCollaboratorsMutation = { performCsvCollaborators: { message?: string | null, successCount?: number | null, duplicatesCount?: number | null, errorRow?: number | null, errorMessage?: string | null } };

export type GetUserProfileGqlQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserProfileGqlQuery = { getCurrentProfile: { lastName: string, firstName: string, email: string, publicId: string } };

export type ChangeUserProfilePassGqlMutationVariables = Exact<{
  data: ChangePasswordInput;
}>;


export type ChangeUserProfilePassGqlMutation = { changePassword: { message: string } };

export type LoginMutationVariables = Exact<{
  data: LoginInputRequest;
}>;


export type LoginMutation = { login: { isGoogleAuthConfigComplete: boolean, isEmailVerified: boolean } };

export type SendEmailMutationVariables = Exact<{
  data: MainLayoutSupportMessageInput;
}>;


export type SendEmailMutation = { sendMessageToSupportMainLayout: { isSent: boolean } };

export type TwoFactorLoginMutationVariables = Exact<{
  TwoFactorCode: Scalars['String'];
}>;


export type TwoFactorLoginMutation = { twoFactorLogin: { organizations: Array<{ id: string, name: string, logo: string, subscription: string, subscriptionExpiry: string, blocked: boolean, blockedReason?: string | null, trialUsed: boolean, collaborators: Array<{ role?: string | null, publicId: string }>, configuration: { availableWizards: Array<string>, availableWorkspaceCount: number, availableCollaboratorsCount: number }, pageInfo: { total: number, sort?: string | null, page: number, count: number }, workspaces: Array<{ id: string, name: string, subscription: string, status?: string | null, organizationId: string, collaborators: Array<{ publicId: string, role?: string | null }> }>, requester: { outsideCollaborator?: boolean | null, publicId: string, role?: string | null } }>, currentUser: { publicId: string, email: string, firstName: string, lastName: string, creationDate?: string | null, lastLoginDate?: string | null, status: string } } };

export type ResendTwoFactorEmailMutationVariables = Exact<{ [key: string]: never; }>;


export type ResendTwoFactorEmailMutation = { twoFactorResendEmail: { message: string } };

export type LoginByRecoveryCodeMutationVariables = Exact<{
  recoveryCode: Scalars['String'];
}>;


export type LoginByRecoveryCodeMutation = { loginByRecoveryCode: { organizations: Array<{ id: string, name: string, logo: string, subscription: string, subscriptionExpiry: string, blocked: boolean, blockedReason?: string | null, trialUsed: boolean, collaborators: Array<{ role?: string | null, publicId: string }>, configuration: { availableWizards: Array<string>, availableWorkspaceCount: number, availableCollaboratorsCount: number }, pageInfo: { total: number, sort?: string | null, page: number, count: number }, workspaces: Array<{ id: string, name: string, subscription: string, status?: string | null, organizationId: string, collaborators: Array<{ publicId: string, role?: string | null }> }>, requester: { outsideCollaborator?: boolean | null, publicId: string, role?: string | null } }>, currentUser: { publicId: string, email: string, firstName: string, lastName: string, creationDate?: string | null, lastLoginDate?: string | null, status: string } } };

export type EmailVerifyMutationVariables = Exact<{
  email: Scalars['String'];
  verificationCode: Scalars['String'];
}>;


export type EmailVerifyMutation = { emailVerify: { message: string, secret?: string | null, qrCode?: string | null } };

export type ResendEmailVerificationCodeMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type ResendEmailVerificationCodeMutation = { resendEmailVerificationCode: { message: string } };

export type RegistrationMutationVariables = Exact<{
  data: RegistrationInputRequest;
}>;


export type RegistrationMutation = { registration: { message: string } };

export type InitialValidateGoogleAuthorizationMutationVariables = Exact<{
  secret: Scalars['String'];
  code: Scalars['String'];
}>;


export type InitialValidateGoogleAuthorizationMutation = { initialValidateGoogleAuthorization: Array<string> };

export type SendEmailToResetPassGqlMutationVariables = Exact<{
  data: EmailInput;
}>;


export type SendEmailToResetPassGqlMutation = { resetPassword: { message: string } };

export type SendPassToResetPassGqlMutationVariables = Exact<{
  data: ChangePasswordOutsideInput;
}>;


export type SendPassToResetPassGqlMutation = { updatePassword: { message: string } };

export type SubscribeToWorkspaceSubscriptionVariables = Exact<{
  workspaceId: Scalars['String'];
  token: Scalars['String'];
  publicId: Scalars['String'];
  organizationId: Scalars['String'];
}>;


export type SubscribeToWorkspaceSubscription = { subscribeToWorkspace: { type: string, publicId?: string | null, workspaceId?: string | null, organizationId?: string | null, payload: string } };

export type PortalAssetFragmentFragment = { id: string, workspaceId: string, assetId: string, serial: string, model: string, manufacture: string, category: string, assigned?: string | null, customFields?: any | null };

export type AssetRequestFragmentFragment = { assetType: AssetsRequestAssetType, comment?: string | null, id: string, requestDate: string, resolution?: string | null, resolveDate?: string | null, status: AssetsRequestStatus, type: AssetsRequestType, workspaceId: string, data: Array<{ fieldName: string, fieldValue?: string | null }>, resolver?: { fullName: string, publicId: string } | null };

export type PortalAssetsGetPhysicalAssetsWithFilterPaginationQueryVariables = Exact<{
  workspaceId: Scalars['String'];
  pageRequest: SharedPaginationInput;
  filter: PortalAssetsFilter;
}>;


export type PortalAssetsGetPhysicalAssetsWithFilterPaginationQuery = { portalAssetsGetPhysicalAssetsWithFilterPagination: { result: Array<{ id: string, workspaceId: string, assetId: string, serial: string, model: string, manufacture: string, category: string, assigned?: string | null, customFields?: any | null }>, pageInfo: { count: number, page: number, total: number, sort?: string | null } } };

export type PortalAssetsGetPhysicalAssetByIdQueryVariables = Exact<{
  workspaceId: Scalars['String'];
  assetId: Scalars['String'];
}>;


export type PortalAssetsGetPhysicalAssetByIdQuery = { portalAssetsGetPhysicalAssetById: { id: string, workspaceId: string, assetId: string, serial: string, model: string, manufacture: string, category: string, assigned?: string | null, customFields?: any | null } };

export type PortalAssetsGetPhysicalAssetsSettingsForFiltersQueryVariables = Exact<{
  workspaceId: Scalars['String'];
}>;


export type PortalAssetsGetPhysicalAssetsSettingsForFiltersQuery = { portalAssetsGetPhysicalAssetsSettingsForFilters: { model: Array<string>, category: Array<string>, manufacture: Array<string> } };

export type PortalAssetsCreateRequestAddAssetMutationVariables = Exact<{
  workspaceId: Scalars['String'];
  data: RequestAddAssetInput;
}>;


export type PortalAssetsCreateRequestAddAssetMutation = { portalAssetsCreateRequestAddAsset: { id: string, message: string } };

export type PortalAssetsGetPhysicalAssetsSettingsQueryVariables = Exact<{
  workspaceId: Scalars['String'];
}>;


export type PortalAssetsGetPhysicalAssetsSettingsQuery = { portalAssetsGetPhysicalAssetsSettings: { model: Array<string>, category: Array<string>, manufacture: Array<string> } };

export type PortalAssetsCreateRequestRequestAssetMutationVariables = Exact<{
  workspaceId: Scalars['String'];
  data: RequestRequestAssetInput;
}>;


export type PortalAssetsCreateRequestRequestAssetMutation = { portalAssetsCreateRequestRequestAsset: { id: string, message: string } };

export type PortalAssetsCreateRequestRemoveAssetMutationVariables = Exact<{
  workspaceId: Scalars['String'];
  data: RequestRemoveAssetInput;
}>;


export type PortalAssetsCreateRequestRemoveAssetMutation = { portalAssetsCreateRequestRemoveAsset: { id: string, message: string } };

export type PortalAssetsGetRequestsWithFilterPaginationQueryVariables = Exact<{
  workspaceId: Scalars['String'];
  pageRequest: SharedPaginationInput;
  filter: PortalAssetsRequestsFilters;
}>;


export type PortalAssetsGetRequestsWithFilterPaginationQuery = { portalAssetsGetRequestsWithFilterPagination: { result: Array<{ assetType: AssetsRequestAssetType, comment?: string | null, id: string, requestDate: string, resolution?: string | null, resolveDate?: string | null, status: AssetsRequestStatus, type: AssetsRequestType, workspaceId: string, data: Array<{ fieldName: string, fieldValue?: string | null }>, resolver?: { fullName: string, publicId: string } | null }>, pageInfo: { page: number, count: number, total: number, sort?: string | null } } };

export type PortalAssetsGetRequestByIdQueryVariables = Exact<{
  workspaceId: Scalars['String'];
  requestId: Scalars['String'];
}>;


export type PortalAssetsGetRequestByIdQuery = { portalAssetsGetRequestById: { assetType: AssetsRequestAssetType, comment?: string | null, id: string, requestDate: string, resolution?: string | null, resolveDate?: string | null, status: AssetsRequestStatus, type: AssetsRequestType, workspaceId: string, data: Array<{ fieldName: string, fieldValue?: string | null }>, resolver?: { fullName: string, publicId: string } | null } };

export type PortalAssetsCancelAssetRequestMutationVariables = Exact<{
  workspaceId: Scalars['String'];
  requestId: Scalars['String'];
}>;


export type PortalAssetsCancelAssetRequestMutation = { portalAssetsCancelAssetRequest: { message: string } };

export type ShortNewDocumentFragmentFragment = { id: string, documentId?: string | null, type: string, name: string, folderId?: string | null, status?: string | null, origin?: boolean | null, version?: number | null, latest?: boolean | null, createdDate?: string | null, lastModified?: string | null, tags?: Array<string> | null, generatedFileId?: string | null, sender?: string | null, workspaceName?: string | null, recipients?: Array<{ role?: string | null, order: number, message?: string | null, fields?: Array<{ id: string, pageId: string, type: string, isRequired?: boolean | null, position: { x: number, y: number, metaPageHeight?: number | null }, size: { width: number, height: number } }> | null, actor: { email: string, firstName: string, lastName: string } }> | null };

export type NewDocumentFragmentFragment = { id: string, documentId?: string | null, workspaceId?: string | null, type: string, name: string, folderId?: string | null, status?: string | null, origin?: boolean | null, version?: number | null, latest?: boolean | null, createdDate?: string | null, tags?: Array<string> | null, lastModified?: string | null, generatedFileId?: string | null, sender?: string | null, workspaceName?: string | null, currentStepEndDate?: string | null, visible?: boolean | null, creatorId?: string | null, deleted?: boolean | null, deletedDate?: string | null, recipients?: Array<{ role?: string | null, message?: string | null, order: number, eta?: number | null, actor: { email: string, firstName: string, lastName: string }, fields?: Array<{ id: string, pageId: string, type: string, isRequired?: boolean | null, position: { x: number, y: number, metaPageHeight?: number | null }, size: { width: number, height: number } }> | null }> | null, accessRules?: Array<{ rule: string }> | null, editors?: Array<{ email: string, firstName: string, lastName: string }> | null, approvers?: Array<{ id?: string | null, order: number, eta: number, groups: Array<{ id?: string | null, name: string, isRequired: boolean, message?: string | null, actors: Array<{ email: string, firstName: string, lastName: string }> }> }> | null, updater?: { email: string, firstName: string, lastName: string } | null, data?: { innerHtml?: string | null, editor?: any | null, pdfFileId?: string | null, variables?: Array<{ id: string, type: string, title: string, value?: string | null, order: number, description?: string | null }> | null } | null };

export type NewDocumentExecutorFragmentFragment = { id: string, workspaceId: string, documentId: string, documentVersionId: string, sender: string, startDate: string, status: string, currentStepId: string, approveSteps: Array<{ id: string, startDate?: string | null, endDate?: string | null, eta: number, groups?: Array<{ id: string, performedByEmail?: string | null, status: string, isRequired: boolean, actors: Array<{ email: string, firstName: string, lastName: string, actions: Array<{ type: string, date: string }> }> }> | null }>, recipientSteps: Array<{ id: string, startDate?: string | null, endDate?: string | null, eta: number, recipients?: Array<{ email: string, firstName: string, lastName: string, status: string, actions: Array<{ type: string, date: string, data?: { fieldId: string, value: string } | null }> }> | null }> };

export type GetShortDocumentsPagingDocsQueryVariables = Exact<{
  pageInfo: PaginationInputAnyFilter;
  workspaceId: Scalars['String'];
}>;


export type GetShortDocumentsPagingDocsQuery = { portalGetShortDocumentsPagingDocs: { files: Array<{ id: string, documentId?: string | null, workspaceId?: string | null, type: string, name: string, folderId?: string | null, status?: string | null, origin?: boolean | null, version?: number | null, latest?: boolean | null, createdDate?: string | null, tags?: Array<string> | null, lastModified?: string | null, generatedFileId?: string | null, sender?: string | null, workspaceName?: string | null, currentStepEndDate?: string | null, recipients?: Array<{ role?: string | null, message?: string | null, order: number, actor: { email: string, firstName: string, lastName: string }, fields?: Array<{ id: string, pageId: string, type: string, position: { x: number, y: number, metaPageHeight?: number | null }, size: { width: number, height: number } }> | null }> | null }>, pageInfo: { total: number, page: number, count: number, sort?: string | null } } };

export type GetSharedShortDocumentsPagingDocsQueryVariables = Exact<{
  pageInfo: PaginationInputAnyFilter;
  workspaceId: Scalars['String'];
}>;


export type GetSharedShortDocumentsPagingDocsQuery = { portalGetSharedShortDocumentsPagingDocs: { files: Array<{ id: string, documentId?: string | null, workspaceId?: string | null, type: string, name: string, folderId?: string | null, status?: string | null, origin?: boolean | null, version?: number | null, latest?: boolean | null, createdDate?: string | null, tags?: Array<string> | null, lastModified?: string | null, generatedFileId?: string | null, sender?: string | null, workspaceName?: string | null, currentStepEndDate?: string | null, recipients?: Array<{ role?: string | null, message?: string | null, order: number, actor: { email: string, firstName: string, lastName: string }, fields?: Array<{ id: string, pageId: string, type: string, position: { x: number, y: number, metaPageHeight?: number | null }, size: { width: number, height: number } }> | null }> | null }>, pageInfo: { total: number, page: number, count: number, sort?: string | null } } };

export type GetFullDocumentWithExecutorForDocsQueryVariables = Exact<{
  documentId: Scalars['String'];
  workspaceId: Scalars['String'];
}>;


export type GetFullDocumentWithExecutorForDocsQuery = { portalGetFullDocumentWithExecutorForDocs: { file?: { id: string, documentId?: string | null, workspaceId?: string | null, type: string, name: string, folderId?: string | null, status?: string | null, origin?: boolean | null, version?: number | null, latest?: boolean | null, createdDate?: string | null, tags?: Array<string> | null, lastModified?: string | null, generatedFileId?: string | null, sender?: string | null, workspaceName?: string | null, currentStepEndDate?: string | null, visible?: boolean | null, creatorId?: string | null, deleted?: boolean | null, deletedDate?: string | null, recipients?: Array<{ role?: string | null, message?: string | null, order: number, eta?: number | null, actor: { email: string, firstName: string, lastName: string }, fields?: Array<{ id: string, pageId: string, type: string, isRequired?: boolean | null, position: { x: number, y: number, metaPageHeight?: number | null }, size: { width: number, height: number } }> | null }> | null, accessRules?: Array<{ rule: string }> | null, editors?: Array<{ email: string, firstName: string, lastName: string }> | null, approvers?: Array<{ id?: string | null, order: number, eta: number, groups: Array<{ id?: string | null, name: string, isRequired: boolean, message?: string | null, actors: Array<{ email: string, firstName: string, lastName: string }> }> }> | null, updater?: { email: string, firstName: string, lastName: string } | null, data?: { innerHtml?: string | null, editor?: any | null, pdfFileId?: string | null, variables?: Array<{ id: string, type: string, title: string, value?: string | null, order: number, description?: string | null }> | null } | null } | null, executor?: { id: string, workspaceId: string, documentId: string, documentVersionId: string, sender: string, startDate: string, status: string, currentStepId: string, approveSteps: Array<{ id: string, startDate?: string | null, endDate?: string | null, eta: number, groups?: Array<{ id: string, performedByEmail?: string | null, status: string, isRequired: boolean, actors: Array<{ email: string, firstName: string, lastName: string, actions: Array<{ type: string, date: string }> }> }> | null }>, recipientSteps: Array<{ id: string, startDate?: string | null, endDate?: string | null, eta: number, recipients?: Array<{ email: string, firstName: string, lastName: string, status: string, actions: Array<{ type: string, date: string, data?: { fieldId: string, value: string } | null }> }> | null }> } | null } };

export type RejectSignStageByStageIdMutationVariables = Exact<{
  stageId: Scalars['String'];
  documentId: Scalars['String'];
  workspaceId: Scalars['String'];
}>;


export type RejectSignStageByStageIdMutation = { portalRejectSignStageByStageId: { file?: { id: string, documentId?: string | null, workspaceId?: string | null, type: string, name: string, folderId?: string | null, status?: string | null, origin?: boolean | null, version?: number | null, latest?: boolean | null, createdDate?: string | null, tags?: Array<string> | null, lastModified?: string | null, generatedFileId?: string | null, sender?: string | null, workspaceName?: string | null, currentStepEndDate?: string | null, visible?: boolean | null, creatorId?: string | null, deleted?: boolean | null, deletedDate?: string | null, recipients?: Array<{ role?: string | null, message?: string | null, order: number, eta?: number | null, actor: { email: string, firstName: string, lastName: string }, fields?: Array<{ id: string, pageId: string, type: string, isRequired?: boolean | null, position: { x: number, y: number, metaPageHeight?: number | null }, size: { width: number, height: number } }> | null }> | null, accessRules?: Array<{ rule: string }> | null, editors?: Array<{ email: string, firstName: string, lastName: string }> | null, approvers?: Array<{ id?: string | null, order: number, eta: number, groups: Array<{ id?: string | null, name: string, isRequired: boolean, message?: string | null, actors: Array<{ email: string, firstName: string, lastName: string }> }> }> | null, updater?: { email: string, firstName: string, lastName: string } | null, data?: { innerHtml?: string | null, editor?: any | null, pdfFileId?: string | null, variables?: Array<{ id: string, type: string, title: string, value?: string | null, order: number, description?: string | null }> | null } | null } | null, executor?: { id: string, workspaceId: string, documentId: string, documentVersionId: string, sender: string, startDate: string, status: string, currentStepId: string, approveSteps: Array<{ id: string, startDate?: string | null, endDate?: string | null, eta: number, groups?: Array<{ id: string, performedByEmail?: string | null, status: string, isRequired: boolean, actors: Array<{ email: string, firstName: string, lastName: string, actions: Array<{ type: string, date: string }> }> }> | null }>, recipientSteps: Array<{ id: string, startDate?: string | null, endDate?: string | null, eta: number, recipients?: Array<{ email: string, firstName: string, lastName: string, status: string, actions: Array<{ type: string, date: string, data?: { fieldId: string, value: string } | null }> }> | null }> } | null } };

export type RejectApproveStageByStageIdMutationVariables = Exact<{
  stageId: Scalars['String'];
  documentId: Scalars['String'];
  workspaceId: Scalars['String'];
}>;


export type RejectApproveStageByStageIdMutation = { portalRejectApproveStageByStageId: { file?: { id: string, documentId?: string | null, workspaceId?: string | null, type: string, name: string, folderId?: string | null, status?: string | null, origin?: boolean | null, version?: number | null, latest?: boolean | null, createdDate?: string | null, tags?: Array<string> | null, lastModified?: string | null, generatedFileId?: string | null, sender?: string | null, workspaceName?: string | null, currentStepEndDate?: string | null, visible?: boolean | null, creatorId?: string | null, deleted?: boolean | null, deletedDate?: string | null, recipients?: Array<{ role?: string | null, message?: string | null, order: number, eta?: number | null, actor: { email: string, firstName: string, lastName: string }, fields?: Array<{ id: string, pageId: string, type: string, isRequired?: boolean | null, position: { x: number, y: number, metaPageHeight?: number | null }, size: { width: number, height: number } }> | null }> | null, accessRules?: Array<{ rule: string }> | null, editors?: Array<{ email: string, firstName: string, lastName: string }> | null, approvers?: Array<{ id?: string | null, order: number, eta: number, groups: Array<{ id?: string | null, name: string, isRequired: boolean, message?: string | null, actors: Array<{ email: string, firstName: string, lastName: string }> }> }> | null, updater?: { email: string, firstName: string, lastName: string } | null, data?: { innerHtml?: string | null, editor?: any | null, pdfFileId?: string | null, variables?: Array<{ id: string, type: string, title: string, value?: string | null, order: number, description?: string | null }> | null } | null } | null, executor?: { id: string, workspaceId: string, documentId: string, documentVersionId: string, sender: string, startDate: string, status: string, currentStepId: string, approveSteps: Array<{ id: string, startDate?: string | null, endDate?: string | null, eta: number, groups?: Array<{ id: string, performedByEmail?: string | null, status: string, isRequired: boolean, actors: Array<{ email: string, firstName: string, lastName: string, actions: Array<{ type: string, date: string }> }> }> | null }>, recipientSteps: Array<{ id: string, startDate?: string | null, endDate?: string | null, eta: number, recipients?: Array<{ email: string, firstName: string, lastName: string, status: string, actions: Array<{ type: string, date: string, data?: { fieldId: string, value: string } | null }> }> | null }> } | null } };

export type FillFillableFieldOnSignStageMutationVariables = Exact<{
  values: Array<FieldIdValueDto> | FieldIdValueDto;
  stageId: Scalars['String'];
  documentId: Scalars['String'];
  workspaceId: Scalars['String'];
}>;


export type FillFillableFieldOnSignStageMutation = { portalFillFillableFieldOnSignStage: { file?: { id: string, documentId?: string | null, workspaceId?: string | null, type: string, name: string, folderId?: string | null, status?: string | null, origin?: boolean | null, version?: number | null, latest?: boolean | null, createdDate?: string | null, tags?: Array<string> | null, lastModified?: string | null, generatedFileId?: string | null, sender?: string | null, workspaceName?: string | null, currentStepEndDate?: string | null, visible?: boolean | null, creatorId?: string | null, deleted?: boolean | null, deletedDate?: string | null, recipients?: Array<{ role?: string | null, message?: string | null, order: number, eta?: number | null, actor: { email: string, firstName: string, lastName: string }, fields?: Array<{ id: string, pageId: string, type: string, isRequired?: boolean | null, position: { x: number, y: number, metaPageHeight?: number | null }, size: { width: number, height: number } }> | null }> | null, accessRules?: Array<{ rule: string }> | null, editors?: Array<{ email: string, firstName: string, lastName: string }> | null, approvers?: Array<{ id?: string | null, order: number, eta: number, groups: Array<{ id?: string | null, name: string, isRequired: boolean, message?: string | null, actors: Array<{ email: string, firstName: string, lastName: string }> }> }> | null, updater?: { email: string, firstName: string, lastName: string } | null, data?: { innerHtml?: string | null, editor?: any | null, pdfFileId?: string | null, variables?: Array<{ id: string, type: string, title: string, value?: string | null, order: number, description?: string | null }> | null } | null } | null, executor?: { id: string, workspaceId: string, documentId: string, documentVersionId: string, sender: string, startDate: string, status: string, currentStepId: string, approveSteps: Array<{ id: string, startDate?: string | null, endDate?: string | null, eta: number, groups?: Array<{ id: string, performedByEmail?: string | null, status: string, isRequired: boolean, actors: Array<{ email: string, firstName: string, lastName: string, actions: Array<{ type: string, date: string }> }> }> | null }>, recipientSteps: Array<{ id: string, startDate?: string | null, endDate?: string | null, eta: number, recipients?: Array<{ email: string, firstName: string, lastName: string, status: string, actions: Array<{ type: string, date: string, data?: { fieldId: string, value: string } | null }> }> | null }> } | null } };

export type ApproveSignStageByStageIdMutationVariables = Exact<{
  stageId: Scalars['String'];
  documentId: Scalars['String'];
  workspaceId: Scalars['String'];
}>;


export type ApproveSignStageByStageIdMutation = { portalApproveSignStageByStageId: { file?: { id: string, documentId?: string | null, workspaceId?: string | null, type: string, name: string, folderId?: string | null, status?: string | null, origin?: boolean | null, version?: number | null, latest?: boolean | null, createdDate?: string | null, tags?: Array<string> | null, lastModified?: string | null, generatedFileId?: string | null, sender?: string | null, workspaceName?: string | null, currentStepEndDate?: string | null, visible?: boolean | null, creatorId?: string | null, deleted?: boolean | null, deletedDate?: string | null, recipients?: Array<{ role?: string | null, message?: string | null, order: number, eta?: number | null, actor: { email: string, firstName: string, lastName: string }, fields?: Array<{ id: string, pageId: string, type: string, isRequired?: boolean | null, position: { x: number, y: number, metaPageHeight?: number | null }, size: { width: number, height: number } }> | null }> | null, accessRules?: Array<{ rule: string }> | null, editors?: Array<{ email: string, firstName: string, lastName: string }> | null, approvers?: Array<{ id?: string | null, order: number, eta: number, groups: Array<{ id?: string | null, name: string, isRequired: boolean, message?: string | null, actors: Array<{ email: string, firstName: string, lastName: string }> }> }> | null, updater?: { email: string, firstName: string, lastName: string } | null, data?: { innerHtml?: string | null, editor?: any | null, pdfFileId?: string | null, variables?: Array<{ id: string, type: string, title: string, value?: string | null, order: number, description?: string | null }> | null } | null } | null, executor?: { id: string, workspaceId: string, documentId: string, documentVersionId: string, sender: string, startDate: string, status: string, currentStepId: string, approveSteps: Array<{ id: string, startDate?: string | null, endDate?: string | null, eta: number, groups?: Array<{ id: string, performedByEmail?: string | null, status: string, isRequired: boolean, actors: Array<{ email: string, firstName: string, lastName: string, actions: Array<{ type: string, date: string }> }> }> | null }>, recipientSteps: Array<{ id: string, startDate?: string | null, endDate?: string | null, eta: number, recipients?: Array<{ email: string, firstName: string, lastName: string, status: string, actions: Array<{ type: string, date: string, data?: { fieldId: string, value: string } | null }> }> | null }> } | null } };

export type ApproveApproveStageByStageIdMutationVariables = Exact<{
  stageId: Scalars['String'];
  documentId: Scalars['String'];
  workspaceId: Scalars['String'];
}>;


export type ApproveApproveStageByStageIdMutation = { portalApproveApproveStageByStageId: { file?: { id: string, documentId?: string | null, workspaceId?: string | null, type: string, name: string, folderId?: string | null, status?: string | null, origin?: boolean | null, version?: number | null, latest?: boolean | null, createdDate?: string | null, tags?: Array<string> | null, lastModified?: string | null, generatedFileId?: string | null, sender?: string | null, workspaceName?: string | null, currentStepEndDate?: string | null, visible?: boolean | null, creatorId?: string | null, deleted?: boolean | null, deletedDate?: string | null, recipients?: Array<{ role?: string | null, message?: string | null, order: number, eta?: number | null, actor: { email: string, firstName: string, lastName: string }, fields?: Array<{ id: string, pageId: string, type: string, isRequired?: boolean | null, position: { x: number, y: number, metaPageHeight?: number | null }, size: { width: number, height: number } }> | null }> | null, accessRules?: Array<{ rule: string }> | null, editors?: Array<{ email: string, firstName: string, lastName: string }> | null, approvers?: Array<{ id?: string | null, order: number, eta: number, groups: Array<{ id?: string | null, name: string, isRequired: boolean, message?: string | null, actors: Array<{ email: string, firstName: string, lastName: string }> }> }> | null, updater?: { email: string, firstName: string, lastName: string } | null, data?: { innerHtml?: string | null, editor?: any | null, pdfFileId?: string | null, variables?: Array<{ id: string, type: string, title: string, value?: string | null, order: number, description?: string | null }> | null } | null } | null, executor?: { id: string, workspaceId: string, documentId: string, documentVersionId: string, sender: string, startDate: string, status: string, currentStepId: string, approveSteps: Array<{ id: string, startDate?: string | null, endDate?: string | null, eta: number, groups?: Array<{ id: string, performedByEmail?: string | null, status: string, isRequired: boolean, actors: Array<{ email: string, firstName: string, lastName: string, actions: Array<{ type: string, date: string }> }> }> | null }>, recipientSteps: Array<{ id: string, startDate?: string | null, endDate?: string | null, eta: number, recipients?: Array<{ email: string, firstName: string, lastName: string, status: string, actions: Array<{ type: string, date: string, data?: { fieldId: string, value: string } | null }> }> | null }> } | null } };

export type UpdateFullDocumentByDocsMutationVariables = Exact<{
  documentId: Scalars['String'];
  data: NewDocDataInput;
  name: Scalars['String'];
  recipients: Array<RecipientInput> | RecipientInput;
  editors: Array<NewDocumentActorInput> | NewDocumentActorInput;
  approvers: Array<DocApproverInput> | DocApproverInput;
  workspaceId: Scalars['String'];
}>;


export type UpdateFullDocumentByDocsMutation = { portalUpdateFullDocumentByDocs: { file?: { id: string, documentId?: string | null, workspaceId?: string | null, type: string, name: string, folderId?: string | null, status?: string | null, origin?: boolean | null, version?: number | null, latest?: boolean | null, createdDate?: string | null, tags?: Array<string> | null, lastModified?: string | null, generatedFileId?: string | null, sender?: string | null, workspaceName?: string | null, currentStepEndDate?: string | null, visible?: boolean | null, creatorId?: string | null, deleted?: boolean | null, deletedDate?: string | null, recipients?: Array<{ role?: string | null, message?: string | null, order: number, eta?: number | null, actor: { email: string, firstName: string, lastName: string }, fields?: Array<{ id: string, pageId: string, type: string, isRequired?: boolean | null, position: { x: number, y: number, metaPageHeight?: number | null }, size: { width: number, height: number } }> | null }> | null, accessRules?: Array<{ rule: string }> | null, editors?: Array<{ email: string, firstName: string, lastName: string }> | null, approvers?: Array<{ id?: string | null, order: number, eta: number, groups: Array<{ id?: string | null, name: string, isRequired: boolean, message?: string | null, actors: Array<{ email: string, firstName: string, lastName: string }> }> }> | null, updater?: { email: string, firstName: string, lastName: string } | null, data?: { innerHtml?: string | null, editor?: any | null, pdfFileId?: string | null, variables?: Array<{ id: string, type: string, title: string, value?: string | null, order: number, description?: string | null }> | null } | null } | null, executor?: { id: string, workspaceId: string, documentId: string, documentVersionId: string, sender: string, startDate: string, status: string, currentStepId: string, approveSteps: Array<{ id: string, startDate?: string | null, endDate?: string | null, eta: number, groups?: Array<{ id: string, performedByEmail?: string | null, status: string, isRequired: boolean, actors: Array<{ email: string, firstName: string, lastName: string, actions: Array<{ type: string, date: string }> }> }> | null }>, recipientSteps: Array<{ id: string, startDate?: string | null, endDate?: string | null, eta: number, recipients?: Array<{ email: string, firstName: string, lastName: string, status: string, actions: Array<{ type: string, date: string, data?: { fieldId: string, value: string } | null }> }> | null }> } | null } };

export type GetDocsMyDocumentsAutocompleteSenderQueryVariables = Exact<{
  page: Scalars['Float'];
  count: Scalars['Float'];
  nameLike: Scalars['String'];
  workspaceId: Scalars['String'];
}>;


export type GetDocsMyDocumentsAutocompleteSenderQuery = { portalGetDocsMyDocumentsAutocompleteSender: { values: Array<string>, pageInfo: { page: number, count: number, total: number } } };

export type HrRequestFragmentFragment = { id: string, workspaceId: string, type: RequestType, requestDate: string, status: HrRequestStatus, resolveDate?: string | null, requestor: { employeeId: string, fullName: string }, resolver?: { employeeId?: string | null, employeeFullName?: string | null, publicId: string, collaboratorFullName: string } | null, data: { editProfile: Array<{ fieldName: string, fieldValue: string }> } };

export type HrIssueFragmentFragment = { id: string, workspaceId: string, anonymous: boolean, requestDate: string, status: HrIssuesStatus, issueType: string, description: string, resolveDate?: string | null, resolution?: string | null, requestor: { employeeId: string, fullName: string }, offender?: { employeeId: string, fullName: string } | null, resolver?: { employeeId?: string | null, employeeFullName?: string | null, publicId: string, collaboratorFullName: string } | null };

export type HrTimeOffFragmentFragment = { id: string, startDate: string, endDate?: string | null, type: string, status: HrTimeOffStatus, comment?: string | null, requestDate: string, currentRouteType: string, currentStepNumber: number, attachments?: Array<{ fileId: string, fileName: string }> | null, approvalRoutes: Array<{ routeType: HrTimeOffRouteType, steps: Array<{ stepNumber: number, type: HrTimeOffStepsType, status: HrTimeOffStepsStatus, resolveDate?: string | null, comment?: string | null, resolver?: { email: string, employeeId?: string | null, employeeFullName?: string | null, publicId?: string | null, collaboratorFullName?: string | null } | null }> }>, requestor: { email: string, employeeId?: string | null, employeeFullName?: string | null, publicId?: string | null, collaboratorFullName?: string | null } };

export type PortalHrGetProfileQueryVariables = Exact<{
  workspaceId: Scalars['String'];
}>;


export type PortalHrGetProfileQuery = { portalHrGetProfile: { id: string, employeeId: string, firstName: string, lastName: string, middleName?: string | null, nickname?: string | null, workEmail: string, birthDay?: string | null, country: string, city: string, street?: string | null, zip?: string | null, workMobilePhone: string, jobTitle: string, department: string, employmentType: string, manager?: string | null, hireDate: string, employeeStatus: { id: string, name: string, textColor: string, backgroundColor: string } } };

export type PortalHrGetProfileJobHistoryQueryVariables = Exact<{
  workspaceId: Scalars['String'];
  pageRequest: SharedPaginationInput;
}>;


export type PortalHrGetProfileJobHistoryQuery = { portalHrGetProfileJobHistory: { result: Array<{ department: string, division: string, effectiveDate: string, employmentType: string, jobTitle: string, location: string, manager?: string | null }>, pageInfo: { page: number, count: number, total: number } } };

export type PortalHrGetSettingsCountriesQueryVariables = Exact<{
  workspaceId: Scalars['String'];
}>;


export type PortalHrGetSettingsCountriesQuery = { portalHrGetSettingsCountries: Array<string> };

export type PortalHrGetRequestsWithFilterPaginationQueryVariables = Exact<{
  workspaceId: Scalars['String'];
  pageRequest: SharedPaginationInput;
  filter: PortalHrRequestsFilter;
}>;


export type PortalHrGetRequestsWithFilterPaginationQuery = { portalHrGetRequestsWithFilterPagination: { result: Array<{ id: string, workspaceId: string, type: RequestType, requestDate: string, status: HrRequestStatus, resolveDate?: string | null, requestor: { employeeId: string, fullName: string }, resolver?: { employeeId?: string | null, employeeFullName?: string | null, publicId: string, collaboratorFullName: string } | null, data: { editProfile: Array<{ fieldName: string, fieldValue: string }> } }>, pageInfo: { count: number, page: number, total: number, sort?: string | null } } };

export type PortalHrGetRequestByIdQueryVariables = Exact<{
  workspaceId: Scalars['String'];
  requestId: Scalars['String'];
}>;


export type PortalHrGetRequestByIdQuery = { portalHrGetRequestById: { id: string, workspaceId: string, type: RequestType, requestDate: string, status: HrRequestStatus, resolveDate?: string | null, requestor: { employeeId: string, fullName: string }, resolver?: { employeeId?: string | null, employeeFullName?: string | null, publicId: string, collaboratorFullName: string } | null, data: { editProfile: Array<{ fieldName: string, fieldValue: string }> } } };

export type PortalHrCreateEditRequestMutationVariables = Exact<{
  workspaceId: Scalars['String'];
  request: PortalHrEditRequestInputDto;
}>;


export type PortalHrCreateEditRequestMutation = { portalHrCreateEditRequest: { message: string } };

export type PortalHrCancelRequestMutationVariables = Exact<{
  workspaceId: Scalars['String'];
  requestId: Scalars['String'];
}>;


export type PortalHrCancelRequestMutation = { portalHrCancelRequest: { message: string } };

export type PortalHrGetOrgTreeQueryVariables = Exact<{
  workspaceId: Scalars['String'];
}>;


export type PortalHrGetOrgTreeQuery = { portalHrGetOrgTree: Array<{ id: string, name: string, manager?: string | null, jobTitle: string, workMobilePhone: string, workEmail: string }> };

export type PortalHrGetIssuesWithFilterPaginationQueryVariables = Exact<{
  workspaceId: Scalars['String'];
  pageRequest: SharedPaginationInput;
  filter: PortalHrIssuesFilter;
}>;


export type PortalHrGetIssuesWithFilterPaginationQuery = { portalHrGetIssuesWithFilterPagination: { result: Array<{ id: string, workspaceId: string, anonymous: boolean, requestDate: string, status: HrIssuesStatus, issueType: string, description: string, resolveDate?: string | null, resolution?: string | null, requestor: { employeeId: string, fullName: string }, offender?: { employeeId: string, fullName: string } | null, resolver?: { employeeId?: string | null, employeeFullName?: string | null, publicId: string, collaboratorFullName: string } | null }>, pageInfo: { count: number, page: number, total: number, sort?: string | null } } };

export type PortalHrGetIssueOffenderAutocompleteQueryVariables = Exact<{
  workspaceId: Scalars['String'];
  pageRequest: SharedPaginationInput;
  search: Scalars['String'];
}>;


export type PortalHrGetIssueOffenderAutocompleteQuery = { portalHrGetIssueOffenderAutocomplete: { result: Array<{ employeeId: string, fullName: string }>, pageInfo: { page: number, count: number, total: number, sort?: string | null } } };

export type PortalHrGetEmployeeAutocompleteQueryVariables = Exact<{
  workspaceId: Scalars['String'];
  pageRequest: SharedPaginationInput;
  search: Scalars['String'];
}>;


export type PortalHrGetEmployeeAutocompleteQuery = { portalHrGetEmployeeAutocomplete: { result: Array<{ employeeId: string, fullName: string }>, pageInfo: { page: number, count: number, total: number, sort?: string | null } } };

export type PortalHrCreateIssueMutationVariables = Exact<{
  workspaceId: Scalars['String'];
  issue: PortalHrCreateIssueInputDto;
}>;


export type PortalHrCreateIssueMutation = { portalHrCreateIssue: { id: string, workspaceId: string, anonymous: boolean, requestDate: string, status: HrIssuesStatus, issueType: string, description: string, resolveDate?: string | null, resolution?: string | null, requestor: { employeeId: string, fullName: string }, offender?: { employeeId: string, fullName: string } | null, resolver?: { employeeId?: string | null, employeeFullName?: string | null, publicId: string, collaboratorFullName: string } | null } };

export type PortalHrGetIssueByIdQueryVariables = Exact<{
  workspaceId: Scalars['String'];
  issueId: Scalars['String'];
}>;


export type PortalHrGetIssueByIdQuery = { portalHrGetIssueById: { id: string, workspaceId: string, anonymous: boolean, requestDate: string, status: HrIssuesStatus, issueType: string, description: string, resolveDate?: string | null, resolution?: string | null, requestor: { employeeId: string, fullName: string }, offender?: { employeeId: string, fullName: string } | null, resolver?: { employeeId?: string | null, employeeFullName?: string | null, publicId: string, collaboratorFullName: string } | null } };

export type PortalHrGetMyTimeOffRequestsWithFilterPaginationQueryVariables = Exact<{
  workspaceId: Scalars['String'];
  pageRequest: SharedPaginationInput;
  filter: PortalHrMyTimeOffFilter;
}>;


export type PortalHrGetMyTimeOffRequestsWithFilterPaginationQuery = { portalHrGetMyTimeOffRequestsWithFilterPagination: { result: Array<{ id: string, startDate: string, endDate?: string | null, type: string, status: HrTimeOffStatus, comment?: string | null, requestDate: string, currentRouteType: string, currentStepNumber: number, attachments?: Array<{ fileId: string, fileName: string }> | null, approvalRoutes: Array<{ routeType: HrTimeOffRouteType, steps: Array<{ stepNumber: number, type: HrTimeOffStepsType, status: HrTimeOffStepsStatus, resolveDate?: string | null, comment?: string | null, resolver?: { email: string, employeeId?: string | null, employeeFullName?: string | null, publicId?: string | null, collaboratorFullName?: string | null } | null }> }>, requestor: { email: string, employeeId?: string | null, employeeFullName?: string | null, publicId?: string | null, collaboratorFullName?: string | null } }>, pageInfo: { count: number, page: number, total: number, sort?: string | null } } };

export type PortalHrGetTimeOffRequestsWithFilterPaginationQueryVariables = Exact<{
  workspaceId: Scalars['String'];
  pageRequest: SharedPaginationInput;
  filter: PortalHrTimeOffFilter;
}>;


export type PortalHrGetTimeOffRequestsWithFilterPaginationQuery = { portalHrGetTimeOffRequestsWithFilterPagination: { result: Array<{ id: string, startDate: string, endDate?: string | null, type: string, status: HrTimeOffStatus, comment?: string | null, requestDate: string, currentRouteType: string, currentStepNumber: number, attachments?: Array<{ fileId: string, fileName: string }> | null, approvalRoutes: Array<{ routeType: HrTimeOffRouteType, steps: Array<{ stepNumber: number, type: HrTimeOffStepsType, status: HrTimeOffStepsStatus, resolveDate?: string | null, comment?: string | null, resolver?: { email: string, employeeId?: string | null, employeeFullName?: string | null, publicId?: string | null, collaboratorFullName?: string | null } | null }> }>, requestor: { email: string, employeeId?: string | null, employeeFullName?: string | null, publicId?: string | null, collaboratorFullName?: string | null } }>, pageInfo: { count: number, page: number, total: number, sort?: string | null } } };

export type PortalHrGetTimeOffRequestsSettingsQueryVariables = Exact<{
  workspaceId: Scalars['String'];
}>;


export type PortalHrGetTimeOffRequestsSettingsQuery = { portalHrGetTimeOffRequestsSettings: { timeOffType: Array<string> } };

export type PortalHrUpdateMyTimeOffRequestMutationVariables = Exact<{
  workspaceId: Scalars['String'];
  timeOffId: Scalars['String'];
  data: PortalHrCreateTimeOffRequestInputDto;
}>;


export type PortalHrUpdateMyTimeOffRequestMutation = { portalHrUpdateMyTimeOffRequest: { message: string } };

export type PortalHrCancelMyTimeOffRequestMutationVariables = Exact<{
  workspaceId: Scalars['String'];
  timeOffId: Scalars['String'];
}>;


export type PortalHrCancelMyTimeOffRequestMutation = { portalHrCancelMyTimeOffRequest: { message: string } };

export type PortalHrGetTimeOffRequestByIdQueryVariables = Exact<{
  workspaceId: Scalars['String'];
  requestId: Scalars['String'];
}>;


export type PortalHrGetTimeOffRequestByIdQuery = { portalHrGetTimeOffRequestById: { id: string, startDate: string, endDate?: string | null, type: string, status: HrTimeOffStatus, comment?: string | null, requestDate: string, currentRouteType: string, currentStepNumber: number, attachments?: Array<{ fileId: string, fileName: string }> | null, approvalRoutes: Array<{ routeType: HrTimeOffRouteType, steps: Array<{ stepNumber: number, type: HrTimeOffStepsType, status: HrTimeOffStepsStatus, resolveDate?: string | null, comment?: string | null, resolver?: { email: string, employeeId?: string | null, employeeFullName?: string | null, publicId?: string | null, collaboratorFullName?: string | null } | null }> }>, requestor: { email: string, employeeId?: string | null, employeeFullName?: string | null, publicId?: string | null, collaboratorFullName?: string | null } } };

export type PortalHrCreateTimeOffRequestMutationVariables = Exact<{
  workspaceId: Scalars['String'];
  data: PortalHrCreateTimeOffRequestInputDto;
}>;


export type PortalHrCreateTimeOffRequestMutation = { portalHrCreateTimeOffRequest: { message: string } };

export type PortalHrGetTimeOffEmployeesAutocompleteQueryVariables = Exact<{
  workspaceId: Scalars['String'];
  pageRequest: SharedPaginationInput;
  search: Scalars['String'];
}>;


export type PortalHrGetTimeOffEmployeesAutocompleteQuery = { portalHrGetTimeOffEmployeesAutocomplete: { result: Array<{ employeeId: string, fullName: string }>, pageInfo: { page: number, count: number, total: number, sort?: string | null } } };

export type PortalHrGetAndChangeStepStatusTimeOffRequestQueryVariables = Exact<{
  workspaceId: Scalars['String'];
  requestId: Scalars['String'];
}>;


export type PortalHrGetAndChangeStepStatusTimeOffRequestQuery = { portalHrGetAndChangeStepStatusTimeOffRequest: { id: string, startDate: string, endDate?: string | null, type: string, status: HrTimeOffStatus, comment?: string | null, requestDate: string, currentRouteType: string, currentStepNumber: number, attachments?: Array<{ fileId: string, fileName: string }> | null, approvalRoutes: Array<{ routeType: HrTimeOffRouteType, steps: Array<{ stepNumber: number, type: HrTimeOffStepsType, status: HrTimeOffStepsStatus, resolveDate?: string | null, comment?: string | null, resolver?: { email: string, employeeId?: string | null, employeeFullName?: string | null, publicId?: string | null, collaboratorFullName?: string | null } | null }> }>, requestor: { email: string, employeeId?: string | null, employeeFullName?: string | null, publicId?: string | null, collaboratorFullName?: string | null } } };

export type PortalHrApproveTimeOffRequestMutationVariables = Exact<{
  workspaceId: Scalars['String'];
  requestId: Scalars['String'];
  comment: Scalars['String'];
}>;


export type PortalHrApproveTimeOffRequestMutation = { portalHrApproveTimeOffRequest: { message: string } };

export type PortalHrRejectTimeOffRequestMutationVariables = Exact<{
  workspaceId: Scalars['String'];
  requestId: Scalars['String'];
  comment: Scalars['String'];
}>;


export type PortalHrRejectTimeOffRequestMutation = { portalHrRejectTimeOffRequest: { message: string } };

export type PortalRequiredActionModelFragmentFragment = { id: string, workspaceId: string, title: string, description: string, createdDate: string, requestorComment: string, resolveDate?: string | null, resolverComment?: string | null, performDate?: string | null, performerComment?: string | null, status: RequiredActionsStatus, type: RequiredActionsType, source: DelegatedTaskSources, requestor: { collaboratorId: string, email: string, fullName: string }, resolver?: { collaboratorId: string, email: string, fullName: string } | null, data?: { attachedFiles?: Array<{ fileName: string, fileId: string, addedToEvidence: boolean }> | null } | null };

export type PortalGetRequiredActionsWithFilterPaginationQueryVariables = Exact<{
  workspaceId: Scalars['String'];
  pageRequest: SharedPaginationInput;
  filter: PortalRequiredActionsFilter;
}>;


export type PortalGetRequiredActionsWithFilterPaginationQuery = { portalGetRequiredActionsWithFilterPagination: { result: Array<{ id: string, workspaceId: string, title: string, description: string, createdDate: string, requestorComment: string, resolveDate?: string | null, resolverComment?: string | null, performDate?: string | null, performerComment?: string | null, status: RequiredActionsStatus, type: RequiredActionsType, source: DelegatedTaskSources, requestor: { collaboratorId: string, email: string, fullName: string }, resolver?: { collaboratorId: string, email: string, fullName: string } | null, data?: { attachedFiles?: Array<{ fileName: string, fileId: string, addedToEvidence: boolean }> | null } | null }>, pageInfo: { count: number, page: number, total: number, sort?: string | null } } };

export type PortalRequiredActionsGetTaskByIdQueryVariables = Exact<{
  workspaceId: Scalars['String'];
  taskId: Scalars['String'];
}>;


export type PortalRequiredActionsGetTaskByIdQuery = { portalRequiredActionsGetTaskById: { id: string, workspaceId: string, title: string, description: string, createdDate: string, requestorComment: string, resolveDate?: string | null, resolverComment?: string | null, performDate?: string | null, performerComment?: string | null, status: RequiredActionsStatus, type: RequiredActionsType, source: DelegatedTaskSources, requestor: { collaboratorId: string, email: string, fullName: string }, resolver?: { collaboratorId: string, email: string, fullName: string } | null, data?: { attachedFiles?: Array<{ fileName: string, fileId: string, addedToEvidence: boolean }> | null } | null } };

export type PortalRequiredActionsResolverAutocompleteQueryVariables = Exact<{
  workspaceId: Scalars['String'];
  pageRequest: SharedPaginationInput;
  search: Scalars['String'];
}>;


export type PortalRequiredActionsResolverAutocompleteQuery = { portalRequiredActionsResolverAutocomplete: { result: Array<{ collaboratorId: string, fullName: string }>, pageInfo: { page: number, count: number, total: number, sort?: string | null } } };

export type PortalRequiredActionsRequestorAutocompleteQueryVariables = Exact<{
  workspaceId: Scalars['String'];
  pageRequest: SharedPaginationInput;
  search: Scalars['String'];
}>;


export type PortalRequiredActionsRequestorAutocompleteQuery = { portalRequiredActionsRequestorAutocomplete: { result: Array<{ collaboratorId: string, fullName: string }>, pageInfo: { page: number, count: number, total: number, sort?: string | null } } };

export type PortalRequiredActionsPerformActionProvideFilesMutationVariables = Exact<{
  workspaceId: Scalars['String'];
  data: PerformActionProvideFilesInputDto;
}>;


export type PortalRequiredActionsPerformActionProvideFilesMutation = { portalRequiredActionsPerformActionProvideFiles: { message: string } };

export type PortalTrainingsAssignmentShortFragmentFragment = { id: string, requestor: string, startDate: string, endDate?: string | null, status: TrainingAssignmentStatus, trainingName?: string | null, examName?: string | null };

export type PortalTrainingAssignmentExamFragmentFragment = { examVersionId: string, examName: string, examDescription: string, examVersion: number, examCategory: string, examLevel: TrainingExamLevel, status: TrainingAssignmentObjectStatus, timeToPass: number, examPassingPoints?: number | null, totalPoints?: number | null, startDate?: string | null, completeDate?: string | null, examCover: { fileType?: string | null, image: string, imageName: string, thumbnail: string, type: MainTrainingCoverImageType }, questions: Array<{ answer?: Array<string> | null, answerDate?: string | null, description: string, question: string, questionId: string, status: TrainingAssignmentExamAnswerStatus, type: TrainingExamQuestionType, order: number, points?: number | null, options: Array<{ correct?: boolean | null, option: string, order: number, points?: number | null }>, validation?: { collaboratorId?: string | null, correctAnswer?: Array<string> | null, email?: string | null, fullName?: string | null, points?: number | null, type: MainTrainingAssignmentPostExamAnswerValidationType, validationDate: string } | null }> };

export type PortalTrainingFragmentFragment = { trainingVersionId: string, trainingName: string, trainingVersion: number, trainingCategory: string, trainingDescription: string, trainingLevel: MainTrainingLevel, status: TrainingAssignmentObjectStatus, limitMaxDuration: number, limitMinDuration: number, startDate?: string | null, completeDate?: string | null, duration: number, trainingCover?: { thumbnail: string, image: string, imageName: string, type: MainTrainingCoverImageType } | null, content: Array<{ sectionId: string, sectionName: string, type: MainTrainingContentType, status: TrainingContentStatus, order: number, data: { name?: string | null, fileId?: string | null, thumbnail?: string | null, url?: string | null, innerHtml?: string | null } }> };

export type PortalTrainingAssignmentModelFragmentFragment = { id: string, workspaceId: string, requestDate: string, startDate: string, endDate?: string | null, actualStartDate?: string | null, completeDate?: string | null, status: TrainingAssignmentStatus, recipient: { collaboratorId: string, fullName: string, email: string }, requestor: { collaboratorId: string, fullName: string, email: string }, training?: { trainingVersionId: string, trainingName: string, trainingVersion: number, trainingCategory: string, trainingLevel: MainTrainingLevel, trainingDescription: string, status: TrainingAssignmentObjectStatus, limitMaxDuration: number, limitMinDuration: number, startDate?: string | null, completeDate?: string | null, trainingCover?: { imageName: string, type: MainTrainingCoverImageType, image: string, thumbnail: string, fileType?: string | null } | null, content: Array<{ sectionId: string, sectionName: string, type: MainTrainingContentType, status: MainTrainingProgressStatus, order: number, data: { name?: string | null, fileId?: string | null, thumbnail?: string | null, innerHtml?: string | null, url?: string | null } }> } | null, postExam?: { examVersionId: string, examName: string, examDescription: string, examVersion: number, examCategory: string, examLevel: TrainingExamLevel, status: TrainingAssignmentObjectStatus, timeToPass: number, examPassingPoints?: number | null, totalPoints?: number | null, startDate?: string | null, completeDate?: string | null, totalQuestions: number, examCover?: { imageName: string, type: MainTrainingCoverImageType, image: string, thumbnail: string, fileType?: string | null } | null, questions?: Array<{ questionId: string, question: string, description: string, order: number, points?: number | null, type: TrainingExamQuestionType, status: TrainingAssignmentExamAnswerStatus, answerDate?: string | null, answer?: Array<string> | null, options?: Array<{ option: string, correct?: boolean | null, points?: number | null, order: number }> | null, validation?: { type: MainTrainingAssignmentPostExamAnswerValidationType, collaboratorId?: string | null, fullName?: string | null, email?: string | null, correctAnswer?: Array<string> | null, points?: number | null, validationDate: string } | null }> | null } | null };

export type PortalTrainingsGetAssignmentsWithFilterPaginationQueryVariables = Exact<{
  workspaceId: Scalars['String'];
  pageRequest: SharedPaginationInput;
  filter: PortalAssignmentsFilters;
}>;


export type PortalTrainingsGetAssignmentsWithFilterPaginationQuery = { portalTrainingsGetAssignmentsWithFilterPagination: { result: Array<{ id: string, requestor: string, startDate: string, endDate?: string | null, status: TrainingAssignmentStatus, trainingName?: string | null, examName?: string | null }>, pageInfo: { count: number, page: number, total: number, sort?: string | null } } };

export type PortalTrainingGetAssignmentRequestorsAutocompleteQueryVariables = Exact<{
  workspaceId: Scalars['String'];
  pageRequest: SharedPaginationInput;
  search: Scalars['String'];
}>;


export type PortalTrainingGetAssignmentRequestorsAutocompleteQuery = { portalTrainingGetAssignmentRequestorsAutocomplete: { result: Array<{ collaboratorId: string, fullName: string }>, pageInfo: { count: number, page: number, total: number, sort?: string | null } } };

export type PortalTrainingGetAssignmentTrainingsAutocompleteQueryVariables = Exact<{
  workspaceId: Scalars['String'];
  pageRequest: SharedPaginationInput;
  search: Scalars['String'];
}>;


export type PortalTrainingGetAssignmentTrainingsAutocompleteQuery = { portalTrainingGetAssignmentTrainingsAutocomplete: { result: Array<{ id: string, name: string }>, pageInfo: { count: number, page: number, total: number, sort?: string | null } } };

export type PortalTrainingGetAssignmentExamsAutocompleteQueryVariables = Exact<{
  workspaceId: Scalars['String'];
  pageRequest: SharedPaginationInput;
  search: Scalars['String'];
}>;


export type PortalTrainingGetAssignmentExamsAutocompleteQuery = { portalTrainingGetAssignmentExamsAutocomplete: { result: Array<{ id: string, name: string }>, pageInfo: { count: number, page: number, total: number, sort?: string | null } } };

export type PortalGetAssignmentTrainingByIdQueryVariables = Exact<{
  workspaceId: Scalars['String'];
  id: Scalars['String'];
}>;


export type PortalGetAssignmentTrainingByIdQuery = { portalGetAssignmentTrainingById: { trainingVersionId: string, trainingName: string, trainingVersion: number, trainingCategory: string, trainingDescription: string, trainingLevel: MainTrainingLevel, status: TrainingAssignmentObjectStatus, limitMaxDuration: number, limitMinDuration: number, startDate?: string | null, completeDate?: string | null, duration: number, trainingCover?: { thumbnail: string, image: string, imageName: string, type: MainTrainingCoverImageType } | null, content: Array<{ sectionId: string, sectionName: string, type: MainTrainingContentType, status: TrainingContentStatus, order: number, data: { name?: string | null, fileId?: string | null, thumbnail?: string | null, url?: string | null, innerHtml?: string | null } }> } };

export type PortalStartTrainingMutationVariables = Exact<{
  workspaceId: Scalars['String'];
  id: Scalars['String'];
}>;


export type PortalStartTrainingMutation = { portalStartTraining: { message: string } };

export type PortalTrainingsStartExamMutationVariables = Exact<{
  workspaceId: Scalars['String'];
  assignmentId: Scalars['String'];
  type: TrainingAssignmentExamType;
}>;


export type PortalTrainingsStartExamMutation = { portalTrainingsStartExam: { message: string } };

export type PortalTrainingsGetExamByAssignmentIdQueryVariables = Exact<{
  workspaceId: Scalars['String'];
  assignmentId: Scalars['String'];
  type: TrainingAssignmentExamType;
}>;


export type PortalTrainingsGetExamByAssignmentIdQuery = { portalTrainingsGetExamByAssignmentId: { examVersionId: string, examName: string, examDescription: string, examVersion: number, examCategory: string, examLevel: TrainingExamLevel, status: TrainingAssignmentObjectStatus, timeToPass: number, examPassingPoints?: number | null, totalPoints?: number | null, startDate?: string | null, completeDate?: string | null, examCover: { fileType?: string | null, image: string, imageName: string, thumbnail: string, type: MainTrainingCoverImageType }, questions: Array<{ answer?: Array<string> | null, answerDate?: string | null, description: string, question: string, questionId: string, status: TrainingAssignmentExamAnswerStatus, type: TrainingExamQuestionType, order: number, points?: number | null, options: Array<{ correct?: boolean | null, option: string, order: number, points?: number | null }>, validation?: { collaboratorId?: string | null, correctAnswer?: Array<string> | null, email?: string | null, fullName?: string | null, points?: number | null, type: MainTrainingAssignmentPostExamAnswerValidationType, validationDate: string } | null }> } };

export type PortalTrainingsExamSaveAnswerMutationVariables = Exact<{
  workspaceId: Scalars['String'];
  assignmentId: Scalars['String'];
  type: TrainingAssignmentExamType;
  questionId: Scalars['String'];
  answer: Array<Scalars['String']> | Scalars['String'];
}>;


export type PortalTrainingsExamSaveAnswerMutation = { portalTrainingsExamSaveAnswer: { readyToFinish: boolean, skippedQuestions: number } };

export type PortalTrainingsExamSkipAnswerMutationVariables = Exact<{
  workspaceId: Scalars['String'];
  assignmentId: Scalars['String'];
  type: TrainingAssignmentExamType;
  questionId: Scalars['String'];
}>;


export type PortalTrainingsExamSkipAnswerMutation = { portalTrainingsExamSkipAnswer: { readyToFinish: boolean, skippedQuestions: number } };

export type PortalTrainingsFinishExamMutationVariables = Exact<{
  workspaceId: Scalars['String'];
  assignmentId: Scalars['String'];
  type: TrainingAssignmentExamType;
}>;


export type PortalTrainingsFinishExamMutation = { portalTrainingsFinishExam: { examStatus: TrainingAssignmentObjectStatus, exam?: { examVersionId: string, examName: string, examDescription: string, examVersion: number, examCategory: string, examLevel: TrainingExamLevel, status: TrainingAssignmentObjectStatus, timeToPass: number, examPassingPoints?: number | null, totalPoints?: number | null, startDate?: string | null, completeDate?: string | null, examCover: { fileType?: string | null, image: string, imageName: string, thumbnail: string, type: MainTrainingCoverImageType }, questions: Array<{ answer?: Array<string> | null, answerDate?: string | null, description: string, question: string, questionId: string, status: TrainingAssignmentExamAnswerStatus, type: TrainingExamQuestionType, order: number, points?: number | null, options: Array<{ correct?: boolean | null, option: string, order: number, points?: number | null }>, validation?: { collaboratorId?: string | null, correctAnswer?: Array<string> | null, email?: string | null, fullName?: string | null, points?: number | null, type: MainTrainingAssignmentPostExamAnswerValidationType, validationDate: string } | null }> } | null } };

export type PortalUpdateTrainingDurationMutationVariables = Exact<{
  workspaceId: Scalars['String'];
  assignmentId: Scalars['String'];
  duration: Scalars['Float'];
}>;


export type PortalUpdateTrainingDurationMutation = { portalUpdateTrainingDuration: { message: string } };

export type PortalFinishTrainingSectionMutationVariables = Exact<{
  workspaceId: Scalars['String'];
  assignmentId: Scalars['String'];
  sectionId: Scalars['String'];
  duration: Scalars['Float'];
}>;


export type PortalFinishTrainingSectionMutation = { portalFinishTrainingSection: { readyToFinish: boolean, nextSection?: string | null, duration: number } };

export type PortalFinishTrainingMutationVariables = Exact<{
  workspaceId: Scalars['String'];
  assignmentId: Scalars['String'];
}>;


export type PortalFinishTrainingMutation = { portalFinishTraining: { message: string } };

export type PortalTrainingsGetAssignmentDetailsQueryVariables = Exact<{
  workspaceId: Scalars['String'];
  assignmentId: Scalars['String'];
}>;


export type PortalTrainingsGetAssignmentDetailsQuery = { portalTrainingsGetAssignmentDetails: { id: string, workspaceId: string, requestDate: string, startDate: string, endDate?: string | null, actualStartDate?: string | null, completeDate?: string | null, status: TrainingAssignmentStatus, recipient: { collaboratorId: string, fullName: string, email: string }, requestor: { collaboratorId: string, fullName: string, email: string }, training?: { trainingVersionId: string, trainingName: string, trainingVersion: number, trainingCategory: string, trainingLevel: MainTrainingLevel, trainingDescription: string, status: TrainingAssignmentObjectStatus, limitMaxDuration: number, limitMinDuration: number, startDate?: string | null, completeDate?: string | null, trainingCover?: { imageName: string, type: MainTrainingCoverImageType, image: string, thumbnail: string, fileType?: string | null } | null, content: Array<{ sectionId: string, sectionName: string, type: MainTrainingContentType, status: MainTrainingProgressStatus, order: number, data: { name?: string | null, fileId?: string | null, thumbnail?: string | null, innerHtml?: string | null, url?: string | null } }> } | null, postExam?: { examVersionId: string, examName: string, examDescription: string, examVersion: number, examCategory: string, examLevel: TrainingExamLevel, status: TrainingAssignmentObjectStatus, timeToPass: number, examPassingPoints?: number | null, totalPoints?: number | null, startDate?: string | null, completeDate?: string | null, totalQuestions: number, examCover?: { imageName: string, type: MainTrainingCoverImageType, image: string, thumbnail: string, fileType?: string | null } | null, questions?: Array<{ questionId: string, question: string, description: string, order: number, points?: number | null, type: TrainingExamQuestionType, status: TrainingAssignmentExamAnswerStatus, answerDate?: string | null, answer?: Array<string> | null, options?: Array<{ option: string, correct?: boolean | null, points?: number | null, order: number }> | null, validation?: { type: MainTrainingAssignmentPostExamAnswerValidationType, collaboratorId?: string | null, fullName?: string | null, email?: string | null, correctAnswer?: Array<string> | null, points?: number | null, validationDate: string } | null }> | null } | null } };

export type WorkerGetStagesQueryVariables = Exact<{
  workspaceId: Scalars['String'];
  data: SharedPaginationInput;
}>;


export type WorkerGetStagesQuery = { workerGetStages: { pageInfo: { page: number, count: number, total: number, sort?: string | null }, stages: Array<{ stage: { executorId: string, name: string, documentName?: string | null, id: string, eta: number, expirationDate: string, runDate: string, status?: string | null, statusChangedDate?: string | null, type: string, automationType: string, actor: { email: string, publicId?: string | null, status?: string | null, statusChangedDate?: string | null } }, stageDocument?: { type: string, links: Array<{ fileName: string, lastUpdate: string, link: string }> } | null, stageCampaignReview?: { email: string, status?: string | null, statusChangedDate: string, firstName?: string | null, lastName?: string | null, publicId?: string | null, mainControl: boolean, verifyRevokeComment?: string | null, appsData?: Array<{ applicationAccessName: string, applicationAccessId: string, applicationId?: string | null, vendorId?: string | null, vendorName?: string | null, data: Array<{ id: string, commentManager?: string | null, statusManager?: string | null, commentVendor?: string | null, statusVendor?: string | null, publicIdVendor?: string | null, publicIdManager?: string | null, employee?: string | null, employeeId?: string | null, account: string, accountId?: string | null, accountType?: string | null, status: string, roles: Array<{ roleName: string, rolePermissions: Array<string> }> }> }> | null } | null }> } };

export type GetCampaignReviewStageByIdQueryVariables = Exact<{
  workspaceId: Scalars['String'];
  executorId: Scalars['String'];
  stageId: Scalars['String'];
}>;


export type GetCampaignReviewStageByIdQuery = { getCampaignReviewStageById: { id: string, type: string, runDate?: string | null, expirationDate: string, eta: number, status?: string | null, statusChangedDate?: string | null, actors: Array<{ email: string, status?: string | null, statusChangedDate: string, firstName?: string | null, lastName?: string | null, publicId?: string | null, mainControl: boolean, verifyRevokeComment?: string | null, appsData?: Array<{ applicationAccessName: string, applicationAccessId: string, applicationId?: string | null, vendorId?: string | null, vendorName?: string | null, data: Array<{ id: string, commentManager?: string | null, statusManager?: string | null, commentVendor?: string | null, statusVendor?: string | null, publicIdVendor?: string | null, publicIdManager?: string | null, employee?: string | null, employeeId?: string | null, account: string, accountId?: string | null, accountType?: string | null, status: string, roles: Array<{ roleName: string, rolePermissions: Array<string> }> }> }> | null }> } };

export type DownLoadFileQueryVariables = Exact<{
  id: Scalars['String'];
  workspaceId: Scalars['String'];
}>;


export type DownLoadFileQuery = { downloadFile?: { file: string } | null };

export type WorkerConfirmStageMutationVariables = Exact<{
  workspaceId: Scalars['String'];
  id: Scalars['String'];
}>;


export type WorkerConfirmStageMutation = { workerConfirmStage?: { message: string } | null };

export type WorkerConfirmSignStageMutationVariables = Exact<{
  workspaceId: Scalars['String'];
  data: WorkerConfirmSignatureDto;
}>;


export type WorkerConfirmSignStageMutation = { workerConfirmSignStage?: { message: string } | null };

export type PortalUploadFileMutationVariables = Exact<{
  file: Scalars['String'];
}>;


export type PortalUploadFileMutation = { portalUploadFile: { message: string } };

export type UpdateDocumentMutationVariables = Exact<{
  workspaceId: Scalars['String'];
  data: WorkerUploadNewFileDto;
}>;


export type UpdateDocumentMutation = { workerUploadNewFileForReview: { message: string } };

export type UpdateCampaignReviewRowsMutationVariables = Exact<{
  workspaceId: Scalars['String'];
  stageId: Scalars['String'];
  data: UpdateRowStatusOrCommentDtoRequestDto;
  executorId: Scalars['String'];
}>;


export type UpdateCampaignReviewRowsMutation = { updateCampaignReviewRowsDocs: { message: string } };

export type VerifyActorChangesDocsMutationVariables = Exact<{
  workspaceId: Scalars['String'];
  signatureId?: InputMaybe<Scalars['String']>;
  stageId: Scalars['String'];
  verifyComment?: InputMaybe<Scalars['String']>;
}>;


export type VerifyActorChangesDocsMutation = { verifyActorChangesDocs: { message: string } };

export type GetFinalApproverByStageIdAndExcIdQueryVariables = Exact<{
  workspaceId: Scalars['String'];
  stageId: Scalars['String'];
  executorId: Scalars['String'];
}>;


export type GetFinalApproverByStageIdAndExcIdQuery = { getFinalApproverByStageIdAndExcId: { email: string, firstName?: string | null, lastName?: string | null, publicId?: string | null, documentId?: string | null, signId?: string | null } };

export type AutocompleteCollaboratorsQueryVariables = Exact<{
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
  autocompleteInput: AutocompleteInput;
  byAllWorkspaces?: InputMaybe<Scalars['Boolean']>;
}>;


export type AutocompleteCollaboratorsQuery = { autocompleteCollaborators: { result: Array<{ publicId: string, firstName?: string | null, lastName?: string | null, email: string }>, pageInfo: { page: number, count: number, total: number, sort?: string | null } } };

export type DownloadEvidenceFileQueryVariables = Exact<{
  fileId: Scalars['String'];
  workspaceId: Scalars['String'];
  fileName: Scalars['String'];
}>;


export type DownloadEvidenceFileQuery = { downloadEvidenceFile: { filename: string, filetype: string, file: string } };

export type DownloadImageInEditorQueryVariables = Exact<{
  workspaceId: Scalars['String'];
  id: Scalars['String'];
}>;


export type DownloadImageInEditorQuery = { downloadFile?: { file: string } | null };

export type UploadImageInEditorMutationVariables = Exact<{
  workspaceId: Scalars['String'];
  file: Scalars['String'];
}>;


export type UploadImageInEditorMutation = { uploadFile: { message: string } };

export type DownloadImageInEditorDocsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type DownloadImageInEditorDocsQuery = { workerDownloadFile?: { file: string } | null };

export type UploadImageInEditorDocsMutationVariables = Exact<{
  file: Scalars['String'];
}>;


export type UploadImageInEditorDocsMutation = { workerUploadFile: { message: string } };

export type DownloadImageInEditorPortalQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type DownloadImageInEditorPortalQuery = { portalDownloadFile?: { file: string } | null };

export type UploadImageInEditorPortalMutationVariables = Exact<{
  file: Scalars['String'];
}>;


export type UploadImageInEditorPortalMutation = { portalUploadFile: { message: string } };

export type DownloadFileTinyQueryVariables = Exact<{
  workspaceId: Scalars['String'];
  id: Scalars['String'];
}>;


export type DownloadFileTinyQuery = { downloadFile?: { file: string } | null };

export type UploadFileTinyMutationVariables = Exact<{
  workspaceId: Scalars['String'];
  file: Scalars['String'];
}>;


export type UploadFileTinyMutation = { uploadFile: { message: string } };

export type IdNameFragmentFragment = { id: string, name: string };

export type AppInfoSmallFragmentFragment = { appId: string, name: string, logo?: string | null };

export type IdNameLogoModelFragmentFragment = { id: string, name: string, logo?: string | null };

export type PageInfoFragmentFragment = { page: number, count: number, total: number, sort?: string | null };

export type GetFiltersFragmentFragment = { name: string, values: Array<string> };

export type ImportCsvFragmentFieldsFragment = { fieldKey?: string | null, fieldTitle?: string | null, csvField?: string | null, description?: string | null, isKey?: boolean | null, isRequired?: boolean | null, isDisabled?: boolean | null };

export type PerformCsvFragmentFragment = { message?: string | null, successCount?: number | null, duplicatesCount?: number | null, errorRow?: number | null, errorMessage?: string | null };

export type GetDateQueryVariables = Exact<{
  organizationId: Scalars['String'];
  workspaceId: Scalars['String'];
}>;


export type GetDateQuery = { getDataForRelease: { frameworks: Array<{ id: string, name: string }>, controls: Array<{ id: string, name: string, frameworkIds: Array<string>, category: string }>, evidences: Array<{ id: string, name: string, controlIds: Array<string> }> } };
